/*
* @license
* Broadcast Theme (c) Invisible Themes
*
* The contents of this file should not be modified.
* add any minor changes to assets/custom.js
*
*/
// (function(e,t,i,s,o){"use strict";(function(){const e={NODE_ENV:"production"};try{if(process){process.env=Object.assign({},process.env);Object.assign(process.env,e);return}}catch(e){}globalThis.process={env:e}})();window.theme=window.theme||{};window.theme.sizes={mobile:480,small:750,large:990,widescreen:1400};window.theme.focusable='button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';function n(){if(document.querySelector("cart-items"))return;const e=document.createElement("cart-items");document.body.appendChild(e)}function r(e){const t=e.querySelectorAll(".form-field");t.forEach((e=>{const t=e.querySelector("label");const i=e.querySelector("input, textarea");if(t&&i){i.addEventListener("keyup",(e=>{if(e.target.value!==""){t.classList.add("label--float")}else{t.classList.remove("label--float")}}));if(i.value&&i.value.length){t.classList.add("label--float")}}}))}let a=u();window.initialWindowHeight=Math.min(window.screen.height,window.innerHeight);function l(){const e={};e.windowHeight=Math.min(window.screen.height,window.innerHeight);e.footerHeight=p('[data-section-type*="footer"]');e.headerHeight=p("[data-header-height]");e.stickyHeaderHeight=document.querySelector("[data-header-sticky]")?e.headerHeight:0;e.collectionNavHeight=p("[data-collection-nav]");e.logoHeight=m();return e}function c(){document.addEventListener("theme:resize",h);d()}function d(){const{windowHeight:e,headerHeight:t,logoHeight:i,footerHeight:s,collectionNavHeight:o}=l();document.documentElement.style.setProperty("--full-height",`${e}px`);document.documentElement.style.setProperty("--three-quarters",`${e*(3/4)}px`);document.documentElement.style.setProperty("--two-thirds",`${e*(2/3)}px`);document.documentElement.style.setProperty("--one-half",`${e/2}px`);document.documentElement.style.setProperty("--one-third",`${e/3}px`);document.documentElement.style.setProperty("--collection-nav-height",`${o}px`);document.documentElement.style.setProperty("--header-height",`${t}px`);document.documentElement.style.setProperty("--footer-height",`${s}px`);document.documentElement.style.setProperty("--content-full",`${e-t-i/2}px`);document.documentElement.style.setProperty("--content-min",`${e-t-s}px`);if(document.querySelector("[data-tracking-consent].popup-cookies--bottom")){document.documentElement.style.setProperty("--cookie-bar-height",`${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`)}}function h(){const{windowHeight:e,headerHeight:t,logoHeight:i,footerHeight:s,collectionNavHeight:o}=l();const n=u();if(n!==a||window.innerWidth>window.theme.sizes.mobile){document.documentElement.style.setProperty("--full-height",`${e}px`);document.documentElement.style.setProperty("--three-quarters",`${e*(3/4)}px`);document.documentElement.style.setProperty("--two-thirds",`${e*(2/3)}px`);document.documentElement.style.setProperty("--one-half",`${e/2}px`);document.documentElement.style.setProperty("--one-third",`${e/3}px`);a=n}document.documentElement.style.setProperty("--collection-nav-height",`${o}px`);document.documentElement.style.setProperty("--header-height",`${t}px`);document.documentElement.style.setProperty("--footer-height",`${s}px`);document.documentElement.style.setProperty("--content-full",`${e-t-i/2}px`);document.documentElement.style.setProperty("--content-min",`${e-t-s}px`);if(document.querySelector("[data-tracking-consent].popup-cookies--bottom")){document.documentElement.style.setProperty("--cookie-bar-height",`${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`)}}function u(){if(window.matchMedia("(orientation: portrait)").matches){return"portrait"}if(window.matchMedia("(orientation: landscape)").matches){return"landscape"}}function p(e){const t=document.querySelector(e);if(t){return t.offsetHeight}else{return 0}}function m(){const e=p("[data-footer-logo]");if(e>0){return e+20}else{return 0}}function f(e,t){let i;return function(){if(e){const s=()=>e.apply(this,arguments);clearTimeout(i);i=setTimeout(s,t)}}}function g(){return document.documentElement.clientWidth||document.body.clientWidth||window.innerWidth}function v(){return document.documentElement.clientHeight||document.body.clientHeight||window.innerHeight}function b(){return g()>=window.theme.sizes.small}function y(){return g()<window.theme.sizes.small}let w=g();let S=v();function E(){document.dispatchEvent(new CustomEvent("theme:resize",{bubbles:true}));if(w!==g()){document.dispatchEvent(new CustomEvent("theme:resize:width",{bubbles:true}));w=g()}if(S!==v()){document.dispatchEvent(new CustomEvent("theme:resize:height",{bubbles:true}));S=v()}}function L(){window.addEventListener("resize",f((function(){E()}),50))}let k=window.scrollY;let A=null;let C=null;let T=null;let q=null;let I=0;function P(){const e=window.scrollY;if(e>k){C=true;A=false}else if(e<k){C=false;A=true}else{A=null;C=null}k=e;document.dispatchEvent(new CustomEvent("theme:scroll",{detail:{up:A,down:C,position:e},bubbles:false}));if(A&&!T){document.dispatchEvent(new CustomEvent("theme:scroll:up",{detail:{position:e},bubbles:false}))}if(C&&!q){document.dispatchEvent(new CustomEvent("theme:scroll:down",{detail:{position:e},bubbles:false}))}q=C;T=A}function x(t){setTimeout((()=>{if(I){clearTimeout(I)}e.disablePageScroll(t.detail,{allowTouchMove:e=>e.tagName==="TEXTAREA"});document.documentElement.setAttribute("data-scroll-locked","")}))}function M(e){const t=e.detail;if(t){I=setTimeout(H,t)}else{H()}}function H(){e.clearQueueScrollLocks();e.enablePageScroll();document.documentElement.removeAttribute("data-scroll-locked")}function O(){let e;window.addEventListener("scroll",(function(){if(e){window.cancelAnimationFrame(e)}e=window.requestAnimationFrame((function(){P()}))}),{passive:true});window.addEventListener("theme:scroll:lock",x);window.addEventListener("theme:scroll:unlock",M)}const B=(e,t="",i)=>{const s=i||document.createElement("div");s.classList.add(t);e.parentNode.insertBefore(s,e);return s.appendChild(e)};function D(e){const t=".rte table";const i=e.querySelectorAll(t);i.forEach((e=>{B(e,"rte__table-wrapper");e.setAttribute("data-scroll-lock-scrollable","")}));const s='.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe';const o=e.querySelectorAll(s);o.forEach((e=>{B(e,"rte__video-wrapper")}))}function F(){return"ontouchstart"in window||navigator.maxTouchPoints>0||navigator.msMaxTouchPoints>0}function _(){if(F()){document.documentElement.className=document.documentElement.className.replace("no-touch","supports-touch");window.theme.touch=true}else{window.theme.touch=false}}function $(e){const t=e.querySelectorAll("[data-aria-toggle]");if(t.length){t.forEach((e=>{e.addEventListener("click",(function(e){e.preventDefault();const t=e.currentTarget;t.setAttribute("aria-expanded",t.getAttribute("aria-expanded")=="false"?"true":"false");const i=t.getAttribute("aria-controls");const s=document.querySelector(`#${i}`);const o=()=>{s.classList.remove("expanding");s.removeEventListener("transitionend",o)};const n=()=>{s.classList.add("expanding");s.removeEventListener("transitionstart",n)};s.addEventListener("transitionstart",n);s.addEventListener("transitionend",o);s.classList.toggle("expanded")}))}))}}function N(){document.body.classList.add("is-loaded")}const W={loading:"is-loading"};const R={img:"img.is-loading"};function V(){document.addEventListener("load",(e=>{if(e.target.tagName.toLowerCase()=="img"&&e.target.classList.contains(W.loading)){e.target.classList.remove(W.loading);e.target.parentNode.classList.remove(W.loading);if(e.target.parentNode.parentNode.classList.contains(W.loading)){e.target.parentNode.parentNode.classList.remove(W.loading)}}}),true)}function U(e){e.querySelectorAll(R.img).forEach((e=>{if(e.complete){e.classList.remove(W.loading);e.parentNode.classList.remove(W.loading);if(e.parentNode.parentNode.classList.contains(W.loading)){e.parentNode.parentNode.classList.remove(W.loading)}}}))}function z(e){var t=window.getComputedStyle(e);return t.display!=="none"&&t.visibility!=="hidden"}function j(e,t){t=t||{};var i=e.tabIndex;e.tabIndex=-1;e.dataset.tabIndex=i;e.focus();if(typeof t.className!=="undefined"){e.classList.add(t.className)}e.addEventListener("blur",s);function s(o){o.target.removeEventListener(o.type,s);e.tabIndex=i;delete e.dataset.tabIndex;if(typeof t.className!=="undefined"){e.classList.remove(t.className)}}}function J(e){e=e||{};var t=window.location.hash;var i=document.getElementById(t.slice(1));if(i&&e.ignore&&i.matches(e.ignore)){return false}if(t&&i){j(i,e)}}function X(e){e=e||{};var t=Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]'));function i(e){return document.getElementById(e)!==null}return t.filter((function(t){if(t.hash==="#"||t.hash===""){return false}if(e.ignore&&t.matches(e.ignore)){return false}if(!i(t.hash.substr(1))){return false}var s=document.querySelector(t.hash);if(!s){return false}t.addEventListener("click",(function(){j(s,e)}));return true}))}function G(e){var t=Array.prototype.slice.call(e.querySelectorAll("[tabindex],"+"[draggable],"+"a[href],"+"area,"+"button:enabled,"+"input:not([type=hidden]):enabled,"+"object,"+"select:enabled,"+"textarea:enabled"));return t.filter((function(e){return!!((e.offsetWidth||e.offsetHeight||e.getClientRects().length)&&z(e))}))}var Y={};function Q(e,t){t=t||{};var i=G(e);var s=t.elementToFocus||e;var o=i[0];var n=i[i.length-1];K();Y.focusin=function(t){if(e!==t.target&&!e.contains(t.target)&&o&&o===t.target){o.focus()}if(t.target!==e&&t.target!==n&&t.target!==o)return;document.addEventListener("keydown",Y.keydown)};Y.focusout=function(){document.removeEventListener("keydown",Y.keydown)};Y.keydown=function(t){if(t.code!=="Tab")return;if(t.target===n&&!t.shiftKey){t.preventDefault();o.focus()}if((t.target===e||t.target===o)&&t.shiftKey){t.preventDefault();n.focus()}};document.addEventListener("focusout",Y.focusout);document.addEventListener("focusin",Y.focusin);j(s,t)}function K(){document.removeEventListener("focusin",Y.focusin);document.removeEventListener("focusout",Y.focusout);document.removeEventListener("keydown",Y.keydown)}function Z(){if(window.accessibility.lastElement&&document.body.classList.contains("is-focused")){setTimeout((()=>{window.accessibility.lastElement?.focus()}))}}function ee(e,t){if(typeof e!=="string"){throw new TypeError(e+" is not a String.")}e=document.querySelectorAll(e);if(e.length===0){return}t=t||{};t.messages=t.messages||{};var i={newWindow:t.messages.newWindow||"Opens in a new window.",external:t.messages.external||"Opens external website.",newWindowExternal:t.messages.newWindowExternal||"Opens external website in a new window."};var s=t.prefix||"a11y";var o={newWindow:s+"-new-window-message",external:s+"-external-message",newWindowExternal:s+"-new-window-external-message"};function n(e){var t=document.createElement("ul");var i=Object.keys(e).reduce((function(t,i){return t+="<li id="+o[i]+">"+e[i]+"</li>"}),"");t.setAttribute("hidden",true);t.innerHTML=i;document.body.appendChild(t)}function r(e){return e.hostname!==window.location.hostname}e.forEach((function(e){var t=e.getAttribute("target");var i=e.getAttribute("rel");var s=r(e);var n=t==="_blank";var a=i===null||i.indexOf("noopener")===-1;if(n&&a){var l=i===null?"noopener":i+" noopener";e.setAttribute("rel",l)}if(s&&n){e.setAttribute("aria-describedby",o.newWindowExternal)}else if(s){e.setAttribute("aria-describedby",o.external)}else if(n){e.setAttribute("aria-describedby",o.newWindow)}}));n(i)}var te=Object.freeze({__proto__:null,forceFocus:j,focusHash:J,bindInPageLinks:X,focusable:G,trapFocus:Q,removeTrapFocus:K,autoFocusLastElement:Z,accessibleLinks:ee});const ie={inputSearch:'input[type="search"]',focusedElements:'[aria-selected="true"] a',resetButton:'button[type="reset"]'};const se={hidden:"hidden"};class oe extends HTMLElement{constructor(){super();this.input=this.querySelector(ie.inputSearch);this.resetButton=this.querySelector(ie.resetButton);if(this.input){this.input.form.addEventListener("reset",this.onFormReset.bind(this));this.input.addEventListener("input",f((e=>{this.onChange(e)}),300).bind(this))}}toggleResetButton(){const e=this.resetButton.classList.contains(se.hidden);if(this.input.value.length>0&&e){this.resetButton.classList.remove(se.hidden)}else if(this.input.value.length===0&&!e){this.resetButton.classList.add(se.hidden)}}onChange(){this.toggleResetButton()}shouldResetForm(){return!document.querySelector(ie.focusedElements)}onFormReset(e){e.preventDefault();if(this.shouldResetForm()){this.input.value="";this.toggleResetButton();e.target.querySelector(ie.inputSearch).focus()}}}customElements.define("header-search-form",oe);const ne={allVisibleElements:'[role="option"]',ariaSelected:'[aria-selected="true"]',popularSearches:"[data-popular-searches]",predictiveSearch:"predictive-search",predictiveSearchResults:"[data-predictive-search-results]",predictiveSearchStatus:"[data-predictive-search-status]",searchInput:'input[type="search"]',searchPopdown:"[data-popdown]",searchResultsLiveRegion:"[data-predictive-search-live-region-count-value]",searchResultsGroupsWrapper:"[data-search-results-groups-wrapper]",searchForText:"[data-predictive-search-search-for-text]",sectionPredictiveSearch:"#shopify-section-predictive-search",selectedLink:'[aria-selected="true"] a',selectedOption:'[aria-selected="true"] a, button[aria-selected="true"]'};class re extends oe{constructor(){super();this.a11y=te;this.abortController=new AbortController;this.allPredictiveSearchInstances=document.querySelectorAll(ne.predictiveSearch);this.cachedResults={};this.input=this.querySelector(ne.searchInput);this.isOpen=false;this.predictiveSearchResults=this.querySelector(ne.predictiveSearchResults);this.searchPopdown=this.closest(ne.searchPopdown);this.popularSearches=this.searchPopdown?.querySelector(ne.popularSearches);this.searchTerm=""}connectedCallback(){this.input.addEventListener("focus",this.onFocus.bind(this));this.input.form.addEventListener("submit",this.onFormSubmit.bind(this));this.addEventListener("focusout",this.onFocusOut.bind(this));this.addEventListener("keyup",this.onKeyup.bind(this));this.addEventListener("keydown",this.onKeydown.bind(this))}getQuery(){return this.input.value.trim()}onChange(){super.onChange();const e=this.getQuery();if(!this.searchTerm||!e.startsWith(this.searchTerm)){this.querySelector(ne.searchResultsGroupsWrapper)?.remove()}this.updateSearchForTerm(this.searchTerm,e);this.searchTerm=e;if(!this.searchTerm.length){this.reset();return}this.getSearchResults(this.searchTerm)}onFormSubmit(e){if(!this.getQuery().length||this.querySelector(ne.selectedLink))e.preventDefault()}onFormReset(e){super.onFormReset(e);if(super.shouldResetForm()){this.searchTerm="";this.abortController.abort();this.abortController=new AbortController;this.closeResults(true)}}shouldResetForm(){return!document.querySelector(ne.selectedLink)}onFocus(){const e=this.getQuery();if(!e.length)return;if(this.searchTerm!==e){this.onChange()}else if(this.getAttribute("results")==="true"){this.open()}else{this.getSearchResults(this.searchTerm)}}onFocusOut(){setTimeout((()=>{if(!this.contains(document.activeElement))this.close()}))}onKeyup(e){if(!this.getQuery().length)this.close(true);e.preventDefault();switch(e.code){case"ArrowUp":this.switchOption("up");break;case"ArrowDown":this.switchOption("down");break;case"Enter":this.selectOption();break}}onKeydown(e){if(e.code==="ArrowUp"||e.code==="ArrowDown"){e.preventDefault()}}updateSearchForTerm(e,t){const i=this.querySelector(ne.searchForText);const s=i?.innerText;if(s){if(s.match(new RegExp(e,"g"))?.length>1){return}const o=s.replace(e,t);i.innerText=o}}switchOption(e){if(!this.getAttribute("open"))return;const t=e==="up";const i=this.querySelector(ne.ariaSelected);const s=Array.from(this.querySelectorAll(ne.allVisibleElements)).filter((e=>e.offsetParent!==null));let o=0;if(t&&!i)return;let n=-1;let r=0;while(n===-1&&r<=s.length){if(s[r]===i){n=r}r++}this.statusElement.textContent="";if(!t&&i){o=n===s.length-1?0:n+1}else if(t){o=n===0?s.length-1:n-1}if(o===n)return;const a=s[o];a.setAttribute("aria-selected",true);if(i)i.setAttribute("aria-selected",false);this.input.setAttribute("aria-activedescendant",a.id)}selectOption(){const e=this.querySelector(ne.selectedOption);if(e)e.click()}getSearchResults(e){const t=e.replace(" ","-").toLowerCase();this.setLiveRegionLoadingState();if(this.cachedResults[t]){this.renderSearchResults(this.cachedResults[t]);return}fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(e)}&section_id=predictive-search`,{signal:this.abortController.signal}).then((e=>{if(!e.ok){var t=new Error(e.status);this.close();throw t}return e.text()})).then((e=>{const i=(new DOMParser).parseFromString(e,"text/html").querySelector(ne.sectionPredictiveSearch).innerHTML;this.allPredictiveSearchInstances.forEach((e=>{e.cachedResults[t]=i}));this.renderSearchResults(i)})).catch((e=>{if(e?.code===20){return}this.close();throw e}))}setLiveRegionLoadingState(){this.statusElement=this.statusElement||this.querySelector(ne.predictiveSearchStatus);this.loadingText=this.loadingText||this.getAttribute("data-loading-text");this.setLiveRegionText(this.loadingText);this.setAttribute("loading",true)}setLiveRegionText(e){this.statusElement.setAttribute("aria-hidden","false");this.statusElement.textContent=e;setTimeout((()=>{this.statusElement.setAttribute("aria-hidden","true")}),1e3)}renderSearchResults(e){this.predictiveSearchResults.innerHTML=e;this.setAttribute("results",true);this.setLiveRegionResults();this.open()}setLiveRegionResults(){this.removeAttribute("loading");this.setLiveRegionText(this.querySelector(ne.searchResultsLiveRegion).textContent)}open(){this.setAttribute("open",true);this.input.setAttribute("aria-expanded",true);this.isOpen=true;this.predictiveSearchResults.style.setProperty("--full-screen",`${window.visualViewport.height}px`)}close(e=false){this.closeResults(e);this.isOpen=false;this.predictiveSearchResults.style.removeProperty("--full-screen")}closeResults(e=false){if(e){this.input.value="";this.removeAttribute("results")}const t=this.querySelector(ne.ariaSelected);if(t)t.setAttribute("aria-selected",false);this.input.setAttribute("aria-activedescendant","");this.removeAttribute("loading");this.removeAttribute("open");this.input.setAttribute("aria-expanded",false);this.predictiveSearchResults?.removeAttribute("style")}reset(){this.predictiveSearchResults.innerHTML="";this.input.val="";this.a11y.removeTrapFocus();if(this.popularSearches){this.input.dispatchEvent(new Event("blur",{bubbles:false}));this.a11y.trapFocus(this.searchPopdown,{elementToFocus:this.input})}}}const ae={popoutList:"[data-popout-list]",popoutToggle:"[data-popout-toggle]",popoutToggleText:"[data-popout-toggle-text]",popoutInput:"[data-popout-input]",popoutOptions:"[data-popout-option]",productGridImage:"[data-product-image]",productGridItem:"[data-grid-item]",section:"[data-section-type]"};const le={listVisible:"popout-list--visible",visible:"is-visible",active:"is-active",selectPopoutTop:"select-popout--top"};const ce={ariaExpanded:"aria-expanded",ariaCurrent:"aria-current",dataValue:"data-value",popoutToggleText:"data-popout-toggle-text",submit:"submit"};class de extends HTMLElement{constructor(){super()}connectedCallback(){this.popoutList=this.querySelector(ae.popoutList);this.popoutToggle=this.querySelector(ae.popoutToggle);this.popoutToggleText=this.querySelector(ae.popoutToggleText);this.popoutInput=this.querySelector(ae.popoutInput);this.popoutOptions=this.querySelectorAll(ae.popoutOptions);this.productGridItem=this.popoutList.closest(ae.productGridItem);this.fireSubmitEvent=this.hasAttribute(ce.submit);this.popupToggleFocusoutEvent=e=>this.onPopupToggleFocusout(e);this.popupListFocusoutEvent=e=>this.onPopupListFocusout(e);this.popupToggleClickEvent=e=>this.onPopupToggleClick(e);this.keyUpEvent=e=>this.onKeyUp(e);this.bodyClickEvent=e=>this.onBodyClick(e);this._connectOptions();this._connectToggle();this._onFocusOut();this.popupListMaxWidth()}onPopupToggleClick(e){const t=e.currentTarget;const i=t.getAttribute(ce.ariaExpanded)==="true";if(this.productGridItem){const e=this.productGridItem.querySelector(ae.productGridImage);if(e){e.classList.toggle(le.visible,!i)}this.popoutList.style.maxHeight=`${Math.abs(this.popoutToggle.getBoundingClientRect().bottom-this.productGridItem.getBoundingClientRect().bottom)}px`}e.currentTarget.setAttribute(ce.ariaExpanded,!i);this.popoutList.classList.toggle(le.listVisible);this.popupListMaxWidth();this.toggleListPosition();document.body.addEventListener("click",this.bodyClickEvent)}onPopupToggleFocusout(e){const t=this.contains(e.relatedTarget);if(!t){this._hideList()}}onPopupListFocusout(e){const t=e.currentTarget.contains(e.relatedTarget);const i=this.popoutList.classList.contains(le.listVisible);if(i&&!t){this._hideList()}}toggleListPosition(){const e=this.querySelector(ae.popoutToggle);const t=e.getAttribute(ce.ariaExpanded)==="true";const i=window.innerHeight;const s=this.popoutList.getBoundingClientRect().bottom;const o=()=>{this.classList.remove(le.selectPopoutTop);this.popoutList.removeEventListener("transitionend",o)};if(t){if(i<s){this.classList.add(le.selectPopoutTop)}}else{this.popoutList.addEventListener("transitionend",o)}}popupListMaxWidth(){this.popoutList.style.setProperty("--max-width","100vw");requestAnimationFrame((()=>{this.popoutList.style.setProperty("--max-width",`${parseInt(document.body.clientWidth-this.popoutList.getBoundingClientRect().left)}px`)}))}popupOptionsClick(e){const t=e.target.closest(ae.popoutOptions);if(t.attributes.href.value==="#"){e.preventDefault();const t=e.currentTarget.hasAttribute(ce.dataValue)?e.currentTarget.getAttribute(ce.dataValue):"";this.popoutInput.value=t;if(this.popoutInput.disabled){this.popoutInput.removeAttribute("disabled")}if(this.fireSubmitEvent){this._submitForm(t)}else{const i=e.currentTarget.parentElement;const s=this.popoutList.querySelector(`.${le.active}`);const o=this.popoutList.querySelector(`[${ce.ariaCurrent}]`);this.popoutInput.dispatchEvent(new Event("change"));if(s){s.classList.remove(le.active);i.classList.add(le.active)}if(this.popoutInput.name=="quantity"&&!i.nextSibling){this.classList.add(le.active)}if(o&&o.hasAttribute(`${ce.ariaCurrent}`)){o.removeAttribute(`${ce.ariaCurrent}`);e.currentTarget.setAttribute(`${ce.ariaCurrent}`,"true")}if(t!==""){this.popoutToggleText.innerHTML=t;if(this.popoutToggleText.hasAttribute(ce.popoutToggleText)&&this.popoutToggleText.getAttribute(ce.popoutToggleText)!==""){this.popoutToggleText.setAttribute(ce.popoutToggleText,t)}}this.onPopupToggleFocusout(e);this.onPopupListFocusout(e)}}}onKeyUp(e){if(e.code!=="Escape"){return}this._hideList();this.popoutToggle.focus()}onBodyClick(e){const t=this.contains(e.target);const i=this.popoutList.classList.contains(le.listVisible);if(i&&!t){this._hideList()}}_connectToggle(){this.popoutToggle.addEventListener("click",this.popupToggleClickEvent)}_connectOptions(){if(this.popoutOptions.length){this.popoutOptions.forEach((e=>{e.addEventListener("click",(e=>this.popupOptionsClick(e)))}))}}_onFocusOut(){this.addEventListener("keyup",this.keyUpEvent);this.popoutToggle.addEventListener("focusout",this.popupToggleFocusoutEvent);this.popoutList.addEventListener("focusout",this.popupListFocusoutEvent)}_submitForm(){const e=this.closest("form");if(e){e.submit()}}_hideList(){this.popoutList.classList.remove(le.listVisible);this.popoutToggle.setAttribute(ce.ariaExpanded,false);this.toggleListPosition();document.body.removeEventListener("click",this.bodyClickEvent)}}class he extends HTMLElement{constructor(){super()}connectedCallback(){this.input=this.querySelector("input");this.changeEvent=new Event("change",{bubbles:true});this.buttonClickEvent=this.onButtonClick.bind(this);this.onQuantityChangeEvent=this.onQuantityChange.bind(this);this.input.addEventListener("change",this.onQuantityChangeEvent);this.querySelectorAll("button").forEach((e=>e.addEventListener("click",this.buttonClickEvent)))}onButtonClick(e){e.preventDefault();const t=this.input.value;const i=e.target.nodeName=="BUTTON"?e.target:e.target.closest("button");if(i.name==="increase")this.input.stepUp();if(i.name==="decrease")this.input.stepDown();if(t!==this.input.value)this.input.dispatchEvent(this.changeEvent)}onQuantityChange(){if(this.input.name=="updates[]"){this.updateCart()}}updateCart(){if(this.quantityValue==="")return;this.dispatchEvent(new CustomEvent("theme:cart:update",{bubbles:true,detail:{id:this.input.dataset.id,quantity:this.input.value}}))}}const ue={aos:"[data-aos]:not(.aos-animate)",aosAnchor:"[data-aos-anchor]",aosIndividual:"[data-aos]:not([data-aos-anchor]):not(.aos-animate)"};const pe={aosAnimate:"aos-animate"};const me={attributes:false,childList:true,subtree:true};let fe=[];const ge=e=>{for(const t of e){if(t.type==="childList"){const e=t.target;const i=e.querySelectorAll(ue.aos);const s=e.querySelectorAll(ue.aosAnchor);if(i.length){i.forEach((e=>{ve.observe(e)}))}if(s.length){Ee(s)}}}};const ve=new IntersectionObserver(((e,t)=>{e.forEach((e=>{if(e.isIntersecting){e.target.classList.add(pe.aosAnimate);t.unobserve(e.target)}}))}),{root:null,rootMargin:"0px",threshold:[0,.1,.25,.5,.75,1]});const be=new IntersectionObserver(((e,t)=>{e.forEach((e=>{if(e.intersectionRatio){const i=e.target.querySelectorAll(ue.aos);if(i.length){i.forEach((e=>{e.classList.add(pe.aosAnimate)}))}t.unobserve(e.target)}}))}),{root:null,rootMargin:"0px",threshold:[.1,.25,.5,.75,1]});function ye(){const e=new MutationObserver(ge);e.observe(document.body,me)}function we(){const e=document.querySelectorAll(ue.aosIndividual);if(e.length){e.forEach((e=>{ve.observe(e)}))}}function Se(){const e=document.querySelectorAll(ue.aosAnchor);if(e.length){Ee(e)}}function Ee(e){if(!e.length)return;e.forEach((e=>{const t=e.dataset.aosAnchor;if(t&&fe.indexOf(t)===-1){const e=document.querySelector(t);if(e){be.observe(e);fe.push(t)}}}))}function Le(){we();Se();ye();document.addEventListener("shopify:section:unload",(e=>{const t="#"+e.target.querySelector("[data-section-id]")?.id;const i=fe.indexOf(t);if(i!==-1){fe.splice(i,1)}}))}const ke={deferredMediaButton:"[data-deferred-media-button]",media:"video, model-viewer, iframe",youtube:'[data-host="youtube"]',vimeo:'[data-host="vimeo"]',productGridItem:"[data-grid-item]",section:".shopify-section",template:"template",video:"video",productModel:"product-model"};const Ae={loaded:"loaded",autoplay:"autoplay"};class Ce extends HTMLElement{constructor(){super();const e=this.querySelector(ke.deferredMediaButton);e?.addEventListener("click",this.loadContent.bind(this));this.section=this.closest(ke.section);this.productGridItem=this.closest(ke.productGridItem);this.hovered=false;this.mouseEnterEvent=()=>this.mouseEnterActions();this.mouseLeaveEvent=()=>this.mouseLeaveActions()}connectedCallback(){if(this.productGridItem){this.section.addEventListener("mouseover",this.mouseOverEvent,{once:true});this.addEventListener("mouseenter",this.mouseEnterEvent);this.addEventListener("mouseleave",this.mouseLeaveEvent)}}disconnectedCallback(){if(this.productGridItem){this.section.removeEventListener("mouseover",this.mouseOverEvent,{once:true});this.removeEventListener("mouseenter",this.mouseEnterEvent);this.removeEventListener("mouseleave",this.mouseLeaveEvent)}}mouseEnterActions(){this.hovered=true;this.videoActions();if(!this.getAttribute(Ae.loaded)){this.loadContent()}}mouseLeaveActions(){this.hovered=false;this.videoActions()}videoActions(){if(this.getAttribute(Ae.loaded)){const e=this.querySelector(ke.youtube);const t=this.querySelector(ke.vimeo);const i=e||t;const s=this.querySelector(ke.video);if(i){let e=this.hovered?"playVideo":"pauseVideo";let s=`{"event":"command","func":"${e}","args":""}`;if(t){e=this.hovered?"play":"pause";s=`{"method":"${e}"}`}i.contentWindow.postMessage(s,"*");i.addEventListener("load",(e=>{this.videoActions()}))}else if(s){if(this.hovered){s.play()}else{s.pause()}}}}loadContent(e=true){this.pauseAllMedia();if(!this.getAttribute(Ae.loaded)){const t=document.createElement("div");const i=this.querySelector(ke.template).content.firstElementChild.cloneNode(true);t.appendChild(i);this.setAttribute(Ae.loaded,true);const s=this.appendChild(t.querySelector(ke.media));if(e)s.focus();if(s.nodeName=="VIDEO"&&s.getAttribute(Ae.autoplay)){s.play()}if(this.productGridItem){this.videoActions()}}}pauseAllMedia(){document.querySelectorAll(ke.youtube).forEach((e=>{e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}',"*")}));document.querySelectorAll(ke.vimeo).forEach((e=>{e.contentWindow.postMessage('{"method":"pause"}',"*")}));document.querySelectorAll(ke.video).forEach((e=>e.pause()));document.querySelectorAll(ke.productModel).forEach((e=>{if(e.modelViewerUI)e.modelViewerUI.pause()}))}}const Te={visible:"is-visible"};class qe{constructor(e,t){if(!e||!t)return;this.observer=null;this.container=e;this.itemSelector=t;this.init()}init(){const e={root:this.container,threshold:[.01,.5,.75,.99]};this.observer=new IntersectionObserver((e=>{e.forEach((e=>{if(e.intersectionRatio>=.99){e.target.classList.add(Te.visible)}else{e.target.classList.remove(Te.visible)}}))}),e);this.container.querySelectorAll(this.itemSelector)?.forEach((e=>{this.observer.observe(e)}))}destroy(){this.observer.disconnect()}}const Ie={dragging:"is-dragging",enabled:"is-enabled",scrolling:"is-scrolling",visible:"is-visible"};const Pe={image:"img, svg",productImage:"[data-product-image]",slide:"[data-grid-item]",slider:"[data-grid-slider]"};class xe{constructor(e){this.slider=e;this.isDown=false;this.startX=0;this.scrollLeft=0;this.velX=0;this.scrollAnimation=null;this.isScrolling=false;this.duration=800;this.scrollStep=this.scrollStep.bind(this);this.scrollToSlide=this.scrollToSlide.bind(this);this.handleMouseDown=this.handleMouseDown.bind(this);this.handleMouseLeave=this.handleMouseLeave.bind(this);this.handleMouseUp=this.handleMouseUp.bind(this);this.handleMouseMove=this.handleMouseMove.bind(this);this.handleMouseWheel=this.handleMouseWheel.bind(this);this.slider.addEventListener("mousedown",this.handleMouseDown);this.slider.addEventListener("mouseleave",this.handleMouseLeave);this.slider.addEventListener("mouseup",this.handleMouseUp);this.slider.addEventListener("mousemove",this.handleMouseMove);this.slider.addEventListener("wheel",this.handleMouseWheel,{passive:true});this.slider.classList.add(Ie.enabled)}handleMouseDown(e){e.preventDefault();this.isDown=true;this.startX=e.pageX-this.slider.offsetLeft;this.scrollLeft=this.slider.scrollLeft;this.cancelMomentumTracking()}handleMouseLeave(){if(!this.isDown)return;this.isDown=false;this.beginMomentumTracking()}handleMouseUp(){this.isDown=false;this.beginMomentumTracking()}handleMouseMove(e){if(!this.isDown)return;e.preventDefault();const t=e.pageX-this.slider.offsetLeft;const i=1;const s=(t-this.startX)*i;const o=this.slider.scrollLeft;const n=s>0?1:-1;this.slider.classList.add(Ie.dragging,Ie.scrolling);this.slider.scrollLeft=this.scrollLeft-s;if(this.slider.scrollLeft!==o){this.velX=this.slider.scrollLeft-o||n}}handleMouseWheel(){this.cancelMomentumTracking();this.slider.classList.remove(Ie.scrolling)}beginMomentumTracking(){this.isScrolling=false;this.slider.classList.remove(Ie.dragging);this.cancelMomentumTracking();this.scrollToSlide()}cancelMomentumTracking(){cancelAnimationFrame(this.scrollAnimation)}scrollToSlide(){if(!this.velX&&!this.isScrolling)return;const e=this.slider.querySelector(`${Pe.slide}.${Ie.visible}`);if(!e)return;const t=parseInt(window.getComputedStyle(e).marginRight)||0;const i=e.offsetWidth+t;const s=e.offsetLeft;const o=this.velX>0?1:-1;const n=Math.floor(Math.abs(this.velX)/100)||1;this.startPosition=this.slider.scrollLeft;this.distance=s-this.startPosition;this.startTime=performance.now();this.isScrolling=true;if(o<0&&this.velX<i){this.distance-=i*n}if(o>0&&this.velX<i){this.distance+=i*n}this.scrollAnimation=requestAnimationFrame(this.scrollStep)}scrollStep(){const e=performance.now()-this.startTime;const t=parseFloat(this.easeOutCubic(Math.min(e,this.duration))).toFixed(1);this.slider.scrollLeft=t;if(e<this.duration){this.scrollAnimation=requestAnimationFrame(this.scrollStep)}else{this.slider.classList.remove(Ie.scrolling);this.velX=0;this.isScrolling=false}}easeOutCubic(e){e/=this.duration;e--;return this.distance*(e*e*e+1)+this.startPosition}destroy(){this.slider.classList.remove(Ie.enabled);this.slider.removeEventListener("mousedown",this.handleMouseDown);this.slider.removeEventListener("mouseleave",this.handleMouseLeave);this.slider.removeEventListener("mouseup",this.handleMouseUp);this.slider.removeEventListener("mousemove",this.handleMouseMove);this.slider.removeEventListener("wheel",this.handleMouseWheel)}}function Me(e){return new Promise((t=>{const i=e.querySelectorAll("[data-aos]");let s=0;function o(e){s++;if(s===i.length){t()}e.target.removeEventListener("animationend",o)}i.forEach((e=>{e.addEventListener("animationend",o)}))}))}const He={buttonArrow:"[data-button-arrow]",collectionImage:"[data-collection-image]",columnImage:"[data-column-image]",productImage:"[data-product-image]",slide:"[data-grid-item]",slider:"[data-grid-slider]"};const Oe={buttonPrev:"data-button-prev",buttonNext:"data-button-next",alignArrows:"align-arrows"};const Be={arrows:"slider__arrows",visible:"is-visible",scrollSnapDisabled:"scroll-snap-disabled"};class De extends HTMLElement{constructor(){super();this.isInitialized=false;this.draggableSlider=null;this.positionArrows=this.positionArrows.bind(this);this.onButtonArrowClick=e=>this.buttonArrowClickEvent(e);this.slidesObserver=null;this.firstLastSlidesObserver=null;this.isDragging=false;this.toggleSlider=this.toggleSlider.bind(this)}connectedCallback(){this.init();this.addEventListener("theme:grid-slider:init",this.init)}init(){this.slider=this.querySelector(He.slider);this.slides=this.querySelectorAll(He.slide);this.buttons=this.querySelectorAll(He.buttonArrow);this.slider.classList.add(Be.scrollSnapDisabled);this.toggleSlider();document.addEventListener("theme:resize:width",this.toggleSlider);Me(this).then((()=>{this.slider.classList.remove(Be.scrollSnapDisabled)}))}toggleSlider(){const e=this.slider.clientWidth;const t=this.getSlidesWidth();const i=e<t;if(i&&(b()||!window.theme.touch)){if(this.isInitialized)return;this.slidesObserver=new qe(this.slider,He.slide);this.initArrows();this.isInitialized=true;this.draggableSlider=new xe(this.slider)}else{this.destroy()}}initArrows(){if(!this.buttons.length){const e=document.createElement("div");e.classList.add(Be.arrows);e.innerHTML=theme.sliderArrows.prev+theme.sliderArrows.next;this.append(e);this.buttons=this.querySelectorAll(He.buttonArrow);this.buttonPrev=this.querySelector(`[${Oe.buttonPrev}]`);this.buttonNext=this.querySelector(`[${Oe.buttonNext}]`)}this.toggleArrowsObserver();if(this.hasAttribute(Oe.alignArrows)){this.positionArrows();this.arrowsResizeObserver()}this.buttons.forEach((e=>{e.addEventListener("click",this.onButtonArrowClick)}))}buttonArrowClickEvent(e){e.preventDefault();const t=this.slider.querySelector(`${He.slide}.${Be.visible}`);let i=null;if(e.target.hasAttribute(Oe.buttonPrev)){i=t?.previousElementSibling}if(e.target.hasAttribute(Oe.buttonNext)){i=t?.nextElementSibling}this.goToSlide(i)}removeArrows(){this.querySelector(`.${Be.arrows}`)?.remove()}goToSlide(e){if(!e)return;this.slider.scrollTo({top:0,left:e.offsetLeft,behavior:"smooth"})}getSlidesWidth(){return this.slider.querySelector(He.slide)?.clientWidth*this.slider.querySelectorAll(He.slide).length}toggleArrowsObserver(){if(this.buttonPrev&&this.buttonNext){const e=this.slides.length;const t=this.slides[0];const i=this.slides[e-1];const s={attributes:true,childList:false,subtree:false};const o=e=>{for(const s of e){if(s.type==="attributes"){const e=s.target;const o=Boolean(e.classList.contains(Be.visible));if(e==t){this.buttonPrev.disabled=o}if(e==i){this.buttonNext.disabled=o}}}};if(t&&i){this.firstLastSlidesObserver=new MutationObserver(o);this.firstLastSlidesObserver.observe(t,s);this.firstLastSlidesObserver.observe(i,s)}}}positionArrows(){const e=this.slider.querySelector(He.productImage)||this.slider.querySelector(He.collectionImage)||this.slider.querySelector(He.columnImage)||this.slider;if(!e)return;this.style.setProperty("--button-position",`${e.clientHeight/2}px`)}arrowsResizeObserver(){document.addEventListener("theme:resize:width",this.positionArrows)}disconnectedCallback(){this.destroy();document.removeEventListener("theme:resize:width",this.toggleSlider)}destroy(){this.isInitialized=false;this.draggableSlider?.destroy();this.draggableSlider=null;this.slidesObserver?.destroy();this.slidesObserver=null;this.removeArrows();document.removeEventListener("theme:resize:width",this.positionArrows)}}const Fe={time:"time",days:"[data-days]",hours:"[data-hours]",minutes:"[data-minutes]",seconds:"[data-seconds]",shopifySection:".shopify-section",countdownBlock:"[data-countdown-block]",tickerText:"[data-ticker-text]"};const _e={expirationBehavior:"data-expiration-behavior",clone:"data-clone"};const $e={showMessage:"show-message",hideCountdown:"hidden"};const Ne={hideSection:"hide-section",showMessage:"show-message"};class We extends HTMLElement{constructor(){super();this.section=this.closest(Fe.shopifySection);this.countdownParent=this.closest(Fe.countdownBlock)||this.section;this.expirationBehavior=this.getAttribute(_e.expirationBehavior);this.time=this.querySelector(Fe.time);this.days=this.querySelector(Fe.days);this.hours=this.querySelector(Fe.hours);this.minutes=this.querySelector(Fe.minutes);this.seconds=this.querySelector(Fe.seconds);this.endDate=Date.parse(this.time.dateTime);this.daysInMs=1e3*60*60*24;this.hoursInMs=this.daysInMs/24;this.minutesInMs=this.hoursInMs/60;this.secondsInMs=this.minutesInMs/60;this.shouldHideOnComplete=this.expirationBehavior===Ne.hideSection;this.shouldShowMessage=this.expirationBehavior===Ne.showMessage;this.update=this.update.bind(this)}connectedCallback(){if(isNaN(this.endDate)){this.onComplete();return}if(this.endDate<=Date.now()){this.onComplete();return}this.update();this.interval=setInterval(this.update,1e3)}disconnectedCallback(){this.stopTimer()}convertTime(e){const t=this.formatDigits(parseInt(e/this.daysInMs,10));e-=t*this.daysInMs;const i=this.formatDigits(parseInt(e/this.hoursInMs,10));e-=i*this.hoursInMs;const s=this.formatDigits(parseInt(e/this.minutesInMs,10));e-=s*this.minutesInMs;const o=this.formatDigits(parseInt(e/this.secondsInMs,10));return{days:t,hours:i,minutes:s,seconds:o}}formatDigits(e){if(e<10)e="0"+e;return e}render(e){this.days.textContent=e.days;this.hours.textContent=e.hours;this.minutes.textContent=e.minutes;this.seconds.textContent=e.seconds}stopTimer(){clearInterval(this.interval)}onComplete(){this.render({days:0,hours:0,minutes:0,seconds:0});if(this.shouldHideOnComplete){this.countdownParent?.classList.add($e.hideCountdown);this.countdownParent?.dispatchEvent(new CustomEvent("theme:countdown:hide",{detail:{element:this},bubbles:true}))}if(this.shouldShowMessage){this.classList?.add($e.showMessage);if(this.closest(Fe.tickerText).hasAttribute(_e.clone))return;this.countdownParent?.dispatchEvent(new CustomEvent("theme:countdown:expire",{bubbles:true}))}}update(){const e=(new Date).getTime();const t=this.endDate-e;if(t<1e3){this.stopTimer();this.onComplete()}const i=this.convertTime(t);this.render(i)}}window.requestIdleCallback=window.requestIdleCallback||function(e){var t=Date.now();return setTimeout((function(){e({didTimeout:false,timeRemaining:function(){return Math.max(0,50-(Date.now()-t))}})}),1)};window.cancelIdleCallback=window.cancelIdleCallback||function(e){clearTimeout(e)};if(window.theme.settings.enableAnimations){Le()}L();O();_();d();V();window.addEventListener("DOMContentLoaded",(()=>{c();$(document);r(document);D(document);U(document);N();n();requestIdleCallback((()=>{if(Shopify.visualPreviewMode){document.documentElement.classList.add("preview-mode")}}))}));document.addEventListener("shopify:section:load",(e=>{const t=e.target;r(t);D(t);$(document);c()}));if(!customElements.get("popout-select")){customElements.define("popout-select",de)}if(!customElements.get("quantity-counter")){customElements.define("quantity-counter",he)}if(!customElements.get("predictive-search")){customElements.define("predictive-search",re)}if(!customElements.get("deferred-media")){customElements.define("deferred-media",Ce)}if(!customElements.get("grid-slider")){customElements.define("grid-slider",De)}if(!customElements.get("countdown-timer")){customElements.define("countdown-timer",We)}const Re=(e,t=false,i="block")=>{if(e){if(t){e.style.removeProperty("display")}else{e.style.display=i}}};Shopify.Products=function(){const e={howManyToShow:4,howManyToStoreInMemory:10,wrapperId:"recently-viewed-products",section:null,target:"api-product-grid-item",onComplete:null};let t=[];let i=null;let s=null;const o=new Date;const n=new Date;const r=90;n.setTime(o.getTime()+36e5*24*r);const a={configuration:{expires:n.toGMTString(),path:"/",domain:window.location.hostname,sameSite:"none",secure:true},name:"shopify_recently_viewed",write:function(e){const t=encodeURIComponent(e.join(" "));document.cookie=`${this.name}=${t}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`},read:function(){let e=[];let t=null;if(document.cookie.indexOf("; ")!==-1&&document.cookie.split("; ").find((e=>e.startsWith(this.name)))){t=document.cookie.split("; ").find((e=>e.startsWith(this.name))).split("=")[1]}if(t!==null){e=decodeURIComponent(t).split(" ")}return e},destroy:function(){const e=null;document.cookie=`${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`},remove:function(e){const t=this.read();const i=t.indexOf(e);if(i!==-1){t.splice(i,1);this.write(t)}}};const l=(t,i)=>{Re(t,true);const o=a.read().length;if(Shopify.recentlyViewed&&s&&o&&o<s&&t.children.length){let e=[];let i=[];let s=0;for(const t in Shopify.recentlyViewed){s+=1;const o=Shopify.recentlyViewed[t];const n=o.split(" ");const r=parseInt(t.split("_")[1]);e=[...e,...n];if(a.read().length===r||s===Object.keys(Shopify.recentlyViewed).length&&!i.length){i=[...i,...n]}}for(let s=0;s<t.children.length;s++){const o=t.children[s];if(e.length){o.classList.remove(...e)}if(i.length){o.classList.add(...i)}}}if(e.onComplete){try{e.onComplete(t,i)}catch(e){console.log(e)}}};const c=(e,t,i,s,o,n)=>{if(t.length&&e<n){fetch(`${window.theme.routes.root}products/${t[0]}?section_id=${o}`).then((e=>e.text())).then((r=>{const a=e*100;const l=i.id?`#${i.id}`:"";const d=document.createElement("div");let h=r;h=h.includes("||itemAnimationDelay||")?h.replaceAll("||itemAnimationDelay||",a):h;h=h.includes("||itemAnimationAnchor||")?h.replaceAll("||itemAnimationAnchor||",l):h;d.innerHTML=h;i.innerHTML+=d.querySelector("[data-api-content]").innerHTML;t.shift();e++;c(e,t,i,s,o,n)})).catch((()=>{a.remove(t[0]);t.shift();c(e,t,i,s,o,n)}))}else{l(i,s)}};return{showRecentlyViewed:function(o){const n=o||{};const r=0;Object.assign(e,n);t=a.read();i=document.querySelector(`#${e.wrapperId}`);s=e.howManyToShow;e.howManyToShow=Math.min(t.length,e.howManyToShow);if(e.howManyToShow&&i){c(r,t,i,e.section,e.target,s)}},getConfig:function(){return e},clearList:function(){a.destroy()},recordRecentlyViewed:function(t){const i=t||{};Object.assign(e,i);let s=a.read();if(window.location.pathname.indexOf("/products/")!==-1){let t=decodeURIComponent(window.location.pathname).match(/\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/)[0].split("/products/")[1];if(e.handle){t=e.handle}const i=s.indexOf(t);if(i===-1){s.unshift(t);s=s.splice(0,e.howManyToStoreInMemory)}else{s.splice(i,1);s.unshift(t)}a.write(s)}},hasProducts:a.read().length>0}}();const Ve={focus:"is-focused"};const Ue={inPageLink:"[data-skip-content]",linkesWithOnlyHash:'a[href="#"]'};class ze{constructor(){this.init()}init(){this.a11y=te;this.html=document.documentElement;this.body=document.body;this.inPageLink=document.querySelector(Ue.inPageLink);this.linkesWithOnlyHash=document.querySelectorAll(Ue.linkesWithOnlyHash);this.a11y.focusHash();this.a11y.bindInPageLinks();this.clickEvents();this.focusEvents()}clickEvents(){if(this.inPageLink){this.inPageLink.addEventListener("click",(e=>{e.preventDefault()}))}if(this.linkesWithOnlyHash){this.linkesWithOnlyHash.forEach((e=>{e.addEventListener("click",(e=>{e.preventDefault()}))}))}}focusEvents(){document.addEventListener("mousedown",(()=>{this.body.classList.remove(Ve.focus)}));document.addEventListener("keyup",(e=>{if(e.code!=="Tab"){return}this.body.classList.add(Ve.focus)}))}}window.accessibility=new ze;const je="${{amount}}";function Je(e,t){if(typeof e==="string"){e=e.replace(".","")}let i="";const s=/\{\{\s*(\w+)\s*\}\}/;const o=t||je;function n(e,t=2,i=",",s="."){if(isNaN(e)||e==null){return 0}e=(e/100).toFixed(t);const o=e.split(".");const n=o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,`$1${i}`);const r=o[1]?s+o[1]:"";return n+r}switch(o.match(s)[1]){case"amount":i=n(e,2);break;case"amount_no_decimals":i=n(e,0);break;case"amount_with_comma_separator":i=n(e,2,".",",");break;case"amount_no_decimals_with_comma_separator":i=n(e,0,".",",");break;case"amount_with_apostrophe_separator":i=n(e,2,"'",".");break;case"amount_no_decimals_with_space_separator":i=n(e,0," ","");break;case"amount_with_space_separator":i=n(e,2," ",",");break;case"amount_with_period_and_space_separator":i=n(e,2," ",".");break}return o.replace(s,i)}const Xe=(e,t)=>{let i,s;return function o(...n){const r=Date.now();s=clearTimeout(s);if(!i||r-i>=t){e.apply(null,n);i=r}else{s=setTimeout(o.bind(null,...n),t-(r-i))}}};function Ge(e){this.status=e.status||null;this.headers=e.headers||null;this.json=e.json||null;this.body=e.body||null}Ge.prototype=Error.prototype;const Ye={animated:"is-animated",active:"is-active",added:"is-added",disabled:"is-disabled",empty:"is-empty",error:"has-error",headerStuck:"js__header__stuck",hidden:"is-hidden",hiding:"is-hiding",loading:"is-loading",open:"is-open",removed:"is-removed",success:"is-success",visible:"is-visible",expanded:"is-expanded",updated:"is-updated",variantSoldOut:"variant--soldout",variantUnavailable:"variant--unavailable"};const Qe={apiContent:"[data-api-content]",apiLineItems:"[data-api-line-items]",apiUpsellItems:"[data-api-upsell-items]",apiCartPrice:"[data-api-cart-price]",animation:"[data-animation]",additionalCheckoutButtons:".additional-checkout-buttons",buttonSkipUpsellProduct:"[data-skip-upsell-product]",cartBarAdd:"[data-add-to-cart-bar]",cartCloseError:"[data-cart-error-close]",cartDrawer:"cart-drawer",cartDrawerClose:"[data-cart-drawer-close]",cartEmpty:"[data-cart-empty]",cartErrors:"[data-cart-errors]",cartItemRemove:"[data-item-remove]",cartPage:"[data-cart-page]",cartForm:"[data-cart-form]",cartTermsCheckbox:"[data-cart-acceptance-checkbox]",cartCheckoutButtonWrapper:"[data-cart-checkout-buttons]",cartCheckoutButton:"[data-cart-checkout-button]",cartTotal:"[data-cart-total]",checkoutButtons:"[data-checkout-buttons]",errorMessage:"[data-error-message]",formCloseError:"[data-close-error]",formErrorsContainer:"[data-cart-errors-container]",formWrapper:"[data-form-wrapper]",freeShipping:"[data-free-shipping]",freeShippingGraph:"[data-progress-graph]",freeShippingProgress:"[data-progress-bar]",headerWrapper:"[data-header-wrapper]",item:"[data-item]",itemsHolder:"[data-items-holder]",leftToSpend:"[data-left-to-spend]",navDrawer:"[data-drawer]",outerSection:"[data-section-id]",priceHolder:"[data-cart-price-holder]",quickAddHolder:"[data-quick-add-holder]",quickAddModal:"[data-quick-add-modal]",qtyInput:'input[name="updates[]"]',upsellProductsHolder:"[data-upsell-products]",upsellWidget:"[data-upsell-widget]",termsErrorMessage:"[data-terms-error-message]",collapsibleBody:"[data-collapsible-body]",recentlyViewedHolderId:"recently-viewed-products-cart"};const Ke={cartTotal:"data-cart-total",disabled:"disabled",freeShipping:"data-free-shipping",freeShippingLimit:"data-free-shipping-limit",item:"data-item",itemIndex:"data-item-index",itemTitle:"data-item-title",open:"open",quickAddHolder:"data-quick-add-holder",quickAddVariant:"data-quick-add-variant",scrollLocked:"data-scroll-locked",upsellAutoOpen:"data-upsell-auto-open"};class Ze extends HTMLElement{constructor(){super()}connectedCallback(){this.cartPage=document.querySelector(Qe.cartPage);this.cartForm=document.querySelector(Qe.cartForm);this.cartDrawer=document.querySelector(Qe.cartDrawer);this.cartEmpty=document.querySelector(Qe.cartEmpty);this.cartTermsCheckbox=document.querySelector(Qe.cartTermsCheckbox);this.cartCheckoutButtonWrapper=document.querySelector(Qe.cartCheckoutButtonWrapper);this.cartCheckoutButton=document.querySelector(Qe.cartCheckoutButton);this.checkoutButtons=document.querySelector(Qe.checkoutButtons);this.itemsHolder=document.querySelector(Qe.itemsHolder);this.priceHolder=document.querySelector(Qe.priceHolder);this.items=document.querySelectorAll(Qe.item);this.cartTotal=document.querySelector(Qe.cartTotal);this.freeShipping=document.querySelectorAll(Qe.freeShipping);this.cartErrorHolder=document.querySelector(Qe.cartErrors);this.cartCloseErrorMessage=document.querySelector(Qe.cartCloseError);this.headerWrapper=document.querySelector(Qe.headerWrapper);this.navDrawer=document.querySelector(Qe.navDrawer);this.upsellProductsHolder=document.querySelector(Qe.upsellProductsHolder);this.subtotal=window.theme.subtotal;this.cart=this.cartDrawer||this.cartPage;this.animateItems=this.animateItems.bind(this);this.addToCart=this.addToCart.bind(this);this.cartAddEvent=this.cartAddEvent.bind(this);this.updateProgress=this.updateProgress.bind(this);this.onCartDrawerClose=this.onCartDrawerClose.bind(this);document.addEventListener("theme:cart:add",this.cartAddEvent);document.addEventListener("theme:announcement:init",this.updateProgress);if(theme.settings.cartType=="drawer"){document.addEventListener("theme:cart-drawer:open",this.animateItems);document.addEventListener("theme:cart-drawer:close",this.onCartDrawerClose)}this.skipUpsellProductsArray=[];this.skipUpsellProductEvent();this.checkSkippedUpsellProductsFromStorage();this.toggleCartUpsellWidgetVisibility();this.circumference=28*Math.PI;this.freeShippingLimit=this.freeShipping.length?Number(this.freeShipping[0].getAttribute(Ke.freeShippingLimit))*100*window.Shopify.currency.rate:0;this.freeShippingMessageHandle(this.subtotal);this.updateProgress();this.build=this.build.bind(this);this.updateCart=this.updateCart.bind(this);this.productAddCallback=this.productAddCallback.bind(this);this.formSubmitHandler=Xe(this.formSubmitHandler.bind(this),50);if(this.cartPage){this.animateItems()}if(this.cart){this.recentlyViewedProducts();this.hasItemsInCart=this.hasItemsInCart.bind(this);this.cartCount=this.getCartItemCount()}this.toggleClassesOnContainers=this.toggleClassesOnContainers.bind(this);this.totalItems=this.items.length;this.cartUpdateFailed=false;this.cartEvents();this.cartRemoveEvents();this.cartUpdateEvents();document.addEventListener("theme:product:add",this.productAddCallback);document.addEventListener("theme:product:add-error",this.productAddCallback);document.dispatchEvent(new CustomEvent("theme:cart:load",{bubbles:true}))}disconnectedCallback(){document.removeEventListener("theme:cart:add",this.cartAddEvent);document.removeEventListener("theme:announcement:init",this.updateProgress);document.removeEventListener("theme:product:add",this.productAddCallback);document.removeEventListener("theme:product:add-error",this.productAddCallback);document.dispatchEvent(new CustomEvent("theme:cart:unload",{bubbles:true}));if(document.documentElement.hasAttribute(Ke.scrollLocked)){document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{bubbles:true}))}}onCartDrawerClose(){this.resetAnimatedItems();if(this.cartDrawer?.classList.contains(Ye.open)){this.cart.classList.remove(Ye.updated)}this.cartEmpty.classList.remove(Ye.updated);this.cartErrorHolder.classList.remove(Ye.expanded);this.cart.querySelectorAll(Qe.animation).forEach((e=>{const t=()=>{e.classList.remove(Ye.hiding);e.removeEventListener("animationend",t)};e.classList.add(Ye.hiding);e.addEventListener("animationend",t)}))}cartUpdateEvents(){this.items=document.querySelectorAll(Qe.item);this.items.forEach((e=>{e.addEventListener("theme:cart:update",(t=>{this.updateCart({id:t.detail.id,quantity:t.detail.quantity},e)}))}))}cartRemoveEvents(){const e=document.querySelectorAll(Qe.cartItemRemove);e.forEach((e=>{const t=e.closest(Qe.item);e.addEventListener("click",(i=>{i.preventDefault();if(e.classList.contains(Ye.disabled))return;this.updateCart({id:e.dataset.id,quantity:0},t)}))}));if(this.cartCloseErrorMessage){this.cartCloseErrorMessage.addEventListener("click",(e=>{e.preventDefault();this.cartErrorHolder.classList.remove(Ye.expanded)}))}}cartAddEvent(e){let t="";let i=e.detail.button;if(i.hasAttribute("disabled"))return;const s=i.closest("form");if(!s.checkValidity()){s.reportValidity();return}t=new FormData(s);if(s!==null&&s.querySelector('[type="file"]')){return}if(theme.settings.cartType==="drawer"&&this.cartDrawer){e.preventDefault()}this.addToCart(t,i)}cartEvents(){if(this.cartTermsCheckbox){this.cartTermsCheckbox.removeEventListener("change",this.formSubmitHandler);this.cartCheckoutButtonWrapper.removeEventListener("click",this.formSubmitHandler);this.cartForm.removeEventListener("submit",this.formSubmitHandler);this.cartTermsCheckbox.addEventListener("change",this.formSubmitHandler);this.cartCheckoutButtonWrapper.addEventListener("click",this.formSubmitHandler);this.cartForm.addEventListener("submit",this.formSubmitHandler)}}formSubmitHandler(){const e=document.querySelector(Qe.cartTermsCheckbox).checked;const t=document.querySelector(Qe.termsErrorMessage);if(!e){if(document.querySelector(Qe.termsErrorMessage).length>0){return}t.innerText=theme.strings.cartAcceptanceError;this.cartCheckoutButton.setAttribute(Ke.disabled,true);t.classList.add(Ye.expanded)}else{t.classList.remove(Ye.expanded);this.cartCheckoutButton.removeAttribute(Ke.disabled)}}formErrorsEvents(e){const t=e.querySelector(Qe.formCloseError);t?.addEventListener("click",(t=>{t.preventDefault();if(e){e.classList.remove(Ye.visible)}}))}getCart(){fetch(theme.routes.cart_url+"?section_id=api-cart-items").then(this.cartErrorsHandler).then((e=>e.text())).then((e=>{const t=document.createElement("div");t.innerHTML=e;const i=t.querySelector(Qe.apiContent);this.build(i)})).catch((e=>console.log(e)))}addToCart(e,t){if(this.cart){this.cart.classList.add(Ye.loading)}const i=t?.closest(Qe.quickAddHolder);if(t){t.classList.add(Ye.loading);t.disabled=true}if(i){i.classList.add(Ye.visible)}fetch(theme.routes.cart_add_url,{method:"POST",headers:{"X-Requested-With":"XMLHttpRequest",Accept:"application/javascript"},body:e}).then((e=>e.json())).then((e=>{if(e.status){this.addToCartError(e,t);if(t){t.classList.remove(Ye.loading);t.disabled=false}return}if(this.cart){if(t){t.classList.remove(Ye.loading);t.classList.add(Ye.added);t.dispatchEvent(new CustomEvent("theme:product:add",{detail:{response:e,button:t},bubbles:true}))}if(theme.settings.cartType==="page"){window.location=theme.routes.cart_url}this.getCart()}else{window.location=theme.routes.cart_url}})).catch((e=>{this.addToCartError(e,t);this.enableCartButtons()}))}updateCart(e={},t=null){this.cart.classList.add(Ye.loading);let i=e.quantity;if(t!==null){if(i){t.classList.add(Ye.loading)}else{t.classList.add(Ye.removed)}}this.disableCartButtons();const s=this.cart.querySelector(`[${Ke.item}="${e.id}"]`)||t;const o=s?.hasAttribute(Ke.itemIndex)?parseInt(s.getAttribute(Ke.itemIndex)):0;const n=s?.hasAttribute(Ke.itemTitle)?s.getAttribute(Ke.itemTitle):null;if(o===0)return;const r={line:o,quantity:i};fetch(theme.routes.cart_change_url,{method:"post",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify(r)}).then((e=>e.text())).then((e=>{const i=JSON.parse(e);if(i.errors){this.cartUpdateFailed=true;this.updateErrorText(n);this.toggleErrorMessage();this.resetLineItem(t);this.enableCartButtons();return}this.getCart()})).catch((e=>{console.log(e);this.enableCartButtons()}))}resetLineItem(e){const t=e.querySelector(Qe.qtyInput);const i=t.getAttribute("value");t.value=i;e.classList.remove(Ye.loading)}disableCartButtons(){const e=this.cart.querySelectorAll("input");const t=this.cart.querySelectorAll(`button, ${Qe.cartItemRemove}`);if(e.length){e.forEach((e=>{e.classList.add(Ye.disabled);e.blur();e.disabled=true}))}if(t.length){t.forEach((e=>{e.setAttribute(Ke.disabled,true)}))}}enableCartButtons(){const e=this.cart.querySelectorAll("input");const t=this.cart.querySelectorAll(`button, ${Qe.cartItemRemove}`);if(e.length){e.forEach((e=>{e.classList.remove(Ye.disabled);e.disabled=false}))}if(t.length){t.forEach((e=>{e.removeAttribute(Ke.disabled)}))}this.cart.classList.remove(Ye.loading)}updateErrorText(e){this.cartErrorHolder.querySelector(Qe.errorMessage).innerText=e}toggleErrorMessage(){if(!this.cartErrorHolder)return;this.cartErrorHolder.classList.toggle(Ye.expanded,this.cartUpdateFailed);this.cartUpdateFailed=false}cartErrorsHandler(e){if(!e.ok){return e.json().then((function(t){const i=new Ge({status:e.statusText,headers:e.headers,json:t});throw i}))}return e}addToCartError(e,t){if(t!==null){const i=t.closest(Qe.outerSection)||t.closest(Qe.quickAddHolder)||t.closest(Qe.quickAddModal);let s=i?.querySelector(Qe.formErrorsContainer);const o=t.closest(Qe.quickAddHolder);if(o&&o.querySelector(Qe.formErrorsContainer)){s=o.querySelector(Qe.formErrorsContainer)}if(s){let t=`${e.message}: ${e.description}`;if(e.message==e.description){t=e.message}s.innerHTML=`<div class="errors">${t}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`;s.classList.add(Ye.visible);this.formErrorsEvents(s)}t.dispatchEvent(new CustomEvent("theme:product:add-error",{detail:{response:e,button:t},bubbles:true}))}const i=t?.closest(Qe.quickAddHolder);if(i){i.dispatchEvent(new CustomEvent("theme:cart:error",{bubbles:true,detail:{message:e.message,description:e.description,holder:i}}))}this.cart?.classList.remove(Ye.loading)}productAddCallback(e){let t=[];let i=null;const s=e.type=="theme:product:add-error";const o=e.detail.button;const n=document.querySelector(Qe.cartBarAdd);t.push(o);i=o.closest(Qe.quickAddHolder);if(n){t.push(n)}t.forEach((e=>{e.classList.remove(Ye.loading);if(!s){e.classList.add(Ye.added)}}));setTimeout((()=>{t.forEach((e=>{e.classList.remove(Ye.added);const t=e.closest(Qe.formWrapper)?.classList.contains(Ye.variantSoldOut)||e.closest(Qe.formWrapper)?.classList.contains(Ye.variantUnavailable);if(!t){e.disabled=false}}));i?.classList.remove(Ye.visible)}),1e3)}toggleClassesOnContainers(){const e=this.hasItemsInCart();this.cart.classList.toggle(Ye.empty,!e);if(!e&&this.cartDrawer){setTimeout((()=>{Q(this.cartDrawer,{elementToFocus:this.cartDrawer.querySelector(Qe.cartDrawerClose)})}),100)}}build(e){const t=e.querySelector(Qe.apiLineItems);const i=e.querySelector(Qe.apiUpsellItems);const s=Boolean(t===null&&i===null);const o=e.querySelector(Qe.apiCartPrice);const n=e.querySelector(Qe.cartTotal);if(this.priceHolder&&o){this.priceHolder.innerHTML=o.innerHTML}if(s){this.itemsHolder.innerHTML=e.innerHTML;if(this.upsellProductsHolder){this.upsellProductsHolder.innerHTML=""}}else{this.itemsHolder.innerHTML=t.innerHTML;if(this.upsellProductsHolder){this.upsellProductsHolder.innerHTML=i.innerHTML}this.skipUpsellProductEvent();this.checkSkippedUpsellProductsFromStorage();this.toggleCartUpsellWidgetVisibility()}this.newTotalItems=t&&t.querySelectorAll(Qe.item).length?t.querySelectorAll(Qe.item).length:0;this.subtotal=n&&n.hasAttribute(Ke.cartTotal)?parseInt(n.getAttribute(Ke.cartTotal)):0;this.cartCount=this.getCartItemCount();document.dispatchEvent(new CustomEvent("theme:cart:change",{bubbles:true,detail:{cartCount:this.cartCount}}));this.cartTotal.innerHTML=this.subtotal===0?window.theme.strings.free:Je(this.subtotal,theme.moneyWithCurrencyFormat);if(this.totalItems!==this.newTotalItems){this.totalItems=this.newTotalItems;this.toggleClassesOnContainers()}if(this.cartDrawer?.classList.contains(Ye.open)){this.cart.classList.add(Ye.updated)}this.cart.classList.remove(Ye.loading);if(!this.hasItemsInCart()){this.cartEmpty.querySelectorAll(Qe.animation).forEach((e=>{e.classList.remove(Ye.animated)}))}this.freeShippingMessageHandle(this.subtotal);this.cartRemoveEvents();this.cartUpdateEvents();this.toggleErrorMessage();this.enableCartButtons();this.updateProgress();this.animateItems();document.dispatchEvent(new CustomEvent("theme:product:added",{bubbles:true}))}getCartItemCount(){return Array.from(this.cart.querySelectorAll(Qe.qtyInput)).reduce(((e,t)=>e+parseInt(t.value)),0)}hasItemsInCart(){return this.totalItems>0}freeShippingMessageHandle(e){if(!this.freeShipping.length)return;this.freeShipping.forEach((t=>{const i=t.hasAttribute(Ke.freeShipping)&&t.getAttribute(Ke.freeShipping)==="true"&&e>=0;t.classList.toggle(Ye.success,i&&e>=this.freeShippingLimit)}))}updateProgress(){this.freeShipping=document.querySelectorAll(Qe.freeShipping);if(!this.freeShipping.length)return;const e=isNaN(this.subtotal/this.freeShippingLimit)?100:this.subtotal/this.freeShippingLimit;const t=Math.min(e*100,100);const i=this.circumference-t/100*this.circumference/2;const s=Je(this.freeShippingLimit-this.subtotal,theme.moneyFormat);this.freeShipping.forEach((e=>{const o=e.querySelector(Qe.freeShippingProgress);const n=e.querySelector(Qe.freeShippingGraph);const r=e.querySelector(Qe.leftToSpend);if(r){r.innerHTML=s.replace(".00","")}if(o){o.value=t}if(n){n.style.setProperty("--stroke-dashoffset",`${i}`)}}))}skipUpsellProductEvent(){if(this.upsellProductsHolder===null){return}const e=this.upsellProductsHolder.querySelectorAll(Qe.buttonSkipUpsellProduct);if(e.length){e.forEach((e=>{e.addEventListener("click",(t=>{t.preventDefault();const i=e.closest(Qe.quickAddHolder).getAttribute(Ke.quickAddHolder);if(!this.skipUpsellProductsArray.includes(i)){this.skipUpsellProductsArray.push(i)}window.sessionStorage.setItem("skip_upsell_products",this.skipUpsellProductsArray);this.removeUpsellProduct(i);this.toggleCartUpsellWidgetVisibility()}))}))}}checkSkippedUpsellProductsFromStorage(){const e=window.sessionStorage.getItem("skip_upsell_products");if(!e)return;const t=e.split(",");t.forEach((e=>{if(!this.skipUpsellProductsArray.includes(e)){this.skipUpsellProductsArray.push(e)}this.removeUpsellProduct(e)}))}removeUpsellProduct(e){if(!this.upsellProductsHolder)return;const t=this.upsellProductsHolder.querySelector(`[${Ke.quickAddHolder}="${e}"]`);if(t){t.parentNode.remove()}}toggleCartUpsellWidgetVisibility(){if(!this.upsellProductsHolder)return;const e=this.upsellProductsHolder.querySelectorAll(Qe.quickAddHolder);const t=this.upsellProductsHolder.closest(Qe.upsellWidget);if(!t)return;t.classList.toggle(Ye.hidden,!e.length);if(e.length&&!t.hasAttribute(Ke.open)&&t.hasAttribute(Ke.upsellAutoOpen)){t.setAttribute(Ke.open,true);const e=t.querySelector(Qe.collapsibleBody);if(e){e.style.height="auto"}}}resetAnimatedItems(){this.cart.querySelectorAll(Qe.animation).forEach((e=>{e.classList.remove(Ye.animated);e.classList.remove(Ye.hiding)}))}animateItems(e){requestAnimationFrame((()=>{let t=this.cart;if(e&&e.detail&&e.detail.target){t=e.detail.target}t?.querySelectorAll(Qe.animation).forEach((e=>{e.classList.add(Ye.animated)}))}))}recentlyViewedProducts(){const e=this.cart.querySelector(`#${Qe.recentlyViewedHolderId}`);if(e){Shopify.Products.showRecentlyViewed({howManyToShow:3,wrapperId:Qe.recentlyViewedHolderId,section:this,target:"api-upsell-product"})}}}if(!customElements.get("cart-items")){customElements.define("cart-items",Ze)}const et={count:"data-cart-count",limit:"data-limit"};class tt extends HTMLElement{constructor(){super();this.cartCount=null;this.limit=this.getAttribute(et.limit);this.onCartChangeCallback=this.onCartChange.bind(this)}connectedCallback(){document.addEventListener("theme:cart:change",this.onCartChangeCallback)}disconnectedCallback(){document.addEventListener("theme:cart:change",this.onCartChangeCallback)}onCartChange(e){this.cartCount=e.detail.cartCount;this.update()}update(){if(this.cartCount!==null){this.setAttribute(et.count,this.cartCount);let e=this.cartCount;if(this.limit&&this.cartCount>=this.limit){e="9+"}this.innerText=e}}}if(!customElements.get("cart-count")){customElements.define("cart-count",tt)}function it(e){return new Promise((t=>{function i(s){if(s.target!=e)return;e.removeEventListener("animationend",i);t()}e?.addEventListener("animationend",i)}))}const st={open:"is-open",closing:"is-closing",duplicate:"drawer--duplicate",drawerEditorError:"drawer-editor-error"};const ot={cartDrawer:"cart-drawer",cartDrawerClose:"[data-cart-drawer-close]",cartDrawerSection:'[data-section-type="cart-drawer"]',cartDrawerInner:"[data-cart-drawer-inner]",shopifySection:".shopify-section"};const nt={drawerUnderlay:"data-drawer-underlay"};class rt extends HTMLElement{constructor(){super();this.cartDrawerIsOpen=false;this.cartDrawerClose=this.querySelector(ot.cartDrawerClose);this.cartDrawerInner=this.querySelector(ot.cartDrawerInner);this.openCartDrawer=this.openCartDrawer.bind(this);this.closeCartDrawer=this.closeCartDrawer.bind(this);this.toggleCartDrawer=this.toggleCartDrawer.bind(this);this.openCartDrawerOnProductAdded=this.openCartDrawerOnProductAdded.bind(this);this.openCartDrawerOnSelect=this.openCartDrawerOnSelect.bind(this);this.closeCartDrawerOnDeselect=this.closeCartDrawerOnDeselect.bind(this);this.cartDrawerSection=this.closest(ot.shopifySection);this.closeCartEvents()}connectedCallback(){const e=this.closest(ot.shopifySection);if(window.theme.hasCartDrawer){if(!window.Shopify.designMode){e.remove();return}else{const e=document.createElement("div");e.classList.add(st.drawerEditorError);e.innerText="Cart drawer section already exists.";if(!this.querySelector(`.${st.drawerEditorError}`)){this.querySelector(ot.cartDrawerInner).append(e)}this.classList.add(st.duplicate)}}window.theme.hasCartDrawer=true;this.addEventListener("theme:cart-drawer:show",this.openCartDrawer);document.addEventListener("theme:cart:toggle",this.toggleCartDrawer);document.addEventListener("theme:quick-add:open",this.closeCartDrawer);document.addEventListener("theme:product:added",this.openCartDrawerOnProductAdded);document.addEventListener("shopify:block:select",this.openCartDrawerOnSelect);document.addEventListener("shopify:section:select",this.openCartDrawerOnSelect);document.addEventListener("shopify:section:deselect",this.closeCartDrawerOnDeselect)}disconnectedCallback(){document.removeEventListener("theme:product:added",this.openCartDrawerOnProductAdded);document.removeEventListener("theme:cart:toggle",this.toggleCartDrawer);document.removeEventListener("theme:quick-add:open",this.closeCartDrawer);document.removeEventListener("shopify:block:select",this.openCartDrawerOnSelect);document.removeEventListener("shopify:section:select",this.openCartDrawerOnSelect);document.removeEventListener("shopify:section:deselect",this.closeCartDrawerOnDeselect);if(document.querySelectorAll(ot.cartDrawer).length<=1){window.theme.hasCartDrawer=false}n()}openCartDrawerOnProductAdded(){if(!this.cartDrawerIsOpen){this.openCartDrawer()}}openCartDrawerOnSelect(e){const t=e.target.querySelector(ot.shopifySection)||e.target.closest(ot.shopifySection)||e.target;if(t===this.cartDrawerSection){this.openCartDrawer(true)}}closeCartDrawerOnDeselect(){if(this.cartDrawerIsOpen){this.closeCartDrawer()}}openCartDrawer(e=false){if(!e&&this.classList.contains(st.duplicate))return;this.cartDrawerIsOpen=true;this.onBodyClickEvent=this.onBodyClickEvent||this.onBodyClick.bind(this);document.body.addEventListener("click",this.onBodyClickEvent);document.dispatchEvent(new CustomEvent("theme:cart-drawer:open",{detail:{target:this},bubbles:true}));document.dispatchEvent(new CustomEvent("theme:scroll:lock",{bubbles:true}));this.classList.add(st.open);this.observeAdditionalCheckoutButtons();it(this.cartDrawerInner).then((()=>{Q(this,{elementToFocus:this.querySelector(ot.cartDrawerClose)})}))}closeCartDrawer(){if(!this.classList.contains(st.open))return;this.classList.add(st.closing);this.classList.remove(st.open);this.cartDrawerIsOpen=false;document.dispatchEvent(new CustomEvent("theme:cart-drawer:close",{bubbles:true}));K();Z();document.body.removeEventListener("click",this.onBodyClickEvent);document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{bubbles:true}));it(this.cartDrawerInner).then((()=>{this.classList.remove(st.closing)}))}toggleCartDrawer(){if(!this.cartDrawerIsOpen){this.openCartDrawer()}else{this.closeCartDrawer()}}closeCartEvents(){this.cartDrawerClose.addEventListener("click",(e=>{e.preventDefault();this.closeCartDrawer()}));this.addEventListener("keyup",(e=>{if(e.code==="Escape"){this.closeCartDrawer()}}))}onBodyClick(e){if(e.target.hasAttribute(nt.drawerUnderlay))this.closeCartDrawer()}observeAdditionalCheckoutButtons(){const e=this.querySelector(ot.additionalCheckoutButtons);if(e){const t=new MutationObserver((()=>{Q(this,{elementToFocus:this.querySelector(ot.cartDrawerClose)});t.disconnect()}));t.observe(e,{subtree:true,childList:true})}}}if(!customElements.get("cart-drawer")){customElements.define("cart-drawer",rt)}const at={collapsible:"[data-collapsible]",trigger:"[data-collapsible-trigger]",body:"[data-collapsible-body]",content:"[data-collapsible-content]"};const lt={desktop:"desktop",disabled:"disabled",mobile:"mobile",open:"open",single:"single"};class ct extends HTMLElement{constructor(){super();this.collapsibles=this.querySelectorAll(at.collapsible);this.single=this.hasAttribute(lt.single);this.toggle=this.toggle.bind(this)}connectedCallback(){this.toggle();document.addEventListener("theme:resize:width",this.toggle);this.collapsibles.forEach((e=>{const t=e.querySelector(at.trigger);const i=e.querySelector(at.body);t?.addEventListener("click",(e=>this.onCollapsibleClick(e)));i?.addEventListener("transitionend",(t=>{if(t.target!==i)return;if(e.getAttribute(lt.open)=="true"){this.setBodyHeight(i,"auto")}if(e.getAttribute(lt.open)=="false"){e.removeAttribute(lt.open);this.setBodyHeight(i,"")}}))}))}disconnectedCallback(){document.removeEventListener("theme:resize:width",this.toggle)}toggle(){const e=b();this.collapsibles.forEach((t=>{if(!t.hasAttribute(lt.desktop)&&!t.hasAttribute(lt.mobile))return;const i=t.hasAttribute(lt.desktop)?t.getAttribute(lt.desktop):"true";const s=t.hasAttribute(lt.mobile)?t.getAttribute(lt.mobile):"true";const o=e&&i=="true"||!e&&s=="true";const n=t.querySelector(at.body);if(o){t.removeAttribute(lt.disabled);t.querySelector(at.trigger).removeAttribute("tabindex");t.removeAttribute(lt.open);this.setBodyHeight(n,"")}else{t.setAttribute(lt.disabled,"");t.setAttribute("open",true);t.querySelector(at.trigger).setAttribute("tabindex",-1)}}))}open(e){if(e.getAttribute("open")=="true")return;const t=e.querySelector(at.body);const i=e.querySelector(at.content);e.setAttribute("open",true);this.setBodyHeight(t,i.offsetHeight)}close(e){if(!e.hasAttribute("open"))return;const t=e.querySelector(at.body);const i=e.querySelector(at.content);this.setBodyHeight(t,i.offsetHeight);e.setAttribute("open",false);setTimeout((()=>{requestAnimationFrame((()=>{this.setBodyHeight(t,0)}))}))}setBodyHeight(e,t){e.style.height=t!=="auto"&&t!==""?`${t}px`:t}onCollapsibleClick(e){e.preventDefault();const t=e.target;const i=t.closest(at.collapsible);if(this.single){this.collapsibles.forEach((e=>{if(e.hasAttribute(lt.open)&&e!=i){requestAnimationFrame((()=>{this.close(e)}))}}))}if(i.hasAttribute(lt.open)){this.close(i)}else{this.open(i)}i.dispatchEvent(new CustomEvent("theme:form:sticky",{bubbles:true,detail:{element:"accordion"}}));i.dispatchEvent(new CustomEvent("theme:collapsible:toggle",{bubbles:true}))}}if(!customElements.get("collapsible-elements")){customElements.define("collapsible-elements",ct)}const dt={details:"details",popdown:"[data-popdown]",popdownClose:"[data-popdown-close]",input:'input:not([type="hidden"])'};const ht={popdownUnderlay:"data-popdown-underlay"};const ut={open:"is-open"};class pt extends HTMLElement{constructor(){super();this.popdown=this.querySelector(dt.popdown);this.popdownContainer=this.querySelector(dt.details);this.popdownClose=this.querySelector(dt.popdownClose);this.popdownTransitionCallback=this.popdownTransitionCallback.bind(this);this.detailsToggleCallback=this.detailsToggleCallback.bind(this);this.a11y=te}connectedCallback(){this.popdown.addEventListener("transitionend",this.popdownTransitionCallback);this.popdownContainer.addEventListener("keyup",(e=>e.code.toUpperCase()==="ESCAPE"&&this.close()));this.popdownContainer.addEventListener("toggle",this.detailsToggleCallback);this.popdownClose.addEventListener("click",this.close.bind(this))}detailsToggleCallback(e){if(e.target.hasAttribute("open")){this.open()}}popdownTransitionCallback(e){if(e.target!==this.popdown)return;if(!this.classList.contains(ut.open)){this.popdownContainer.removeAttribute("open");this.a11y.removeTrapFocus()}else if(e.propertyName==="transform"){this.a11y.trapFocus(this.popdown,{elementToFocus:this.popdown.querySelector(dt.input)})}}onBodyClick(e){if(!this.contains(e.target)||e.target.hasAttribute(ht.popdownUnderlay))this.close()}open(){this.onBodyClickEvent=this.onBodyClickEvent||this.onBodyClick.bind(this);document.body.addEventListener("click",this.onBodyClickEvent);document.dispatchEvent(new CustomEvent("theme:scroll:lock",{bubbles:true}));requestAnimationFrame((()=>{this.classList.add(ut.open)}))}close(){this.classList.remove(ut.open);document.body.removeEventListener("click",this.onBodyClickEvent);document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{bubbles:true}))}}customElements.define("header-search-popdown",pt);const mt={inputSearch:'input[type="search"]'};class ft extends oe{constructor(){super();this.allSearchInputs=document.querySelectorAll(mt.inputSearch);this.setupEventListeners()}setupEventListeners(){let e=[];this.allSearchInputs.forEach((t=>e.push(t.form)));this.input.addEventListener("focus",this.onInputFocus.bind(this));if(e.length<2)return;e.forEach((e=>e.addEventListener("reset",this.onFormReset.bind(this))));this.allSearchInputs.forEach((e=>e.addEventListener("input",this.onInput.bind(this))))}onFormReset(e){super.onFormReset(e);if(super.shouldResetForm()){this.keepInSync("",this.input)}}onInput(e){const t=e.target;this.keepInSync(t.value,t)}onInputFocus(){if(!b()){this.scrollIntoView({behavior:"smooth"})}}keepInSync(e,t){this.allSearchInputs.forEach((i=>{if(i!==t){i.value=e}}))}}customElements.define("main-search",ft);const gt={actions:"[data-actions]",content:"[data-content]",trigger:"[data-button]"};const vt={height:"data-height"};const bt={open:"is-open",enabled:"is-enabled"};class yt extends HTMLElement{constructor(){super();this.initialHeight=this.getAttribute(vt.height);this.content=this.querySelector(gt.content);this.trigger=this.querySelector(gt.trigger);this.actions=this.querySelector(gt.actions);this.toggleActions=this.toggleActions.bind(this)}connectedCallback(){this.setHeight(this.initialHeight);this.trigger.addEventListener("click",(()=>{this.setHeight(this.content.offsetHeight);this.classList.add(bt.open)}));this.setHeight(this.initialHeight);this.toggleActions();document.addEventListener("theme:resize",this.toggleActions);document.addEventListener("theme:collapsible:toggle",this.toggleActions)}disconnectedCallback(){document.removeEventListener("theme:resize",this.toggleActions);document.removeEventListener("theme:collapsible:toggle",this.toggleActions)}setHeight(e){this.style.setProperty("--height",`${e}px`)}toggleActions(){this.classList.toggle(bt.enabled,this.content.offsetHeight+this.actions.offsetHeight>this.initialHeight)}}if(!customElements.get("toggle-ellipsis")){customElements.define("toggle-ellipsis",yt)}const wt={templateAddresses:".template-addresses",addressNewForm:"#AddressNewForm",btnNew:".address-new-toggle",btnEdit:".address-edit-toggle",btnDelete:".address-delete",dataFormId:"data-form-id",dataConfirmMessage:"data-confirm-message",editAddress:"#EditAddress",addressCountryNew:"AddressCountryNew",addressProvinceNew:"AddressProvinceNew",addressProvinceContainerNew:"AddressProvinceContainerNew",addressCountryOption:".address-country-option",addressCountry:"AddressCountry",addressProvince:"AddressProvince",addressProvinceContainer:"AddressProvinceContainer"};const St={hidden:"hidden"};class Et{constructor(e){this.section=e;this.addressNewForm=this.section.querySelector(wt.addressNewForm);this.init()}init(){if(this.addressNewForm){const e=this.section;const t=this.addressNewForm;this.customerAddresses();const i=e.querySelectorAll(wt.btnNew);if(i.length){i.forEach((e=>{e.addEventListener("click",(function(){t.classList.toggle(St.hidden)}))}))}const s=e.querySelectorAll(wt.btnEdit);if(s.length){s.forEach((t=>{t.addEventListener("click",(function(){const t=this.getAttribute(wt.dataFormId);e.querySelector(`${wt.editAddress}_${t}`).classList.toggle(St.hidden)}))}))}const o=e.querySelectorAll(wt.btnDelete);if(o.length){o.forEach((e=>{e.addEventListener("click",(function(){const e=this.getAttribute(wt.dataFormId);const t=this.getAttribute(wt.dataConfirmMessage);if(confirm(t)){Shopify.postLink(window.theme.routes.addresses_url+"/"+e,{parameters:{_method:"delete"}})}}))}))}}}customerAddresses(){if(Shopify.CountryProvinceSelector){new Shopify.CountryProvinceSelector(wt.addressCountryNew,wt.addressProvinceNew,{hideElement:wt.addressProvinceContainerNew})}const e=this.section.querySelectorAll(wt.addressCountryOption);e.forEach((e=>{const t=e.getAttribute(wt.dataFormId);const i=`${wt.addressCountry}_${t}`;const s=`${wt.addressProvince}_${t}`;const o=`${wt.addressProvinceContainer}_${t}`;new Shopify.CountryProvinceSelector(i,s,{hideElement:o})}))}}const Lt=document.querySelector(wt.templateAddresses);if(Lt){new Et(Lt)}const kt={accountTemplateLogged:".customer-logged-in",account:".account",accountSidebarMobile:".account-sidebar--mobile"};class At{constructor(e){this.section=e;this.init()}init(){if(this.section.querySelector(kt.account)){this.accountMobileSidebar()}}accountMobileSidebar(){if(this.section.querySelector(kt.accountSidebarMobile)){this.section.querySelector(kt.accountSidebarMobile).addEventListener("click",(function(){const e=this.nextElementSibling;if(e&&e.tagName==="UL"){e.classList.toggle("visible")}}))}}}const Ct=document.querySelector(kt.accountTemplateLogged);if(Ct){new At(Ct)}const Tt={form:"[data-account-form]",showReset:"[data-show-reset]",hideReset:"[data-hide-reset]",recover:"[data-recover-password]",recoverSuccess:"[data-recover-success]",login:"[data-login-form]",recoverHash:"#recover",hideClass:"is-hidden"};class qt{constructor(e){this.form=e;this.showButton=e.querySelector(Tt.showReset);this.hideButton=e.querySelector(Tt.hideReset);this.recover=e.querySelector(Tt.recover);this.recoverSuccess=e.querySelector(Tt.recoverSuccess);this.login=e.querySelector(Tt.login);this.init()}init(){if(window.location.hash==Tt.recoverHash||this.recoverSuccess){this.showRecoverPasswordForm()}else{this.hideRecoverPasswordForm()}this.showButton.addEventListener("click",function(e){e.preventDefault();this.showRecoverPasswordForm()}.bind(this),false);this.hideButton.addEventListener("click",function(e){e.preventDefault();this.hideRecoverPasswordForm()}.bind(this),false)}showRecoverPasswordForm(){this.login.classList.add(Tt.hideClass);this.recover.classList.remove(Tt.hideClass);window.location.hash=Tt.recoverHash;return false}hideRecoverPasswordForm(){this.recover.classList.add(Tt.hideClass);this.login.classList.remove(Tt.hideClass);window.location.hash="";return false}}const It=document.querySelector(Tt.form);if(It){new qt(It)}window.Shopify=window.Shopify||{};window.Shopify.theme=window.Shopify.theme||{};window.Shopify.theme.sections=window.Shopify.theme.sections||{};window.Shopify.theme.sections.registered=window.Shopify.theme.sections.registered||{};window.Shopify.theme.sections.instances=window.Shopify.theme.sections.instances||[];const Pt=window.Shopify.theme.sections.registered;const xt=window.Shopify.theme.sections.instances;const Mt={id:"data-section-id",type:"data-section-type"};class Ht{constructor(e=null,t=[]){this.type=e;this.components=Dt(t);this.callStack={onLoad:[],onUnload:[],onSelect:[],onDeselect:[],onBlockSelect:[],onBlockDeselect:[],onReorder:[]};t.forEach((e=>{for(const[t,i]of Object.entries(e)){const e=this.callStack[t];if(Array.isArray(e)&&typeof i==="function"){e.push(i)}else{console.warn(`Unregisted function: '${t}' in component: '${this.type}'`);console.warn(i)}}}))}getStack(){return this.callStack}}class Ot{constructor(e,t){this.container=Bt(e);this.id=e.getAttribute(Mt.id);this.type=t.type;this.callStack=t.getStack();try{this.onLoad()}catch(e){console.warn(`Error in section: ${this.id}`);console.warn(this);console.warn(e)}}callFunctions(e,t=null){this.callStack[e].forEach((e=>{const i={id:this.id,type:this.type,container:this.container};if(t){e.call(i,t)}else{e.call(i)}}))}onLoad(){this.callFunctions("onLoad")}onUnload(){this.callFunctions("onUnload")}onSelect(e){this.callFunctions("onSelect",e)}onDeselect(e){this.callFunctions("onDeselect",e)}onBlockSelect(e){this.callFunctions("onBlockSelect",e)}onBlockDeselect(e){this.callFunctions("onBlockDeselect",e)}onReorder(e){this.callFunctions("onReorder",e)}}function Bt(e){if(!(e instanceof Element)){throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.")}if(e.getAttribute(Mt.id)===null){throw new Error("Theme Sections: The section container provided does not have an id assigned to the "+Mt.id+" attribute.")}return e}function Dt(e){if(typeof e!=="undefined"&&typeof e!=="object"||e===null){throw new TypeError("Theme Sections: The components object provided is not a valid")}return e}function Ft(e,t){if(typeof e!=="string"){throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered")}if(typeof Pt[e]!=="undefined"){throw new Error('Theme Sections: A section of type "'+e+'" has already been registered. You cannot register the same section type twice')}if(!Array.isArray(t)){t=[t]}const i=new Ht(e,t);Pt[e]=i;return Pt}function _t(e,t){e=Ut(e);if(typeof t==="undefined"){t=document.querySelectorAll("["+Mt.type+"]")}t=zt(t);e.forEach((function(e){const i=Pt[e];if(typeof i==="undefined"){return}t=t.filter((function(t){if(Vt(t)){return false}if(t.getAttribute(Mt.type)===null){return false}if(t.getAttribute(Mt.type)!==e){return true}xt.push(new Ot(t,i));return false}))}))}function $t(e){var t=Wt(e);t.forEach((function(e){e.onReorder()}))}function Nt(e){var t=Wt(e);t.forEach((function(e){var t=xt.map((function(e){return e.id})).indexOf(e.id);xt.splice(t,1);e.onUnload()}))}function Wt(e){var t=[];if(NodeList.prototype.isPrototypeOf(e)||Array.isArray(e)){var i=e[0]}if(e instanceof Element||i instanceof Element){var s=zt(e);s.forEach((function(e){t=t.concat(xt.filter((function(t){return t.container===e})))}))}else if(typeof e==="string"||typeof i==="string"){var o=Ut(e);o.forEach((function(e){t=t.concat(xt.filter((function(t){return t.type===e})))}))}return t}function Rt(e){var t;for(var i=0;i<xt.length;i++){if(xt[i].id===e){t=xt[i];break}}return t}function Vt(e){return Wt(e).length>0}function Ut(e){if(e==="*"){e=Object.keys(Pt)}else if(typeof e==="string"){e=[e]}else if(e.constructor===Ot){e=[e.prototype.type]}else if(Array.isArray(e)&&e[0].constructor===Ot){e=e.map((function(e){return e.type}))}e=e.map((function(e){return e.toLowerCase()}));return e}function zt(e){if(NodeList.prototype.isPrototypeOf(e)&&e.length>0){e=Array.prototype.slice.call(e)}else if(NodeList.prototype.isPrototypeOf(e)&&e.length===0){e=[]}else if(e===null){e=[]}else if(!Array.isArray(e)&&e instanceof Element){e=[e]}return e}if(window.Shopify.designMode){document.addEventListener("shopify:section:load",(function(e){var t=e.detail.sectionId;var i=e.target.querySelector("["+Mt.id+'="'+t+'"]');if(i!==null){_t(i.getAttribute(Mt.type),i)}}));document.addEventListener("shopify:section:reorder",(function(e){var t=e.detail.sectionId;var i=e.target.querySelector("["+Mt.id+'="'+t+'"]');var s=Wt(i)[0];if(typeof s==="object"){$t(i)}}));document.addEventListener("shopify:section:unload",(function(e){var t=e.detail.sectionId;var i=e.target.querySelector("["+Mt.id+'="'+t+'"]');var s=Wt(i)[0];if(typeof s==="object"){Nt(i)}}));document.addEventListener("shopify:section:select",(function(e){var t=Rt(e.detail.sectionId);if(typeof t==="object"){t.onSelect(e)}}));document.addEventListener("shopify:section:deselect",(function(e){var t=Rt(e.detail.sectionId);if(typeof t==="object"){t.onDeselect(e)}}));document.addEventListener("shopify:block:select",(function(e){var t=Rt(e.detail.sectionId);if(typeof t==="object"){t.onBlockSelect(e)}}));document.addEventListener("shopify:block:deselect",(function(e){var t=Rt(e.detail.sectionId);if(typeof t==="object"){t.onBlockDeselect(e)}}))}const jt={tooltip:"data-tooltip",tooltipStopMouseEnter:"data-tooltip-stop-mouseenter"};const Jt={tooltipDefault:"tooltip-default",visible:"is-visible",hiding:"is-hiding"};let Xt={};class Gt{constructor(e,t={}){this.tooltip=e;if(!this.tooltip.hasAttribute(jt.tooltip))return;this.label=this.tooltip.getAttribute(jt.tooltip);this.class=t.class||Jt.tooltipDefault;this.transitionSpeed=t.transitionSpeed||200;this.hideTransitionTimeout=0;this.addPinEvent=()=>this.addPin();this.addPinMouseEvent=()=>this.addPin(true);this.removePinEvent=e=>Xe(this.removePin(e),50);this.removePinMouseEvent=e=>this.removePin(e,true,true);this.init()}init(){if(!document.querySelector(`.${this.class}`)){const e=`<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`;const t=document.createElement("div");t.className=this.class;t.innerHTML=e;document.body.appendChild(t)}this.tooltip.addEventListener("mouseenter",this.addPinMouseEvent);this.tooltip.addEventListener("mouseleave",this.removePinMouseEvent);this.tooltip.addEventListener("theme:tooltip:init",this.addPinEvent);document.addEventListener("theme:tooltip:close",this.removePinEvent)}addPin(e=false){const t=document.querySelector(`.${this.class}`);if(this.label&&t&&(e&&!this.tooltip.hasAttribute(jt.tooltipStopMouseEnter)||!e)){const e=t.querySelector(`.${this.class}__arrow`);const i=t.querySelector(`.${this.class}__inner`);const s=t.querySelector(`.${this.class}__text`);s.innerHTML=this.label;const o=i.offsetWidth;const n=this.tooltip.getBoundingClientRect();const r=n.top;const a=n.width;const l=n.height;const c=r+l+window.scrollY;let d=n.left-o/2+a/2;const h=d+o;const u=24;const p=h-g()+u;if(p>0){d-=p}if(d<0){d=0}e.style.left=`${n.left+a/2}px`;t.style.setProperty("--tooltip-top",`${c}px`);i.style.transform=`translateX(${d}px)`;t.classList.remove(Jt.hiding);t.classList.add(Jt.visible);document.addEventListener("theme:scroll",this.removePinEvent)}}removePin(e,t=false,i=false){const s=document.querySelector(`.${this.class}`);const o=s.classList.contains(Jt.visible);if(s&&(t&&!this.tooltip.hasAttribute(jt.tooltipStopMouseEnter)||!t)){if(o&&(i||e.detail.hideTransition)){s.classList.add(Jt.hiding);if(this.hideTransitionTimeout){clearTimeout(this.hideTransitionTimeout)}this.hideTransitionTimeout=setTimeout((()=>{s.classList.remove(Jt.hiding)}),this.transitionSpeed)}s.classList.remove(Jt.visible);document.removeEventListener("theme:scroll",this.removePinEvent)}}unload(){this.tooltip.removeEventListener("mouseenter",this.addPinMouseEvent);this.tooltip.removeEventListener("mouseleave",this.removePinMouseEvent);this.tooltip.removeEventListener("theme:tooltip:init",this.addPinEvent);document.removeEventListener("theme:tooltip:close",this.removePinEvent);document.removeEventListener("theme:scroll",this.removePinEvent)}}const Yt={onLoad(){Xt[this.id]=[];const e=this.container.querySelectorAll(`[${jt.tooltip}]`);e.forEach((e=>{Xt[this.id].push(new Gt(e))}))},onUnload:function(){Xt[this.id].forEach((e=>{if(typeof e.unload==="function"){e.unload()}}))}};var Qt={};const Kt={onLoad(){Qt[this.id]=[];const e=this.container.querySelectorAll("[data-parallax-wrapper]");e.forEach((e=>{const i=e.querySelector("[data-parallax-img]");Qt[this.id].push(new t(i,{center:true,round:true,frame:e}))}));window.addEventListener("load",(()=>{Qt[this.id].forEach((e=>{if(typeof e.refresh==="function"){e.refresh()}}))}))},onUnload:function(){Qt[this.id].forEach((e=>{if(typeof e.destroy==="function"){e.destroy()}}))}};Ft("article",[Yt,Kt]);const Zt={aos:"[data-aos]",collectionImage:".collection-item__image",columnImage:"[data-column-image]",flickityNextArrow:".flickity-button.next",flickityPrevArrow:".flickity-button.previous",link:"a:not(.btn)",productItemImage:".product-item__image",slide:"[data-slide]",slideValue:"data-slide",slider:"[data-slider]",sliderThumb:"[data-slider-thumb]"};const ei={arrowPositionMiddle:"data-arrow-position-middle",slideIndex:"data-slide-index",sliderOptions:"data-options",slideTextColor:"data-slide-text-color"};const ti={aosAnimate:"aos-animate",desktop:"desktop",focused:"is-focused",flickityEnabled:"flickity-enabled",heroContentTransparent:"hero__content--transparent",initialized:"is-initialized",isLoading:"is-loading",isSelected:"is-selected",mobile:"mobile",singleSlide:"single-slide",sliderInitialized:"js-slider--initialized"};const ii={};class si{constructor(e,t=null){this.container=e;this.slideshow=t||this.container.querySelector(Zt.slider);if(!this.slideshow)return;this.slideshowSlides=this.slideshow.querySelectorAll(Zt.slide);if(this.slideshowSlides.length<=1)return;this.sliderThumbs=this.container.querySelectorAll(Zt.sliderThumb);this.multipleSlides=this.slideshow.hasAttribute(ei.slidesLargeDesktop);if(this.slideshow.hasAttribute(ei.sliderOptions)){this.customOptions=JSON.parse(decodeURIComponent(this.slideshow.getAttribute(ei.sliderOptions)))}this.flkty=null;this.init()}init(){this.slideshow.classList.add(ti.isLoading);let e=Zt.slide;const t=b();const o=`${Zt.slide}:not(.${ti.mobile})`;const n=`${Zt.slide}:not(.${ti.desktop})`;const r=this.slideshow.querySelectorAll(n).length||this.slideshow.querySelectorAll(o).length;if(r){if(t){e=o}else{e=n}}if(this.slideshow.querySelectorAll(e).length<=1){this.slideshow.classList.add(ti.singleSlide);this.slideshow.classList.remove(ti.isLoading)}this.sliderOptions={cellSelector:e,contain:true,wrapAround:true,adaptiveHeight:true,...this.customOptions,on:{ready:()=>{requestAnimationFrame((()=>{this.slideshow.classList.add(ti.initialized);this.slideshow.classList.remove(ti.isLoading);this.slideshow.parentNode.dispatchEvent(new CustomEvent("theme:slider:loaded",{bubbles:true,detail:{slider:this}}))}));this.slideActions();if(this.sliderOptions.prevNextButtons){this.positionArrows()}},change:e=>{const t=this.slideshowSlides[e];if(!t||this.sliderOptions.groupCells)return;const i=t.querySelectorAll(Zt.aos);if(i.length){i.forEach((e=>{e.classList.remove(ti.aosAnimate);requestAnimationFrame((()=>{setTimeout((()=>{e.classList.add(ti.aosAnimate)}),0)}))}))}},resize:()=>{if(this.sliderOptions.prevNextButtons){this.positionArrows()}}}};if(this.sliderOptions.fade){this.flkty=new s(this.slideshow,this.sliderOptions)}if(!this.sliderOptions.fade){this.flkty=new i(this.slideshow,this.sliderOptions)}this.flkty.on("change",(()=>this.slideActions(true)));if(this.sliderThumbs.length){this.sliderThumbs.forEach((e=>{e.addEventListener("click",(t=>{t.preventDefault();const i=[...e.parentElement.children].indexOf(e);this.flkty.select(i)}))}))}if(!this.flkty||!this.flkty.isActive){this.slideshow.classList.remove(ti.isLoading)}}slideActions(e=false){const t=this.slideshow.querySelector(`.${ti.isSelected}`);if(!t)return;const i=t.hasAttribute(ei.slideTextColor)?t.getAttribute(ei.slideTextColor):"";const s=t.querySelector(Zt.link);const o=this.slideshow.querySelectorAll(`${Zt.slide} a, ${Zt.slide} button`);if(document.body.classList.contains(ti.focused)&&s&&this.sliderOptions.groupCells&&e){s.focus()}if(o.length){o.forEach((e=>{const t=e.closest(Zt.slide);if(t){const i=t.classList.contains(ti.isSelected)?0:-1;e.setAttribute("tabindex",i)}}))}if(i!=="rgba(0,0,0,0)"&&i!==""){this.slideshow.style.setProperty("--text",i)}if(this.sliderThumbs.length&&this.sliderThumbs.length===this.slideshowSlides.length&&t.hasAttribute(ei.slideIndex)){const e=parseInt(t.getAttribute(ei.slideIndex));const i=this.container.querySelector(`${Zt.sliderThumb}.${ti.isSelected}`);if(i){i.classList.remove(ti.isSelected)}this.sliderThumbs[e].classList.add(ti.isSelected)}}positionArrows(){if(this.slideshow.hasAttribute(ei.arrowPositionMiddle)&&this.sliderOptions.prevNextButtons){const e=this.slideshow.querySelector(Zt.collectionImage)||this.slideshow.querySelector(Zt.productItemImage)||this.slideshow.querySelector(Zt.columnImage);if(!e)return;this.slideshow.querySelector(Zt.flickityPrevArrow).style.top=e.clientHeight/2+"px";this.slideshow.querySelector(Zt.flickityNextArrow).style.top=e.clientHeight/2+"px"}}onUnload(){if(this.slideshow&&this.flkty){this.flkty.options.watchCSS=false;this.flkty.destroy()}}onBlockSelect(e){if(!this.slideshow)return;const t=this.slideshow.querySelector(`[${Zt.slideValue}="${e.detail.blockId}"]`);if(!t)return;let i=parseInt(t.getAttribute(ei.slideIndex));if(this.multipleSlides&&!this.slideshow.classList.contains(ti.sliderInitialized)){i=0}this.slideshow.classList.add(ti.isSelected);if(this.flkty&&this.slideshow.classList.contains(ti.flickityEnabled)){this.flkty.selectCell(i);this.flkty.stopPlayer()}}onBlockDeselect(){if(!this.slideshow)return;this.slideshow.classList.remove(ti.isSelected);if(this.flkty&&this.sliderOptions.hasOwnProperty("autoPlay")&&this.sliderOptions.autoPlay){this.flkty.playPlayer()}}}const oi={onLoad(){ii[this.id]=[];const e=this.container.querySelectorAll(Zt.slider);e.forEach((e=>{ii[this.id].push(new si(this.container,e))}))},onUnload(){ii[this.id].forEach((e=>{if(typeof e.onUnload==="function"){e.onUnload()}}))},onBlockSelect(e){ii[this.id].forEach((t=>{if(typeof t.onBlockSelect==="function"){t.onBlockSelect(e)}}))},onBlockDeselect(e){ii[this.id].forEach((t=>{if(typeof t.onBlockDeselect==="function"){t.onBlockDeselect(e)}}))}};Ft("blog-section",[oi]);Ft("hero",Kt);Ft("double",oi);const ni=e=>{let{stickyHeaderHeight:t}=l();window.scrollTo({top:e+window.scrollY-t,left:0,behavior:"smooth"})};class ri{constructor(e,t,i=7){const s=new Date;const o=new Date;o.setTime(s.getTime()+36e5*24*i);this.configuration={expires:o.toGMTString(),path:"/",domain:window.location.hostname,sameSite:"none",secure:true};this.name=e;this.value=t}write(){const e=document.cookie.indexOf("; ")!==-1&&!document.cookie.split("; ").find((e=>e.startsWith(this.name)));if(e||document.cookie.indexOf("; ")===-1){document.cookie=`${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`}}read(){if(document.cookie.indexOf("; ")!==-1&&document.cookie.split("; ").find((e=>e.startsWith(this.name)))){const e=document.cookie.split("; ").find((e=>e.startsWith(this.name))).split("=")[1];return e}else{return false}}destroy(){if(document.cookie.split("; ").find((e=>e.startsWith(this.name)))){document.cookie=`${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`}}}const ai={newsletterForm:"[data-newsletter-form]",newsletterHeading:"[data-newsletter-heading]",newsletterPopup:"[data-newsletter]"};const li={success:"has-success",error:"has-error",hidden:"hidden"};const ci={cookieNameAttribute:"data-cookie-name"};const di={};class hi{constructor(e){this.sessionStorage=window.sessionStorage;this.newsletter=e;this.popup=this.newsletter.closest(ai.newsletterPopup);if(this.popup){this.cookie=new ri(this.popup.getAttribute(ci.cookieNameAttribute),"user_has_closed",null)}this.stopSubmit=true;this.isChallengePage=false;this.formID=null;this.checkForChallengePage();this.newsletterSubmit=e=>this.newsletterSubmitEvent(e);if(!this.isChallengePage){this.init()}}init(){this.newsletter.addEventListener("submit",this.newsletterSubmit);this.showMessage()}newsletterSubmitEvent(e){if(this.stopSubmit){e.preventDefault();e.stopImmediatePropagation();this.removeStorage();this.writeStorage();this.stopSubmit=false;this.newsletter.submit()}}checkForChallengePage(){this.isChallengePage=window.location.pathname==="/challenge"}writeStorage(){if(this.sessionStorage!==undefined){this.sessionStorage.setItem("newsletter_form_id",this.newsletter.id)}}readStorage(){this.formID=this.sessionStorage.getItem("newsletter_form_id")}removeStorage(){this.sessionStorage.removeItem("newsletter_form_id")}showMessage(){this.readStorage();if(this.newsletter.id===this.formID){const e=document.getElementById(this.formID);const t=e.parentElement.querySelector(ai.newsletterHeading);const i=window.location.search.indexOf("?customer_posted=true")!==-1;const s=window.location.search.indexOf("accepts_marketing")!==-1;if(i){e.classList.remove(li.error);e.classList.add(li.success);if(t){t.classList.add(li.hidden);e.classList.remove(li.hidden)}if(this.popup){this.cookie.write()}}else if(s){e.classList.remove(li.success);e.classList.add(li.error);if(t){t.classList.add(li.hidden);e.classList.remove(li.hidden)}}if(i||s){window.addEventListener("load",(()=>{this.scrollToForm(e)}))}}}scrollToForm(e){const t=e.getBoundingClientRect();const i=t.top>=0&&t.left>=0&&t.bottom<=v()&&t.right<=g();if(!i){setTimeout((()=>{ni(e.getBoundingClientRect().top)}),500)}}unload(){this.newsletter.removeEventListener("submit",this.newsletterSubmit)}}const ui={onLoad(){di[this.id]=[];const e=this.container.querySelectorAll(ai.newsletterForm);e.forEach((e=>{di[this.id].push(new hi(e))}))},onUnload(){di[this.id].forEach((e=>{if(typeof e.unload==="function"){e.unload()}}))}};Ft("footer",[Kt,ui]);const pi={collectionSidebar:"[data-collection-sidebar]",collectionSidebarSlideOut:"[data-collection-sidebar-slide-out]",collectionSidebarCloseButton:"[data-collection-sidebar-close]",groupTagsButton:"[data-aria-toggle]",animation:"[data-animation]"};const mi={animated:"drawer--animated",hiding:"is-hiding",expanded:"expanded",noMobileAnimation:"no-mobile-animation",focused:"is-focused"};let fi={};class gi{constructor(e){this.container=e.container;this.collectionSidebar=this.container.querySelector(pi.collectionSidebar);this.groupTagsButton=this.container.querySelector(pi.groupTagsButton);this.a11y=te;this.groupTagsButtonClickEvent=e=>this.groupTagsButtonClick(e);this.sidebarResizeEvent=()=>this.toggleSidebarSlider();this.collectionSidebarCloseEvent=e=>this.collectionSidebarClose(e);this.init()}init(){if(this.groupTagsButton!==null){document.addEventListener("theme:resize:width",this.sidebarResizeEvent);this.groupTagsButton.addEventListener("click",this.groupTagsButtonClickEvent);if(this.collectionSidebar){setTimeout((()=>{this.collectionSidebar.classList.remove(mi.noMobileAnimation)}),1e3)}const e=new MutationObserver((e=>{for(const t of e){if(t.type==="attributes"){const e=t.target.getAttribute("aria-expanded")=="true";if(e){this.showSidebarCallback()}}}}));e.observe(this.groupTagsButton,{attributes:true,childList:false,subtree:false})}this.container.addEventListener("keyup",function(e){if(e.code!=="Escape"){return}this.hideSidebar()}.bind(this));if(this.collectionSidebar){this.collectionSidebar.addEventListener("transitionend",(()=>{if(!this.collectionSidebar.classList.contains(mi.expanded)){this.collectionSidebar.classList.remove(mi.animated)}}));this.toggleSidebarSlider();this.container.addEventListener("theme:filter:close",this.collectionSidebarCloseEvent)}}showSidebarCallback(){const e=this.container.querySelector(pi.collectionSidebarSlideOut);const t=document.documentElement.hasAttribute("data-scroll-locked");const i=y();this.collectionSidebar.classList.add(mi.animated);if(e===null){if(!i&&t){this.a11y.removeTrapFocus();document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{bubbles:true}))}}if(i||e!==null){if(e){this.a11y.trapFocus(this.collectionSidebar,{elementToFocus:this.collectionSidebar.querySelector(pi.collectionSidebarCloseButton)})}document.dispatchEvent(new CustomEvent("theme:scroll:lock",{bubbles:true}))}}hideSidebar(){const e=this.container.querySelector(pi.collectionSidebarSlideOut);const t=document.documentElement.hasAttribute("data-scroll-locked");this.groupTagsButton.setAttribute("aria-expanded","false");this.collectionSidebar.classList.remove(mi.expanded);if(e){this.a11y.removeTrapFocus()}if(t){document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{bubbles:true}))}}toggleSidebarSlider(){if(y()){this.hideSidebar()}else if(this.collectionSidebar.classList.contains(mi.expanded)){this.showSidebarCallback()}}collectionSidebarClose(e){e.preventDefault();this.hideSidebar();if(document.body.classList.contains(mi.focused)&&this.groupTagsButton){this.groupTagsButton.focus()}}groupTagsButtonClick(){const e=document.documentElement.hasAttribute("data-scroll-locked");if(e){document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{bubbles:true}))}}onUnload(){if(this.groupTagsButton!==null){document.removeEventListener("theme:resize:width",this.sidebarResizeEvent);this.groupTagsButton.removeEventListener("click",this.groupTagsButtonClickEvent)}if(this.collectionSidebar){this.container.removeEventListener("theme:filter:close",this.collectionSidebarCloseEvent)}}}const vi={onLoad(){fi[this.id]=new gi(this)},onUnload(){fi[this.id].onUnload()}};Ft("collection",[oi,Kt,vi,Yt]);const bi={frame:"[data-ticker-frame]",scale:"[data-ticker-scale]",text:"[data-ticker-text]",clone:"data-clone"};const yi={autoplay:"autoplay",speed:"speed"};const wi={animation:"ticker--animated",unloaded:"ticker--unloaded",comparitor:"ticker__comparitor"};const Si={speed:1.63,space:100};class Ei extends HTMLElement{constructor(){super();this.autoplay=this.hasAttribute(yi.autoplay);this.scale=this.querySelector(bi.scale);this.text=this.querySelector(bi.text);this.speed=this.hasAttribute(yi.speed)?this.getAttribute(yi.speed):Si.speed;this.comparitor=this.text.cloneNode(true);this.comparitor.classList.add(wi.comparitor);this.appendChild(this.comparitor);this.scale.classList.remove(wi.unloaded);this.checkWidthEvent=this.checkWidth.bind(this)}connectedCallback(){this.checkWidth();this.addEventListener("theme:ticker:refresh",f((()=>this.checkWidthEvent()),50));screen.orientation.addEventListener("change",this.checkWidthEvent);document.addEventListener("theme:resize:width",this.checkWidthEvent)}disconnectedCallback(){document.removeEventListener("theme:resize:width",this.checkWidthEvent)}checkWidth(){this.text=this.querySelector(bi.text);const e=window.getComputedStyle(this).paddingLeft.replace("px","")*2;const t=this.clientWidth-e<this.comparitor.clientWidth;if(t||this.autoplay){this.text.classList.remove(wi.animation);const i=this.scale.querySelectorAll(`[${bi.clone}]`);const s=this.autoplay?parseInt((window.innerWidth-e)/this.text.clientWidth):2;i?.forEach((e=>{e.remove()}));if(this.autoplay||t){for(let e=0;e<=s;e++){const e=this.text.cloneNode(true);e.setAttribute(bi.clone,"");this.scale.appendChild(e)}}const o=(this.text.clientWidth/Si.space*Number(this.speed)).toFixed(2);this.scale.style.removeProperty("--animation-time");this.scale.style.setProperty("--animation-time",`${o}s`);this.scale.querySelectorAll(bi.text)?.forEach((e=>{e.classList.add(wi.animation)}))}else{this.text.classList.add(wi.animation);const e=this.scale.querySelectorAll(`[${bi.clone}]`);e.forEach((e=>{e.parentNode.removeChild(e)}));this.text.classList.remove(wi.animation)}}}const Li={marquee:".announcement__bar-holder--marquee",slide:"[data-slide]",slider:"[data-slider]",ticker:"ticker-bar",tickerSlide:".announcement__slide"};const ki={hidden:"hidden"};class Ai extends HTMLElement{constructor(){super();this.slider=this.querySelector(Li.slider);this.enableSlider=b();this.slidesCount=this.querySelectorAll(Li.tickerSlide).length;this.initSliderEvent=e=>this.initSlider(e)}connectedCallback(){if(this.slider){this.initSliders()}this.addEventListener("theme:block:select",(e=>{this.onBlockSelect(e)}));this.addEventListener("theme:block:deselect",(e=>{this.onBlockDeselect(e)}));this.addEventListener("theme:countdown:hide",(e=>{if(window.Shopify.designMode)return;const t=e.target.closest(Li.marquee);if(this.slidesCount===1){const e=this.querySelector(Li.ticker);e.style.display="none"}if(t){const t=e.target.closest(Li.tickerSlide);this.removeTickerText(t)}else{const t=e.target.closest(Li.slide);this.removeSlide(t)}}));this.addEventListener("theme:countdown:expire",(()=>{this.querySelectorAll(Li.ticker)?.forEach((e=>{e.dispatchEvent(new CustomEvent("theme:ticker:refresh"))}))}));document.dispatchEvent(new CustomEvent("theme:announcement:init",{bubbles:true}))}initSliders(){this.initSlider();document.addEventListener("theme:resize:width",this.initSliderEvent);this.addEventListener("theme:slider:loaded",(()=>{this.querySelectorAll(Li.tickerBar)?.forEach((e=>{e.dispatchEvent(new CustomEvent("theme:ticker:refresh"))}))}))}initSlider(){const e=b();const t=!e;if(e&&this.enableSlider||t&&!this.enableSlider){this.slider.flkty?.destroy();if(e&&this.enableSlider){this.enableSlider=false}else if(t&&!this.enableSlider){this.enableSlider=true}this.slider=new si(this,this.querySelector(Li.slider));this.slider.flkty?.reposition()}}removeSlide(e){this.slider.flkty?.remove(e);if(this.slider.flkty?.cells.length===0){this.section.classList.add(ki.hidden)}}removeTickerText(e){const t=e.closest(Li.ticker);e.remove();t.dispatchEvent(new CustomEvent("theme:ticker:refresh"))}onBlockSelect(e){if(this.slider){this.slider.onBlockSelect(e)}}onBlockDeselect(e){if(this.slider){this.slider.onBlockDeselect(e)}}disconnectedCallback(){document.removeEventListener("theme:resize:width",this.initSliderEvent);document.removeEventListener("theme:resize:width",this.tickerResizeEvent);this.removeEventListener("theme:block:select",(e=>{this.onBlockSelect(e)}));this.removeEventListener("theme:block:deselect",(e=>{this.onBlockDeselect(e)}))}}if(!customElements.get("announcement-bar")){customElements.define("announcement-bar",Ai)}if(!customElements.get("ticker-bar")){customElements.define("ticker-bar",Ei)}const Ci={body:"body",drawerWrappper:"[data-drawer]",drawerInner:"[data-drawer-inner]",underlay:"[data-drawer-underlay]",stagger:"[data-stagger-animation]",wrapper:"[data-header-wrapper]",drawerToggle:"data-drawer-toggle",focusable:'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'};const Ti={animated:"drawer--animated",open:"is-open",closing:"is-closing",isFocused:"is-focused",headerStuck:"js__header__stuck"};let qi={};class Ii{constructor(e){this.isAnimating=false;this.drawer=e;this.drawerWrapper=this.drawer.closest(Ci.drawerWrappper);this.drawerInner=this.drawer.querySelector(Ci.drawerInner);this.underlay=this.drawer.querySelector(Ci.underlay);this.wrapper=this.drawer.closest(Ci.wrapper);this.key=this.drawer.dataset.drawer;this.btnSelector=`[${Ci.drawerToggle}='${this.key}']`;this.buttons=document.querySelectorAll(this.btnSelector);this.staggers=this.drawer.querySelectorAll(Ci.stagger);this.body=document.querySelector(Ci.body);this.showDrawer=this.showDrawer.bind(this);this.hideDrawer=this.hideDrawer.bind(this);this.connectToggle();this.connectDrawer();this.closers()}connectToggle(){this.buttons.forEach((e=>{e.addEventListener("click",(()=>{this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle",{bubbles:false}))}))}))}connectDrawer(){this.drawer.addEventListener("theme:drawer:toggle",(()=>{if(this.drawer.classList.contains(Ti.open)){this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close",{bubbles:true}))}else{this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open",{bubbles:true}))}}));document.addEventListener("theme:cart-drawer:open",this.hideDrawer);document.addEventListener("theme:drawer:close",this.hideDrawer);document.addEventListener("theme:drawer:open",this.showDrawer)}closers(){this.wrapper.addEventListener("keyup",(e=>{if(e.code!=="Escape"){return}this.hideDrawer()}));this.underlay.addEventListener("click",(()=>{this.hideDrawer()}))}showDrawer(){if(this.isAnimating)return;this.isAnimating=true;this.buttons.forEach((e=>{e.setAttribute("aria-expanded",true)}));this.drawer.classList.add(Ti.open,Ti.animated);document.dispatchEvent(new CustomEvent("theme:scroll:lock",{bubbles:true}));if(this.drawerInner&&this.drawerInner.querySelector(this.btnSelector)){K();it(this.drawerInner).then((()=>{this.drawer.querySelector(Ci.focusable).focus();this.isAnimating=false;Q(this.drawerInner,{elementToFocus:this.drawerInner.querySelector(this.btnSelector)})}))}}hideDrawer(){if(!this.drawer.classList.contains(Ti.open)||this.isAnimating){return}this.isAnimating=true;this.drawer.classList.add(Ti.closing);this.drawer.classList.remove(Ti.open);K();if(this.body.classList.contains(Ti.isFocused)&&this.buttons.length){this.buttons[0].focus()}this.buttons.forEach((e=>{e.setAttribute("aria-expanded",false)}));document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{bubbles:true}));it(this.drawerInner).then((()=>{this.drawer.classList.remove(Ti.closing,Ti.animated);this.isAnimating=false;document.dispatchEvent(new CustomEvent("theme:sliderule:close",{bubbles:false}))}))}onUnload(){document.removeEventListener("theme:cart-drawer:open",this.hideDrawer);document.removeEventListener("theme:drawer:close",this.hideDrawer);document.removeEventListener("theme:drawer:open",this.showDrawer)}}const Pi={onLoad(){qi[this.id]=[];const e=this.container.querySelectorAll(Ci.drawerWrappper);e.forEach((e=>{qi[this.id].push(new Ii(e))}))},onUnload(){qi[this.id].forEach((e=>{if(typeof e.onUnload==="function"){e.onUnload()}}))}};const xi={pageHeader:".page-header"};const Mi={stuck:"js__header__stuck",sticky:"has-header-sticky",headerGroup:"shopify-section-group-header-group"};const Hi={stickyHeader:"data-header-sticky",scrollLock:"data-scroll-locked"};let Oi={};class Bi{constructor(e){this.wrapper=e;this.sticks=this.wrapper.hasAttribute(Hi.stickyHeader);document.body.classList.toggle(Mi.sticky,this.sticks);if(!this.sticks)return;this.isStuck=false;this.cls=this.wrapper.classList;this.headerOffset=document.querySelector(xi.pageHeader)?.offsetTop;this.updateHeaderOffset=this.updateHeaderOffset.bind(this);this.scrollEvent=e=>this.onScroll(e);this.listen();this.stickOnLoad()}listen(){document.addEventListener("theme:scroll",this.scrollEvent);document.addEventListener("shopify:section:load",this.updateHeaderOffset);document.addEventListener("shopify:section:unload",this.updateHeaderOffset)}onScroll(e){if(e.detail.down){if(!this.isStuck&&e.detail.position>this.headerOffset){this.stickSimple()}}else if(e.detail.position<=this.headerOffset){this.unstickSimple()}}updateHeaderOffset(e){if(!e.target.classList.contains(Mi.headerGroup))return;setTimeout((()=>{this.headerOffset=document.querySelector(xi.pageHeader)?.offsetTop}))}stickOnLoad(){if(window.scrollY>this.headerOffset){this.stickSimple()}}stickSimple(){this.cls.add(Mi.stuck);this.isStuck=true}unstickSimple(){if(!document.documentElement.hasAttribute(Hi.scrollLock)){this.cls.remove(Mi.stuck);this.isStuck=false}}unload(){document.removeEventListener("theme:scroll",this.scrollEvent);document.removeEventListener("shopify:section:load",this.updateHeaderOffset);document.removeEventListener("shopify:section:unload",this.updateHeaderOffset)}}const Di={onLoad(){Oi=new Bi(this.container)},onUnload:function(){if(typeof Oi.unload==="function"){Oi.unload()}}};const Fi={disclosureToggle:"data-hover-disclosure-toggle",disclosureWrappper:"[data-hover-disclosure]",link:"[data-top-link]",wrapper:"[data-header-wrapper]",stagger:"[data-stagger]",staggerPair:"[data-stagger-first]",staggerAfter:"[data-stagger-second]",focusable:'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'};const _i={isVisible:"is-visible",meganavVisible:"meganav--visible",meganavIsTransitioning:"meganav--is-transitioning"};let $i={};let Ni={};class Wi{constructor(e){this.disclosure=e;this.wrapper=e.closest(Fi.wrapper);this.key=this.disclosure.id;this.trigger=document.querySelector(`[${Fi.disclosureToggle}='${this.key}']`);this.link=this.trigger.querySelector(Fi.link);this.grandparent=this.trigger.classList.contains("grandparent");this.transitionTimeout=0;this.trigger.setAttribute("aria-haspopup",true);this.trigger.setAttribute("aria-expanded",false);this.trigger.setAttribute("aria-controls",this.key);this.connectHoverToggle();this.handleTablets();this.staggerChildAnimations()}onBlockSelect(e){if(this.disclosure.contains(e.target)){this.showDisclosure(e)}}onBlockDeselect(e){if(this.disclosure.contains(e.target)){this.hideDisclosure()}}showDisclosure(e){if(e&&e.type&&e.type==="mouseenter"){this.wrapper.classList.add(_i.meganavIsTransitioning)}if(this.grandparent){this.wrapper.classList.add(_i.meganavVisible)}else{this.wrapper.classList.remove(_i.meganavVisible)}this.trigger.setAttribute("aria-expanded",true);this.trigger.classList.add(_i.isVisible);this.disclosure.classList.add(_i.isVisible);if(this.transitionTimeout){clearTimeout(this.transitionTimeout)}this.transitionTimeout=setTimeout((()=>{this.wrapper.classList.remove(_i.meganavIsTransitioning)}),200)}hideDisclosure(){this.disclosure.classList.remove(_i.isVisible);this.trigger.classList.remove(_i.isVisible);this.trigger.setAttribute("aria-expanded",false);this.wrapper.classList.remove(_i.meganavVisible,_i.meganavIsTransitioning)}staggerChildAnimations(){const e=this.disclosure.querySelectorAll(Fi.stagger);e.forEach(((e,t)=>{e.style.transitionDelay=`${t*50+10}ms`}));const t=this.disclosure.querySelectorAll(Fi.staggerPair);t.forEach(((e,t)=>{const i=t*100;e.style.transitionDelay=`${i}ms`;e.parentElement.querySelectorAll(Fi.staggerAfter).forEach(((e,t)=>{const s=t+1;const o=s*20;e.style.transitionDelay=`${i+o}ms`}))}))}handleTablets(){this.trigger.addEventListener("touchstart",function(e){const t=this.disclosure.classList.contains(_i.isVisible);if(!t){e.preventDefault();this.showDisclosure(e)}}.bind(this),{passive:true})}connectHoverToggle(){this.trigger.addEventListener("mouseenter",(e=>this.showDisclosure(e)));this.link.addEventListener("focus",(e=>this.showDisclosure(e)));this.trigger.addEventListener("mouseleave",(()=>this.hideDisclosure()));this.trigger.addEventListener("focusout",(e=>{const t=this.trigger.contains(e.relatedTarget);if(!t){this.hideDisclosure()}}));this.disclosure.addEventListener("keyup",(e=>{if(e.code!=="Escape"){return}this.hideDisclosure()}))}}const Ri={onLoad(){$i[this.id]=[];Ni=this.container.querySelectorAll(Fi.disclosureWrappper);Ni.forEach((e=>{$i[this.id].push(new Wi(e))}))},onBlockSelect(e){$i[this.id].forEach((t=>{if(typeof t.onBlockSelect==="function"){t.onBlockSelect(e)}}))},onBlockDeselect(e){$i[this.id].forEach((t=>{if(typeof t.onBlockDeselect==="function"){t.onBlockDeselect(e)}}))}};const Vi={slideruleOpen:"data-sliderule-open",slideruleClose:"data-sliderule-close",sliderulePane:"data-sliderule-pane",slideruleWrappper:"[data-sliderule]",drawerContent:"[data-drawer-content]",focusable:'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',dataAnimates:"data-animates",children:`:scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *`};const Ui={isVisible:"is-visible",isHiding:"is-hiding",isHidden:"is-hidden",focused:"is-focused",scrolling:"is-scrolling"};let zi={};class ji{constructor(e){this.sliderule=e;this.key=this.sliderule.id;const t=`[${Vi.slideruleOpen}='${this.key}']`;this.exitSelector=`[${Vi.slideruleClose}='${this.key}']`;this.trigger=document.querySelector(t);this.exit=document.querySelectorAll(this.exitSelector);this.pane=document.querySelector(`[${Vi.sliderulePane}]`);this.children=this.sliderule.querySelectorAll(Vi.children);this.drawerContent=document.querySelector(Vi.drawerContent);this.cachedButton=null;this.accessibility=te;this.trigger.setAttribute("aria-haspopup",true);this.trigger.setAttribute("aria-expanded",false);this.trigger.setAttribute("aria-controls",this.key);this.closeSliderule=this.closeSliderule.bind(this);this.clickEvents();this.keyboardEvents();document.addEventListener("theme:sliderule:close",this.closeSliderule)}clickEvents(){this.trigger.addEventListener("click",(()=>{this.cachedButton=this.trigger;this.showSliderule()}));this.exit.forEach((e=>{e.addEventListener("click",(()=>{this.hideSliderule()}))}))}keyboardEvents(){this.sliderule.addEventListener("keyup",(e=>{e.stopPropagation();if(e.code!=="Escape"){return}this.hideSliderule()}))}trapFocusSliderule(e=true){const t=e?this.sliderule.querySelector(this.exitSelector):this.cachedButton;this.accessibility.removeTrapFocus();if(t&&this.drawerContent){this.accessibility.trapFocus(this.drawerContent,{elementToFocus:document.body.classList.contains(Ui.focused)?t:null})}}hideSliderule(e=false){const t=parseInt(this.pane.dataset.sliderulePane,10)-1;this.pane.setAttribute(Vi.sliderulePane,t);this.pane.classList.add(Ui.isHiding);this.sliderule.classList.add(Ui.isHiding);const i=e?`[${Vi.dataAnimates}].${Ui.isHidden}`:`[${Vi.dataAnimates}="${t}"]`;const s=this.pane.querySelectorAll(i);if(s.length){s.forEach((e=>{e.classList.remove(Ui.isHidden)}))}const o=e?this.pane.querySelectorAll(`.${Ui.isVisible}, .${Ui.isHiding}`):this.children;o.forEach(((i,s)=>{const n=o.length-1==s;i.classList.remove(Ui.isVisible);if(e){i.classList.remove(Ui.isHiding);this.pane.classList.remove(Ui.isHiding)}const r=()=>{if(parseInt(this.pane.getAttribute(Vi.sliderulePane))===t){this.sliderule.classList.remove(Ui.isVisible)}this.sliderule.classList.remove(Ui.isHiding);this.pane.classList.remove(Ui.isHiding);if(n){this.accessibility.removeTrapFocus();if(!e){this.trapFocusSliderule(false)}}i.removeEventListener("animationend",r)};if(window.theme.settings.enableAnimations){i.addEventListener("animationend",r)}else{r()}}))}showSliderule(){let e=null;const t=this.sliderule.closest(`.${Ui.isVisible}`);let i=this.pane;if(t){i=t}i.scrollTo({top:0,left:0,behavior:"smooth"});i.classList.add(Ui.scrolling);const s=()=>{if(i.scrollTop<=0){i.classList.remove(Ui.scrolling);if(e){cancelAnimationFrame(e)}}else{e=requestAnimationFrame(s)}};e=requestAnimationFrame(s);this.sliderule.classList.add(Ui.isVisible);const o=parseInt(this.pane.dataset.sliderulePane,10);const n=o+1;this.pane.setAttribute(Vi.sliderulePane,n);const r=this.pane.querySelectorAll(`[${Vi.dataAnimates}="${o}"]`);if(r.length){r.forEach(((e,t)=>{const i=r.length-1==t;e.classList.add(Ui.isHiding);const s=()=>{e.classList.remove(Ui.isHiding);if(parseInt(this.pane.getAttribute(Vi.sliderulePane))!==o){e.classList.add(Ui.isHidden)}if(i){this.trapFocusSliderule()}e.removeEventListener("animationend",s)};if(window.theme.settings.enableAnimations){e.addEventListener("animationend",s)}else{s()}}))}}closeSliderule(){if(this.pane&&this.pane.hasAttribute(Vi.sliderulePane)&&parseInt(this.pane.getAttribute(Vi.sliderulePane))>0){this.hideSliderule(true);if(parseInt(this.pane.getAttribute(Vi.sliderulePane))>0){this.pane.setAttribute(Vi.sliderulePane,0)}}}onUnload(){document.removeEventListener("theme:sliderule:close",this.closeSliderule)}}const Ji={onLoad(){zi[this.id]=[];const e=this.container.querySelectorAll(Vi.slideruleWrappper);e.forEach((e=>{zi[this.id].push(new ji(e))}))},onUnload(){zi[this.id].forEach((e=>{if(typeof e.onUnload==="function"){e.onUnload()}}))}};const Xi={wrapper:"[data-header-wrapper]",style:"data-header-style",widthContentWrapper:"[data-takes-space-wrapper]",widthContent:"[data-child-takes-space]",desktop:"[data-header-desktop]",deadLink:'.navlink[href="#"]',cartDrawer:"cart-drawer",cartToggleButton:"[data-cart-toggle]",firstSectionOverlayHeader:".main-content > .shopify-section.section-overlay-header:first-of-type"};const Gi={clone:"js__header__clone",firstSectionOverlayHeader:"has-first-section-overlay-header",showMobileClass:"js__show__mobile",transparent:"has-header-transparent"};const Yi={transparent:"data-header-transparent"};let Qi={};class Ki{constructor(e){this.wrapper=e;this.style=this.wrapper.dataset.style;this.desktop=this.wrapper.querySelector(Xi.desktop);this.deadLinks=document.querySelectorAll(Xi.deadLink);this.resizeObserver=null;this.checkWidth=this.checkWidth.bind(this);this.killDeadLinks();if(this.style!=="drawer"&&this.desktop){this.minWidth=this.getMinWidth();this.listenWidth()}this.cartToggleEvent();const t=document.querySelector(Xi.firstSectionOverlayHeader);document.body.classList.toggle(Gi.transparent,this.wrapper.hasAttribute(Yi.transparent));document.body.classList.toggle(Gi.firstSectionOverlayHeader,t)}initTicker(e=false){this.tickerFrames.forEach((t=>{new Ei(t,e)}));this.tickerResizeEvent=e=>this.onTickerResize(e);document.addEventListener("theme:resize:width",this.tickerResizeEvent)}listenWidth(){if("ResizeObserver"in window){this.resizeObserver=new ResizeObserver(this.checkWidth);this.resizeObserver.observe(this.wrapper)}else{document.addEventListener("theme:resize",this.checkWidth)}}killDeadLinks(){this.deadLinks.forEach((e=>{e.onclick=e=>{e.preventDefault()}}))}checkWidth(){if(document.body.clientWidth<this.minWidth){this.wrapper.classList.add(Gi.showMobileClass);const{headerHeight:e}=l();document.documentElement.style.setProperty("--header-height",`${e}px`)}else{this.wrapper.classList.remove(Gi.showMobileClass)}}getMinWidth(){const e=this.wrapper.cloneNode(true);e.classList.add(Gi.clone);document.body.appendChild(e);const t=e.querySelectorAll(Xi.widthContentWrapper);let i=0;let s=0;t.forEach((e=>{const t=e.querySelectorAll(Xi.widthContent);let o=0;if(t.length===3){o=Zi(t)}else{o=es(t)}if(o>i){i=o;s=t.length*20}}));document.body.removeChild(e);return i+s}cartToggleEvent(){if(theme.settings.cartType!=="drawer")return;this.wrapper.querySelectorAll(Xi.cartToggleButton)?.forEach((e=>{e.addEventListener("click",(t=>{const i=document.querySelector(Xi.cartDrawer);if(i){t.preventDefault();i.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));window.accessibility.lastElement=e}}))}))}toggleButtonClick(e){e.preventDefault();document.dispatchEvent(new CustomEvent("theme:cart:toggle",{bubbles:true}))}unload(){if("ResizeObserver"in window){this.resizeObserver?.unobserve(this.wrapper)}else{document.removeEventListener("theme:resize",this.checkWidth)}}}function Zi(e){let t=[];e.forEach((e=>{if(e.firstElementChild){t.push(e.firstElementChild.clientWidth)}}));if(t[0]>t[2]){t[2]=t[0]}else{t[0]=t[2]}const i=t.reduce(((e,t)=>e+t));return i}function es(e){let t=0;e.forEach((e=>{t+=e.clientWidth}));return t}const ts={onLoad(){Qi=new Ki(this.container)},onUnload(){if(typeof Qi.unload==="function"){Qi.unload()}}};Ft("header",[ts,Pi,Ji,Di,Ri]);if(!customElements.get("ticker-bar")){customElements.define("ticker-bar",Ei)}const is={scrollElement:"[data-block-scroll]",flickityEnabled:"flickity-enabled"};const ss={};class os{constructor(e){this.container=e.container}onBlockSelect(e){const t=this.container.querySelector(is.scrollElement);if(t&&!t.classList.contains(is.flickityEnabled)){const i=e.srcElement;if(i){t.scrollTo({top:0,left:i.offsetLeft,behavior:"smooth"})}}}}const ns={onLoad(){ss[this.id]=new os(this)},onBlockSelect(e){ss[this.id].onBlockSelect(e)}};const rs={slider:"[data-slider-mobile]",slide:"[data-slide]",thumb:"[data-slider-thumb]",sliderContainer:"[data-slider-container]",popupContainer:"[data-popup-container]",popupClose:"[data-popup-close]"};const as={isAnimating:"is-animating",isSelected:"is-selected",isOpen:"is-open"};const ls={thumbValue:"data-slider-thumb"};const cs={};class ds{constructor(e){this.container=e.container;this.slider=this.container.querySelector(rs.slider);this.slides=this.container.querySelectorAll(rs.slide);this.thumbs=this.container.querySelectorAll(rs.thumb);this.popupContainer=this.container.querySelector(rs.popupContainer);this.popupClose=this.container.querySelectorAll(rs.popupClose);this.popupCloseByEvent=this.popupCloseByEvent.bind(this);this.init()}init(){if(this.slider&&this.slides.length&&this.thumbs.length){this.popupContainer.addEventListener("transitionend",(e=>{if(e.target!=this.popupContainer)return;this.popupContainer.classList.remove(as.isAnimating);if(e.target.classList.contains(as.isOpen)){this.popupOpenCallback()}else{this.popupCloseCallback()}}));this.popupContainer.addEventListener("transitionstart",(e=>{if(e.target!=this.popupContainer)return;this.popupContainer.classList.add(as.isAnimating)}));this.popupClose.forEach((e=>{e.addEventListener("click",(()=>{this.popupContainer.classList.remove(as.isOpen);document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{bubbles:true}))}))}));this.thumbs.forEach(((e,t)=>{e.addEventListener("click",(i=>{i.preventDefault();const s=e.hasAttribute(ls.thumbValue)&&e.getAttribute(ls.thumbValue)!==""?parseInt(e.getAttribute(ls.thumbValue)):t;const o=this.slides[s];if(y()){const e=parseInt(window.getComputedStyle(this.slider).paddingLeft);this.slider.scrollTo({top:0,left:o.offsetLeft-e,behavior:"auto"});document.dispatchEvent(new CustomEvent("theme:scroll:lock",{bubbles:true}));this.popupContainer.classList.add(as.isAnimating,as.isOpen)}else{let{stickyHeaderHeight:e}=l();const t=o.getBoundingClientRect().top;const i=o.offsetHeight/2;const s=window.innerHeight;const n=s/2;const r=this.container.querySelector(rs.sliderContainer);let a=t+i-n+window.scrollY;if(r){const t=r.getBoundingClientRect().top+window.scrollY;const i=r.offsetHeight;const o=t+i;if(a<t){a=t-e}else if(a+s>o){a=o-s}}window.scrollTo({top:a,left:0,behavior:"smooth"})}}))}))}}popupCloseByEvent(){this.popupContainer.classList.remove(as.isOpen)}popupOpenCallback(){document.addEventListener("theme:quick-add:open",this.popupCloseByEvent,{once:true});document.addEventListener("theme:product:added",this.popupCloseByEvent,{once:true})}popupCloseCallback(){document.removeEventListener("theme:quick-add:open",this.popupCloseByEvent,{once:true});document.removeEventListener("theme:product:added",this.popupCloseByEvent,{once:true})}}const hs={onLoad(){cs[this.id]=new ds(this)}};Ft("look",[hs,ns]);function us(){this.entries=[]}us.prototype.add=function(e,t,i){this.entries.push({element:e,event:t,fn:i});e.addEventListener(t,i)};us.prototype.removeAll=function(){this.entries=this.entries.filter((function(e){e.element.removeEventListener(e.event,e.fn);return false}))};function ps(e,t){gs(e);var i=fs(e,t);return ms(e,i)}function ms(e,t){gs(e);bs(t);var i=e.variants.filter((function(e){return t.every((function(t,i){return e.options[i]===t}))}));return i[0]||null}function fs(e,t){gs(e);vs(t);var i=[];t.forEach((function(t){for(var s=0;s<e.options.length;s++){var o=e.options[s].name||e.options[s];if(o.toLowerCase()===t.name.toLowerCase()){i[s]=t.value;break}}}));return i}function gs(e){if(typeof e!=="object"){throw new TypeError(e+" is not an object.")}if(Object.keys(e).length===0&&e.constructor===Object){throw new Error(e+" is empty.")}}function vs(e){if(!Array.isArray(e)){throw new TypeError(e+" is not an array.")}if(e.length===0){throw new Error(e+" is empty.")}if(e[0].hasOwnProperty("name")){if(typeof e[0].name!=="string"){throw new TypeError("Invalid value type passed for name of option "+e[0].name+". Value should be string.")}}else{throw new Error(e[0]+"does not contain name key.")}}function bs(e){if(Array.isArray(e)&&typeof e[0]==="object"){throw new Error(e+"is not a valid array of options.")}}var ys={idInput:'[name="id"]',planInput:'[name="selling_plan"]',optionInput:'[name^="options"]',quantityInput:'[name="quantity"]',propertyInput:'[name^="properties"]'};function ws(e,t){if(/variant=/.test(e)){return e.replace(/(variant=)[^&]+/,"$1"+t)}else if(/\?/.test(e)){return e.concat("&variant=").concat(t)}return e.concat("?variant=").concat(t)}class Ss{constructor(e,t,i){this.element=e;this.product=this._validateProductObject(t);this.variantElement=this.element.querySelector(ys.idInput);i=i||{};this._listeners=new us;this._listeners.add(this.element,"submit",this._onSubmit.bind(this,i));this.optionInputs=this._initInputs(ys.optionInput,i.onOptionChange);this.planInputs=this._initInputs(ys.planInput,i.onPlanChange);this.quantityInputs=this._initInputs(ys.quantityInput,i.onQuantityChange);this.propertyInputs=this._initInputs(ys.propertyInput,i.onPropertyChange)}destroy(){this._listeners.removeAll()}options(){return this._serializeInputValues(this.optionInputs,(function(e){var t=/(?:^(options\[))(.*?)(?:\])/;e.name=t.exec(e.name)[2];return e}))}variant(){const e=this.options();if(e.length){return ps(this.product,e)}else{return this.product.variants[0]}}plan(e){let t={allocation:null,group:null,detail:null};const i=this.element.querySelector(`${ys.planInput}:checked`);if(!i)return null;const s=i.value;const o=s&&s!==""?s:null;if(o&&e){t.allocation=e.selling_plan_allocations.find((function(e){return e.selling_plan_id.toString()===o.toString()}))}if(t.allocation){t.group=this.product.selling_plan_groups.find((function(e){return e.id.toString()===t.allocation.selling_plan_group_id.toString()}))}if(t.group){t.detail=t.group.selling_plans.find((function(e){return e.id.toString()===o.toString()}))}if(t&&t.allocation&&t.detail&&t.allocation){return t}else return null}properties(){return this._serializeInputValues(this.propertyInputs,(function(e){var t=/(?:^(properties\[))(.*?)(?:\])/;e.name=t.exec(e.name)[2];return e}))}quantity(){return this.quantityInputs[0]?Number.parseInt(this.quantityInputs[0].value,10):1}getFormState(){const e=this.variant();return{options:this.options(),variant:e,properties:this.properties(),quantity:this.quantity(),plan:this.plan(e)}}_setIdInputValue(e){if(e&&e.id){this.variantElement.value=e.id.toString()}else{this.variantElement.value=""}this.variantElement.dispatchEvent(new Event("change"))}_onSubmit(e,t){t.dataset=this.getFormState();if(e.onFormSubmit){e.onFormSubmit(t)}}_onOptionChange(e){this._setIdInputValue(e.dataset.variant)}_onFormEvent(e){if(typeof e==="undefined"){return Function.prototype.bind()}return function(t){t.dataset=this.getFormState();this._setIdInputValue(t.dataset.variant);e(t)}.bind(this)}_initInputs(e,t){var i=Array.prototype.slice.call(this.element.querySelectorAll(e));return i.map(function(e){this._listeners.add(e,"change",this._onFormEvent(t));return e}.bind(this))}_serializeInputValues(e,t){return e.reduce((function(e,i){if(i.checked||i.type!=="radio"&&i.type!=="checkbox"){e.push(t({name:i.name,value:i.value}))}return e}),[])}_validateProductObject(e){if(typeof e!=="object"){throw new TypeError(e+" is not an object.")}if(typeof e.variants[0].options==="undefined"){throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route")}return e}}function Es(e){const t=`${window.theme.routes.root}products/${e}.js`;return window.fetch(t).then((e=>e.json())).catch((e=>{console.error(e)}))}const Ls={scrollbarAttribute:"data-scrollbar",scrollbar:"data-scrollbar-slider",scrollbarSlideFullWidth:"data-scrollbar-slide-fullwidth",scrollbarArrowPrev:"[data-scrollbar-arrow-prev]",scrollbarArrowNext:"[data-scrollbar-arrow-next]"};const ks={hidden:"is-hidden"};const As={delay:200};class Cs{constructor(e){this.scrollbar=e;this.arrowNext=this.scrollbar.parentNode.querySelector(Ls.scrollbarArrowNext);this.arrowPrev=this.scrollbar.parentNode.querySelector(Ls.scrollbarArrowPrev);if(this.scrollbar.hasAttribute(Ls.scrollbarAttribute)){this.init();this.listen()}if(this.scrollbar.hasAttribute(Ls.scrollbar)){this.scrollToVisibleElement()}}init(){if(this.arrowNext&&this.arrowPrev){this.toggleNextArrow();this.events()}}listen(){document.addEventListener("theme:modal:open",(()=>{this.toggleNextArrow()}));document.addEventListener("theme:resize",(()=>{this.toggleNextArrow()}))}events(){this.arrowNext.addEventListener("click",(e=>{e.preventDefault();this.goToNext()}));this.arrowPrev.addEventListener("click",(e=>{e.preventDefault();this.goToPrev()}));this.scrollbar.addEventListener("scroll",(()=>{this.togglePrevArrow();this.toggleNextArrow()}))}goToNext(){const e=this.scrollbar.hasAttribute(Ls.scrollbarSlideFullWidth)?this.scrollbar.getBoundingClientRect().width:this.scrollbar.getBoundingClientRect().width/2;const t=e+this.scrollbar.scrollLeft;this.move(t);this.arrowPrev.classList.remove(ks.hidden);this.toggleNextArrow()}goToPrev(){const e=this.scrollbar.hasAttribute(Ls.scrollbarSlideFullWidth)?this.scrollbar.getBoundingClientRect().width:this.scrollbar.getBoundingClientRect().width/2;const t=this.scrollbar.scrollLeft-e;this.move(t);this.arrowNext.classList.remove(ks.hidden);this.togglePrevArrow()}toggleNextArrow(){setTimeout((()=>{this.arrowNext?.classList.toggle(ks.hidden,Math.round(this.scrollbar.scrollLeft+this.scrollbar.getBoundingClientRect().width+1)>=this.scrollbar.scrollWidth)}),As.delay)}togglePrevArrow(){setTimeout((()=>{this.arrowPrev.classList.toggle(ks.hidden,this.scrollbar.scrollLeft<=0)}),As.delay)}scrollToVisibleElement(){[].forEach.call(this.scrollbar.children,(e=>{e.addEventListener("click",(t=>{t.preventDefault();this.move(e.offsetLeft-e.clientWidth)}))}))}move(e){this.scrollbar.scrollTo({top:0,left:e,behavior:"smooth"})}}const Ts={gridSwatchForm:"[data-grid-swatch-form]",input:"[data-swatch-input]",productItem:"[data-grid-item]",productInfo:"[data-product-information]",sectionId:"[data-section-id]",productImage:"[data-product-image]",swatchButton:"[data-swatch-button]",swatchLink:"[data-swatch-link]",swatchText:"[data-swatch-text]",template:"[data-swatch-template]"};const qs={visible:"is-visible",hidden:"hidden",stopEvents:"no-events",swatch:"swatch"};const Is={image:"data-swatch-image",handle:"data-swatch-handle",label:"data-swatch-label",scrollbar:"data-scrollbar",swatchCount:"data-swatch-count",tooltip:"data-tooltip",variant:"data-swatch-variant",variantName:"data-swatch-variant-name",variantTitle:"data-variant-title",swatchValues:"data-swatch-values"};class Ps extends HTMLElement{constructor(){super()}connectedCallback(){if(this.hasAttribute(Is.tooltip)){new Gt(this)}}}class xs extends HTMLElement{constructor(){super();this.productItemMouseLeaveEvent=()=>this.hideVariantImages();this.showVariantImageEvent=e=>this.showVariantImage(e)}connectedCallback(){this.handle=this.getAttribute(Is.handle);this.productItem=this.closest(Ts.productItem);this.productInfo=this.closest(Ts.productInfo);this.productImage=this.productItem.querySelector(Ts.productImage);this.template=document.querySelector(Ts.template).innerHTML;this.swatchesJSON=this.getSwatchesJSON();this.swatchesStyle=theme.settings.collectionSwatchStyle;const e=this.getAttribute(Is.label).trim().toLowerCase();Es(this.handle).then((t=>{this.product=t;this.colorOption=t.options.find((function(t){return t.name.toLowerCase()===e||null}));if(this.colorOption){this.swatches=this.colorOption.values;this.init()}}))}init(){this.innerHTML="";this.count=0;this.limitedCount=0;this.swatches.forEach((e=>{let t=null;let i=false;let s="";for(const i of this.product.variants){const o=i.options.includes(e);if(!t&&o){t=i}if(o&&i.featured_media){s=i.featured_media.preview_image.src;t=i;break}}for(const t of this.product.variants){const s=t.options.includes(e);if(s&&t.available){i=true;break}}if(t){const o=document.createElement("div");o.innerHTML=this.template;const n=o.querySelector(Ts.swatchButton);const r=o.querySelector(Ts.swatchLink);const a=o.querySelector(Ts.swatchText);const l=this.swatchesJSON[e];const c=theme.settings.swatchesType=="native"?l:`var(--${l})`;const d=t.title.replaceAll('"',"'");n.style=`--animation-delay: ${100*this.count/1250}s`;n.classList.add(`${qs.swatch}-${l}`);n.dataset.tooltip=e;n.dataset.swatchVariant=t.id;n.dataset.swatchVariantName=d;n.dataset.swatchImage=s;n.dataset.variant=t.id;n.style.setProperty("--swatch",c);r.href=ws(this.product.url,t.id);r.dataset.swatch=e;r.disabled=!i;a.innerText=e;if(this.swatchesStyle!="limited"){this.innerHTML+=o.innerHTML}else if(this.count<=4){this.innerHTML+=o.innerHTML;this.limitedCount++}this.count++}}));this.swatchCount=this.productInfo.querySelector(`[${Is.swatchCount}]`);this.swatchElements=this.querySelectorAll(Ts.swatchLink);this.swatchForm=this.productInfo.querySelector(Ts.gridSwatchForm);this.hideSwatchesTimer=0;if(this.swatchCount.hasAttribute(Is.swatchCount)){if(this.swatchesStyle=="text"||this.swatchesStyle=="text-slider"){this.swatchCount.innerText=`${this.count} ${this.count>1?theme.strings.otherColor:theme.strings.oneColor}`;if(this.swatchesStyle=="text")return;this.swatchCount.addEventListener("mouseenter",(()=>{if(this.hideSwatchesTimer)clearTimeout(this.hideSwatchesTimer);this.productInfo.classList.add(qs.stopEvents);this.swatchForm.classList.add(qs.visible)}));this.productInfo.addEventListener("mouseleave",(()=>{this.hideSwatchesTimer=setTimeout((()=>{this.productInfo.classList.remove(qs.stopEvents);this.swatchForm.classList.remove(qs.visible)}),100)}))}if(this.swatchesStyle=="slider"||this.swatchesStyle=="grid"){this.swatchForm.classList.add(qs.visible)}if(this.swatchesStyle=="limited"){const e=this.count-this.limitedCount;this.swatchForm.classList.add(qs.visible);if(e>0){this.innerHTML+=`<div class="swatch-limited">+${e}</div>`}}}if(this.swatchesStyle=="text-slider"||this.swatchesStyle=="slider"){if(this.hasAttribute(Is.scrollbar)){new Cs(this)}}this.bindSwatchButtonEvents()}bindSwatchButtonEvents(){this.querySelectorAll(Ts.swatchButton)?.forEach((e=>{e.addEventListener("mouseenter",this.showVariantImageEvent);if(e.hasAttribute(Is.tooltip)){new Gt(e)}}));this.productItem.addEventListener("mouseleave",this.productItemMouseLeaveEvent)}showVariantImage(e){const t=e.target;const i=t.getAttribute(Is.variantName)?.replaceAll('"',"'");const s=this.productImage.querySelectorAll(`[${Is.variantTitle}]`);const o=this.productImage.querySelector(`[${Is.variantTitle}="${i}"]`);s?.forEach((e=>{e.classList.remove(qs.visible)}));o?.classList.add(qs.visible)}hideVariantImages(){this.productImage.querySelectorAll(`[${Is.variantTitle}].${qs.visible}`)?.forEach((e=>{e.classList.remove(qs.visible)}))}getSwatchesJSON(){if(!this.hasAttribute(Is.swatchValues))return{};const e=this.getAttribute(Is.swatchValues).split(",");const t={};e?.forEach((e=>{const[i,s]=e.split(":");t[i.trim()]=s.trim()}));return t}}const Ms={productCutline:"[data-product-cutline]",productLink:"[data-product-link]",productGridItem:"[data-grid-item]",productInfo:"[data-product-information]",productImage:"[data-product-image-default]",productImageSibling:"[data-product-image-sibling]",productPrice:"[data-product-price]",siblingsInnerHolder:"[data-sibling-inner]",siblingCount:"[data-sibling-count]",siblingFieldset:"[data-sibling-fieldset]",siblingLink:"[data-sibling-link]",tooltip:"[data-tooltip]"};const Hs={visible:"is-visible",fade:"is-fade",stopEvents:"no-events",active:"is-active"};const Os={siblingAddedImage:"data-sibling-added-image",siblingCutline:"data-sibling-cutline",siblingImage:"data-sibling-image",siblingLink:"data-sibling-link",siblingPrice:"data-sibling-price",siblingCompareAtPrice:"data-sibling-compare-at-price",productLink:"data-product-link"};class Bs{constructor(e,t){this.swatches=e;this.product=t;this.productLinks=this.product.querySelectorAll(Ms.productLink);this.productCutline=this.product.querySelector(Ms.productCutline);this.productPrice=this.product.querySelector(Ms.productPrice);this.productImage=this.product.querySelector(Ms.productImage);this.productImageSibling=this.product.querySelector(Ms.productImageSibling);this.init()}init(){this.cacheDefaultValues();this.product.addEventListener("mouseleave",(()=>this.resetProductValues()));this.swatches.forEach((e=>{e.addEventListener("mouseenter",(e=>this.showSibling(e)))}));if(this.productLinks.length){this.swatches.forEach((e=>{e.addEventListener("click",(()=>{this.productLinks[0].click()}))}))}}cacheDefaultValues(){this.productLinkValue=this.productLinks[0].hasAttribute(Os.productLink)?this.productLinks[0].getAttribute(Os.productLink):"";this.productPriceValue=this.productPrice.innerHTML;if(this.productCutline){this.productCutlineValue=this.productCutline.innerHTML}}resetProductValues(){this.product.classList.remove(Hs.active);if(this.productLinkValue){this.productLinks.forEach((e=>{e.href=this.productLinkValue}))}if(this.productPrice){this.productPrice.innerHTML=this.productPriceValue}if(this.productCutline&&this.productCutline){this.productCutline.innerHTML=this.productCutlineValue;this.productCutline.title=this.productCutlineValue}this.hideSiblingImage()}showSibling(e){const t=e.target;const i=t.hasAttribute(Os.siblingLink)?t.getAttribute(Os.siblingLink):"";const s=t.hasAttribute(Os.siblingPrice)?t.getAttribute(Os.siblingPrice):"";const o=t.hasAttribute(Os.siblingCompareAtPrice)?t.getAttribute(Os.siblingCompareAtPrice):"";const n=t.hasAttribute(Os.siblingCutline)?t.getAttribute(Os.siblingCutline):"";const r=t.hasAttribute(Os.siblingImage)?t.getAttribute(Os.siblingImage):"";if(i){this.productLinks.forEach((e=>{e.href=i}))}if(o){this.productPrice.innerHTML=`<span class="price sale"><span class="new-price">${s}</span> <span class="old-price">${o}</span></span>`}else{this.productPrice.innerHTML=`<span class="price">${s}</span>`}if(this.productCutline){if(n){this.productCutline.innerHTML=n;this.productCutline.title=n}else{this.productCutline.innerHTML="";this.productCutline.title=""}}if(r){this.showSiblingImage(r)}}showSiblingImage(e){if(!this.productImageSibling)return;const t=window.devicePixelRatio||1;const i=this.productImage.offsetWidth*t;const s=Math.ceil(i/180)*180;const n=o.getSizedImageUrl(e,`${s}x`);const r=this.productImageSibling.querySelector(`[src="${n}"]`);const a=()=>{this.productImageSibling.classList.add(Hs.visible);this.productImageSibling.querySelector(`[src="${n}"]`).classList.add(Hs.fade)};const l=()=>{this.productImageSibling.querySelectorAll("img").forEach((e=>{e.classList.remove(Hs.fade)}));requestAnimationFrame(a)};if(r){l()}else{const e=document.createElement("img");e.src=n;if(this.productCutline){e.alt=this.productCutline.innerText}e.addEventListener("load",(()=>{this.productImageSibling.append(e);l()}))}}hideSiblingImage(){if(!this.productImageSibling)return;this.productImageSibling.classList.remove(Hs.visible);this.productImageSibling.querySelectorAll("img").forEach((e=>{e.classList.remove(Hs.fade)}))}}class Ds extends HTMLElement{constructor(){super()}connectedCallback(){this.product=this.closest(Ms.productGridItem);this.siblingScrollbar=this.querySelector(Ms.siblingsInnerHolder);this.siblingCount=this.querySelector(Ms.siblingCount);this.siblingFieldset=this.querySelector(Ms.siblingFieldset);this.siblingLinks=this.querySelectorAll(Ms.siblingLink);this.productInfo=this.closest(Ms.productInfo);this.productLink=this.closest(Ms.link);this.hideSwatchesTimer=0;this.swatchesStyle=theme.settings.collectionSwatchStyle;this.initScrollbar();if(this.siblingFieldset&&this.productInfo){if(this.swatchesStyle=="grid"||this.swatchesStyle=="slider"||this.swatchesStyle=="limited"){this.siblingFieldset.classList.add(Hs.visible)}if(this.siblingCount){this.siblingCount.addEventListener("mouseenter",(()=>this.showSiblings()));this.productInfo.addEventListener("mouseleave",(()=>this.hideSiblings()))}}if(this.siblingLinks.length){new Bs(this.siblingLinks,this.product)}this.querySelectorAll(Ms.tooltip).forEach((e=>{new Gt(e)}))}showSiblings(){if(this.hideSwatchesTimer)clearTimeout(this.hideSwatchesTimer);if(this.productLink){this.productLink.classList.add(Hs.stopEvents)}if(this.swatchesStyle=="text")return;this.siblingFieldset.classList.add(Hs.visible)}hideSiblings(){this.hideSwatchesTimer=setTimeout((()=>{if(this.productLink){this.productLink.classList.remove(Hs.stopEvents)}this.siblingFieldset.classList.remove(Hs.visible)}),100)}initScrollbar(){if(this.siblingScrollbar){new Cs(this.siblingScrollbar)}}}const Fs={slide:"[data-hover-slide]",slideTouch:"[data-hover-slide-touch]",slider:"[data-hover-slider]",productLink:"[data-product-link]",flickityButton:".flickity-prev-next-button"};class _s extends HTMLElement{constructor(){super();this.flkty=null;this.slider=this.querySelector(Fs.slider);this.handleScroll=this.handleScroll.bind(this)}connectedCallback(){if(window.theme.touch){this.initTouch()}else{this.initFlickity()}}disconnectedCallback(){if(this.flkty){this.flkty.options.watchCSS=false;this.flkty.destroy()}}initTouch(){this.style.setProperty("--slides-count",this.querySelectorAll(Fs.slideTouch).length);this.slider.addEventListener("scroll",this.handleScroll)}handleScroll(){const e=this.slider.scrollLeft/this.slider.clientWidth;this.style.setProperty("--slider-index",e)}initFlickity(){if(this.querySelectorAll(Fs.slide).length<2)return;this.flkty=new i(this.slider,{cellSelector:Fs.slide,contain:true,wrapAround:true,watchCSS:true,autoPlay:false,draggable:false,pageDots:false,prevNextButtons:true});this.flkty.pausePlayer();this.addEventListener("mouseenter",(()=>{this.flkty.unpausePlayer()}));this.addEventListener("mouseleave",(()=>{this.flkty.pausePlayer()}));this.closest(Fs.productLink).addEventListener("click",(e=>{if(e.target.matches(Fs.flickityButton)){e.preventDefault()}}))}}const $s={body:"body",dataRelatedSectionElem:"[data-related-section]",dataTabsHolder:"[data-tabs-holder]",dataTab:"data-tab",dataTabIndex:"data-tab-index",dataAos:"[data-aos]",blockId:"data-block-id",tabsLi:"[data-tab]",tabLink:".tab-link",tabLinkRecent:".tab-link__recent",tabContent:".tab-content",scrollbarHolder:"[data-scrollbar]"};const Ns={current:"current",hidden:"hidden",aosAnimate:"aos-animate",aosNoTransition:"aos-no-transition",focused:"is-focused"};const Ws={};class Rs{constructor(e){this.container=e;this.body=document.querySelector($s.body);this.accessibility=window.accessibility;if(this.container){this.scrollbarHolder=this.container.querySelectorAll($s.scrollbarHolder);this.init();this.initNativeScrollbar()}}init(){const e=this.container.querySelectorAll($s.tabsLi);this.container.addEventListener("theme:tab:check",(()=>this.checkRecentTab()));this.container.addEventListener("theme:tab:hide",(()=>this.hideRelatedTab()));if(e.length){e.forEach((e=>{const t=parseInt(e.getAttribute($s.dataTab));const i=this.container.querySelector(`${$s.tabContent}-${t}`);e.addEventListener("click",(()=>{this.tabChange(e,i)}));e.addEventListener("keyup",(t=>{if((t.code==="Space"||t.code==="Enter")&&this.body.classList.contains(Ns.focused)){this.tabChange(e,i)}}))}))}}tabChange(e,t){if(e.classList.contains(Ns.current)){return}const i=this.container.querySelector(`${$s.tabsLi}.${Ns.current}`);const s=this.container.querySelector(`${$s.tabContent}.${Ns.current}`);i?.classList.remove(Ns.current);s?.classList.remove(Ns.current);e.classList.add(Ns.current);t.classList.add(Ns.current);if(e.classList.contains(Ns.hidden)){t.classList.add(Ns.hidden)}this.accessibility.a11y.removeTrapFocus();this.container.dispatchEvent(new CustomEvent("theme:tab:change",{bubbles:true}));e.dispatchEvent(new CustomEvent("theme:form:sticky",{bubbles:true,detail:{element:"tab"}}));this.animateItems(t)}animateItems(e,t=true){const i=e.querySelectorAll($s.dataAos);if(i.length){i.forEach((e=>{e.classList.remove(Ns.aosAnimate);if(t){e.classList.add(Ns.aosNoTransition);requestAnimationFrame((()=>{e.classList.remove(Ns.aosNoTransition);e.classList.add(Ns.aosAnimate)}))}}))}}initNativeScrollbar(){if(this.scrollbarHolder.length){this.scrollbarHolder.forEach((e=>{new Cs(e)}))}}checkRecentTab(){const e=this.container.querySelector($s.tabLinkRecent);if(e){e.classList.remove(Ns.hidden);const t=parseInt(e.getAttribute($s.dataTab));const i=this.container.querySelector(`${$s.tabContent}[${$s.dataTabIndex}="${t}"]`);if(i){i.classList.remove(Ns.hidden);this.animateItems(i,false)}this.initNativeScrollbar()}}hideRelatedTab(){const e=this.container.querySelector($s.dataRelatedSectionElem);if(!e){return}const t=e.closest(`${$s.tabContent}.${Ns.current}`);if(!t){return}const i=parseInt(t.getAttribute($s.dataTabIndex));const s=this.container.querySelectorAll($s.tabsLi);if(s.length>i){const e=s[i].nextSibling;if(e){s[i].classList.add(Ns.hidden);e.dispatchEvent(new Event("click"));this.initNativeScrollbar()}}}onBlockSelect(e){const t=this.container.querySelector(`${$s.tabLink}[${$s.blockId}="${e.detail.blockId}"]`);if(t){t.dispatchEvent(new Event("click"));t.parentNode.scrollTo({top:0,left:t.offsetLeft-t.clientWidth,behavior:"smooth"})}}}const Vs={onLoad(){Ws[this.id]=[];const e=this.container.querySelectorAll($s.dataTabsHolder);e.forEach((e=>{Ws[this.id].push(new Rs(e))}))},onBlockSelect(e){Ws[this.id].forEach((t=>{if(typeof t.onBlockSelect==="function"){t.onBlockSelect(e)}}))}};function Us(){const e=Boolean(document.querySelectorAll("dialog[open][data-scroll-lock-required]").length);const t=Boolean(document.querySelectorAll(".drawer.is-open").length);return e||t}const zs={added:"is-added",animated:"is-animated",disabled:"is-disabled",error:"has-error",loading:"is-loading",open:"is-open",overlayText:"product-item--overlay-text",visible:"is-visible",siblingLinkCurrent:"sibling__link--current"};const js={errorDelay:3e3};const Js={animation:"[data-animation]",apiContent:"[data-api-content]",buttonQuickAdd:"[data-quick-add-btn]",buttonAddToCart:"[data-add-to-cart]",cartDrawer:"cart-drawer",cartPage:"[data-cart-page]",cartLineItems:"[data-line-items]",dialog:"dialog",focusable:'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',messageError:"[data-message-error]",modalButton:"[data-quick-add-modal-handle]",modalContainer:"[data-product-upsell-container]",modalContent:"[data-product-upsell-ajax]",modalClose:"[data-quick-add-modal-close]",productGridItem:"data-grid-item",productInformationHolder:"[data-product-information]",quickAddHolder:"[data-quick-add-holder]",quickAddModal:"[data-quick-add-modal]",quickAddModalTemplate:"[data-quick-add-modal-template]",tooltip:"[data-tooltip]"};const Xs={closing:"closing",productId:"data-product-id",modalHandle:"data-quick-add-modal-handle",siblingSwapper:"data-sibling-swapper",quickAddHolder:"data-quick-add-holder"};class Gs extends HTMLElement{constructor(){super();this.container=this;this.quickAddHolder=this.container.querySelector(Js.quickAddHolder);if(this.quickAddHolder){this.modal=null;this.currentModal=null;this.productId=this.quickAddHolder.getAttribute(Xs.quickAddHolder);this.modalButton=this.quickAddHolder.querySelector(Js.modalButton);this.handle=this.modalButton?.getAttribute(Xs.modalHandle);this.buttonQuickAdd=this.quickAddHolder.querySelector(Js.buttonQuickAdd);this.buttonATC=this.quickAddHolder.querySelector(Js.buttonAddToCart);this.button=this.modalButton||this.buttonATC;this.modalClose=this.modalClose.bind(this);this.modalCloseOnProductAdded=this.modalCloseOnProductAdded.bind(this);this.a11y=te;this.isAnimating=false;this.modalButtonClickEvent=this.modalButtonClickEvent.bind(this);this.quickAddLoadingToggle=this.quickAddLoadingToggle.bind(this)}}connectedCallback(){if(this.modalButton){this.modalButton.addEventListener("click",this.modalButtonClickEvent)}if(this.buttonATC){this.buttonATC.addEventListener("click",(e=>{e.preventDefault();window.accessibility.lastElement=this.buttonATC;document.dispatchEvent(new CustomEvent("theme:cart:add",{detail:{button:this.buttonATC}}))}))}if(this.quickAddHolder){this.quickAddHolder.addEventListener("animationend",this.quickAddLoadingToggle);this.errorHandler()}}modalButtonClickEvent(e){e.preventDefault();const t=this.modalButton.hasAttribute(Xs.siblingSwapper);const i=this.modalButton.classList.contains(zs.siblingLinkCurrent);if(i)return;this.modalButton.classList.add(zs.loading);this.modalButton.disabled=true;if(t&&!i){this.currentModal=e.target.closest(Js.quickAddModal);this.currentModal.classList.add(zs.loading)}this.renderModal()}modalCreate(e){const t=document.querySelector(`${Js.quickAddModal}[${Xs.productId}="${this.productId}"]`);if(t){this.modal=t;this.modalOpen()}else{const t=this.quickAddHolder.querySelector(Js.quickAddModalTemplate);if(!t)return;const i=document.createElement("div");i.innerHTML=t.innerHTML;document.body.appendChild(i.querySelector(Js.quickAddModal));t.remove();this.modal=document.querySelector(`${Js.quickAddModal}[${Xs.productId}="${this.productId}"]`);this.modal.querySelector(Js.modalContent).innerHTML=(new DOMParser).parseFromString(e,"text/html").querySelector(Js.apiContent).innerHTML;this.modal.querySelectorAll(Js.tooltip).forEach((e=>{new Gt(e)}));this.modalCreatedCallback()}}modalOpen(){if(this.currentModal){this.currentModal.dispatchEvent(new CustomEvent("theme:modal:close",{bubbles:false}))}if(typeof this.modal.show==="function"){this.modal.show()}this.modal.setAttribute("open",true);this.modal.removeAttribute("inert");this.quickAddHolder.classList.add(zs.disabled);if(this.modalButton){this.modalButton.classList.remove(zs.loading);this.modalButton.disabled=false;window.accessibility.lastElement=this.modalButton}requestAnimationFrame((()=>{this.modal.querySelectorAll(Js.animation).forEach((e=>{e.classList.add(zs.animated)}))}));document.dispatchEvent(new CustomEvent("theme:quick-add:open",{bubbles:true}));document.dispatchEvent(new CustomEvent("theme:scroll:lock",{bubbles:true}));document.addEventListener("theme:product:added",this.modalCloseOnProductAdded,{once:true})}modalClose(){if(this.isAnimating){return}if(!this.modal.hasAttribute(Xs.closing)){this.modal.setAttribute(Xs.closing,"");this.isAnimating=true;return}if(typeof this.modal.close==="function"){this.modal.close()}else{this.modal.removeAttribute("open")}this.modal.removeAttribute(Xs.closing);this.modal.setAttribute("inert","");this.modal.classList.remove(zs.loading);if(this.modalButton){this.modalButton.disabled=false}if(this.quickAddHolder&&this.quickAddHolder.classList.contains(zs.disabled)){this.quickAddHolder.classList.remove(zs.disabled)}this.resetAnimatedItems();if(!Us()){document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{bubbles:true}))}document.removeEventListener("theme:product:added",this.modalCloseOnProductAdded);this.a11y.removeTrapFocus();this.a11y.autoFocusLastElement()}modalEvents(){this.modal.querySelector(Js.modalClose)?.addEventListener("click",(e=>{e.preventDefault();this.modalClose()}));this.modal.addEventListener("click",(e=>{if(e.target.nodeName==="DIALOG"&&e.type==="click"){this.modalClose()}}));this.modal.addEventListener("keydown",(e=>{if(e.code=="Escape"){e.preventDefault();this.modalClose()}}));this.modal.addEventListener("theme:modal:close",(()=>{this.modalClose()}));this.modal.addEventListener("animationend",(e=>{if(e.target!==this.modal)return;this.isAnimating=false;if(this.modal.hasAttribute(Xs.closing)){this.modalClose()}else{setTimeout((()=>{this.a11y.trapFocus(this.modal);const e=this.modal.querySelector("[autofocus]")||this.modal.querySelector(Js.focusable);e?.focus()}),50)}}))}modalCloseOnProductAdded(){this.resetQuickAddButtons();if(this.modal&&this.modal.hasAttribute("open")){this.modalClose()}}quickAddLoadingToggle(e){if(e.target!=this.quickAddHolder)return;this.quickAddHolder.classList.remove(zs.disabled)}errorHandler(){this.quickAddHolder.addEventListener("theme:cart:error",(e=>{const t=e.detail.holder;const i=t.closest(`[${Js.productGridItem}]`);if(!i)return;const s=t.querySelector(Js.messageError);const o=i.classList.contains(zs.overlayText);const n=i.querySelector(Js.productInformationHolder);const r=t.querySelector(Js.buttonAddToCart);if(r){r.classList.remove(zs.added,zs.loading);t.classList.add(zs.error)}if(s){s.innerText=e.detail.description}if(o){n.classList.add(zs.hidden)}setTimeout((()=>{this.resetQuickAddButtons();if(o){n.classList.remove(zs.hidden)}}),js.errorDelay)}))}resetQuickAddButtons(){if(this.quickAddHolder){this.quickAddHolder.classList.remove(zs.visible,zs.error)}if(this.buttonQuickAdd){this.buttonQuickAdd.classList.remove(zs.added);this.buttonQuickAdd.disabled=false}}renderModal(){if(this.modal){this.modalOpen()}else{window.fetch(`${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`).then(this.upsellErrorsHandler).then((e=>e.text())).then((e=>{this.modalCreate(e)}))}}modalCreatedCallback(){this.modalEvents();this.modalOpen();D(this.modal)}upsellErrorsHandler(e){if(!e.ok){return e.json().then((function(t){const i=new Ge({status:e.statusText,headers:e.headers,json:t});throw i}))}return e}resetAnimatedItems(){this.modal?.querySelectorAll(Js.animation).forEach((e=>{e.classList.remove(zs.animated)}))}}Ft("product-grid",[Vs]);if(!customElements.get("quick-add-product")){customElements.define("quick-add-product",Gs)}if(!customElements.get("radio-swatch")){customElements.define("radio-swatch",Ps)}if(!customElements.get("grid-swatch")){customElements.define("grid-swatch",xs)}if(!customElements.get("product-siblings")){customElements.define("product-siblings",Ds)}if(!customElements.get("hover-images")){customElements.define("hover-images",_s)}const Ys={fields:'input:not([type="checkbox"]):not([type="hidden"]), textarea',fieldEmail:'input[type="email"]',fieldCheckbox:'input[type="checkbox"]',form:"[data-form-wrapper]"};class Qs extends HTMLElement{constructor(){super();this.fieldCheckbox=this.querySelector(Ys.fieldCheckbox);this.fieldEmail=this.querySelector(Ys.fieldEmail);this.fields=this.querySelectorAll(Ys.fields);this.form=this.closest(Ys.form);this.onChangeEvent=e=>this.onChange(e)}connectedCallback(){if(this.fieldCheckbox){this.fieldCheckbox.addEventListener("change",this.onChangeEvent);if(this.form){this.form.addEventListener("theme:product:add",(()=>{this.fieldCheckbox.checked=false;this.fieldCheckbox.dispatchEvent(new Event("change"))}))}}}clearInputValues(){if(this.fields.length){this.fields.forEach((e=>{e.value=""}))}}onChange(e){this.fieldEmail.required=Boolean(e.target.checked);if(!e.target.checked){this.clearInputValues()}}disconnectedCallback(){this.fieldCheckbox.removeEventListener("change",this.onChangeEvent)}}const Ks={productPage:".product__page",formWrapper:"[data-form-wrapper]",headerSticky:"[data-header-sticky]",productMediaList:"[data-product-media-list]"};const Zs={sticky:"is-sticky"};const eo={stickyEnabled:"data-sticky-enabled"};window.theme.variables={productPageSticky:false};const to={};class io{constructor(e){this.section=e;this.container=e.container;this.stickyEnabled=this.container.getAttribute(eo.stickyEnabled)==="true";this.formWrapper=this.container.querySelector(Ks.formWrapper);this.stickyScrollTop=0;this.scrollLastPosition=0;this.stickyDefaultTop=0;this.currentPoint=0;this.defaultTopBottomSpacings=30;this.scrollTop=window.scrollY;this.scrollDirectionDown=true;this.requestAnimationSticky=null;this.stickyFormLoad=true;this.stickyFormLastHeight=null;this.onChangeCounter=0;this.scrollEvent=e=>this.scrollEvents(e);this.resizeEvent=e=>this.resizeEvents(e);this.stickyFormEvent=e=>this.stickyFormEvents(e);setTimeout((()=>{this.init()}),50)}init(){if(this.stickyEnabled){this.stickyScrollCheck();document.addEventListener("theme:resize",this.resizeEvent)}this.initSticky()}initSticky(){if(theme.variables.productPageSticky){this.requestAnimationSticky=requestAnimationFrame((()=>this.calculateStickyPosition()));this.formWrapper.addEventListener("theme:form:sticky",this.stickyFormEvent);document.addEventListener("theme:scroll",this.scrollEvent)}}stickyFormEvents(e){this.removeAnimationFrameSticky();this.requestAnimationSticky=requestAnimationFrame((()=>this.calculateStickyPosition(e)))}scrollEvents(e){this.scrollTop=e.detail.position;this.scrollDirectionDown=e.detail.down;if(!this.requestAnimationSticky){this.requestAnimationSticky=requestAnimationFrame((()=>this.calculateStickyPosition()))}}resizeEvents(e){this.stickyScrollCheck();document.removeEventListener("theme:scroll",this.scrollEvent);this.formWrapper.removeEventListener("theme:form:sticky",this.stickyFormEvent);this.initSticky()}stickyScrollCheck(){const e=this.container.querySelector(`${Ks.productPage} ${Ks.formWrapper}`);if(!e)return;if(b()){const t=this.container.querySelector(Ks.formWrapper);const i=this.container.querySelector(Ks.productMediaList);if(!t||!i)return;const s=t.offsetHeight;const o=i.offsetHeight;if(s<o){theme.variables.productPageSticky=true;e.classList.add(Zs.sticky)}else{theme.variables.productPageSticky=false;e.classList.remove(Zs.sticky)}}else{theme.variables.productPageSticky=false;e.classList.remove(Zs.sticky)}}calculateStickyPosition(e=null){const t=document.documentElement.hasAttribute("data-scroll-locked");if(t){this.removeAnimationFrameSticky();return}const i=Boolean(e&&e.detail);const s=Boolean(i&&e.detail.element&&e.detail.element==="accordion");const o=this.formWrapper.offsetHeight;const n=window.innerHeight-o-this.defaultTopBottomSpacings;const r=Math.abs(this.scrollTop-this.scrollLastPosition);if(this.scrollDirectionDown){this.stickyScrollTop-=r}else{this.stickyScrollTop+=r}if(this.stickyFormLoad){if(document.querySelector(Ks.headerSticky)){let{headerHeight:e}=l();this.stickyDefaultTop=e}else{this.stickyDefaultTop=this.defaultTopBottomSpacings}this.stickyScrollTop=this.stickyDefaultTop}this.stickyScrollTop=Math.min(Math.max(this.stickyScrollTop,n),this.stickyDefaultTop);const a=this.stickyScrollTop-this.currentPoint;this.currentPoint=this.stickyFormLoad?this.stickyScrollTop:this.currentPoint+a*.5;this.formWrapper.style.setProperty("--sticky-top",`${this.currentPoint}px`);this.scrollLastPosition=this.scrollTop;this.stickyFormLoad=false;if(s&&this.onChangeCounter<=10||s&&this.stickyFormLastHeight!==o||this.stickyScrollTop!==this.currentPoint&&this.requestAnimationSticky){if(s){this.onChangeCounter+=1}if(s&&this.stickyFormLastHeight!==o){this.onChangeCounter=11}this.requestAnimationSticky=requestAnimationFrame((()=>this.calculateStickyPosition(e)))}else if(this.requestAnimationSticky){this.removeAnimationFrameSticky()}this.stickyFormLastHeight=o}removeAnimationFrameSticky(){if(this.requestAnimationSticky){cancelAnimationFrame(this.requestAnimationSticky);this.requestAnimationSticky=null;this.onChangeCounter=0}}onUnload(){if(this.stickyEnabled){document.removeEventListener("theme:resize",this.resizeEvent)}if(theme.variables.productPageSticky){document.removeEventListener("theme:scroll",this.scrollEvent)}}}const so={onLoad(){to[this.id]=new io(this)},onUnload(){to[this.id].onUnload()}};const oo={buttonArrow:"[data-button-arrow]",deferredMediaButton:"[data-deferred-media-button]",focusedElement:"model-viewer, video, iframe, button, [href], input, [tabindex]",productMedia:"[data-image-id]",productMediaList:"[data-product-media-list]",section:"[data-section-type]"};const no={arrows:"slider__arrows",dragging:"is-dragging",hidden:"hidden",isFocused:"is-focused",mediaActive:"media--active",mediaHidden:"media--hidden",mediaHiding:"media--hiding"};const ro={activeMedia:"data-active-media",buttonPrev:"data-button-prev",buttonNext:"data-button-next",imageId:"data-image-id",mediaId:"data-media-id",type:"data-type",faderDesktop:"data-fader-desktop",faderMobile:"data-fader-mobile"};class ao extends HTMLElement{constructor(){super();this.initialized=false;this.buttons=false;this.isDown=false;this.startX=0;this.startY=0;this.scrollLeft=0;this.onButtonArrowClick=e=>this.buttonArrowClickEvent(e);this.container=this.closest(oo.section);this.handleMouseDown=this.handleMouseDown.bind(this);this.handleMouseLeave=this.handleMouseLeave.bind(this);this.handleMouseUp=this.handleMouseUp.bind(this);this.handleMouseMove=this.handleMouseMove.bind(this);this.handleKeyUp=this.handleKeyUp.bind(this);this.productMediaItems=this.querySelectorAll(oo.productMedia);this.productMediaList=this.querySelector(oo.productMediaList);this.setHeight=this.setHeight.bind(this);this.toggleEvents=this.toggleEvents.bind(this);this.selectMediaEvent=e=>this.showMediaOnVariantSelect(e)}connectedCallback(){if(Object.keys(this.productMediaItems).length===1)return;this.productMediaObserver();this.toggleEvents();this.listen();this.setHeight()}disconnectedCallback(){this.unlisten()}listen(){document.addEventListener("theme:resize:width",this.toggleEvents);document.addEventListener("theme:resize:width",this.setHeight);this.addEventListener("theme:media:select",this.selectMediaEvent)}unlisten(){document.removeEventListener("theme:resize:width",this.toggleEvents);document.removeEventListener("theme:resize:width",this.setHeight);this.removeEventListener("theme:media:select",this.selectMediaEvent)}toggleEvents(){const e=y();if(e&&this.hasAttribute(ro.faderMobile)||!e&&this.hasAttribute(ro.faderDesktop)){this.bindEventListeners()}else{this.unbindEventListeners()}}bindEventListeners(){if(this.initialized)return;this.productMediaList.addEventListener("mousedown",this.handleMouseDown);this.productMediaList.addEventListener("mouseleave",this.handleMouseLeave);this.productMediaList.addEventListener("mouseup",this.handleMouseUp);this.productMediaList.addEventListener("mousemove",this.handleMouseMove);this.productMediaList.addEventListener("touchstart",this.handleMouseDown,{passive:true});this.productMediaList.addEventListener("touchend",this.handleMouseUp,{passive:true});this.productMediaList.addEventListener("touchmove",this.handleMouseMove,{passive:true});this.productMediaList.addEventListener("keyup",this.handleKeyUp);this.initArrows();this.resetScrollPosition();this.initialized=true}unbindEventListeners(){if(!this.initialized)return;this.productMediaList.removeEventListener("mousedown",this.handleMouseDown);this.productMediaList.removeEventListener("mouseleave",this.handleMouseLeave);this.productMediaList.removeEventListener("mouseup",this.handleMouseUp);this.productMediaList.removeEventListener("mousemove",this.handleMouseMove);this.productMediaList.removeEventListener("touchstart",this.handleMouseDown);this.productMediaList.removeEventListener("touchend",this.handleMouseUp);this.productMediaList.removeEventListener("touchmove",this.handleMouseMove);this.productMediaList.removeEventListener("keyup",this.handleKeyUp);this.removeArrows();this.initialized=false}handleMouseDown(e){this.isDown=true;this.startX=(e.pageX||e.changedTouches[0].screenX)-this.offsetLeft;this.startY=(e.pageY||e.changedTouches[0].screenY)-this.offsetTop}handleMouseLeave(){if(!this.isDown)return;this.isDown=false}handleMouseUp(e){const t=(e.pageX||e.changedTouches[0].screenX)-this.offsetLeft;const i=(e.pageY||e.changedTouches[0].screenY)-this.offsetTop;const s=t-this.startX;const o=i-this.startY;const n=s>0?1:-1;const r=this.getCurrentMedia().hasAttribute(ro.type)&&this.getCurrentMedia().getAttribute(ro.type)==="image";if(Math.abs(s)>10&&Math.abs(s)>Math.abs(o)&&r){n<0?this.showNextImage():this.showPreviousImage()}this.isDown=false;requestAnimationFrame((()=>{this.classList.remove(no.dragging)}))}handleMouseMove(){if(!this.isDown)return;this.classList.add(no.dragging)}handleKeyUp(e){if(e.code==="ArrowLeft"){this.showPreviousImage()}if(e.code==="ArrowRight"){this.showNextImage()}}handleArrowsClickEvent(){this.querySelectorAll(oo.buttonArrow)?.forEach((e=>{e.addEventListener("click",(e=>{e.preventDefault();if(e.target.hasAttribute(ro.buttonPrev)){this.showPreviousImage()}if(e.target.hasAttribute(ro.buttonNext)){this.showNextImage()}}))}))}resetScrollPosition(){if(this.productMediaList.scrollLeft!==0){this.productMediaList.scrollLeft=0}}initArrows(){if(!this.buttons.length){const e=document.createElement("div");e.classList.add(no.arrows);e.innerHTML=theme.sliderArrows.prev+theme.sliderArrows.next;this.productMediaList.append(e);this.buttons=this.querySelectorAll(oo.buttonArrow);this.buttonPrev=this.querySelector(`[${ro.buttonPrev}]`);this.buttonNext=this.querySelector(`[${ro.buttonNext}]`)}this.handleArrowsClickEvent();this.preloadImageOnArrowHover()}removeArrows(){this.querySelector(`.${no.arrows}`)?.remove()}preloadImageOnArrowHover(){this.buttonPrev?.addEventListener("mouseover",(()=>{const e=this.getPreviousMediaId();this.preloadImage(e)}));this.buttonNext?.addEventListener("mouseover",(()=>{const e=this.getNextMediaId();this.preloadImage(e)}))}preloadImage(e){this.querySelector(`[${ro.mediaId}="${e}"] img`)?.setAttribute("loading","eager")}showMediaOnVariantSelect(e){const t=e.detail.id;this.setActiveMedia(t)}getCurrentMedia(){return this.querySelector(`${oo.productMedia}.${no.mediaActive}`)}getNextMediaId(){const e=this.getCurrentMedia();const t=e?.nextElementSibling.hasAttribute(ro.imageId)?e?.nextElementSibling:this.querySelector(oo.productMedia);return t?.getAttribute(ro.mediaId)}getPreviousMediaId(){const e=this.getCurrentMedia();const t=this.productMediaItems.length-1;const i=e?.previousElementSibling||this.productMediaItems[t];return i?.getAttribute(ro.mediaId)}showNextImage(){const e=this.getNextMediaId();this.selectMedia(e)}showPreviousImage(){const e=this.getPreviousMediaId();this.selectMedia(e)}selectMedia(e){this.dispatchEvent(new CustomEvent("theme:media:select",{detail:{id:e}}))}setActiveMedia(e){if(!e)return;this.setAttribute(ro.activeMedia,e);const t=this.querySelector(`${oo.productMedia}.${no.mediaActive}`);const i=this.querySelector(`[${ro.mediaId}="${e}"]`);const s=i?.querySelector(oo.focusedElement);const o=i.querySelector("deferred-media");t?.classList.add(no.mediaHiding);t?.classList.remove(no.mediaActive);i?.classList.remove(no.mediaHiding,no.mediaHidden);i?.classList.add(no.mediaActive);if(o&&o.getAttribute("loaded")!==true){i.querySelector(oo.deferredMediaButton)?.dispatchEvent(new Event("click",{bubbles:false}))}requestAnimationFrame((()=>{this.setHeight();if(document.body.classList.contains(no.isFocused)){s?.focus()}}))}setHeight(){const e=this.querySelector(`${oo.productMedia}.${no.mediaActive}`)?.offsetHeight||this.productMediaItems[0]?.offsetHeight;this.style.setProperty("--height",`${e}px`)}productMediaObserver(){this.productMediaItems.forEach((e=>{e.addEventListener("transitionend",(t=>{if(t.target==e&&e.classList.contains(no.mediaHiding)){e.classList.remove(no.mediaHiding);e.classList.add(no.mediaHidden)}}));e.addEventListener("transitioncancel",(t=>{if(t.target==e&&e.classList.contains(no.mediaHiding)){e.classList.remove(no.mediaHiding);e.classList.add(no.mediaHidden)}}))}))}}const lo=e=>{if(e){e.style.display="none"}};const co={optionPosition:"data-option-position",optionInput:'[name^="options"], [data-popout-option]',optionInputCurrent:'[name^="options"]:checked, [name^="options"][type="hidden"]',selectOptionValue:"data-value",popout:"[data-popout]"};const ho={soldOut:"sold-out",unavailable:"unavailable",sale:"sale"};class uo{constructor(e,t){this.container=e;this.productJSON=t;this.optionElements=this.container.querySelectorAll(co.optionInput);if(this.productJSON&&this.optionElements.length){this.init()}}init(){this.update()}update(){this.getCurrentState();this.optionElements.forEach((e=>{const t=e.closest(`[${co.optionPosition}]`);if(!t)return;const i=e.value||e.getAttribute(co.selectOptionValue);const s=t.getAttribute(co.optionPosition);const o=parseInt(s,10)-1;const n=e.closest(co.popout);let r=[...this.selections];r[o]=i;const a=this.productJSON.variants.find((e=>{let t=true;for(let i=0;i<r.length;i++){if(e.options[i]!==r[i]){t=false}}return t}));e.classList.remove(ho.soldOut,ho.unavailable);e.parentNode.classList.remove(ho.sale);if(n){n.classList.remove(ho.soldOut,ho.unavailable,ho.sale)}if(typeof a==="undefined"){e.classList.add(ho.unavailable);if(n){n.classList.add(ho.unavailable)}}else if(a&&a.available===false){e.classList.add(ho.soldOut);if(n){n.classList.add(ho.soldOut)}}if(a&&a.compare_at_price>a.price&&theme.settings.variantOnSale){e.parentNode.classList.add(ho.sale)}}))}getCurrentState(){this.selections=[];const e=this.container.querySelectorAll(co.optionInputCurrent);if(e.length){e.forEach((e=>{const t=e.value;if(t&&t!==""){this.selections.push(t)}}))}}}const po={product:"[data-product]",productForm:"[data-product-form]",productNotification:"product-notification",variantTitle:"[data-variant-title]",notificationProduct:"[data-notification-product]",addToCart:"[data-add-to-cart]",addToCartText:"[data-add-to-cart-text]",cartPage:"[data-cart-page]",comparePrice:"[data-compare-price]",comparePriceText:"[data-compare-text]",formWrapper:"[data-form-wrapper]",originalSelectorId:"[data-product-select]",priceWrapper:"[data-price-wrapper]",productImages:"product-images",productImage:"[data-product-image]",productMediaList:"[data-product-media-list]",productJson:"[data-product-json]",productPrice:"[data-product-price]",unitPrice:"[data-product-unit-price]",unitBase:"[data-product-base]",unitWrapper:"[data-product-unit]",isPreOrder:"[data-product-preorder]",productSlide:".product__slide",subPrices:"[data-subscription-watch-price]",subSelectors:"[data-subscription-selectors]",subsToggle:"[data-toggles-group]",subsChild:"data-group-toggle",subDescription:"[data-plan-description]",section:"[data-section-type]",variantSku:"[data-variant-sku]",variantBarcode:"[data-variant-barcode]",variantFinalSaleMeta:"[data-variant-final-sale-metafield]",variantButtons:"[data-variant-buttons]",variantOptionImage:"[data-variant-option-image]",quickAddModal:"[data-quick-add-modal]",priceOffWrap:"[data-price-off]",priceOffType:"[data-price-off-type]",priceOffAmount:"[data-price-off-amount]",remainingCount:"[data-remaining-count]",remainingMax:"[data-remaining-max]",remainingWrapper:"[data-remaining-wrapper]",remainingJSON:"[data-product-remaining-json]",optionValue:"[data-option-value]",optionPosition:"[data-option-position]",installment:"[data-product-form-installment]",inputId:'input[name="id"]'};const mo={hidden:"hidden",variantSoldOut:"variant--soldout",variantUnavailable:"variant--unavailable",productPriceSale:"product__price--sale",remainingLow:"count-is-low",remainingIn:"count-is-in",remainingOut:"count-is-out",remainingUnavailable:"count-is-unavailable"};const fo={remainingMaxAttr:"data-remaining-max",enableHistoryState:"data-enable-history-state",notificationPopup:"data-notification-popup",faderDesktop:"data-fader-desktop",faderMobile:"data-fader-mobile",optionPosition:"data-option-position",imageId:"data-image-id",mediaId:"data-media-id",quickAddButton:"data-quick-add-btn",finalSale:"data-final-sale",variantImageScroll:"data-variant-image-scroll"};class go extends HTMLElement{constructor(){super()}connectedCallback(){this.cartAddEvents();this.container=this.closest(po.section)||this.closest(po.quickAddModal);if(!this.container)return;this.sectionId=this.container.dataset.sectionId;this.product=this.container.querySelector(po.product);this.productForm=this.container.querySelector(po.productForm);this.productNotification=this.container.querySelector(po.productNotification);this.productImages=this.container.querySelector(po.productImages);this.productMediaList=this.container.querySelector(po.productMediaList);this.installmentForm=this.container.querySelector(po.installment);this.skuWrapper=this.container.querySelector(po.variantSku);this.barcodeWrapper=this.container.querySelector(po.variantBarcode);this.sellout=null;this.variantImageScroll=this.container.getAttribute(fo.variantImageScroll)==="true";this.priceOffWrap=this.container.querySelector(po.priceOffWrap);this.priceOffAmount=this.container.querySelector(po.priceOffAmount);this.priceOffType=this.container.querySelector(po.priceOffType);this.planDescription=this.container.querySelector(po.subDescription);this.remainingWrapper=this.container.querySelector(po.remainingWrapper);if(this.remainingWrapper){const e=this.container.querySelector(po.remainingMax);if(e){this.remainingMaxInt=parseInt(e.getAttribute(fo.remainingMaxAttr),10);this.remainingCount=this.container.querySelector(po.remainingCount);this.remainingJSONWrapper=this.container.querySelector(po.remainingJSON);this.remainingJSON=null;if(this.remainingJSONWrapper&&this.remainingJSONWrapper.innerHTML!==""){this.remainingJSON=JSON.parse(this.remainingJSONWrapper.innerHTML)}else{console.warn("Missing product quantity JSON")}}}this.enableHistoryState=this.container.getAttribute(fo.enableHistoryState)==="true";this.hasUnitPricing=this.container.querySelector(po.unitWrapper);this.subSelectors=this.container.querySelector(po.subSelectors);this.subPrices=this.container.querySelector(po.subPrices);this.isPreOrder=this.container.querySelector(po.isPreOrder);let e=null;const t=this.container.querySelector(po.productJson);if(t){e=t.innerHTML}if(e){this.productJSON=JSON.parse(e);this.linkForm();this.sellout=new uo(this.container,this.productJSON)}else{console.error("Missing product JSON")}this.variantOptionImages=this.container.querySelectorAll(po.variantOptionImage);this.variantButtons=this.container.querySelectorAll(po.variantButtons);if(this.variantOptionImages.length>1){this.optionImagesWidth()}}cartAddEvents(){this.buttonATC=this.querySelector(po.addToCart);this.buttonATC.addEventListener("click",(e=>{e.preventDefault();document.dispatchEvent(new CustomEvent("theme:cart:add",{detail:{button:this.buttonATC},bubbles:false}));if(!this.closest(po.quickAddModal)){window.accessibility.lastElement=this.buttonATC}}))}destroy(){this.productForm.destroy()}linkForm(){this.productForm=new Ss(this.container,this.productJSON,{onOptionChange:this.onOptionChange.bind(this),onPlanChange:this.onPlanChange.bind(this)});this.pushState(this.productForm.getFormState(),true);this.subsToggleListeners()}onOptionChange(e){this.pushState(e.dataset);this.updateProductImage(e)}onPlanChange(e){if(this.subPrices){this.pushState(e.dataset)}}pushState(e,t=false){this.productState=this.setProductState(e);this.updateAddToCartState(e);this.updateNotificationForm(e);this.updateProductPrices(e);this.updateSaleText(e);this.updateSku(e);this.updateBarcode(e);this.updateSubscriptionText(e);this.updateRemaining(e);this.updateLegend(e);this.fireHookEvent(e);this.sellout?.update(e);if(this.enableHistoryState&&!t){this.updateHistoryState(e)}}updateAddToCartState(e){const t=e.variant;let i=theme.strings.addToCart;const s=this.container.querySelectorAll(po.priceWrapper);const o=this.container.querySelectorAll(po.addToCart);const n=this.container.querySelectorAll(po.addToCartText);const r=this.container.querySelectorAll(po.formWrapper);if(this.installmentForm&&t){const e=this.installmentForm.querySelector(po.inputId);e.value=t.id;e.dispatchEvent(new Event("change",{bubbles:true}))}if(this.isPreOrder){i=theme.strings.preOrder}if(s.length&&t){s.forEach((e=>{e.classList.remove(mo.hidden)}))}o?.forEach((e=>{if(e.hasAttribute(fo.quickAddButton))return;if(t){if(t.available){e.disabled=false}else{e.disabled=true}}else{e.disabled=true}}));n?.forEach((e=>{let s=i;if(t){if(!t.available){s=theme.strings.soldOut}}else{s=theme.strings.unavailable}e.textContent=s}));if(r.length){r.forEach((e=>{if(t){if(t.available){e.classList.remove(mo.variantSoldOut,mo.variantUnavailable)}else{e.classList.add(mo.variantSoldOut);e.classList.remove(mo.variantUnavailable)}const i=e.querySelector(po.originalSelectorId);if(i){i.value=t.id}const s=e.querySelector(`${po.inputId}[form]`);if(s){s.value=t.id;s.dispatchEvent(new Event("change"))}}else{e.classList.add(mo.variantUnavailable);e.classList.remove(mo.variantSoldOut)}}))}}updateNotificationForm(e){if(!this.productNotification)return;const t=this.productNotification.querySelector(po.variantTitle);const i=this.productNotification.querySelector(po.notificationProduct);if(t!=null){t.textContent=e.variant.title;i.value=e.variant.name}}updateHistoryState(e){const t=e.variant;const i=e.plan;const s=window.location.href;if(t&&s.includes("/product")){const e=new window.URL(s);const o=e.searchParams;o.set("variant",t.id);if(i&&i.detail&&i.detail.id&&this.productState.hasPlan){o.set("selling_plan",i.detail.id)}else{o.delete("selling_plan")}e.search=o.toString();const n=e.toString();window.history.replaceState({path:n},"",n)}}updateRemaining(e){const t=e.variant;this.remainingWrapper?.classList.remove(mo.remainingIn,mo.remainingOut,mo.remainingUnavailable,mo.remainingLow);if(t&&this.remainingWrapper&&this.remainingJSON){const e=this.remainingJSON[t.id];if(e==="out"||e<1){this.remainingWrapper.classList.add(mo.remainingOut)}if(e==="in"||e>=this.remainingMaxInt){this.remainingWrapper.classList.add(mo.remainingIn)}if(e==="low"||e>0&&e<this.remainingMaxInt){this.remainingWrapper.classList.add(mo.remainingLow);if(this.remainingCount){this.remainingCount.innerHTML=e}}}else if(!t&&this.remainingWrapper){this.remainingWrapper.classList.add(mo.remainingUnavailable)}}optionImagesWidth(){if(!this.variantButtons)return;let e=0;requestAnimationFrame((()=>{this.variantOptionImages.forEach((t=>{const i=t.clientWidth;if(i>e){e=i}}));this.variantButtons.forEach((t=>{t.style?.setProperty("--option-image-width",e+"px")}))}))}getBaseUnit(e){return e.unit_price_measurement.reference_value===1?e.unit_price_measurement.reference_unit:e.unit_price_measurement.reference_value+e.unit_price_measurement.reference_unit}subsToggleListeners(){const e=this.container.querySelectorAll(po.subsToggle);e.forEach((e=>{e.addEventListener("change",function(e){const t=e.target.value.toString();const i=this.container.querySelector(`[${po.subsChild}="${t}"]`);const s=this.container.querySelectorAll(`[${po.subsChild}]`);if(i){i.classList.remove(mo.hidden);const e=i.querySelector(`[name="selling_plan"]`);e.checked=true;e.dispatchEvent(new Event("change"))}s.forEach((e=>{if(e!==i){e.classList.add(mo.hidden);const t=e.querySelectorAll(`[name="selling_plan"]`);t.forEach((e=>{e.checked=false;e.dispatchEvent(new Event("change"))}))}}))}.bind(this))}))}updateSaleText(e){if(this.productState.planSale){this.updateSaleTextSubscription(e)}else if(this.productState.onSale){this.updateSaleTextStandard(e)}else if(this.priceOffWrap){this.priceOffWrap.classList.add(mo.hidden)}}isVariantFinalSale(e){const t=document.querySelector(po.variantFinalSaleMeta).textContent;const i=JSON.parse(t);let s=false;i.forEach((t=>{if(Number(t.variant_id)===e.id){s=t.metafield_value==="true"}}));return s}updateSaleTextStandard(e){const t=e.variant;if(this.priceOffType){this.priceOffType.innerHTML=window.theme.strings.sale||"sale"}if(this.priceOffAmount&&this.priceOffWrap){const e=(t.compare_at_price-t.price)/t.compare_at_price;const i=Math.floor(e*100);this.priceOffAmount.innerHTML=`${i}%`;this.priceOffWrap.classList.remove(mo.hidden)}if(this.priceOffWrap.hasAttribute(fo.finalSale)||this.isVariantFinalSale(t)){this.priceOffWrap.classList.remove(mo.hidden)}else{this.priceOffWrap.classList.add(mo.hidden)}}updateSubscriptionText(e){if(e.plan&&this.planDescription){this.planDescription.innerHTML=e.plan.detail.description;this.planDescription.classList.remove(mo.hidden)}else if(this.planDescription){this.planDescription.classList.add(mo.hidden)}}updateSaleTextSubscription(e){if(this.priceOffType){this.priceOffType.innerHTML=window.theme.strings.subscription||"subscripton"}if(this.priceOffAmount&&this.priceOffWrap){const t=e.plan.detail.price_adjustments[0];const i=t.value;if(t&&t.value_type==="percentage"){this.priceOffAmount.innerHTML=`${i}%`}else{this.priceOffAmount.innerHTML=Je(i,theme.moneyFormat)}this.priceOffWrap.classList.remove(mo.hidden)}}updateProductPrices(e){const t=e.variant;const i=e.plan;const s=this.container.querySelectorAll(po.priceWrapper);s.forEach((e=>{const s=e.querySelector(po.comparePrice);const o=e.querySelector(po.productPrice);const n=e.querySelector(po.comparePriceText);let r="";let a="";if(this.productState.available){r=t.compare_at_price;a=t.price}if(this.productState.hasPlan){a=i.allocation.price}if(this.productState.planSale){r=i.allocation.compare_at_price;a=i.allocation.price}if(s){if(this.productState.onSale||this.productState.planSale){s.classList.remove(mo.hidden);n.classList.remove(mo.hidden);o.classList.add(mo.productPriceSale)}else{s.classList.add(mo.hidden);n.classList.add(mo.hidden);o.classList.remove(mo.productPriceSale)}s.innerHTML=Je(r,theme.moneyFormat)}o.innerHTML=a===0?window.theme.strings.free:Je(a,theme.moneyFormat)}));if(this.hasUnitPricing){this.updateProductUnits(e)}}updateProductUnits(e){const t=e.variant;const i=e.plan;let s=null;if(t&&t.unit_price){s=t.unit_price}if(i&&i.allocation&&i.allocation.unit_price){s=i.allocation.unit_price}if(s){const e=this.getBaseUnit(t);const i=Je(s,theme.moneyFormat);this.container.querySelector(po.unitPrice).innerHTML=i;this.container.querySelector(po.unitBase).innerHTML=e;Re(this.container.querySelector(po.unitWrapper))}else{lo(this.container.querySelector(po.unitWrapper))}}updateSku(e){if(!this.skuWrapper)return;this.skuWrapper.innerHTML=`${theme.strings.sku}: ${e.variant.sku}`}updateBarcode(e){if(!this.barcodeWrapper)return;this.barcodeWrapper.innerHTML=`${theme.strings.barcode}: ${e.variant.barcode}`}fireHookEvent(e){const t=e.variant;this.container.dispatchEvent(new CustomEvent("theme:variant:change",{detail:{variant:t},bubbles:true}))}setProductState(e){const t=e.variant;const i=e.plan;const s={available:true,soldOut:false,onSale:false,showUnitPrice:false,requiresPlan:false,hasPlan:false,planPerDelivery:false,planSale:false};if(!t||t.requires_selling_plan&&!i){s.available=false}else{if(!t.available){s.soldOut=true}if(t.compare_at_price>t.price){s.onSale=true}if(t.unit_price){s.showUnitPrice=true}if(this.product&&this.product.requires_selling_plan){s.requiresPlan=true}if(i&&this.subPrices){s.hasPlan=true;if(i.allocation.per_delivery_price!==i.allocation.price){s.planPerDelivery=true}if(t.price>i.allocation.price){s.planSale=true}}}return s}updateProductImage(e){const t=e.dataset.variant;if(t){if(t.featured_media){const e=this.container.querySelector(`[${fo.imageId}="${t.featured_media.id}"]`);if(e){const t=e.getAttribute(fo.mediaId);const i=b();e.dispatchEvent(new CustomEvent("theme:media:select",{bubbles:true,detail:{id:t}}));if(i&&!this.productImages.hasAttribute(fo.faderDesktop)&&this.variantImageScroll){const t=e.getBoundingClientRect().top;document.dispatchEvent(new CustomEvent("theme:tooltip:close",{bubbles:false,detail:{hideTransition:false}}));ni(t)}if(!i&&!this.productImages.hasAttribute(fo.faderMobile)){this.productMediaList.scrollTo({left:e.offsetLeft})}}}}}updateLegend(e){const t=e.variant;if(t){const e=this.container.querySelectorAll(po.optionValue);if(e.length){e.forEach((e=>{const i=e.closest(po.optionPosition);if(i){const s=i.getAttribute(fo.optionPosition);const o=parseInt(s,10)-1;const n=t.options[o];e.innerHTML=n}}))}}}}const vo={open:"[data-popup-open]",close:"[data-popup-close]",focusable:'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'};const bo={closing:"closing"};class yo{constructor(e,t,i=true,s=true){this.popup=e;this.holder=t;this.a11y=te;this.isAnimating=false;this.showModal=i;this.enableScrollLock=s;this.buttonPopupOpen=this.holder?.querySelector(vo.open);this.popupEvents()}popupOpen(){if(!this.popup)return;this.isAnimating=true;if(this.showModal&&typeof this.popup.showModal==="function"){this.popup.showModal()}else if(!this.showModal&&typeof this.popup.show==="function"){this.popup.show()}else{this.popup.setAttribute("open","")}this.popup.removeAttribute("inert");this.popup.focus();if(this.enableScrollLock){document.dispatchEvent(new CustomEvent("theme:scroll:lock",{bubbles:true}))}it(this.popup).then((()=>{this.isAnimating=false;if(this.enableScrollLock){this.a11y.trapFocus(this.popup)}const e=this.popup.querySelector("[autofocus]")||this.popup.querySelector(vo.focusable);e?.focus()}))}popupClose(){if(this.isAnimating||!this.popup||this.popup.hasAttribute("inert")){return}if(!this.popup.hasAttribute(bo.closing)){this.popup.setAttribute(bo.closing,"");this.isAnimating=true;it(this.popup).then((()=>{this.isAnimating=false;this.popupClose()}));return}if(typeof this.popup.close==="function"){this.popup.close()}else{this.popup.removeAttribute("open")}this.popupCloseActions()}popupCloseActions(){if(this.popup.hasAttribute("inert"))return;this.popup.setAttribute("inert","");this.popup.removeAttribute(bo.closing);if(!Us()&&this.enableScrollLock){document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{bubbles:true}))}this.popup.dispatchEvent(new CustomEvent("theme:popup:onclose",{bubbles:false}));if(this.enableScrollLock){this.a11y.removeTrapFocus();this.a11y.autoFocusLastElement()}}popupEvents(){if(!this.popup)return;this.buttonPopupOpen?.addEventListener("click",(e=>{e.preventDefault();this.popupOpen();window.accessibility.lastElement=this.buttonPopupOpen}));const e=this.popup.querySelectorAll(vo.close);if(e.length){e.forEach((e=>{e.addEventListener("click",(e=>{e.preventDefault();this.popupClose()}))}))}if(this.showModal){this.popup.addEventListener("click",(e=>{if(e.target.nodeName==="DIALOG"&&e.type==="click"){this.popupClose()}}))}this.popup.addEventListener("keydown",(e=>{if(e.code==="Escape"){e.preventDefault();this.popupClose()}}));this.popup.addEventListener("close",(()=>this.popupCloseActions()))}}const wo={dialog:"dialog"};class So extends HTMLElement{constructor(){super()}connectedCallback(){new yo(this.querySelector(wo.dialog),this,true,true)}}class Eo extends Ce{constructor(){super()}loadContent(){super.loadContent();Shopify.loadFeatures([{name:"model-viewer-ui",version:"1.0",onLoad:this.setupModelViewerUI.bind(this)}])}setupModelViewerUI(e){if(e)return;this.modelViewerUI=new Shopify.ModelViewerUI(this.querySelector("model-viewer"))}}window.ProductModel={loadShopifyXR(){Shopify.loadFeatures([{name:"shopify-xr",version:"1.0",onLoad:this.setupShopifyXR.bind(this)}])},setupShopifyXR(e){if(e)return;if(!window.ShopifyXR){document.addEventListener("shopify_xr_initialized",(()=>this.setupShopifyXR()));return}document.querySelectorAll('[id^="ModelJSON-"]').forEach((e=>{window.ShopifyXR.addModels(JSON.parse(e.textContent));e.remove()}));window.ShopifyXR.setupXRElements()}};window.addEventListener("DOMContentLoaded",(()=>{if(window.ProductModel)window.ProductModel.loadShopifyXR()}));const Lo={addToCart:"[data-add-to-cart]",productImage:"[data-product-image]",productJson:"[data-product-json]",form:"[data-product-form]",cartBar:"#cart-bar",productNotificationPopupButton:"[data-popup-open]",productSubmitAdd:".product__submit__add",formWrapper:"[data-form-wrapper]",productVariants:"[data-product-variants]",slider:"[data-slider]"};const ko={expanded:"is-expanded",visible:"is-visible",loading:"is-loading",added:"is-added"};const Ao={cartBarEnabled:"data-cart-bar-enabled",cartBarAdd:"data-add-to-cart-bar",cartBarScroll:"data-cart-bar-scroll",cartBarProductNotification:"data-cart-bar-product-notification",sectionId:"data-section-id",sliderIndex:"data-slider-index"};const Co={};class To{constructor(e){this.section=e;this.container=e.container;this.id=this.container.getAttribute(Ao.sectionId);this.sliders=this.container.querySelectorAll(Lo.slider);this.slider=[];this.formWrapper=this.container.querySelector(Lo.formWrapper);this.cartBarEnabled=this.container.hasAttribute(Ao.cartBarEnabled);this.cartBar=this.container.querySelector(Lo.cartBar);this.setCartBarHeight=this.setCartBarHeight.bind(this);this.scrollToTop=this.scrollToTop.bind(this);this.toggleCartBarOnScroll=this.toggleCartBarOnScroll.bind(this);this.unlockTimer=0;this.accessibility=te;const t=this.container.querySelector(Lo.productJson);if(t&&!t.innerHTML||!t){return}const i=JSON.parse(t.innerHTML).handle;let s={};if(i){s={handle:i}}Shopify.Products.recordRecentlyViewed(s);this.form=this.container.querySelector(Lo.form);if(this.sliders.length){this.sliders.forEach(((e,t)=>{e.setAttribute(Ao.sliderIndex,t);this.slider.push(new si(this.container,e))}))}if(this.cartBarEnabled){this.initCartBar();this.setCartBarHeight();document.addEventListener("theme:scroll",this.toggleCartBarOnScroll);document.addEventListener("theme:resize",this.setCartBarHeight)}}initCartBar(){this.cartBarBtns=this.cartBar.querySelectorAll(Lo.productSubmitAdd);if(this.cartBarBtns.length>0){this.cartBarBtns.forEach((e=>{e.addEventListener("click",(e=>{e.preventDefault();if(e.currentTarget.hasAttribute(Ao.cartBarAdd)){if(this.cartBarEnabled){e.currentTarget.classList.add(ko.loading);e.currentTarget.setAttribute("disabled","disabled")}this.form.querySelector(Lo.addToCart).dispatchEvent(new Event("click",{bubbles:true}))}else if(e.currentTarget.hasAttribute(Ao.cartBarScroll)){this.scrollToTop()}else if(e.currentTarget.hasAttribute(Ao.cartBarProductNotification)){this.container.querySelector(Lo.productNotificationPopupButton).dispatchEvent(new Event("click"))}}));if(e.hasAttribute(Ao.cartBarAdd)){document.addEventListener("theme:product:add-error",this.scrollToTop)}}))}this.setCartBarHeight()}scrollToTop(){const e=this.container.querySelector(Lo.productVariants);const t=b()?this.container:e?e:this.form;const i=t.getBoundingClientRect().top;ni(b()?i:i-10)}toggleCartBarOnScroll(){const e=window.scrollY;const t=theme.variables.productPageSticky&&this.formWrapper?this.formWrapper:this.form;if(t&&this.cartBar){const i=t.offsetTop;const s=t.offsetHeight;const o=e>i+s;this.cartBar.classList.toggle(ko.visible,o)}}setCartBarHeight(){const e=this.cartBar.offsetHeight;document.documentElement.style.setProperty("--cart-bar-height",`${e}px`)}onUnload(){document.removeEventListener("theme:product:add-error",this.scrollToTop);if(this.cartBarEnabled){document.removeEventListener("theme:scroll",this.toggleCartBarOnScroll);document.removeEventListener("theme:resize",this.setCartBarHeight)}}onBlockSelect(e){const t=e.srcElement.closest(Lo.slider);if(t&&this.slider.length){const i=t.hasAttribute(Ao.sliderIndex)?t.getAttribute(Ao.sliderIndex):0;if(!this.slider[i])return;this.slider[i].onBlockSelect(e)}}onBlockDeselect(e){const t=e.srcElement.closest(Lo.slider);if(t&&this.slider.length){const i=t.hasAttribute(Ao.sliderIndex)?t.getAttribute(Ao.sliderIndex):0;if(!this.slider[i])return;this.slider[i].onBlockDeselect(e)}}}const qo={onLoad(){Co[this.id]=new To(this)},onUnload(e){Co[this.id].onUnload(e)},onBlockSelect(e){Co[this.id].onBlockSelect(e)},onBlockDeselect(e){Co[this.id].onBlockDeselect(e)}};Ft("product",[qo,Yt,Vs,so]);if(!customElements.get("product-form")){customElements.define("product-form",go)}if(!customElements.get("product-images")){customElements.define("product-images",ao)}if(!customElements.get("product-modal")){customElements.define("product-modal",So)}if(!customElements.get("product-model")){customElements.define("product-model",Eo)}if(!customElements.get("product-siblings")){customElements.define("product-siblings",Ds)}if(!customElements.get("radio-swatch")){customElements.define("radio-swatch",Ps)}if(!customElements.get("recipient-form")){customElements.define("recipient-form",Qs)}const Io={apiRelatedProductsTemplate:"[data-api-related-template]",relatedSection:"[data-related-section]",relatedProduct:"[data-grid-item]",recentlyViewed:"[data-recent-wrapper]",recentlyViewedWrapper:"[data-recently-viewed-wrapper]",productItem:".product-item",slider:"grid-slider"};const Po={limit:"data-limit",minimum:"data-minimum",productId:"data-product-id"};const xo={isHidden:"is-hidden",gridMobileSlider:"grid--mobile-slider"};const Mo={};class Ho{constructor(e){this.section=e;this.sectionId=e.id;this.container=e.container;this.related();this.recent()}related(){const e=this.container.querySelector(Io.relatedSection);if(!e){return}const t=e.getAttribute(Po.productId);const i=e.getAttribute(Po.limit);const s=`${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${i}&product_id=${t}&intent=related`;fetch(s).then((e=>e.text())).then((t=>{const i=document.createElement("div");i.innerHTML=(new DOMParser).parseFromString(t,"text/html").querySelector(Io.apiRelatedProductsTemplate).innerHTML;const s=i.querySelector(Io.relatedProduct);if(s){e.innerHTML=i.innerHTML;const t=parseInt(e.style.getPropertyValue("--COLUMNS-MOBILE"));if(t===0){const t=e.querySelector(Io.relatedProduct);t.parentElement.classList.add(xo.gridMobileSlider)}}else{e.dispatchEvent(new CustomEvent("theme:tab:hide",{bubbles:true}))}})).catch((function(){e.dispatchEvent(new CustomEvent("theme:tab:hide",{bubbles:true}))}))}recent(){const e=this.container.querySelector(Io.recentlyViewed);const t=e?parseInt(e.getAttribute(Po.limit)):4;Shopify.Products.showRecentlyViewed({howManyToShow:t,wrapperId:`recently-viewed-products-${this.sectionId}`,section:this.section,target:"api-product-grid-item",onComplete:(e,t)=>{const i=t.container;if(!i)return;const s=i.querySelector(Io.recentlyViewed);const o=i.querySelector(Io.recentlyViewedWrapper);const n=e.querySelectorAll(Io.productItem);const r=s.querySelector(Io.slider);const a=s.hasAttribute(Po.minimum)?parseInt(s.getAttribute(Po.minimum)):4;const l=!o&&n.length>0;const c=o&&n.length>=a;if(l||c){if(c){o.classList.remove(xo.isHidden)}s.classList.remove("is-hidden");s.dispatchEvent(new CustomEvent("theme:tab:check",{bubbles:true}));if(r){r.dispatchEvent(new CustomEvent("theme:grid-slider:init",{bubbles:true}))}}}})}}const Oo={onLoad(){Mo[this.id]=new Ho(this)}};Ft("related",[Oo,Vs]);Ft("reviews",[oi,ns]);const Bo={};const Do={sliderLogos:"[data-slider-logos]",sliderText:"[data-slider-text]",slide:"[data-slide]"};const Fo={isSelected:"is-selected",isInitialized:"is-initialized",flickityEnabled:"flickity-enabled"};const _o={slideData:"data-slide",slideIndex:"data-slide-index"};class $o{constructor(e){this.container=e.container;this.slideshowNav=this.container.querySelector(Do.sliderLogos);this.slideshowText=this.container.querySelector(Do.sliderText);this.setSlideshowNavStateOnResize=()=>this.setSlideshowNavState();this.flkty=null;this.flktyNav=null;this.logoSlides=this.slideshowNav.querySelectorAll(Do.slide);this.logoSlidesWidth=this.getSlidesWidth();this.initSlideshowText();this.initSlideshowNav()}getSlidesWidth(){const e=this.logoSlides.length;const t=200;return e*t}initSlideshowText(){if(!this.slideshowText)return;this.flkty=new s(this.slideshowText,{fade:true,autoPlay:false,prevNextButtons:false,cellAlign:"left",contain:true,pageDots:false,wrapAround:false,selectedAttraction:.2,friction:.6,draggable:false,accessibility:false,on:{ready:()=>this.sliderAccessibility(),change:()=>this.sliderAccessibility()}})}sliderAccessibility(){const e=this.slideshowText.querySelectorAll(`${Do.slide} a, ${Do.slide} button`);if(e.length){e.forEach((e=>{const t=e.closest(Do.slide);if(t){const i=t.classList.contains(Fo.isSelected)?0:-1;e.setAttribute("tabindex",i)}}))}}initSlideshowNav(){if(!this.slideshowNav)return;if(this.logoSlides.length){this.logoSlides.forEach((e=>{e.addEventListener("click",(()=>{const t=parseInt(e.getAttribute(_o.slideIndex));const i=this.slideshowNav.classList.contains(Fo.flickityEnabled);if(this.flkty){this.flkty.select(t)}if(i){this.flktyNav.select(t);if(!this.slideshowNav.classList.contains(Fo.isSelected)){this.flktyNav.playPlayer()}}else{const t=this.slideshowNav.querySelector(`.${Fo.isSelected}`);if(t){t.classList.remove(Fo.isSelected)}e.classList.add(Fo.isSelected)}}))}))}this.setSlideshowNavState();document.addEventListener("theme:resize",this.setSlideshowNavStateOnResize)}setSlideshowNavState(){const e=this.slideshowNav.classList.contains(Fo.flickityEnabled);if(this.logoSlidesWidth>g()){if(!e){this.slideshowNav.classList.add(Fo.isInitialized);const e=this.slideshowNav.querySelector(`.${Fo.isSelected}`);if(e){e.classList.remove(Fo.isSelected)}this.logoSlides[0].classList.add(Fo.isSelected);if(!this.flktyNav){this.flktyNav=new i(this.slideshowNav,{autoPlay:4e3,prevNextButtons:false,contain:false,pageDots:false,wrapAround:true,watchCSS:true,selectedAttraction:.05,friction:.8,initialIndex:0});this.flktyNav.on("deactivate",(()=>{this.slideshowNav.querySelector(Do.slide).classList.add(Fo.isSelected);if(this.flkty){this.flkty.select(0)}}));if(this.flkty){this.flkty.select(0);this.flktyNav.on("change",(e=>this.flkty.select(e)))}}}}else if(e){this.slideshowNav.classList.remove(Fo.isInitialized)}}onBlockSelect(e){if(!this.slideshowNav)return;const t=this.slideshowNav.querySelector(`[${_o.slideData}="${e.detail.blockId}"]`);const i=parseInt(t.getAttribute(_o.slideIndex));if(this.slideshowNav.classList.contains(Fo.flickityEnabled)){this.flktyNav.select(i);this.flktyNav.stopPlayer();this.slideshowNav.classList.add(Fo.isSelected)}else{t.dispatchEvent(new Event("click"))}}onBlockDeselect(){if(this.slideshowNav&&this.slideshowNav.classList.contains(Fo.flickityEnabled)){this.flktyNav.playPlayer();this.slideshowNav.classList.remove(Fo.isSelected)}}onUnload(){document.removeEventListener("theme:resize",this.setSlideshowNavStateOnResize)}}const No={onLoad(){Bo[this.id]=new $o(this)},onUnload(e){Bo[this.id].onUnload(e)},onBlockSelect(e){Bo[this.id].onBlockSelect(e)},onBlockDeselect(e){Bo[this.id].onBlockDeselect(e)}};Ft("logos",[No,ns]);function Wo(e,t,i){let s=document.getElementsByTagName("head")[0];let o=false;let n=document.createElement("script");n.src=e;n.onload=n.onreadystatechange=function(){if(!o&&(!this.readyState||this.readyState=="loaded"||this.readyState=="complete")){o=true;t()}else{i()}};s.appendChild(n)}const Ro={};window.isYoutubeAPILoaded=false;window.isVimeoAPILoaded=false;function Vo(e={}){if(!e.type){e.type="json"}if(e.url){if(Ro[e.url]){return Ro[e.url]}else{return Uo(e.url,e.type)}}else if(e.json){if(Ro[e.json]){return Promise.resolve(Ro[e.json])}else{return window.fetch(e.json).then((e=>e.json())).then((t=>{Ro[e.json]=t;return t}))}}else if(e.name){const t="".concat(e.name,e.version);if(Ro[t]){return Ro[t]}else{return zo(e)}}else{return Promise.reject()}}function Uo(e,t){const i=new Promise(((i,s)=>{if(t==="text"){fetch(e).then((e=>e.text())).then((e=>{i(e)})).catch((e=>{s(e)}))}else{Wo(e,(function(){i()}),(function(){s()}))}}));Ro[e]=i;return i}function zo(e){const t="".concat(e.name,e.version);const i=new Promise(((t,i)=>{try{window.Shopify.loadFeatures([{name:e.name,version:e.version,onLoad:e=>{jo(t,i,e)}}])}catch(e){i(e)}}));Ro[t]=i;return i}function jo(e,t,i){if(i){return t(i)}else{return e()}}const Jo={popupContainer:".pswp",popupCloseBtn:".pswp__custom-close",popupIframe:"iframe, video",popupThumbs:".pswp__thumbs",popupButtons:".pswp__button, .pswp__caption-close"};const Xo={current:"is-current",customLoader:"pswp--custom-loader",customOpen:"pswp--custom-opening",loader:"pswp__loader",popupCloseButton:"pswp__button--close",isFocused:"is-focused"};const Go={dataOptionClasses:"data-pswp-option-classes",ariaCurrent:"aria-current"};const Yo=`<div class="${Xo.loader}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;class Qo{constructor(e,t=""){this.items=e;this.pswpElement=document.querySelectorAll(Jo.popupContainer)[0];this.popup=null;this.popupThumbs=null;this.popupThumbsContainer=this.pswpElement.querySelector(Jo.popupThumbs);this.closeBtn=this.pswpElement.querySelector(Jo.popupCloseBtn);this.keyupCloseEvent=e=>this.keyupClose(e);this.a11y=te;const i={history:false,focus:false,mainClass:""};this.options=t!==""?t:i;this.init()}init(){this.pswpElement.classList.add(Xo.customOpen);this.initLoader();Vo({url:window.theme.assets.photoswipe}).then((()=>this.loadPopup())).catch((e=>console.error(e)))}initLoader(){if(this.pswpElement.classList.contains(Xo.customLoader)&&this.options!==""&&this.options.mainClass){this.pswpElement.setAttribute(Go.dataOptionClasses,this.options.mainClass);let e=document.createElement("div");e.innerHTML=Yo;e=e.firstChild;this.pswpElement.appendChild(e)}else{this.pswpElement.setAttribute(Go.dataOptionClasses,"")}}loadPopup(){const e=window.themePhotoswipe.PhotoSwipe.default;const t=window.themePhotoswipe.PhotoSwipeUI.default;if(this.pswpElement.classList.contains(Xo.customLoader)){this.pswpElement.classList.remove(Xo.customLoader)}this.pswpElement.classList.remove(Xo.customOpen);this.popup=new e(this.pswpElement,t,this.items,this.options);this.popup.init();this.thumbsActions();if(document.body.classList.contains(Xo.isFocused)){setTimeout((()=>{this.a11y.trapFocus(this.pswpElement,{elementToFocus:this.closeBtn})}),200)}this.popup.listen("close",(()=>this.onClose()));if(this.options&&this.options.closeElClasses&&this.options.closeElClasses.length){this.options.closeElClasses.forEach((e=>{const t=this.pswpElement.querySelector(`.pswp__${e}`);if(t){t.addEventListener("keyup",this.keyupCloseEvent)}}))}}thumbsActions(){if(!this.popupThumbsContainer||!this.popupThumbsContainer.children.length)return;this.popupThumbsContainer.addEventListener("wheel",(e=>this.stopDisabledScroll(e)));this.popupThumbsContainer.addEventListener("mousewheel",(e=>this.stopDisabledScroll(e)));this.popupThumbsContainer.addEventListener("DOMMouseScroll",(e=>this.stopDisabledScroll(e)));this.popupThumbs=this.pswpElement.querySelectorAll(`${Jo.popupThumbs} > *`);this.popupThumbs.forEach(((e,t)=>{e.addEventListener("click",(i=>{i.preventDefault();const s=e.parentElement.querySelector(`.${Xo.current}`);s.classList.remove(Xo.current);s.setAttribute(Go.ariaCurrent,false);e.classList.add(Xo.current);e.setAttribute(Go.ariaCurrent,true);this.popup.goTo(t)}))}));this.popup.listen("imageLoadComplete",(()=>this.setCurrentThumb()));this.popup.listen("beforeChange",(()=>this.setCurrentThumb()))}stopDisabledScroll(e){e.stopPropagation()}keyupClose(e){if(e.code==="Enter"){this.popup.close()}}onClose(){const e=this.pswpElement.querySelector(Jo.popupIframe);if(e){e.parentNode.removeChild(e)}if(this.popupThumbsContainer&&this.popupThumbsContainer.firstChild){while(this.popupThumbsContainer.firstChild)this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild)}this.pswpElement.setAttribute(Go.dataOptionClasses,"");const t=this.pswpElement.querySelector(`.${Xo.loader}`);if(t){this.pswpElement.removeChild(t)}if(this.options&&this.options.closeElClasses&&this.options.closeElClasses.length){this.options.closeElClasses.forEach((e=>{const t=this.pswpElement.querySelector(`.pswp__${e}`);if(t){t.removeEventListener("keyup",this.keyupCloseEvent)}}))}this.a11y.removeTrapFocus();this.a11y.autoFocusLastElement()}setCurrentThumb(){const e=this.pswpElement.querySelector(`${Jo.popupThumbs} > .${Xo.current}`);if(e){e.classList.remove(Xo.current);e.setAttribute(Go.ariaCurrent,false)}if(!this.popupThumbs)return;const t=this.popupThumbs[this.popup.getCurrentIndex()];t.classList.add(Xo.current);t.setAttribute(Go.ariaCurrent,true);this.scrollThumbs(t)}scrollThumbs(e){const t=this.popupThumbsContainer.scrollLeft;const i=this.popupThumbsContainer.offsetWidth;const s=t+i;const o=e.offsetLeft;const n=e.offsetWidth;const r=o+n;if(s<=r||s>o){const t=parseInt(window.getComputedStyle(e).marginLeft);this.popupThumbsContainer.scrollTo({top:0,left:o-t,behavior:"smooth"})}}}const Ko={videoPlay:"data-video-play"};class Zo extends HTMLElement{constructor(){super()}connectedCallback(){this.videoPlay=this.querySelectorAll(`[${Ko.videoPlay}]`);this.videoPlay?.forEach((e=>{e.addEventListener("click",(e=>{const t=e.currentTarget;if(t.getAttribute(Ko.videoPlay).trim()!==""){e.preventDefault();const i=[{html:t.getAttribute(Ko.videoPlay)}];const s={mainClass:"pswp--video"};new Qo(i,s);window.accessibility.lastElement=t}}))}))}}const en={videoTemplate:"[data-video-template]"};const tn={loading:"is-loading"};const sn={videoId:"data-video-id"};class on extends HTMLElement{constructor(){super()}connectedCallback(){this.videoId=this.getAttribute(sn.videoId);this.videoTemplate=this.querySelector(en.videoTemplate);this.video=null;this.powerSaverVideoPlay=this.powerSaverVideoPlay.bind(this);if(this.videoId){this.renderVideo()}}powerSaverVideoPlay(){this.video?.play()}renderVideo(){this.videoTemplateObserver=new IntersectionObserver(((e,t)=>{e.forEach((e=>{if(e.isIntersecting){const i=this.videoTemplate.innerHTML;this.innerHTML=i;this.classList.remove(tn.loading);this.video=this.querySelector("video");this.observeVideoPlayToggle();this.video.play().then((()=>{})).catch((()=>{document.addEventListener("click",this.powerSaverVideoPlay,{passive:true,bubbles:true,once:true});document.addEventListener("touchstart",this.powerSaverVideoPlay,{passive:true,bubbles:true,once:true})}));t.unobserve(e.target)}}))}),{root:null,rootMargin:"300px",threshold:[0,.1,.25,.5,.75,1]});this.videoTemplateObserver.observe(this)}observeVideoPlayToggle(){if(!this.video)return;const e={rootMargin:"0px",threshold:[0,1]};this.videoPlayObserver=new IntersectionObserver((e=>{e.forEach((e=>{const t=e.isIntersecting;if(t&&typeof this.video.play==="function"){const e=this.video.play();if(e!==undefined){e.then((e=>{})).catch((e=>{}))}}if(!t&&typeof this.video.pause==="function"){this.video.pause()}}))}),e);this.videoPlayObserver.observe(this.video)}disconnectedCallback(){if(this.videoTemplateObserver){this.videoTemplateObserver.disconnect()}if(this.videoPlayObserver){this.videoPlayObserver.disconnect()}if(this.videoId){document.removeEventListener("click",this.powerSaverVideoPlay);document.removeEventListener("touchstart",this.powerSaverVideoPlay)}}}Ft("featured-video",[Kt]);if(!customElements.get("video-background")){customElements.define("video-background",on)}if(!customElements.get("video-popup")){customElements.define("video-popup",Zo)}Ft("slideshow",[oi,Kt]);const nn={imagesContainer:"[data-images-container]",imageHolder:"[data-image-holder]",imageElement:"[data-image-element]",rangeButton:"[data-range-button]",rangeInput:"[data-range-input]"};class rn extends HTMLElement{constructor(){super();this.imageHolder=this.querySelector(nn.imageHolder);this.imageElement=this.querySelector(nn.imageElement);this.rangeButton=this.querySelector(nn.rangeButton);this.rangeInput=this.querySelector(nn.rangeInput);this.setOverlapImageSize=this.setOverlapImageSize.bind(this)}connectedCallback(){this.setOverlapImageSize();this.setImagePosition();this.rangeInput.addEventListener("input",(()=>this.setImagePosition()));document.addEventListener("theme:resize",this.setOverlapImageSize)}disconnectedCallback(){document.removeEventListener("theme:resize",this.setOverlapImageSize)}setImagePosition(){const e=this.rangeInput.value;const t=this.imageElement.offsetWidth;const i=this.rangeButton.offsetWidth;this.rangeButton.style.left=`${e}%`;this.imageHolder.style.width=`${(t-i)*(100-e)/100+i/2}px`}setOverlapImageSize(){const e=this.offsetWidth;this.imageElement.style.width=`${e}px`;this.setImagePosition()}}Ft("custom-content",[oi,Kt,ui]);if(!customElements.get("video-background")){customElements.define("video-background",on)}if(!customElements.get("video-popup")){customElements.define("video-popup",Zo)}if(!customElements.get("compare-images")){customElements.define("compare-images",rn)}var an={};an.basic=[];an.light=[{featureType:"administrative",elementType:"labels",stylers:[{visibility:"simplified"},{lightness:"64"},{hue:"#ff0000"}]},{featureType:"administrative",elementType:"labels.text.fill",stylers:[{color:"#bdbdbd"}]},{featureType:"administrative",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"landscape",elementType:"all",stylers:[{color:"#f0f0f0"},{visibility:"simplified"}]},{featureType:"landscape.natural.landcover",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"landscape.natural.terrain",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"poi",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"poi",elementType:"geometry.fill",stylers:[{visibility:"off"}]},{featureType:"poi",elementType:"labels",stylers:[{lightness:"100"}]},{featureType:"poi.park",elementType:"all",stylers:[{visibility:"on"}]},{featureType:"poi.park",elementType:"geometry",stylers:[{saturation:"-41"},{color:"#e8ede7"}]},{featureType:"poi.park",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"road",elementType:"all",stylers:[{saturation:"-100"}]},{featureType:"road",elementType:"labels",stylers:[{lightness:"25"},{gamma:"1.06"},{saturation:"-100"}]},{featureType:"road.highway",elementType:"all",stylers:[{visibility:"simplified"}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{gamma:"10.00"}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{weight:"0.01"},{visibility:"simplified"}]},{featureType:"road.highway",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"road.highway",elementType:"labels.text.fill",stylers:[{weight:"0.01"}]},{featureType:"road.highway",elementType:"labels.text.stroke",stylers:[{weight:"0.01"}]},{featureType:"road.arterial",elementType:"geometry.fill",stylers:[{weight:"0.8"}]},{featureType:"road.arterial",elementType:"geometry.stroke",stylers:[{weight:"0.01"}]},{featureType:"road.arterial",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"road.local",elementType:"geometry.fill",stylers:[{weight:"0.01"}]},{featureType:"road.local",elementType:"geometry.stroke",stylers:[{gamma:"10.00"},{lightness:"100"},{weight:"0.4"}]},{featureType:"road.local",elementType:"labels",stylers:[{visibility:"simplified"},{weight:"0.01"},{lightness:"39"}]},{featureType:"road.local",elementType:"labels.text.stroke",stylers:[{weight:"0.50"},{gamma:"10.00"},{lightness:"100"}]},{featureType:"transit",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"water",elementType:"all",stylers:[{color:"#cfe5ee"},{visibility:"on"}]}];an.white_label=[{featureType:"all",elementType:"all",stylers:[{visibility:"simplified"}]},{featureType:"all",elementType:"labels",stylers:[{visibility:"simplified"}]},{featureType:"administrative",elementType:"labels",stylers:[{gamma:"3.86"},{lightness:"100"}]},{featureType:"administrative",elementType:"labels.text.fill",stylers:[{color:"#cccccc"}]},{featureType:"landscape",elementType:"all",stylers:[{color:"#f2f2f2"}]},{featureType:"poi",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"road",elementType:"all",stylers:[{saturation:-100},{lightness:45}]},{featureType:"road.highway",elementType:"all",stylers:[{visibility:"simplified"}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{weight:"0.8"}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{weight:"0.8"}]},{featureType:"road.highway",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"road.highway",elementType:"labels.text.fill",stylers:[{weight:"0.8"}]},{featureType:"road.highway",elementType:"labels.text.stroke",stylers:[{weight:"0.01"}]},{featureType:"road.arterial",elementType:"geometry.stroke",stylers:[{weight:"0"}]},{featureType:"road.arterial",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"road.local",elementType:"geometry.stroke",stylers:[{weight:"0.01"}]},{featureType:"road.local",elementType:"labels.text",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"water",elementType:"all",stylers:[{color:"#e4e4e4"},{visibility:"on"}]}];an.dark_label=[{featureType:"all",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"all",elementType:"labels.text.fill",stylers:[{saturation:36},{color:"#000000"},{lightness:40}]},{featureType:"all",elementType:"labels.text.stroke",stylers:[{visibility:"on"},{color:"#000000"},{lightness:16}]},{featureType:"all",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{color:"#000000"},{lightness:20}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#000000"},{lightness:17},{weight:1.2}]},{featureType:"administrative",elementType:"labels",stylers:[{visibility:"simplified"},{lightness:"-82"}]},{featureType:"administrative",elementType:"labels.text.stroke",stylers:[{invert_lightness:true},{weight:"7.15"}]},{featureType:"landscape",elementType:"geometry",stylers:[{color:"#000000"},{lightness:20}]},{featureType:"landscape",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"poi",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#000000"},{lightness:21}]},{featureType:"road",elementType:"labels",stylers:[{visibility:"simplified"}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#000000"},{lightness:17},{weight:"0.8"}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#000000"},{lightness:29},{weight:"0.01"}]},{featureType:"road.highway",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#000000"},{lightness:18}]},{featureType:"road.arterial",elementType:"geometry.stroke",stylers:[{weight:"0.01"}]},{featureType:"road.local",elementType:"geometry",stylers:[{color:"#000000"},{lightness:16}]},{featureType:"road.local",elementType:"geometry.stroke",stylers:[{weight:"0.01"}]},{featureType:"road.local",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"geometry",stylers:[{color:"#000000"},{lightness:19}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#000000"},{lightness:17}]}];function ln(e){return an[e]}window.theme.allMaps=window.theme.allMaps||{};let cn=window.theme.allMaps;window.theme.mapAPI=window.theme.mapAPI||null;class dn{constructor(e){this.container=e.container;this.mapContainer=this.container.querySelector("[data-map-container]");this.key=this.container.getAttribute("data-api-key");this.styleString=this.container.getAttribute("data-style")||"";this.zoomString=this.container.getAttribute("data-zoom")||14;this.address=this.container.getAttribute("data-address");this.enableCorrection=this.container.getAttribute("data-latlong-correction");this.lat=this.container.getAttribute("data-lat");this.long=this.container.getAttribute("data-long");if(this.key){this.initMaps()}}initMaps(){const e=un(this.key);e.then((()=>this.enableCorrection==="true"&&this.lat!==""&&this.long!==""?new google.maps.LatLng(this.lat,this.long):mn(this.address))).then((e=>{const t=parseInt(this.zoomString,10);const i=ln(this.styleString);const s={zoom:t,styles:i,center:e,draggable:true,clickableIcons:false,scrollwheel:false,zoomControl:false,disableDefaultUI:true};const o=pn(this.mapContainer,s);return o})).then((e=>{this.map=e;cn[this.id]=e})).catch((e=>{console.log("Failed to load Google Map");console.log(e)}))}unload(){if(typeof window.google!=="undefined"){google.maps.event.clearListeners(this.map,"resize")}}}const hn={onLoad(){cn[this.id]=new dn(this)},onUnload(){if(typeof cn[this.id].unload==="function"){cn[this.id].unload()}}};Ft("map",hn);function un(e){if(window.theme.mapAPI===null){const t=`https://maps.googleapis.com/maps/api/js?key=${e}`;window.theme.mapAPI=Vo({url:t})}return window.theme.mapAPI}function pn(e,t){var i=new google.maps.Map(e,t);var s=i.getCenter();new google.maps.Marker({map:i,position:s});google.maps.event.addDomListener(window,"resize",(function(){google.maps.event.trigger(i,"resize");i.setCenter(s)}));return i}function mn(e){return new Promise(((t,i)=>{var s=new google.maps.Geocoder;s.geocode({address:e},(function(e,s){if(s=="OK"){var o={lat:e[0].geometry.location.lat(),lng:e[0].geometry.location.lng()};t(o)}else{i(s)}}))}))}const fn={largePromo:"[data-large-promo]",largePromoInner:"[data-large-promo-inner]",trackingInner:"[data-tracking-consent-inner]",tracking:"[data-tracking-consent]",trackingAccept:"[data-confirm-cookies]",cartBar:"cart-bar",newsletterPopup:"[data-newsletter]",newsletterPopupHolder:"[data-newsletter-holder]",newsletterHeading:"[data-newsletter-heading]",newsletterField:"[data-newsletter-field]",promoPopup:"[data-promo-text]",newsletterForm:"[data-newsletter-form]",delayAttribite:"data-popup-delay",cookieNameAttribute:"data-cookie-name",dataTargetReferrer:"data-target-referrer"};const gn={hidden:"hidden",hasValue:"has-value",cartBarVisible:"cart-bar-visible",isVisible:"is-visible",success:"has-success",selected:"selected",hasBlockSelected:"has-block-selected",mobile:"mobile",desktop:"desktop",bottom:"bottom"};const vn={enable:"data-enable"};let bn={};class yn{constructor(e,t,i){this.element=t;this.delay=e.getAttribute(fn.delayAttribite);this.isSubmitted=window.location.href.indexOf("accepts_marketing")!==-1||window.location.href.indexOf("customer_posted=true")!==-1;this.popupActions=i;this.showPopupOnScrollEvent=()=>this.showPopupOnScroll();if(this.delay==="always"||this.isSubmitted){this.always()}if(this.delay&&this.delay.includes("delayed")&&!this.isSubmitted){const e=this.delay.includes("_")?parseInt(this.delay.split("_")[1]):10;this.delayed(e)}if(this.delay==="bottom"&&!this.isSubmitted){this.bottom()}if(this.delay==="idle"&&!this.isSubmitted){this.idle()}}always(){this.popupActions.popupOpen()}delayed(e=10){setTimeout((()=>{this.popupActions.popupOpen()}),e*1e3)}idle(){let e=0;let t=6e4;const i=["mousemove","mousedown","click","touchmove","touchstart","touchend","keydown","keypress"];const s=["load","resize","scroll"];const o=()=>{e=setTimeout((()=>{e=0;this.popupActions.popupOpen()}),t);i.forEach((e=>{document.addEventListener(e,n)}));s.forEach((e=>{window.addEventListener(e,n)}))};const n=()=>{if(e){clearTimeout(e)}i.forEach((e=>{document.removeEventListener(e,n)}));s.forEach((e=>{window.removeEventListener(e,n)}));o()};o()}bottom(){document.addEventListener("theme:scroll",this.showPopupOnScrollEvent)}showPopupOnScroll(){if(window.scrollY+window.innerHeight>=document.body.clientHeight){this.popupActions.popupOpen();document.removeEventListener("theme:scroll",this.showPopupOnScrollEvent)}}onUnload(){document.removeEventListener("theme:scroll",this.showPopupOnScrollEvent)}}class wn{constructor(e){this.el=e;this.locationPath=location.href;if(!this.el.hasAttribute(fn.dataTargetReferrer)){return false}this.init()}init(){if(this.locationPath.indexOf(this.el.getAttribute(fn.dataTargetReferrer))===-1&&!window.Shopify.designMode){this.el.parentNode.removeChild(this.el)}}}class Sn{constructor(e){this.popup=e;this.modal=this.popup.querySelector(fn.largePromoInner);this.form=this.popup.querySelector(fn.newsletterForm);this.cookie=new ri(this.popup.getAttribute(fn.cookieNameAttribute),"user_has_closed");this.isTargeted=new wn(this.popup);this.popupActions=new yo(this.modal,this.modal,true,true);this.a11y=te;this.init()}init(){const e=this.cookie.read()!==false;const t=this.popup.classList.contains(gn.mobile);const i=this.popup.classList.contains(gn.desktop);const s=!b();let o=true;if(t&&!s||i&&s){o=false}if(!o){this.a11y.removeTrapFocus();document.dispatchEvent(new CustomEvent("theme:scroll:unlock",{bubbles:true}));return}if(!e||window.Shopify.designMode){if(!window.Shopify.designMode&&!window.location.pathname.endsWith("/challenge")){new yn(this.popup,this.modal,this.popupActions)}if(this.form&&this.form.classList.contains(gn.success)){this.checkForSuccess()}this.modal.addEventListener("theme:popup:onclose",(()=>this.cookie.write()))}}checkForSuccess(){this.popupActions.popupOpen();this.cookie.write()}onBlockSelect(e){if(this.popup.contains(e.target)){this.popupActions.popupOpen();this.popup.classList.add(gn.selected);this.popup.parentNode.classList.add(gn.hasBlockSelected)}}onBlockDeselect(e){if(this.popup.contains(e.target)){this.popupActions.popupClose();this.popup.classList.remove(gn.selected);this.popup.parentNode.classList.remove(gn.hasBlockSelected)}}}class En{constructor(e){this.popup=e;this.modal=document.querySelector(fn.tracking);this.acceptButton=this.modal.querySelector(fn.trackingAccept);this.enable=this.modal.getAttribute(vn.enable)==="true";this.showPopup=false;this.popupActions=new yo(this.popup,this.popup,false,false);window.Shopify.loadFeatures([{name:"consent-tracking-api",version:"0.1"}],(e=>{if(e){throw e}const t=window.Shopify.customerPrivacy.userCanBeTracked();const i=window.Shopify.customerPrivacy.getTrackingConsent();this.showPopup=!t&&i==="no_interaction"&&this.enable;if(window.Shopify.designMode){this.showPopup=true}this.init()}))}init(){if(this.showPopup){this.popupActions.popupOpen()}this.clickEvents()}clickEvents(){this.acceptButton.addEventListener("click",(e=>{e.preventDefault();window.Shopify.customerPrivacy.setTrackingConsent(true,(()=>this.popupActions.popupClose()));document.documentElement.style.setProperty("--cookie-bar-height","0px")}));document.addEventListener("trackingConsentAccepted",(()=>{}))}onSelect(){if(this.showPopup){this.popupActions.popupOpen();this.popup.classList.add(gn.selected);this.popup.parentNode.classList.add(gn.hasBlockSelected)}}onDeselect(){if(this.showPopup){this.popupActions.popupClose();this.popup.classList.remove(gn.selected);this.popup.parentNode.classList.remove(gn.hasBlockSelected)}}}class Ln{constructor(e){this.popup=e;this.cookie=new ri(this.popup.getAttribute(fn.cookieNameAttribute),"user_has_closed");this.isTargeted=new wn(this.popup);this.popupActions=new yo(this.popup,this.popup,false,false);this.init()}init(){const e=this.cookie.read()!==false;if(!e||window.Shopify.designMode){if(!window.Shopify.designMode){new yn(this.popup,this.popup,this.popupActions)}else{this.popupActions.popupOpen()}this.popup.addEventListener("theme:popup:onclose",(()=>this.cookie.write()))}}onSelect(){this.popupActions.popupOpen();this.popup.classList.add(gn.selected);this.popup.parentNode.classList.add(gn.hasBlockSelected)}onDeselect(){this.popupActions.popupClose();this.popup.classList.remove(gn.selected);this.popup.parentNode.classList.remove(gn.hasBlockSelected)}}class kn{constructor(e){this.popup=e;this.holder=this.popup.querySelector(fn.newsletterPopupHolder);this.heading=this.popup.querySelector(fn.newsletterHeading);this.newsletterField=this.popup.querySelector(fn.newsletterField);this.cookie=new ri(this.popup.getAttribute(fn.cookieNameAttribute),"newsletter_is_closed");this.form=this.popup.querySelector(fn.newsletterForm);this.isTargeted=new wn(this.popup);this.popupActions=new yo(this.holder,this.holder,false,false);this.resetClassTimer=0;this.init()}init(){const e=this.cookie.read()!==false;const t=window.location.search.indexOf("?customer_posted=true")!==-1;const i=[...this.holder.classList].toString();const s=i.includes(gn.bottom);if(t){this.delay=0}if(!e||window.Shopify.designMode){this.show();if(this.form.classList.contains(gn.success)){this.checkForSuccess()}}if(s){this.observeCartBar()}}show(){if(!window.location.pathname.endsWith("/challenge")){if(!window.Shopify.designMode){new yn(this.popup,this.holder,this.popupActions)}else{this.popupActions.popupOpen()}}this.showForm();this.inputField();this.holder.addEventListener("theme:popup:onclose",(()=>this.cookie.write()))}checkForSuccess(){this.popupActions.popupOpen();this.cookie.write()}observeCartBar(){this.cartBar=document.getElementById(fn.cartBar);if(!this.cartBar)return;const e={attributes:true,childList:false,subtree:false};let t=this.cartBar.classList.contains(gn.isVisible);document.body.classList.toggle(gn.cartBarVisible,t);const i=e=>{for(const i of e){if(i.type==="attributes"){t=i.target.classList.contains(gn.isVisible);document.body.classList.toggle(gn.cartBarVisible,t)}}};this.observer=new MutationObserver(i);this.observer.observe(this.cartBar,e)}showForm(){this.heading.addEventListener("click",(e=>{e.preventDefault();this.heading.classList.add(gn.hidden);this.form.classList.remove(gn.hidden);this.newsletterField.focus()}));this.heading.addEventListener("keyup",(e=>{if(e.code==="Enter"){this.heading.dispatchEvent(new Event("click"))}}))}inputField(){const e=()=>{if(this.resetClassTimer){clearTimeout(this.resetClassTimer)}if(this.newsletterField.value!==""){this.holder.classList.add(gn.hasValue)}};const t=()=>{if(this.resetClassTimer){clearTimeout(this.resetClassTimer)}this.resetClassTimer=setTimeout((()=>{this.holder.classList.remove(gn.hasValue)}),2e3)};this.newsletterField.addEventListener("input",e);this.newsletterField.addEventListener("focus",e);this.newsletterField.addEventListener("focusout",t)}onBlockSelect(e){if(this.popup.contains(e.target)){this.popupActions.popupOpen();this.popup.classList.add(gn.selected);this.popup.parentNode.classList.add(gn.hasBlockSelected)}}onBlockDeselect(e){if(this.popup.contains(e.target)){this.popupActions.popupClose();this.popup.classList.remove(gn.selected);this.popup.parentNode.classList.remove(gn.hasBlockSelected)}}onUnload(){if(this.observer){this.observer.disconnect()}}}const An={onLoad(){bn[this.id]=[];const e=this.container.querySelectorAll(fn.largePromo);e.forEach((e=>{bn[this.id].push(new Sn(e))}));const t=this.container.querySelectorAll(fn.tracking);t.forEach((e=>{bn[this.id].push(new En(e))}));const i=this.container.querySelectorAll(fn.newsletterPopup);i.forEach((e=>{bn[this.id].push(new kn(e))}));const s=this.container.querySelectorAll(fn.promoPopup);s.forEach((e=>{bn[this.id].push(new Ln(e))}))},onBlockSelect(e){bn[this.id].forEach((t=>{if(typeof t.onBlockSelect==="function"){t.onBlockSelect(e)}}))},onBlockDeselect(e){bn[this.id].forEach((t=>{if(typeof t.onBlockDeselect==="function"){t.onBlockDeselect(e)}}))},onSelect(){bn[this.id].forEach((e=>{if(typeof e.onSelect==="function"){e.onSelect()}}))},onDeselect(){bn[this.id].forEach((e=>{if(typeof e.onDeselect==="function"){e.onDeselect()}}))},onUnload(){bn[this.id].forEach((e=>{if(typeof e.onUnload==="function"){e.onUnload()}}))}};Ft("popups",[An,ui]);const Cn={modal:"[data-password-modal]",loginErrors:"#login_form .errors"};class Tn{constructor(e){this.container=e.container;this.popupActions=new yo(this.container.querySelector(Cn.modal),this.container,true,true);if(this.container.querySelector(Cn.loginErrors)){this.popupActions.popupOpen()}}}const qn={onLoad(){new Tn(this)}};Ft("password-template",qn);Ft("list-collections",[oi,ns]);Ft("columns",[ns,oi]);Ft("newsletter",ui);if(!customElements.get("compare-images")){customElements.define("compare-images",rn)}const In={scrollToElement:"[data-scroll-to]",tooltip:"[data-tooltip]",collapsibleTrigger:"[data-collapsible-trigger]"};const Pn={open:"open",dataScrollTo:"data-scroll-to",tooltipStopMousenterValue:"data-tooltip-stop-mouseenter"};const xn={};class Mn{constructor(e){this.section=e;this.container=e.container;this.scrollToButtons=this.container.querySelectorAll(In.scrollToElement);if(this.scrollToButtons.length){this.init()}}init(){this.scrollToButtons.forEach((e=>{e.addEventListener("click",(()=>{const t=this.container.querySelector(e.getAttribute(Pn.dataScrollTo));if(!t||e.tagName==="A")return;this.scrollToElement(t)}))}))}scrollToElement(e){ni(e.getBoundingClientRect().top+1);const t=e.nextElementSibling.matches("details")?e.nextElementSibling:null;if(t){const e=t?.querySelector(In.collapsibleTrigger);const i=t.hasAttribute(Pn.open);if(!i){e?.dispatchEvent(new Event("click"))}}const i=document.querySelectorAll(`${In.tooltip}:not([${Pn.tooltipStopMousenterValue}])`);if(i.length){i.forEach((e=>{e.setAttribute(Pn.tooltipStopMousenterValue,"");setTimeout((()=>{e.removeAttribute(Pn.tooltipStopMousenterValue)}),1e3)}))}}}const Hn={onLoad(){xn[this.id]=new Mn(this)}};const On={scrollSpy:"[data-scroll-spy]"};const Bn={selected:"is-selected"};const Dn={scrollSpy:"data-scroll-spy",mobile:"data-scroll-spy-mobile",desktop:"data-scroll-spy-desktop",triggerPoint:"data-scroll-trigger-point"};const Fn={};class _n{constructor(e,t){this.container=e;this.elementToSpy=t;this.anchorSelector=`[${Dn.scrollSpy}="#${this.elementToSpy.id}"]`;this.anchor=this.container.querySelector(this.anchorSelector);this.anchorSiblings=this.container.querySelectorAll(`[${Dn.scrollSpy}]`);this.initialized=false;if(!this.anchor)return;this.triggerPoint=this.anchor.getAttribute(Dn.triggerPoint);this.scrollCallback=()=>this.onScroll();this.toggleScrollObserver=this.toggleScrollObserver.bind(this);this.init()}init(){this.toggleScrollObserver();document.addEventListener("theme:resize:width",this.toggleScrollObserver)}toggleScrollObserver(){if(this.isEligible()){if(!this.initialized){document.addEventListener("theme:scroll",this.scrollCallback);this.initialized=true}}else{document.removeEventListener("theme:scroll",this.scrollCallback);this.initialized=false}}isEligible(){const e=b();const t=!e;return t&&this.anchor.hasAttribute(Dn.mobile)||e&&this.anchor.hasAttribute(Dn.desktop)||!this.anchor.hasAttribute(Dn.desktop)&&!this.anchor.hasAttribute(Dn.mobile)}onScroll(){this.top=this.elementToSpy.getBoundingClientRect().top;const e=Math.round(window.innerHeight);const t=Math.round(window.scrollY);const i=t+e;const s=Math.round(this.top+t);const o=this.elementToSpy.offsetHeight;const n=s+o;const r=n<t;const a=s<i;const l=a&&!r;if(!l)return;if(!this.triggerPointReached())return;this.anchorSiblings.forEach((e=>{if(!e.matches(this.anchorSelector)){e.classList.remove(Bn.selected)}}));this.anchor.classList.add(Bn.selected)}triggerPointReached(){let e=false;switch(this.triggerPoint){case"top":e=this.top<=0;break;case"middle":e=this.top<=window.innerHeight/2;break;case"bottom":e=this.top<=window.innerHeight;break;default:e=this.top<=0}return e}onUnload(){document.removeEventListener("theme:resize:width",this.toggleScrollObserver);document.removeEventListener("theme:scroll",this.scrollCallback)}}const $n={onLoad(){Fn[this.id]=[];this.container.querySelectorAll(On.scrollSpy)?.forEach((e=>{const t=this.container.querySelector(e.getAttribute(Dn.scrollSpy));Fn[this.id].push(new _n(this.container,t))}))},onUnload(){Fn[this.id].forEach((e=>{if(typeof e.onUnload==="function"){e.onUnload()}}))}};Ft("sidebar",[Hn,$n]);const Nn={button:"[data-hover-target]",image:"[data-collection-image]"};const Wn={target:"data-hover-target"};const Rn={visible:"is-visible",selected:"is-selected"};let Vn={};class Un{constructor(e){this.container=e.container;this.buttons=this.container.querySelectorAll(Nn.button);this.init()}init(){if(this.buttons.length){this.buttons.forEach((e=>{e.addEventListener("mouseenter",(e=>{const t=e.currentTarget.getAttribute(Wn.target);this.updateState(t)}))}))}}updateState(e){const t=this.container.querySelector(`[${Wn.target}="${e}"]`);const i=this.container.querySelector(`#${e}:not(.${Rn.visible})`);const s=this.container.querySelector(`${Nn.button}.${Rn.selected}`);const o=this.container.querySelector(`${Nn.image}.${Rn.visible}`);if(i&&b()){o?.classList.remove(Rn.visible);s?.classList.remove(Rn.selected);i.classList.add(Rn.visible);t.classList.add(Rn.selected)}}onBlockSelect(e){this.updateState(e.target.id)}}const zn={onLoad(){Vn[this.id]=new Un(this)},onBlockSelect(e){Vn[this.id].onBlockSelect(e)}};Ft("collections-hover",[zn,$n]);const jn={image:"[data-featured-image]",imagesHolder:"[data-featured-aside]",contentHolder:"[data-featured-content]",wrapper:"[data-featured-wrapper]"};const Jn={horizontalScroll:"data-horizontal-scroll",horizontalScrollReversed:"data-horizontal-scroll-reversed"};const Xn={};class Gn{constructor(e){this.container=e.container;this.horizontalScroll=this.container.hasAttribute(Jn.horizontalScroll);this.horizontalScrollReversed=this.container.hasAttribute(Jn.horizontalScrollReversed);this.images=this.container.querySelectorAll(jn.image);this.imagesHolder=this.container.querySelector(jn.imagesHolder);this.contentHolder=this.container.querySelector(jn.contentHolder);this.wrapper=this.container.querySelector(jn.wrapper);this.requestAnimationSticky=null;this.lastPercent=0;this.scrollEvent=()=>this.scrollEvents();this.calculateHorizontalPositionEvent=()=>this.calculateHorizontalPosition();this.calculateHeightEvent=()=>this.calculateHeight();this.init()}init(){if(this.horizontalScroll&&this.imagesHolder){this.requestAnimationSticky=requestAnimationFrame(this.calculateHorizontalPositionEvent);document.addEventListener("theme:scroll",this.scrollEvent)}if(this.wrapper&&this.contentHolder&&this.images.length){this.calculateHeight();document.addEventListener("theme:resize:width",this.calculateHeightEvent)}}scrollEvents(){if(!this.requestAnimationSticky){this.requestAnimationSticky=requestAnimationFrame(this.calculateHorizontalPositionEvent)}}removeAnimationFrame(){if(this.requestAnimationSticky){cancelAnimationFrame(this.requestAnimationSticky);this.requestAnimationSticky=null}}calculateHorizontalPosition(){let e=window.scrollY+this.headerHeight;const t=e+window.innerHeight;const i=this.imagesHolder.offsetTop;const s=this.imagesHolder.offsetHeight;const o=i+s+this.headerHeight;const n=s-(window.innerHeight-this.headerHeight);const r=this.horizontalScrollReversed?1:-1;let a=0;if(e>=i&&t<=o){a=(e-i)/n*100}else if(e<i){a=0}else{a=100}a*=this.images.length-1;this.container.style.setProperty("--translateX",`${a*r}%`);if(this.lastPercent!==a){this.requestAnimationSticky=requestAnimationFrame(this.calculateHorizontalPositionEvent)}else if(this.requestAnimationSticky){this.removeAnimationFrame()}this.lastPercent=a}calculateHeight(){let{stickyHeaderHeight:e}=l();this.container.style.removeProperty("--min-height");this.container.style.setProperty("--min-height",`${this.wrapper.offsetHeight+this.contentHolder.offsetHeight}px`);this.headerHeight=e}onUnload(){if(this.horizontalScroll&&this.imagesHolder){document.removeEventListener("theme:scroll",this.calculateHorizontalPositionEvent)}if(this.wrapper&&this.contentHolder&&this.images.length){document.removeEventListener("theme:resize:width",this.calculateHeightEvent)}}}const Yn={onLoad(){Xn[this.id]=new Gn(this)},onUnload(e){Xn[this.id].onUnload(e)}};Ft("featured-product",[Yn]);const Qn={holder:"[data-timeline-holder]",rows:"[data-timeline-rows]",row:"[data-timeline-row]",rowEditor:"[data-timeline-row-editor]",button:"[data-timeline-button]",scrollElement:"[data-block-scroll]",headerSticky:"[data-header-sticky]",headerHeight:"[data-header-height]"};const Kn={selected:"is-selected"};const Zn={};class er{constructor(e){this.container=e.container;this.rows=this.container.querySelectorAll(Qn.row);this.holder=this.container.querySelector(Qn.holder);if(this.rows.length<2||!this.holder)return;this.rowsWidth=0;this.rowsHeight=[];this.holderTop=this.holder.getBoundingClientRect().top+window.scrollY;this.holderHeight=this.holder.offsetHeight;this.buttons=this.container.querySelectorAll(Qn.button);this.rowsHolder=this.container.querySelector(Qn.rows);this.requestAnimation=null;this.isDesktopView=b();this.isScrollEnabled=false;this.scrollEvent=e=>this.scrollEvents(e);this.resizeEvent=()=>this.resizeEvents();this.init()}init(){this.calculateRowsDimensions();this.requestAnimation=requestAnimationFrame((()=>this.calculatePosition()));if(this.isDesktopView&&!this.isScrollEnabled){this.isScrollEnabled=true;document.addEventListener("theme:scroll",this.scrollEvent)}this.rowsHolder.addEventListener("scroll",this.scrollEvent);document.addEventListener("theme:resize:width",this.resizeEvent);if(this.buttons.length){this.buttons.forEach(((e,t)=>{e.addEventListener("click",(e=>{e.preventDefault();const i=e.currentTarget.closest(Qn.row);if(!i)return;if(b()){const e=Math.max(...this.rowsHeight);const i=this.holderHeight/this.rows.length;const s=this.holder.getBoundingClientRect().top;const o=t>0&&e<i?i*t+s:s;const n=o+1;ni(n)}else{const e=16;const t=i.offsetLeft-e;this.rowsHolder.scrollTo({left:t,behavior:"smooth"})}}))}))}}resizeEvents(){this.holderTop=this.holder.getBoundingClientRect().top+window.scrollY;this.holderHeight=this.holder.offsetHeight;this.calculateRowsDimensions();this.requestAnimation=requestAnimationFrame((()=>this.calculatePosition()));const e=b();if(e&&!this.isScrollEnabled){this.isScrollEnabled=true;document.addEventListener("theme:scroll",this.scrollEvent)}else if(!e&&this.isScrollEnabled){this.isScrollEnabled=false;document.removeEventListener("theme:scroll",this.scrollEvent)}}scrollEvents(e){if(!this.requestAnimation){const t=e.currentTarget;this.requestAnimation=requestAnimationFrame((()=>this.calculatePosition(t)))}}removeAnimationFrame(){if(this.requestAnimation){cancelAnimationFrame(this.requestAnimation);this.requestAnimation=null}}calculateRowsDimensions(){if(this.rows.length){this.rowsHeight=[];this.rowsWidth=0;let e=0;this.rows.forEach(((t,i)=>{this.rowsHeight.push(t.offsetHeight);this.rowsWidth+=t.offsetWidth+parseInt(getComputedStyle(t).marginRight);if(window.Shopify.designMode){const s=this.container.querySelectorAll(Qn.rowEditor);if(s.length){e+=t.offsetHeight;s[i]?.style.setProperty("--row-height-min",`${t.offsetHeight}px`);s[i+1]?.style.setProperty("--row-top-mobile",`${e}px`)}}}))}}calculatePosition(e=null){this.removeAnimationFrame();const t=b();const i=this.holderHeight/this.rows.length;let s=this.holderTop;const o=window.innerHeight;const n=window.scrollY+o*1.5;const r=16;let a=0;if(!t&&e){const t=e.scrollLeft-r;const i=e.offsetWidth;a=t/(this.rowsWidth-i)*100;this.holder.style.setProperty("--percent-mobile",`${a}%`)}if(t&&(n<this.holderTop||n>this.holderTop+this.holderHeight+o))return;this.rows.forEach(((e,o)=>{if(o>0){const o=e.offsetLeft/this.rowsWidth*100;let r=a>o;if(t){r=s+i<n;if(s-i<n){e.previousElementSibling?.style.setProperty("--percent-desktop",`${(n-s)/i*100}%`)}}e.classList.toggle(Kn.selected,r)}s+=i}))}onUnload(){if(this.isScrollEnabled){this.isScrollEnabled=false;document.removeEventListener("theme:scroll",this.scrollEvent)}this.rowsHolder.removeEventListener("scroll",this.scrollEvent);document.removeEventListener("theme:resize:width",this.resizeEvent)}onBlockSelect(e){const t=this.container.querySelector(Qn.scrollElement);if(t){const i=e.srcElement;const s=[...i.parentElement.children].indexOf(i);const o=this.rows[s];if(o){t.scrollTo({top:0,left:o.offsetLeft,behavior:"smooth"})}}}}const tr={onLoad(){Zn[this.id]=new er(this)},onUnload(e){Zn[this.id].onUnload(e)},onBlockSelect(e){Zn[this.id].onBlockSelect(e)}};Ft("timeline",[tr]);document.addEventListener("DOMContentLoaded",(function(){_t("*");const e=document.querySelector("[data-scroll-top-button]");if(e){e.addEventListener("click",(()=>{window.scrollTo({top:0,left:0,behavior:"smooth"})}));document.addEventListener("theme:scroll",(()=>{e.classList.toggle("is-visible",window.scrollY>window.innerHeight)}))}if(window.self!==window.top){document.querySelector("html").classList.add("iframe")}let t="scrollBehavior"in document.documentElement.style;if(!t){Vo({url:window.theme.assets.smoothscroll})}}));if(window.navigator.cookieEnabled){document.documentElement.className=document.documentElement.className.replace("supports-no-cookies","supports-cookies")}})(themeVendor.ScrollLock,themeVendor.Rellax,themeVendor.Flickity,themeVendor.FlickityFade,themeVendor.themeImages);

(function (e, t, i, s, o) {
    "use strict";
    (function () {
        const e = { NODE_ENV: "production" };
        try {
            if (process) {
                process.env = Object.assign({}, process.env);
                Object.assign(process.env, e);
                return;
            }
        } catch (e) {}
        globalThis.process = { env: e };
    })();
    window.theme = window.theme || {};
    window.theme.sizes = { mobile: 480, small: 750, large: 990, widescreen: 1400 };
    window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    function n() {
        if (document.querySelector("cart-items")) return;
        const e = document.createElement("cart-items");
        document.body.appendChild(e);
    }
    function r(e) {
        const t = e.querySelectorAll(".form-field");
        t.forEach((e) => {
            const t = e.querySelector("label");
            const i = e.querySelector("input, textarea");
            if (t && i) {
                i.addEventListener("keyup", (e) => {
                    if (e.target.value !== "") {
                        t.classList.add("label--float");
                    } else {
                        t.classList.remove("label--float");
                    }
                });
                if (i.value && i.value.length) {
                    t.classList.add("label--float");
                }
            }
        });
    }
    let a = u();
    window.initialWindowHeight = Math.min(window.screen.height, window.innerHeight);
    function l() {
        const e = {};
        e.windowHeight = Math.min(window.screen.height, window.innerHeight);
        e.footerHeight = p('[data-section-type*="footer"]');
        e.headerHeight = p("[data-header-height]");
        e.stickyHeaderHeight = document.querySelector("[data-header-sticky]") ? e.headerHeight : 0;
        e.collectionNavHeight = p("[data-collection-nav]");
        e.logoHeight = m();
        return e;
    }
    function c() {
        document.addEventListener("theme:resize", h);
        d();
    }
    function d() {
        const { windowHeight: e, headerHeight: t, logoHeight: i, footerHeight: s, collectionNavHeight: o } = l();
        document.documentElement.style.setProperty("--full-height", `${e}px`);
        document.documentElement.style.setProperty("--three-quarters", `${e * (3 / 4)}px`);
        document.documentElement.style.setProperty("--two-thirds", `${e * (2 / 3)}px`);
        document.documentElement.style.setProperty("--one-half", `${e / 2}px`);
        document.documentElement.style.setProperty("--one-third", `${e / 3}px`);
        document.documentElement.style.setProperty("--collection-nav-height", `${o}px`);
        document.documentElement.style.setProperty("--header-height", `${t}px`);
        document.documentElement.style.setProperty("--footer-height", `${s}px`);
        document.documentElement.style.setProperty("--content-full", `${e - t - i / 2}px`);
        document.documentElement.style.setProperty("--content-min", `${e - t - s}px`);
        if (document.querySelector("[data-tracking-consent].popup-cookies--bottom")) {
            document.documentElement.style.setProperty("--cookie-bar-height", `${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`);
        }
    }
    function h() {
        const { windowHeight: e, headerHeight: t, logoHeight: i, footerHeight: s, collectionNavHeight: o } = l();
        const n = u();
        if (n !== a || window.innerWidth > window.theme.sizes.mobile) {
            document.documentElement.style.setProperty("--full-height", `${e}px`);
            document.documentElement.style.setProperty("--three-quarters", `${e * (3 / 4)}px`);
            document.documentElement.style.setProperty("--two-thirds", `${e * (2 / 3)}px`);
            document.documentElement.style.setProperty("--one-half", `${e / 2}px`);
            document.documentElement.style.setProperty("--one-third", `${e / 3}px`);
            a = n;
        }
        document.documentElement.style.setProperty("--collection-nav-height", `${o}px`);
        document.documentElement.style.setProperty("--header-height", `${t}px`);
        document.documentElement.style.setProperty("--footer-height", `${s}px`);
        document.documentElement.style.setProperty("--content-full", `${e - t - i / 2}px`);
        document.documentElement.style.setProperty("--content-min", `${e - t - s}px`);
        if (document.querySelector("[data-tracking-consent].popup-cookies--bottom")) {
            document.documentElement.style.setProperty("--cookie-bar-height", `${document.querySelector("[data-tracking-consent].popup-cookies--bottom").offsetHeight}px`);
        }
    }
    function u() {
        if (window.matchMedia("(orientation: portrait)").matches) {
            return "portrait";
        }
        if (window.matchMedia("(orientation: landscape)").matches) {
            return "landscape";
        }
    }
    function p(e) {
        const t = document.querySelector(e);
        if (t) {
            return t.offsetHeight;
        } else {
            return 0;
        }
    }
    function m() {
        const e = p("[data-footer-logo]");
        if (e > 0) {
            return e + 20;
        } else {
            return 0;
        }
    }
    function f(e, t) {
        let i;
        return function () {
            if (e) {
                const s = () => e.apply(this, arguments);
                clearTimeout(i);
                i = setTimeout(s, t);
            }
        };
    }
    function g() {
        return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
    }
    function v() {
        return document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight;
    }
    function b() {
        return g() >= window.theme.sizes.small;
    }
    function y() {
        return g() < window.theme.sizes.small;
    }
    let w = g();
    let S = v();
    function E() {
        document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: true }));
        if (w !== g()) {
            document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: true }));
            w = g();
        }
        if (S !== v()) {
            document.dispatchEvent(new CustomEvent("theme:resize:height", { bubbles: true }));
            S = v();
        }
    }
    function L() {
        window.addEventListener(
            "resize",
            f(function () {
                E();
            }, 50)
        );
    }
    let k = window.scrollY;
    let A = null;
    let C = null;
    let T = null;
    let q = null;
    let I = 0;
    function P() {
        const e = window.scrollY;
        if (e > k) {
            C = true;
            A = false;
        } else if (e < k) {
            C = false;
            A = true;
        } else {
            A = null;
            C = null;
        }
        k = e;
        document.dispatchEvent(new CustomEvent("theme:scroll", { detail: { up: A, down: C, position: e }, bubbles: false }));
        if (A && !T) {
            document.dispatchEvent(new CustomEvent("theme:scroll:up", { detail: { position: e }, bubbles: false }));
        }
        if (C && !q) {
            document.dispatchEvent(new CustomEvent("theme:scroll:down", { detail: { position: e }, bubbles: false }));
        }
        q = C;
        T = A;
    }
    function x(t) {
        setTimeout(() => {
            if (I) {
                clearTimeout(I);
            }
            e.disablePageScroll(t.detail, { allowTouchMove: (e) => e.tagName === "TEXTAREA" });
            document.documentElement.setAttribute("data-scroll-locked", "");
        });
    }
    function M(e) {
        const t = e.detail;
        if (t) {
            I = setTimeout(H, t);
        } else {
            H();
        }
    }
    function H() {
        e.clearQueueScrollLocks();
        e.enablePageScroll();
        document.documentElement.removeAttribute("data-scroll-locked");
    }
    function O() {
        let e;
        window.addEventListener(
            "scroll",
            function () {
                if (e) {
                    window.cancelAnimationFrame(e);
                }
                e = window.requestAnimationFrame(function () {
                    P();
                });
            },
            { passive: true }
        );
        window.addEventListener("theme:scroll:lock", x);
        window.addEventListener("theme:scroll:unlock", M);
    }
    const B = (e, t = "", i) => {
        const s = i || document.createElement("div");
        s.classList.add(t);
        e.parentNode.insertBefore(s, e);
        return s.appendChild(e);
    };
    function D(e) {
        const t = ".rte table";
        const i = e.querySelectorAll(t);
        i.forEach((e) => {
            B(e, "rte__table-wrapper");
            e.setAttribute("data-scroll-lock-scrollable", "");
        });
        const s = '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe';
        const o = e.querySelectorAll(s);
        o.forEach((e) => {
            B(e, "rte__video-wrapper");
        });
    }
    function F() {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
    function _() {
        if (F()) {
            document.documentElement.className = document.documentElement.className.replace("no-touch", "supports-touch");
            window.theme.touch = true;
        } else {
            window.theme.touch = false;
        }
    }
    function $(e) {
        const t = e.querySelectorAll("[data-aria-toggle]");
        if (t.length) {
            t.forEach((e) => {
                e.addEventListener("click", function (e) {
                    e.preventDefault();
                    const t = e.currentTarget;
                    t.setAttribute("aria-expanded", t.getAttribute("aria-expanded") == "false" ? "true" : "false");
                    const i = t.getAttribute("aria-controls");
                    const s = document.querySelector(`#${i}`);
                    const o = () => {
                        s.classList.remove("expanding");
                        s.removeEventListener("transitionend", o);
                    };
                    const n = () => {
                        s.classList.add("expanding");
                        s.removeEventListener("transitionstart", n);
                    };
                    s.addEventListener("transitionstart", n);
                    s.addEventListener("transitionend", o);
                    s.classList.toggle("expanded");
                });
            });
        }
    }
    function N() {
        document.body.classList.add("is-loaded");
    }
    const W = { loading: "is-loading" };
    const R = { img: "img.is-loading" };
    function V() {
        document.addEventListener(
            "load",
            (e) => {
                if (e.target.tagName.toLowerCase() == "img" && e.target.classList.contains(W.loading)) {
                    e.target.classList.remove(W.loading);
                    e.target.parentNode.classList.remove(W.loading);
                    if (e.target.parentNode.parentNode.classList.contains(W.loading)) {
                        e.target.parentNode.parentNode.classList.remove(W.loading);
                    }
                }
            },
            true
        );
    }
    function U(e) {
        e.querySelectorAll(R.img).forEach((e) => {
            if (e.complete) {
                e.classList.remove(W.loading);
                e.parentNode.classList.remove(W.loading);
                if (e.parentNode.parentNode.classList.contains(W.loading)) {
                    e.parentNode.parentNode.classList.remove(W.loading);
                }
            }
        });
    }
    function z(e) {
        var t = window.getComputedStyle(e);
        return t.display !== "none" && t.visibility !== "hidden";
    }
    function j(e, t) {
        t = t || {};
        var i = e.tabIndex;
        e.tabIndex = -1;
        e.dataset.tabIndex = i;
        e.focus();
        if (typeof t.className !== "undefined") {
            e.classList.add(t.className);
        }
        e.addEventListener("blur", s);
        function s(o) {
            o.target.removeEventListener(o.type, s);
            e.tabIndex = i;
            delete e.dataset.tabIndex;
            if (typeof t.className !== "undefined") {
                e.classList.remove(t.className);
            }
        }
    }
    function J(e) {
        e = e || {};
        var t = window.location.hash;
        var i = document.getElementById(t.slice(1));
        if (i && e.ignore && i.matches(e.ignore)) {
            return false;
        }
        if (t && i) {
            j(i, e);
        }
    }
    function X(e) {
        e = e || {};
        var t = Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]'));
        function i(e) {
            return document.getElementById(e) !== null;
        }
        return t.filter(function (t) {
            if (t.hash === "#" || t.hash === "") {
                return false;
            }
            if (e.ignore && t.matches(e.ignore)) {
                return false;
            }
            if (!i(t.hash.substr(1))) {
                return false;
            }
            var s = document.querySelector(t.hash);
            if (!s) {
                return false;
            }
            t.addEventListener("click", function () {
                j(s, e);
            });
            return true;
        });
    }
    function G(e) {
        var t = Array.prototype.slice.call(e.querySelectorAll("[tabindex]," + "[draggable]," + "a[href]," + "area," + "button:enabled," + "input:not([type=hidden]):enabled," + "object," + "select:enabled," + "textarea:enabled"));
        return t.filter(function (e) {
            return !!((e.offsetWidth || e.offsetHeight || e.getClientRects().length) && z(e));
        });
    }
    var Y = {};
    function Q(e, t) {
        t = t || {};
        var i = G(e);
        var s = t.elementToFocus || e;
        var o = i[0];
        var n = i[i.length - 1];
        K();
        Y.focusin = function (t) {
            if (e !== t.target && !e.contains(t.target) && o && o === t.target) {
                o.focus();
            }
            if (t.target !== e && t.target !== n && t.target !== o) return;
            document.addEventListener("keydown", Y.keydown);
        };
        Y.focusout = function () {
            document.removeEventListener("keydown", Y.keydown);
        };
        Y.keydown = function (t) {
            if (t.code !== "Tab") return;
            if (t.target === n && !t.shiftKey) {
                t.preventDefault();
                o.focus();
            }
            if ((t.target === e || t.target === o) && t.shiftKey) {
                t.preventDefault();
                n.focus();
            }
        };
        document.addEventListener("focusout", Y.focusout);
        document.addEventListener("focusin", Y.focusin);
        j(s, t);
    }
    function K() {
        document.removeEventListener("focusin", Y.focusin);
        document.removeEventListener("focusout", Y.focusout);
        document.removeEventListener("keydown", Y.keydown);
    }
    function Z() {
        if (window.accessibility.lastElement && document.body.classList.contains("is-focused")) {
            setTimeout(() => {
                window.accessibility.lastElement?.focus();
            });
        }
    }
    function ee(e, t) {
        if (typeof e !== "string") {
            throw new TypeError(e + " is not a String.");
        }
        e = document.querySelectorAll(e);
        if (e.length === 0) {
            return;
        }
        t = t || {};
        t.messages = t.messages || {};
        var i = { newWindow: t.messages.newWindow || "Opens in a new window.", external: t.messages.external || "Opens external website.", newWindowExternal: t.messages.newWindowExternal || "Opens external website in a new window." };
        var s = t.prefix || "a11y";
        var o = { newWindow: s + "-new-window-message", external: s + "-external-message", newWindowExternal: s + "-new-window-external-message" };
        function n(e) {
            var t = document.createElement("ul");
            var i = Object.keys(e).reduce(function (t, i) {
                return (t += "<li id=" + o[i] + ">" + e[i] + "</li>");
            }, "");
            t.setAttribute("hidden", true);
            t.innerHTML = i;
            document.body.appendChild(t);
        }
        function r(e) {
            return e.hostname !== window.location.hostname;
        }
        e.forEach(function (e) {
            var t = e.getAttribute("target");
            var i = e.getAttribute("rel");
            var s = r(e);
            var n = t === "_blank";
            var a = i === null || i.indexOf("noopener") === -1;
            if (n && a) {
                var l = i === null ? "noopener" : i + " noopener";
                e.setAttribute("rel", l);
            }
            if (s && n) {
                e.setAttribute("aria-describedby", o.newWindowExternal);
            } else if (s) {
                e.setAttribute("aria-describedby", o.external);
            } else if (n) {
                e.setAttribute("aria-describedby", o.newWindow);
            }
        });
        n(i);
    }
    var te = Object.freeze({ __proto__: null, forceFocus: j, focusHash: J, bindInPageLinks: X, focusable: G, trapFocus: Q, removeTrapFocus: K, autoFocusLastElement: Z, accessibleLinks: ee });
    const ie = { inputSearch: 'input[type="search"]', focusedElements: '[aria-selected="true"] a', resetButton: 'button[type="reset"]' };
    const se = { hidden: "hidden" };
    class oe extends HTMLElement {
        constructor() {
            super();
            this.input = this.querySelector(ie.inputSearch);
            this.resetButton = this.querySelector(ie.resetButton);
            if (this.input) {
                this.input.form.addEventListener("reset", this.onFormReset.bind(this));
                this.input.addEventListener(
                    "input",
                    f((e) => {
                        this.onChange(e);
                    }, 300).bind(this)
                );
            }
        }
        toggleResetButton() {
            const e = this.resetButton.classList.contains(se.hidden);
            if (this.input.value.length > 0 && e) {
                this.resetButton.classList.remove(se.hidden);
            } else if (this.input.value.length === 0 && !e) {
                this.resetButton.classList.add(se.hidden);
            }
        }
        onChange() {
            this.toggleResetButton();
        }
        shouldResetForm() {
            return !document.querySelector(ie.focusedElements);
        }
        onFormReset(e) {
            e.preventDefault();
            if (this.shouldResetForm()) {
                this.input.value = "";
                this.toggleResetButton();
                e.target.querySelector(ie.inputSearch).focus();
            }
        }
    }
    customElements.define("header-search-form", oe);
    const ne = {
        allVisibleElements: '[role="option"]',
        ariaSelected: '[aria-selected="true"]',
        popularSearches: "[data-popular-searches]",
        predictiveSearch: "predictive-search",
        predictiveSearchResults: "[data-predictive-search-results]",
        predictiveSearchStatus: "[data-predictive-search-status]",
        searchInput: 'input[type="search"]',
        searchPopdown: "[data-popdown]",
        searchResultsLiveRegion: "[data-predictive-search-live-region-count-value]",
        searchResultsGroupsWrapper: "[data-search-results-groups-wrapper]",
        searchForText: "[data-predictive-search-search-for-text]",
        sectionPredictiveSearch: "#shopify-section-predictive-search",
        selectedLink: '[aria-selected="true"] a',
        selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
    };
    class re extends oe {
        constructor() {
            super();
            this.a11y = te;
            this.abortController = new AbortController();
            this.allPredictiveSearchInstances = document.querySelectorAll(ne.predictiveSearch);
            this.cachedResults = {};
            this.input = this.querySelector(ne.searchInput);
            this.isOpen = false;
            this.predictiveSearchResults = this.querySelector(ne.predictiveSearchResults);
            this.searchPopdown = this.closest(ne.searchPopdown);
            this.popularSearches = this.searchPopdown?.querySelector(ne.popularSearches);
            this.searchTerm = "";
        }
        connectedCallback() {
            this.input.addEventListener("focus", this.onFocus.bind(this));
            this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
            this.addEventListener("focusout", this.onFocusOut.bind(this));
            this.addEventListener("keyup", this.onKeyup.bind(this));
            this.addEventListener("keydown", this.onKeydown.bind(this));
        }
        getQuery() {
            return this.input.value.trim();
        }
        onChange() {
            super.onChange();
            const e = this.getQuery();
            if (!this.searchTerm || !e.startsWith(this.searchTerm)) {
                this.querySelector(ne.searchResultsGroupsWrapper)?.remove();
            }
            this.updateSearchForTerm(this.searchTerm, e);
            this.searchTerm = e;
            if (!this.searchTerm.length) {
                this.reset();
                return;
            }
            this.getSearchResults(this.searchTerm);
        }
        onFormSubmit(e) {
            if (!this.getQuery().length || this.querySelector(ne.selectedLink)) e.preventDefault();
        }
        onFormReset(e) {
            super.onFormReset(e);
            if (super.shouldResetForm()) {
                this.searchTerm = "";
                this.abortController.abort();
                this.abortController = new AbortController();
                this.closeResults(true);
            }
        }
        shouldResetForm() {
            return !document.querySelector(ne.selectedLink);
        }
        onFocus() {
            const e = this.getQuery();
            if (!e.length) return;
            if (this.searchTerm !== e) {
                this.onChange();
            } else if (this.getAttribute("results") === "true") {
                this.open();
            } else {
                this.getSearchResults(this.searchTerm);
            }
        }
        onFocusOut() {
            setTimeout(() => {
                if (!this.contains(document.activeElement)) this.close();
            });
        }
        onKeyup(e) {
            if (!this.getQuery().length) this.close(true);
            e.preventDefault();
            switch (e.code) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption();
                    break;
            }
        }
        onKeydown(e) {
            if (e.code === "ArrowUp" || e.code === "ArrowDown") {
                e.preventDefault();
            }
        }
        updateSearchForTerm(e, t) {
            const i = this.querySelector(ne.searchForText);
            const s = i?.innerText;
            if (s) {
                if (s.match(new RegExp(e, "g"))?.length > 1) {
                    return;
                }
                const o = s.replace(e, t);
                i.innerText = o;
            }
        }
        switchOption(e) {
            if (!this.getAttribute("open")) return;
            const t = e === "up";
            const i = this.querySelector(ne.ariaSelected);
            const s = Array.from(this.querySelectorAll(ne.allVisibleElements)).filter((e) => e.offsetParent !== null);
            let o = 0;
            if (t && !i) return;
            let n = -1;
            let r = 0;
            while (n === -1 && r <= s.length) {
                if (s[r] === i) {
                    n = r;
                }
                r++;
            }
            this.statusElement.textContent = "";
            if (!t && i) {
                o = n === s.length - 1 ? 0 : n + 1;
            } else if (t) {
                o = n === 0 ? s.length - 1 : n - 1;
            }
            if (o === n) return;
            const a = s[o];
            a.setAttribute("aria-selected", true);
            if (i) i.setAttribute("aria-selected", false);
            this.input.setAttribute("aria-activedescendant", a.id);
        }
        selectOption() {
            const e = this.querySelector(ne.selectedOption);
            if (e) e.click();
        }
        getSearchResults(e) {
            const t = e.replace(" ", "-").toLowerCase();
            this.setLiveRegionLoadingState();
            if (this.cachedResults[t]) {
                this.renderSearchResults(this.cachedResults[t]);
                return;
            }
            fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(e)}&section_id=predictive-search`, { signal: this.abortController.signal })
                .then((e) => {
                    if (!e.ok) {
                        var t = new Error(e.status);
                        this.close();
                        throw t;
                    }
                    return e.text();
                })
                .then((e) => {
                    const i = new DOMParser().parseFromString(e, "text/html").querySelector(ne.sectionPredictiveSearch).innerHTML;
                    this.allPredictiveSearchInstances.forEach((e) => {
                        e.cachedResults[t] = i;
                    });
                    this.renderSearchResults(i);
                })
                .catch((e) => {
                    if (e?.code === 20) {
                        return;
                    }
                    this.close();
                    throw e;
                });
        }
        setLiveRegionLoadingState() {
            this.statusElement = this.statusElement || this.querySelector(ne.predictiveSearchStatus);
            this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
            this.setLiveRegionText(this.loadingText);
            this.setAttribute("loading", true);
        }
        setLiveRegionText(e) {
            this.statusElement.setAttribute("aria-hidden", "false");
            this.statusElement.textContent = e;
            setTimeout(() => {
                this.statusElement.setAttribute("aria-hidden", "true");
            }, 1e3);
        }
        renderSearchResults(e) {
            this.predictiveSearchResults.innerHTML = e;
            this.setAttribute("results", true);
            this.setLiveRegionResults();
            this.open();
        }
        setLiveRegionResults() {
            this.removeAttribute("loading");
            this.setLiveRegionText(this.querySelector(ne.searchResultsLiveRegion).textContent);
        }
        open() {
            this.setAttribute("open", true);
            this.input.setAttribute("aria-expanded", true);
            this.isOpen = true;
            this.predictiveSearchResults.style.setProperty("--full-screen", `${window.visualViewport.height}px`);
        }
        close(e = false) {
            this.closeResults(e);
            this.isOpen = false;
            this.predictiveSearchResults.style.removeProperty("--full-screen");
        }
        closeResults(e = false) {
            if (e) {
                this.input.value = "";
                this.removeAttribute("results");
            }
            const t = this.querySelector(ne.ariaSelected);
            if (t) t.setAttribute("aria-selected", false);
            this.input.setAttribute("aria-activedescendant", "");
            this.removeAttribute("loading");
            this.removeAttribute("open");
            this.input.setAttribute("aria-expanded", false);
            this.predictiveSearchResults?.removeAttribute("style");
        }
        reset() {
            this.predictiveSearchResults.innerHTML = "";
            this.input.val = "";
            this.a11y.removeTrapFocus();
            if (this.popularSearches) {
                this.input.dispatchEvent(new Event("blur", { bubbles: false }));
                this.a11y.trapFocus(this.searchPopdown, { elementToFocus: this.input });
            }
        }
    }
    const ae = {
        popoutList: "[data-popout-list]",
        popoutToggle: "[data-popout-toggle]",
        popoutToggleText: "[data-popout-toggle-text]",
        popoutInput: "[data-popout-input]",
        popoutOptions: "[data-popout-option]",
        productGridImage: "[data-product-image]",
        productGridItem: "[data-grid-item]",
        section: "[data-section-type]",
    };
    const le = { listVisible: "popout-list--visible", visible: "is-visible", active: "is-active", selectPopoutTop: "select-popout--top" };
    const ce = { ariaExpanded: "aria-expanded", ariaCurrent: "aria-current", dataValue: "data-value", popoutToggleText: "data-popout-toggle-text", submit: "submit" };
    class de extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.popoutList = this.querySelector(ae.popoutList);
            this.popoutToggle = this.querySelector(ae.popoutToggle);
            this.popoutToggleText = this.querySelector(ae.popoutToggleText);
            this.popoutInput = this.querySelector(ae.popoutInput);
            this.popoutOptions = this.querySelectorAll(ae.popoutOptions);
            this.productGridItem = this.popoutList.closest(ae.productGridItem);
            this.fireSubmitEvent = this.hasAttribute(ce.submit);
            this.popupToggleFocusoutEvent = (e) => this.onPopupToggleFocusout(e);
            this.popupListFocusoutEvent = (e) => this.onPopupListFocusout(e);
            this.popupToggleClickEvent = (e) => this.onPopupToggleClick(e);
            this.keyUpEvent = (e) => this.onKeyUp(e);
            this.bodyClickEvent = (e) => this.onBodyClick(e);
            this._connectOptions();
            this._connectToggle();
            this._onFocusOut();
            this.popupListMaxWidth();
        }
        onPopupToggleClick(e) {
            const t = e.currentTarget;
            const i = t.getAttribute(ce.ariaExpanded) === "true";
            if (this.productGridItem) {
                const e = this.productGridItem.querySelector(ae.productGridImage);
                if (e) {
                    e.classList.toggle(le.visible, !i);
                }
                this.popoutList.style.maxHeight = `${Math.abs(this.popoutToggle.getBoundingClientRect().bottom - this.productGridItem.getBoundingClientRect().bottom)}px`;
            }
            e.currentTarget.setAttribute(ce.ariaExpanded, !i);
            this.popoutList.classList.toggle(le.listVisible);
            this.popupListMaxWidth();
            this.toggleListPosition();
            document.body.addEventListener("click", this.bodyClickEvent);
        }
        onPopupToggleFocusout(e) {
            const t = this.contains(e.relatedTarget);
            if (!t) {
                this._hideList();
            }
        }
        onPopupListFocusout(e) {
            const t = e.currentTarget.contains(e.relatedTarget);
            const i = this.popoutList.classList.contains(le.listVisible);
            if (i && !t) {
                this._hideList();
            }
        }
        toggleListPosition() {
            const e = this.querySelector(ae.popoutToggle);
            const t = e.getAttribute(ce.ariaExpanded) === "true";
            const i = window.innerHeight;
            const s = this.popoutList.getBoundingClientRect().bottom;
            const o = () => {
                this.classList.remove(le.selectPopoutTop);
                this.popoutList.removeEventListener("transitionend", o);
            };
            if (t) {
                if (i < s) {
                    this.classList.add(le.selectPopoutTop);
                }
            } else {
                this.popoutList.addEventListener("transitionend", o);
            }
        }
        popupListMaxWidth() {
            this.popoutList.style.setProperty("--max-width", "100vw");
            requestAnimationFrame(() => {
                this.popoutList.style.setProperty("--max-width", `${parseInt(document.body.clientWidth - this.popoutList.getBoundingClientRect().left)}px`);
            });
        }
        popupOptionsClick(e) {
            const t = e.target.closest(ae.popoutOptions);
            if (t.attributes.href.value === "#") {
                e.preventDefault();
                const t = e.currentTarget.hasAttribute(ce.dataValue) ? e.currentTarget.getAttribute(ce.dataValue) : "";
                this.popoutInput.value = t;
                if (this.popoutInput.disabled) {
                    this.popoutInput.removeAttribute("disabled");
                }
                if (this.fireSubmitEvent) {
                    this._submitForm(t);
                } else {
                    const i = e.currentTarget.parentElement;
                    const s = this.popoutList.querySelector(`.${le.active}`);
                    const o = this.popoutList.querySelector(`[${ce.ariaCurrent}]`);
                    this.popoutInput.dispatchEvent(new Event("change"));
                    if (s) {
                        s.classList.remove(le.active);
                        i.classList.add(le.active);
                    }
                    if (this.popoutInput.name == "quantity" && !i.nextSibling) {
                        this.classList.add(le.active);
                    }
                    if (o && o.hasAttribute(`${ce.ariaCurrent}`)) {
                        o.removeAttribute(`${ce.ariaCurrent}`);
                        e.currentTarget.setAttribute(`${ce.ariaCurrent}`, "true");
                    }
                    if (t !== "") {
                        this.popoutToggleText.innerHTML = t;
                        if (this.popoutToggleText.hasAttribute(ce.popoutToggleText) && this.popoutToggleText.getAttribute(ce.popoutToggleText) !== "") {
                            this.popoutToggleText.setAttribute(ce.popoutToggleText, t);
                        }
                    }
                    this.onPopupToggleFocusout(e);
                    this.onPopupListFocusout(e);
                }
            }
        }
        onKeyUp(e) {
            if (e.code !== "Escape") {
                return;
            }
            this._hideList();
            this.popoutToggle.focus();
        }
        onBodyClick(e) {
            const t = this.contains(e.target);
            const i = this.popoutList.classList.contains(le.listVisible);
            if (i && !t) {
                this._hideList();
            }
        }
        _connectToggle() {
            this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
        }
        _connectOptions() {
            if (this.popoutOptions.length) {
                this.popoutOptions.forEach((e) => {
                    e.addEventListener("click", (e) => this.popupOptionsClick(e));
                });
            }
        }
        _onFocusOut() {
            this.addEventListener("keyup", this.keyUpEvent);
            this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent);
            this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent);
        }
        _submitForm() {
            const e = this.closest("form");
            if (e) {
                e.submit();
            }
        }
        _hideList() {
            this.popoutList.classList.remove(le.listVisible);
            this.popoutToggle.setAttribute(ce.ariaExpanded, false);
            this.toggleListPosition();
            document.body.removeEventListener("click", this.bodyClickEvent);
        }
    }
    class he extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.input = this.querySelector("input");
            this.changeEvent = new Event("change", { bubbles: true });
            this.buttonClickEvent = this.onButtonClick.bind(this);
            this.onQuantityChangeEvent = this.onQuantityChange.bind(this);
            this.input.addEventListener("change", this.onQuantityChangeEvent);
            this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.buttonClickEvent));
        }
        onButtonClick(e) {
            e.preventDefault();
            const t = this.input.value;
            const i = e.target.nodeName == "BUTTON" ? e.target : e.target.closest("button");
            if (i.name === "increase") this.input.stepUp();
            if (i.name === "decrease") this.input.stepDown();
            if (t !== this.input.value) this.input.dispatchEvent(this.changeEvent);
        }
        onQuantityChange() {
            if (this.input.name == "updates[]") {
                this.updateCart();
            }
        }
        updateCart() {
            if (this.quantityValue === "") return;
            this.dispatchEvent(new CustomEvent("theme:cart:update", { bubbles: true, detail: { id: this.input.dataset.id, quantity: this.input.value } }));
        }
    }
    const ue = { aos: "[data-aos]:not(.aos-animate)", aosAnchor: "[data-aos-anchor]", aosIndividual: "[data-aos]:not([data-aos-anchor]):not(.aos-animate)" };
    const pe = { aosAnimate: "aos-animate" };
    const me = { attributes: false, childList: true, subtree: true };
    let fe = [];
    const ge = (e) => {
        for (const t of e) {
            if (t.type === "childList") {
                const e = t.target;
                const i = e.querySelectorAll(ue.aos);
                const s = e.querySelectorAll(ue.aosAnchor);
                if (i.length) {
                    i.forEach((e) => {
                        ve.observe(e);
                    });
                }
                if (s.length) {
                    Ee(s);
                }
            }
        }
    };
    const ve = new IntersectionObserver(
        (e, t) => {
            e.forEach((e) => {
                if (e.isIntersecting) {
                    e.target.classList.add(pe.aosAnimate);
                    t.unobserve(e.target);
                }
            });
        },
        { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    );
    const be = new IntersectionObserver(
        (e, t) => {
            e.forEach((e) => {
                if (e.intersectionRatio) {
                    const i = e.target.querySelectorAll(ue.aos);
                    if (i.length) {
                        i.forEach((e) => {
                            e.classList.add(pe.aosAnimate);
                        });
                    }
                    t.unobserve(e.target);
                }
            });
        },
        { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
    );
    function ye() {
        const e = new MutationObserver(ge);
        e.observe(document.body, me);
    }
    function we() {
        const e = document.querySelectorAll(ue.aosIndividual);
        if (e.length) {
            e.forEach((e) => {
                ve.observe(e);
            });
        }
    }
    function Se() {
        const e = document.querySelectorAll(ue.aosAnchor);
        if (e.length) {
            Ee(e);
        }
    }
    function Ee(e) {
        if (!e.length) return;
        e.forEach((e) => {
            const t = e.dataset.aosAnchor;
            if (t && fe.indexOf(t) === -1) {
                const e = document.querySelector(t);
                if (e) {
                    be.observe(e);
                    fe.push(t);
                }
            }
        });
    }
    function Le() {
        we();
        Se();
        ye();
        document.addEventListener("shopify:section:unload", (e) => {
            const t = "#" + e.target.querySelector("[data-section-id]")?.id;
            const i = fe.indexOf(t);
            if (i !== -1) {
                fe.splice(i, 1);
            }
        });
    }
    const ke = {
        deferredMediaButton: "[data-deferred-media-button]",
        media: "video, model-viewer, iframe",
        youtube: '[data-host="youtube"]',
        vimeo: '[data-host="vimeo"]',
        productGridItem: "[data-grid-item]",
        section: ".shopify-section",
        template: "template",
        video: "video",
        productModel: "product-model",
    };
    const Ae = { loaded: "loaded", autoplay: "autoplay" };
    class Ce extends HTMLElement {
        constructor() {
            super();
            const e = this.querySelector(ke.deferredMediaButton);
            e?.addEventListener("click", this.loadContent.bind(this));
            this.section = this.closest(ke.section);
            this.productGridItem = this.closest(ke.productGridItem);
            this.hovered = false;
            this.mouseEnterEvent = () => this.mouseEnterActions();
            this.mouseLeaveEvent = () => this.mouseLeaveActions();
        }
        connectedCallback() {
            if (this.productGridItem) {
                this.section.addEventListener("mouseover", this.mouseOverEvent, { once: true });
                this.addEventListener("mouseenter", this.mouseEnterEvent);
                this.addEventListener("mouseleave", this.mouseLeaveEvent);
            }
        }
        disconnectedCallback() {
            if (this.productGridItem) {
                this.section.removeEventListener("mouseover", this.mouseOverEvent, { once: true });
                this.removeEventListener("mouseenter", this.mouseEnterEvent);
                this.removeEventListener("mouseleave", this.mouseLeaveEvent);
            }
        }
        mouseEnterActions() {
            this.hovered = true;
            this.videoActions();
            if (!this.getAttribute(Ae.loaded)) {
                this.loadContent();
            }
        }
        mouseLeaveActions() {
            this.hovered = false;
            this.videoActions();
        }
        videoActions() {
            if (this.getAttribute(Ae.loaded)) {
                const e = this.querySelector(ke.youtube);
                const t = this.querySelector(ke.vimeo);
                const i = e || t;
                const s = this.querySelector(ke.video);
                if (i) {
                    let e = this.hovered ? "playVideo" : "pauseVideo";
                    let s = `{"event":"command","func":"${e}","args":""}`;
                    if (t) {
                        e = this.hovered ? "play" : "pause";
                        s = `{"method":"${e}"}`;
                    }
                    i.contentWindow.postMessage(s, "*");
                    i.addEventListener("load", (e) => {
                        this.videoActions();
                    });
                } else if (s) {
                    if (this.hovered) {
                        s.play();
                    } else {
                        s.pause();
                    }
                }
            }
        }
        loadContent(e = true) {
            this.pauseAllMedia();
            if (!this.getAttribute(Ae.loaded)) {
                const t = document.createElement("div");
                const i = this.querySelector(ke.template).content.firstElementChild.cloneNode(true);
                t.appendChild(i);
                this.setAttribute(Ae.loaded, true);
                const s = this.appendChild(t.querySelector(ke.media));
                if (e) s.focus();
                if (s.nodeName == "VIDEO" && s.getAttribute(Ae.autoplay)) {
                    s.play();
                }
                if (this.productGridItem) {
                    this.videoActions();
                }
            }
        }
        pauseAllMedia() {
            document.querySelectorAll(ke.youtube).forEach((e) => {
                e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
            });
            document.querySelectorAll(ke.vimeo).forEach((e) => {
                e.contentWindow.postMessage('{"method":"pause"}', "*");
            });
            document.querySelectorAll(ke.video).forEach((e) => e.pause());
            document.querySelectorAll(ke.productModel).forEach((e) => {
                if (e.modelViewerUI) e.modelViewerUI.pause();
            });
        }
    }
    const Te = { visible: "is-visible" };
    class qe {
        constructor(e, t) {
            if (!e || !t) return;
            this.observer = null;
            this.container = e;
            this.itemSelector = t;
            this.init();
        }
        init() {
            const e = { root: this.container, threshold: [0.01, 0.5, 0.75, 0.99] };
            this.observer = new IntersectionObserver((e) => {
                e.forEach((e) => {
                    if (e.intersectionRatio >= 0.99) {
                        e.target.classList.add(Te.visible);
                    } else {
                        e.target.classList.remove(Te.visible);
                    }
                });
            }, e);
            this.container.querySelectorAll(this.itemSelector)?.forEach((e) => {
                this.observer.observe(e);
            });
        }
        destroy() {
            this.observer.disconnect();
        }
    }
    const Ie = { dragging: "is-dragging", enabled: "is-enabled", scrolling: "is-scrolling", visible: "is-visible" };
    const Pe = { image: "img, svg", productImage: "[data-product-image]", slide: "[data-grid-item]", slider: "[data-grid-slider]" };
    class xe {
        constructor(e) {
            this.slider = e;
            this.isDown = false;
            this.startX = 0;
            this.scrollLeft = 0;
            this.velX = 0;
            this.scrollAnimation = null;
            this.isScrolling = false;
            this.duration = 800;
            this.scrollStep = this.scrollStep.bind(this);
            this.scrollToSlide = this.scrollToSlide.bind(this);
            this.handleMouseDown = this.handleMouseDown.bind(this);
            this.handleMouseLeave = this.handleMouseLeave.bind(this);
            this.handleMouseUp = this.handleMouseUp.bind(this);
            this.handleMouseMove = this.handleMouseMove.bind(this);
            this.handleMouseWheel = this.handleMouseWheel.bind(this);
            this.slider.addEventListener("mousedown", this.handleMouseDown);
            this.slider.addEventListener("mouseleave", this.handleMouseLeave);
            this.slider.addEventListener("mouseup", this.handleMouseUp);
            this.slider.addEventListener("mousemove", this.handleMouseMove);
            this.slider.addEventListener("wheel", this.handleMouseWheel, { passive: true });
            this.slider.classList.add(Ie.enabled);
        }
        handleMouseDown(e) {
            e.preventDefault();
            this.isDown = true;
            this.startX = e.pageX - this.slider.offsetLeft;
            this.scrollLeft = this.slider.scrollLeft;
            this.cancelMomentumTracking();
        }
        handleMouseLeave() {
            if (!this.isDown) return;
            this.isDown = false;
            this.beginMomentumTracking();
        }
        handleMouseUp() {
            this.isDown = false;
            this.beginMomentumTracking();
        }
        handleMouseMove(e) {
            if (!this.isDown) return;
            e.preventDefault();
            const t = e.pageX - this.slider.offsetLeft;
            const i = 1;
            const s = (t - this.startX) * i;
            const o = this.slider.scrollLeft;
            const n = s > 0 ? 1 : -1;
            this.slider.classList.add(Ie.dragging, Ie.scrolling);
            this.slider.scrollLeft = this.scrollLeft - s;
            if (this.slider.scrollLeft !== o) {
                this.velX = this.slider.scrollLeft - o || n;
            }
        }
        handleMouseWheel() {
            this.cancelMomentumTracking();
            this.slider.classList.remove(Ie.scrolling);
        }
        beginMomentumTracking() {
            this.isScrolling = false;
            this.slider.classList.remove(Ie.dragging);
            this.cancelMomentumTracking();
            this.scrollToSlide();
        }
        cancelMomentumTracking() {
            cancelAnimationFrame(this.scrollAnimation);
        }
        scrollToSlide() {
            if (!this.velX && !this.isScrolling) return;
            const e = this.slider.querySelector(`${Pe.slide}.${Ie.visible}`);
            if (!e) return;
            const t = parseInt(window.getComputedStyle(e).marginRight) || 0;
            const i = e.offsetWidth + t;
            const s = e.offsetLeft;
            const o = this.velX > 0 ? 1 : -1;
            const n = Math.floor(Math.abs(this.velX) / 100) || 1;
            this.startPosition = this.slider.scrollLeft;
            this.distance = s - this.startPosition;
            this.startTime = performance.now();
            this.isScrolling = true;
            if (o < 0 && this.velX < i) {
                this.distance -= i * n;
            }
            if (o > 0 && this.velX < i) {
                this.distance += i * n;
            }
            this.scrollAnimation = requestAnimationFrame(this.scrollStep);
        }
        scrollStep() {
            const e = performance.now() - this.startTime;
            const t = parseFloat(this.easeOutCubic(Math.min(e, this.duration))).toFixed(1);
            this.slider.scrollLeft = t;
            if (e < this.duration) {
                this.scrollAnimation = requestAnimationFrame(this.scrollStep);
            } else {
                this.slider.classList.remove(Ie.scrolling);
                this.velX = 0;
                this.isScrolling = false;
            }
        }
        easeOutCubic(e) {
            e /= this.duration;
            e--;
            return this.distance * (e * e * e + 1) + this.startPosition;
        }
        destroy() {
            this.slider.classList.remove(Ie.enabled);
            this.slider.removeEventListener("mousedown", this.handleMouseDown);
            this.slider.removeEventListener("mouseleave", this.handleMouseLeave);
            this.slider.removeEventListener("mouseup", this.handleMouseUp);
            this.slider.removeEventListener("mousemove", this.handleMouseMove);
            this.slider.removeEventListener("wheel", this.handleMouseWheel);
        }
    }
    function Me(e) {
        return new Promise((t) => {
            const i = e.querySelectorAll("[data-aos]");
            let s = 0;
            function o(e) {
                s++;
                if (s === i.length) {
                    t();
                }
                e.target.removeEventListener("animationend", o);
            }
            i.forEach((e) => {
                e.addEventListener("animationend", o);
            });
        });
    }
    const He = { buttonArrow: "[data-button-arrow]", collectionImage: "[data-collection-image]", columnImage: "[data-column-image]", productImage: "[data-product-image]", slide: "[data-grid-item]", slider: "[data-grid-slider]" };
    const Oe = { buttonPrev: "data-button-prev", buttonNext: "data-button-next", alignArrows: "align-arrows" };
    const Be = { arrows: "slider__arrows", visible: "is-visible", scrollSnapDisabled: "scroll-snap-disabled" };
    class De extends HTMLElement {
        constructor() {
            super();
            this.isInitialized = false;
            this.draggableSlider = null;
            this.positionArrows = this.positionArrows.bind(this);
            this.onButtonArrowClick = (e) => this.buttonArrowClickEvent(e);
            this.slidesObserver = null;
            this.firstLastSlidesObserver = null;
            this.isDragging = false;
            this.toggleSlider = this.toggleSlider.bind(this);
        }
        connectedCallback() {
            this.init();
            this.addEventListener("theme:grid-slider:init", this.init);
        }
        init() {
            this.slider = this.querySelector(He.slider);
            this.slides = this.querySelectorAll(He.slide);
            this.buttons = this.querySelectorAll(He.buttonArrow);
            this.slider.classList.add(Be.scrollSnapDisabled);
            this.toggleSlider();
            document.addEventListener("theme:resize:width", this.toggleSlider);
            Me(this).then(() => {
                this.slider.classList.remove(Be.scrollSnapDisabled);
            });
        }
        toggleSlider() {
            const e = this.slider.clientWidth;
            const t = this.getSlidesWidth();
            const i = e < t;
            if (i && (b() || !window.theme.touch)) {
                if (this.isInitialized) return;
                this.slidesObserver = new qe(this.slider, He.slide);
                this.initArrows();
                this.isInitialized = true;
                this.draggableSlider = new xe(this.slider);
            } else {
                this.destroy();
            }
        }
        initArrows() {
            if (!this.buttons.length) {
                const e = document.createElement("div");
                e.classList.add(Be.arrows);
                e.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next;
                this.append(e);
                this.buttons = this.querySelectorAll(He.buttonArrow);
                this.buttonPrev = this.querySelector(`[${Oe.buttonPrev}]`);
                this.buttonNext = this.querySelector(`[${Oe.buttonNext}]`);
            }
            this.toggleArrowsObserver();
            if (this.hasAttribute(Oe.alignArrows)) {
                this.positionArrows();
                this.arrowsResizeObserver();
            }
            this.buttons.forEach((e) => {
                e.addEventListener("click", this.onButtonArrowClick);
            });
        }
        buttonArrowClickEvent(e) {
            e.preventDefault();
            const t = this.slider.querySelector(`${He.slide}.${Be.visible}`);
            let i = null;
            if (e.target.hasAttribute(Oe.buttonPrev)) {
                i = t?.previousElementSibling;
            }
            if (e.target.hasAttribute(Oe.buttonNext)) {
                i = t?.nextElementSibling;
            }
            this.goToSlide(i);
        }
        removeArrows() {
            this.querySelector(`.${Be.arrows}`)?.remove();
        }
        goToSlide(e) {
            if (!e) return;
            this.slider.scrollTo({ top: 0, left: e.offsetLeft, behavior: "smooth" });
        }
        getSlidesWidth() {
            return this.slider.querySelector(He.slide)?.clientWidth * this.slider.querySelectorAll(He.slide).length;
        }
        toggleArrowsObserver() {
            if (this.buttonPrev && this.buttonNext) {
                const e = this.slides.length;
                const t = this.slides[0];
                const i = this.slides[e - 1];
                const s = { attributes: true, childList: false, subtree: false };
                const o = (e) => {
                    for (const s of e) {
                        if (s.type === "attributes") {
                            const e = s.target;
                            const o = Boolean(e.classList.contains(Be.visible));
                            if (e == t) {
                                this.buttonPrev.disabled = o;
                            }
                            if (e == i) {
                                this.buttonNext.disabled = o;
                            }
                        }
                    }
                };
                if (t && i) {
                    this.firstLastSlidesObserver = new MutationObserver(o);
                    this.firstLastSlidesObserver.observe(t, s);
                    this.firstLastSlidesObserver.observe(i, s);
                }
            }
        }
        positionArrows() {
            const e = this.slider.querySelector(He.productImage) || this.slider.querySelector(He.collectionImage) || this.slider.querySelector(He.columnImage) || this.slider;
            if (!e) return;
            this.style.setProperty("--button-position", `${e.clientHeight / 2}px`);
        }
        arrowsResizeObserver() {
            document.addEventListener("theme:resize:width", this.positionArrows);
        }
        disconnectedCallback() {
            this.destroy();
            document.removeEventListener("theme:resize:width", this.toggleSlider);
        }
        destroy() {
            this.isInitialized = false;
            this.draggableSlider?.destroy();
            this.draggableSlider = null;
            this.slidesObserver?.destroy();
            this.slidesObserver = null;
            this.removeArrows();
            document.removeEventListener("theme:resize:width", this.positionArrows);
        }
    }
    const Fe = {
        time: "time",
        days: "[data-days]",
        hours: "[data-hours]",
        minutes: "[data-minutes]",
        seconds: "[data-seconds]",
        shopifySection: ".shopify-section",
        countdownBlock: "[data-countdown-block]",
        tickerText: "[data-ticker-text]",
    };
    const _e = { expirationBehavior: "data-expiration-behavior", clone: "data-clone" };
    const $e = { showMessage: "show-message", hideCountdown: "hidden" };
    const Ne = { hideSection: "hide-section", showMessage: "show-message" };
    class We extends HTMLElement {
        constructor() {
            super();
            this.section = this.closest(Fe.shopifySection);
            this.countdownParent = this.closest(Fe.countdownBlock) || this.section;
            this.expirationBehavior = this.getAttribute(_e.expirationBehavior);
            this.time = this.querySelector(Fe.time);
            this.days = this.querySelector(Fe.days);
            this.hours = this.querySelector(Fe.hours);
            this.minutes = this.querySelector(Fe.minutes);
            this.seconds = this.querySelector(Fe.seconds);
            this.endDate = Date.parse(this.time.dateTime);
            this.daysInMs = 1e3 * 60 * 60 * 24;
            this.hoursInMs = this.daysInMs / 24;
            this.minutesInMs = this.hoursInMs / 60;
            this.secondsInMs = this.minutesInMs / 60;
            this.shouldHideOnComplete = this.expirationBehavior === Ne.hideSection;
            this.shouldShowMessage = this.expirationBehavior === Ne.showMessage;
            this.update = this.update.bind(this);
        }
        connectedCallback() {
            if (isNaN(this.endDate)) {
                this.onComplete();
                return;
            }
            if (this.endDate <= Date.now()) {
                this.onComplete();
                return;
            }
            this.update();
            this.interval = setInterval(this.update, 1e3);
        }
        disconnectedCallback() {
            this.stopTimer();
        }
        convertTime(e) {
            const t = this.formatDigits(parseInt(e / this.daysInMs, 10));
            e -= t * this.daysInMs;
            const i = this.formatDigits(parseInt(e / this.hoursInMs, 10));
            e -= i * this.hoursInMs;
            const s = this.formatDigits(parseInt(e / this.minutesInMs, 10));
            e -= s * this.minutesInMs;
            const o = this.formatDigits(parseInt(e / this.secondsInMs, 10));
            return { days: t, hours: i, minutes: s, seconds: o };
        }
        formatDigits(e) {
            if (e < 10) e = "0" + e;
            return e;
        }
        render(e) {
            this.days.textContent = e.days;
            this.hours.textContent = e.hours;
            this.minutes.textContent = e.minutes;
            this.seconds.textContent = e.seconds;
        }
        stopTimer() {
            clearInterval(this.interval);
        }
        onComplete() {
            this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            if (this.shouldHideOnComplete) {
                this.countdownParent?.classList.add($e.hideCountdown);
                this.countdownParent?.dispatchEvent(new CustomEvent("theme:countdown:hide", { detail: { element: this }, bubbles: true }));
            }
            if (this.shouldShowMessage) {
                this.classList?.add($e.showMessage);
                if (this.closest(Fe.tickerText).hasAttribute(_e.clone)) return;
                this.countdownParent?.dispatchEvent(new CustomEvent("theme:countdown:expire", { bubbles: true }));
            }
        }
        update() {
            const e = new Date().getTime();
            const t = this.endDate - e;
            if (t < 1e3) {
                this.stopTimer();
                this.onComplete();
            }
            const i = this.convertTime(t);
            this.render(i);
        }
    }
    window.requestIdleCallback =
        window.requestIdleCallback ||
        function (e) {
            var t = Date.now();
            return setTimeout(function () {
                e({
                    didTimeout: false,
                    timeRemaining: function () {
                        return Math.max(0, 50 - (Date.now() - t));
                    },
                });
            }, 1);
        };
    window.cancelIdleCallback =
        window.cancelIdleCallback ||
        function (e) {
            clearTimeout(e);
        };
    if (window.theme.settings.enableAnimations) {
        Le();
    }
    L();
    O();
    _();
    d();
    V();
    window.addEventListener("DOMContentLoaded", () => {
        c();
        $(document);
        r(document);
        D(document);
        U(document);
        N();
        n();
        requestIdleCallback(() => {
            if (Shopify.visualPreviewMode) {
                document.documentElement.classList.add("preview-mode");
            }
        });
    });
    document.addEventListener("shopify:section:load", (e) => {
        const t = e.target;
        r(t);
        D(t);
        $(document);
        c();
    });
    if (!customElements.get("popout-select")) {
        customElements.define("popout-select", de);
    }
    if (!customElements.get("quantity-counter")) {
        customElements.define("quantity-counter", he);
    }
    if (!customElements.get("predictive-search")) {
        customElements.define("predictive-search", re);
    }
    if (!customElements.get("deferred-media")) {
        customElements.define("deferred-media", Ce);
    }
    if (!customElements.get("grid-slider")) {
        customElements.define("grid-slider", De);
    }
    if (!customElements.get("countdown-timer")) {
        customElements.define("countdown-timer", We);
    }
    const Re = (e, t = false, i = "block") => {
        if (e) {
            if (t) {
                e.style.removeProperty("display");
            } else {
                e.style.display = i;
            }
        }
    };
    Shopify.Products = (function () {
        const e = { howManyToShow: 4, howManyToStoreInMemory: 10, wrapperId: "recently-viewed-products", section: null, target: "api-product-grid-item", onComplete: null };
        let t = [];
        let i = null;
        let s = null;
        const o = new Date();
        const n = new Date();
        const r = 90;
        n.setTime(o.getTime() + 36e5 * 24 * r);
        const a = {
            configuration: { expires: n.toGMTString(), path: "/", domain: window.location.hostname, sameSite: "none", secure: true },
            name: "shopify_recently_viewed",
            write: function (e) {
                const t = encodeURIComponent(e.join(" "));
                document.cookie = `${this.name}=${t}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
            },
            read: function () {
                let e = [];
                let t = null;
                if (document.cookie.indexOf("; ") !== -1 && document.cookie.split("; ").find((e) => e.startsWith(this.name))) {
                    t = document.cookie
                        .split("; ")
                        .find((e) => e.startsWith(this.name))
                        .split("=")[1];
                }
                if (t !== null) {
                    e = decodeURIComponent(t).split(" ");
                }
                return e;
            },
            destroy: function () {
                const e = null;
                document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
            },
            remove: function (e) {
                const t = this.read();
                const i = t.indexOf(e);
                if (i !== -1) {
                    t.splice(i, 1);
                    this.write(t);
                }
            },
        };
        const l = (t, i) => {
            Re(t, true);
            const o = a.read().length;
            if (Shopify.recentlyViewed && s && o && o < s && t.children.length) {
                let e = [];
                let i = [];
                let s = 0;
                for (const t in Shopify.recentlyViewed) {
                    s += 1;
                    const o = Shopify.recentlyViewed[t];
                    const n = o.split(" ");
                    const r = parseInt(t.split("_")[1]);
                    e = [...e, ...n];
                    if (a.read().length === r || (s === Object.keys(Shopify.recentlyViewed).length && !i.length)) {
                        i = [...i, ...n];
                    }
                }
                for (let s = 0; s < t.children.length; s++) {
                    const o = t.children[s];
                    if (e.length) {
                        o.classList.remove(...e);
                    }
                    if (i.length) {
                        o.classList.add(...i);
                    }
                }
            }
            if (e.onComplete) {
                try {
                    e.onComplete(t, i);
                } catch (e) {
                    console.log(e);
                }
            }
        };
        const c = (e, t, i, s, o, n) => {
            if (t.length && e < n) {
                fetch(`${window.theme.routes.root}products/${t[0]}?section_id=${o}`)
                    .then((e) => e.text())
                    .then((r) => {
                        const a = e * 100;
                        const l = i.id ? `#${i.id}` : "";
                        const d = document.createElement("div");
                        let h = r;
                        h = h.includes("||itemAnimationDelay||") ? h.replaceAll("||itemAnimationDelay||", a) : h;
                        h = h.includes("||itemAnimationAnchor||") ? h.replaceAll("||itemAnimationAnchor||", l) : h;
                        d.innerHTML = h;
                        i.innerHTML += d.querySelector("[data-api-content]").innerHTML;
                        t.shift();
                        e++;
                        c(e, t, i, s, o, n);
                    })
                    .catch(() => {
                        a.remove(t[0]);
                        t.shift();
                        c(e, t, i, s, o, n);
                    });
            } else {
                l(i, s);
            }
        };
        return {
            showRecentlyViewed: function (o) {
                const n = o || {};
                const r = 0;
                Object.assign(e, n);
                t = a.read();
                i = document.querySelector(`#${e.wrapperId}`);
                s = e.howManyToShow;
                e.howManyToShow = Math.min(t.length, e.howManyToShow);
                if (e.howManyToShow && i) {
                    c(r, t, i, e.section, e.target, s);
                }
            },
            getConfig: function () {
                return e;
            },
            clearList: function () {
                a.destroy();
            },
            recordRecentlyViewed: function (t) {
                const i = t || {};
                Object.assign(e, i);
                let s = a.read();
                if (window.location.pathname.indexOf("/products/") !== -1) {
                    let t = decodeURIComponent(window.location.pathname)
                        .match(
                            /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
                        )[0]
                        .split("/products/")[1];
                    if (e.handle) {
                        t = e.handle;
                    }
                    const i = s.indexOf(t);
                    if (i === -1) {
                        s.unshift(t);
                        s = s.splice(0, e.howManyToStoreInMemory);
                    } else {
                        s.splice(i, 1);
                        s.unshift(t);
                    }
                    a.write(s);
                }
            },
            hasProducts: a.read().length > 0,
        };
    })();
    const Ve = { focus: "is-focused" };
    const Ue = { inPageLink: "[data-skip-content]", linkesWithOnlyHash: 'a[href="#"]' };
    class ze {
        constructor() {
            this.init();
        }
        init() {
            this.a11y = te;
            this.html = document.documentElement;
            this.body = document.body;
            this.inPageLink = document.querySelector(Ue.inPageLink);
            this.linkesWithOnlyHash = document.querySelectorAll(Ue.linkesWithOnlyHash);
            this.a11y.focusHash();
            this.a11y.bindInPageLinks();
            this.clickEvents();
            this.focusEvents();
        }
        clickEvents() {
            if (this.inPageLink) {
                this.inPageLink.addEventListener("click", (e) => {
                    e.preventDefault();
                });
            }
            if (this.linkesWithOnlyHash) {
                this.linkesWithOnlyHash.forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault();
                    });
                });
            }
        }
        focusEvents() {
            document.addEventListener("mousedown", () => {
                this.body.classList.remove(Ve.focus);
            });
            document.addEventListener("keyup", (e) => {
                if (e.code !== "Tab") {
                    return;
                }
                this.body.classList.add(Ve.focus);
            });
        }
    }
    window.accessibility = new ze();
    const je = "${{amount}}";
    function Je(e, t) {
        if (typeof e === "string") {
            e = e.replace(".", "");
        }
        let i = "";
        const s = /\{\{\s*(\w+)\s*\}\}/;
        const o = t || je;
        function n(e, t = 2, i = ",", s = ".") {
            if (isNaN(e) || e == null) {
                return 0;
            }
            e = (e / 100).toFixed(t);
            const o = e.split(".");
            const n = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`);
            const r = o[1] ? s + o[1] : "";
            return n + r;
        }
        switch (o.match(s)[1]) {
            case "amount":
                i = n(e, 2);
                break;
            case "amount_no_decimals":
                i = n(e, 0);
                break;
            case "amount_with_comma_separator":
                i = n(e, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                i = n(e, 0, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                i = n(e, 2, "'", ".");
                break;
            case "amount_no_decimals_with_space_separator":
                i = n(e, 0, " ", "");
                break;
            case "amount_with_space_separator":
                i = n(e, 2, " ", ",");
                break;
            case "amount_with_period_and_space_separator":
                i = n(e, 2, " ", ".");
                break;
        }
        return o.replace(s, i);
    }
    const Xe = (e, t) => {
        let i, s;
        return function o(...n) {
            const r = Date.now();
            s = clearTimeout(s);
            if (!i || r - i >= t) {
                e.apply(null, n);
                i = r;
            } else {
                s = setTimeout(o.bind(null, ...n), t - (r - i));
            }
        };
    };
    function Ge(e) {
        this.status = e.status || null;
        this.headers = e.headers || null;
        this.json = e.json || null;
        this.body = e.body || null;
    }
    Ge.prototype = Error.prototype;
    const Ye = {
        animated: "is-animated",
        active: "is-active",
        added: "is-added",
        disabled: "is-disabled",
        empty: "is-empty",
        error: "has-error",
        headerStuck: "js__header__stuck",
        hidden: "is-hidden",
        hiding: "is-hiding",
        loading: "is-loading",
        open: "is-open",
        removed: "is-removed",
        success: "is-success",
        visible: "is-visible",
        expanded: "is-expanded",
        updated: "is-updated",
        variantSoldOut: "variant--soldout",
        variantUnavailable: "variant--unavailable",
    };
    const Qe = {
        apiContent: "[data-api-content]",
        apiLineItems: "[data-api-line-items]",
        apiUpsellItems: "[data-api-upsell-items]",
        apiCartPrice: "[data-api-cart-price]",
        animation: "[data-animation]",
        additionalCheckoutButtons: ".additional-checkout-buttons",
        buttonSkipUpsellProduct: "[data-skip-upsell-product]",
        cartBarAdd: "[data-add-to-cart-bar]",
        cartCloseError: "[data-cart-error-close]",
        cartDrawer: "cart-drawer",
        cartDrawerClose: "[data-cart-drawer-close]",
        cartEmpty: "[data-cart-empty]",
        cartErrors: "[data-cart-errors]",
        cartItemRemove: "[data-item-remove]",
        cartPage: "[data-cart-page]",
        cartForm: "[data-cart-form]",
        cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
        cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
        cartCheckoutButton: "[data-cart-checkout-button]",
        cartTotal: "[data-cart-total]",
        checkoutButtons: "[data-checkout-buttons]",
        errorMessage: "[data-error-message]",
        formCloseError: "[data-close-error]",
        formErrorsContainer: "[data-cart-errors-container]",
        formWrapper: "[data-form-wrapper]",
        freeShipping: "[data-free-shipping]",
        freeShippingGraph: "[data-progress-graph]",
        freeShippingProgress: "[data-progress-bar]",
        headerWrapper: "[data-header-wrapper]",
        item: "[data-item]",
        itemsHolder: "[data-items-holder]",
        leftToSpend: "[data-left-to-spend]",
        navDrawer: "[data-drawer]",
        outerSection: "[data-section-id]",
        priceHolder: "[data-cart-price-holder]",
        quickAddHolder: "[data-quick-add-holder]",
        quickAddModal: "[data-quick-add-modal]",
        qtyInput: 'input[name="updates[]"]',
        upsellProductsHolder: "[data-upsell-products]",
        upsellWidget: "[data-upsell-widget]",
        termsErrorMessage: "[data-terms-error-message]",
        collapsibleBody: "[data-collapsible-body]",
        recentlyViewedHolderId: "recently-viewed-products-cart",
    };
    const Ke = {
        cartTotal: "data-cart-total",
        disabled: "disabled",
        freeShipping: "data-free-shipping",
        freeShippingLimit: "data-free-shipping-limit",
        item: "data-item",
        itemIndex: "data-item-index",
        itemTitle: "data-item-title",
        open: "open",
        quickAddHolder: "data-quick-add-holder",
        quickAddVariant: "data-quick-add-variant",
        scrollLocked: "data-scroll-locked",
        upsellAutoOpen: "data-upsell-auto-open",
    };
    class Ze extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.cartPage = document.querySelector(Qe.cartPage);
            this.cartForm = document.querySelector(Qe.cartForm);
            this.cartDrawer = document.querySelector(Qe.cartDrawer);
            this.cartEmpty = document.querySelector(Qe.cartEmpty);
            this.cartTermsCheckbox = document.querySelector(Qe.cartTermsCheckbox);
            this.cartCheckoutButtonWrapper = document.querySelector(Qe.cartCheckoutButtonWrapper);
            this.cartCheckoutButton = document.querySelector(Qe.cartCheckoutButton);
            this.checkoutButtons = document.querySelector(Qe.checkoutButtons);
            this.itemsHolder = document.querySelector(Qe.itemsHolder);
            this.priceHolder = document.querySelector(Qe.priceHolder);
            this.items = document.querySelectorAll(Qe.item);
            this.cartTotal = document.querySelector(Qe.cartTotal);
            this.freeShipping = document.querySelectorAll(Qe.freeShipping);
            this.cartErrorHolder = document.querySelector(Qe.cartErrors);
            this.cartCloseErrorMessage = document.querySelector(Qe.cartCloseError);
            this.headerWrapper = document.querySelector(Qe.headerWrapper);
            this.navDrawer = document.querySelector(Qe.navDrawer);
            this.upsellProductsHolder = document.querySelector(Qe.upsellProductsHolder);
            this.subtotal = window.theme.subtotal;
            this.cart = this.cartDrawer || this.cartPage;
            this.animateItems = this.animateItems.bind(this);
            this.addToCart = this.addToCart.bind(this);
            this.cartAddEvent = this.cartAddEvent.bind(this);
            this.updateProgress = this.updateProgress.bind(this);
            this.onCartDrawerClose = this.onCartDrawerClose.bind(this);
            document.addEventListener("theme:cart:add", this.cartAddEvent);
            document.addEventListener("theme:announcement:init", this.updateProgress);
            if (theme.settings.cartType == "drawer") {
                document.addEventListener("theme:cart-drawer:open", this.animateItems);
                document.addEventListener("theme:cart-drawer:close", this.onCartDrawerClose);
            }
            this.skipUpsellProductsArray = [];
            this.skipUpsellProductEvent();
            this.checkSkippedUpsellProductsFromStorage();
            this.toggleCartUpsellWidgetVisibility();
            this.circumference = 28 * Math.PI;
            this.freeShippingLimit = this.freeShipping.length ? Number(this.freeShipping[0].getAttribute(Ke.freeShippingLimit)) * 100 * window.Shopify.currency.rate : 0;
            this.freeShippingMessageHandle(this.subtotal);
            this.updateProgress();
            this.build = this.build.bind(this);
            this.updateCart = this.updateCart.bind(this);
            this.productAddCallback = this.productAddCallback.bind(this);
            this.formSubmitHandler = Xe(this.formSubmitHandler.bind(this), 50);
            if (this.cartPage) {
                this.animateItems();
            }
            if (this.cart) {
                this.recentlyViewedProducts();
                this.hasItemsInCart = this.hasItemsInCart.bind(this);
                this.cartCount = this.getCartItemCount();
            }
            this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this);
            this.totalItems = this.items.length;
            this.cartUpdateFailed = false;
            this.cartEvents();
            this.cartRemoveEvents();
            this.cartUpdateEvents();
            document.addEventListener("theme:product:add", this.productAddCallback);
            document.addEventListener("theme:product:add-error", this.productAddCallback);
            document.dispatchEvent(new CustomEvent("theme:cart:load", { bubbles: true }));
        }
        disconnectedCallback() {
            document.removeEventListener("theme:cart:add", this.cartAddEvent);
            document.removeEventListener("theme:announcement:init", this.updateProgress);
            document.removeEventListener("theme:product:add", this.productAddCallback);
            document.removeEventListener("theme:product:add-error", this.productAddCallback);
            document.dispatchEvent(new CustomEvent("theme:cart:unload", { bubbles: true }));
            if (document.documentElement.hasAttribute(Ke.scrollLocked)) {
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
            }
        }
        onCartDrawerClose() {
            this.resetAnimatedItems();
            if (this.cartDrawer?.classList.contains(Ye.open)) {
                this.cart.classList.remove(Ye.updated);
            }
            this.cartEmpty.classList.remove(Ye.updated);
            this.cartErrorHolder.classList.remove(Ye.expanded);
            this.cart.querySelectorAll(Qe.animation).forEach((e) => {
                const t = () => {
                    e.classList.remove(Ye.hiding);
                    e.removeEventListener("animationend", t);
                };
                e.classList.add(Ye.hiding);
                e.addEventListener("animationend", t);
            });
        }
        cartUpdateEvents() {
            this.items = document.querySelectorAll(Qe.item);
            this.items.forEach((e) => {
                e.addEventListener("theme:cart:update", (t) => {
                    this.updateCart({ id: t.detail.id, quantity: t.detail.quantity }, e);
                });
            });
        }
        cartRemoveEvents() {
            const e = document.querySelectorAll(Qe.cartItemRemove);
            e.forEach((e) => {
                const t = e.closest(Qe.item);
                e.addEventListener("click", (i) => {
                    i.preventDefault();
                    if (e.classList.contains(Ye.disabled)) return;
                    this.updateCart({ id: e.dataset.id, quantity: 0 }, t);
                });
            });
            if (this.cartCloseErrorMessage) {
                this.cartCloseErrorMessage.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.cartErrorHolder.classList.remove(Ye.expanded);
                });
            }
        }
        cartAddEvent(e) {
            let t = "";
            let i = e.detail.button;
            if (i.hasAttribute("disabled")) return;
            const s = i.closest("form");
            if (!s.checkValidity()) {
                s.reportValidity();
                return;
            }
            t = new FormData(s);
            if (s !== null && s.querySelector('[type="file"]')) {
                return;
            }
            if (theme.settings.cartType === "drawer" && this.cartDrawer) {
                e.preventDefault();
            }
            this.addToCart(t, i);
        }
        cartEvents() {
            if (this.cartTermsCheckbox) {
                this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler);
                this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler);
                this.cartForm.removeEventListener("submit", this.formSubmitHandler);
                this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler);
                this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler);
                this.cartForm.addEventListener("submit", this.formSubmitHandler);
            }
        }
        formSubmitHandler() {
            const e = document.querySelector(Qe.cartTermsCheckbox).checked;
            const t = document.querySelector(Qe.termsErrorMessage);
            if (!e) {
                if (document.querySelector(Qe.termsErrorMessage).length > 0) {
                    return;
                }
                t.innerText = theme.strings.cartAcceptanceError;
                this.cartCheckoutButton.setAttribute(Ke.disabled, true);
                t.classList.add(Ye.expanded);
            } else {
                t.classList.remove(Ye.expanded);
                this.cartCheckoutButton.removeAttribute(Ke.disabled);
            }
        }
        formErrorsEvents(e) {
            const t = e.querySelector(Qe.formCloseError);
            t?.addEventListener("click", (t) => {
                t.preventDefault();
                if (e) {
                    e.classList.remove(Ye.visible);
                }
            });
        }
        getCart() {
            fetch(theme.routes.cart_url + "?section_id=api-cart-items")
                .then(this.cartErrorsHandler)
                .then((e) => e.text())
                .then((e) => {
                    const t = document.createElement("div");
                    t.innerHTML = e;
                    const i = t.querySelector(Qe.apiContent);
                    this.build(i);
                })
                .catch((e) => console.log(e));
        }
        addToCart(e, t) {
            if (this.cart) {
                this.cart.classList.add(Ye.loading);
            }
            const i = t?.closest(Qe.quickAddHolder);
            if (t) {
                t.classList.add(Ye.loading);
                t.disabled = true;
            }
            if (i) {
                i.classList.add(Ye.visible);
            }
            fetch(theme.routes.cart_add_url, { method: "POST", headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" }, body: e })
                .then((e) => e.json())
                .then((e) => {
                    if (e.status) {
                        this.addToCartError(e, t);
                        if (t) {
                            t.classList.remove(Ye.loading);
                            t.disabled = false;
                        }
                        return;
                    }
                    if (this.cart) {
                        if (t) {
                            t.classList.remove(Ye.loading);
                            t.classList.add(Ye.added);
                            t.dispatchEvent(new CustomEvent("theme:product:add", { detail: { response: e, button: t }, bubbles: true }));
                        }
                        if (theme.settings.cartType === "page") {
                            window.location = theme.routes.cart_url;
                        }
                        this.getCart();
                    } else {
                        window.location = theme.routes.cart_url;
                    }
                })
                .catch((e) => {
                    this.addToCartError(e, t);
                    this.enableCartButtons();
                });
        }
        updateCart(e = {}, t = null) {
            this.cart.classList.add(Ye.loading);
            let i = e.quantity;
            if (t !== null) {
                if (i) {
                    t.classList.add(Ye.loading);
                } else {
                    t.classList.add(Ye.removed);
                }
            }
            this.disableCartButtons();
            const s = this.cart.querySelector(`[${Ke.item}="${e.id}"]`) || t;
            const o = s?.hasAttribute(Ke.itemIndex) ? parseInt(s.getAttribute(Ke.itemIndex)) : 0;
            const n = s?.hasAttribute(Ke.itemTitle) ? s.getAttribute(Ke.itemTitle) : null;
            if (o === 0) return;
            const r = { line: o, quantity: i };
            fetch(theme.routes.cart_change_url, { method: "post", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(r) })
                .then((e) => e.text())
                .then((e) => {
                    const i = JSON.parse(e);
                    if (i.errors) {
                        this.cartUpdateFailed = true;
                        this.updateErrorText(n);
                        this.toggleErrorMessage();
                        this.resetLineItem(t);
                        this.enableCartButtons();
                        return;
                    }
                    this.getCart();
                })
                .catch((e) => {
                    console.log(e);
                    this.enableCartButtons();
                });
        }
        resetLineItem(e) {
            const t = e.querySelector(Qe.qtyInput);
            const i = t.getAttribute("value");
            t.value = i;
            e.classList.remove(Ye.loading);
        }
        disableCartButtons() {
            const e = this.cart.querySelectorAll("input");
            const t = this.cart.querySelectorAll(`button, ${Qe.cartItemRemove}`);
            if (e.length) {
                e.forEach((e) => {
                    e.classList.add(Ye.disabled);
                    e.blur();
                    e.disabled = true;
                });
            }
            if (t.length) {
                t.forEach((e) => {
                    e.setAttribute(Ke.disabled, true);
                });
            }
        }
        enableCartButtons() {
            const e = this.cart.querySelectorAll("input");
            const t = this.cart.querySelectorAll(`button, ${Qe.cartItemRemove}`);
            if (e.length) {
                e.forEach((e) => {
                    e.classList.remove(Ye.disabled);
                    e.disabled = false;
                });
            }
            if (t.length) {
                t.forEach((e) => {
                    e.removeAttribute(Ke.disabled);
                });
            }
            this.cart.classList.remove(Ye.loading);
        }
        updateErrorText(e) {
            this.cartErrorHolder.querySelector(Qe.errorMessage).innerText = e;
        }
        toggleErrorMessage() {
            if (!this.cartErrorHolder) return;
            this.cartErrorHolder.classList.toggle(Ye.expanded, this.cartUpdateFailed);
            this.cartUpdateFailed = false;
        }
        cartErrorsHandler(e) {
            if (!e.ok) {
                return e.json().then(function (t) {
                    const i = new Ge({ status: e.statusText, headers: e.headers, json: t });
                    throw i;
                });
            }
            return e;
        }
        addToCartError(e, t) {
            if (t !== null) {
                const i = t.closest(Qe.outerSection) || t.closest(Qe.quickAddHolder) || t.closest(Qe.quickAddModal);
                let s = i?.querySelector(Qe.formErrorsContainer);
                const o = t.closest(Qe.quickAddHolder);
                if (o && o.querySelector(Qe.formErrorsContainer)) {
                    s = o.querySelector(Qe.formErrorsContainer);
                }
                if (s) {
                    let t = `${e.message}: ${e.description}`;
                    if (e.message == e.description) {
                        t = e.message;
                    }
                    s.innerHTML = `<div class="errors">${t}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`;
                    s.classList.add(Ye.visible);
                    this.formErrorsEvents(s);
                }
                t.dispatchEvent(new CustomEvent("theme:product:add-error", { detail: { response: e, button: t }, bubbles: true }));
            }
            const i = t?.closest(Qe.quickAddHolder);
            if (i) {
                i.dispatchEvent(new CustomEvent("theme:cart:error", { bubbles: true, detail: { message: e.message, description: e.description, holder: i } }));
            }
            this.cart?.classList.remove(Ye.loading);
        }
        productAddCallback(e) {
            let t = [];
            let i = null;
            const s = e.type == "theme:product:add-error";
            const o = e.detail.button;
            const n = document.querySelector(Qe.cartBarAdd);
            t.push(o);
            i = o.closest(Qe.quickAddHolder);
            if (n) {
                t.push(n);
            }
            t.forEach((e) => {
                e.classList.remove(Ye.loading);
                if (!s) {
                    e.classList.add(Ye.added);
                }
            });
            setTimeout(() => {
                t.forEach((e) => {
                    e.classList.remove(Ye.added);
                    const t = e.closest(Qe.formWrapper)?.classList.contains(Ye.variantSoldOut) || e.closest(Qe.formWrapper)?.classList.contains(Ye.variantUnavailable);
                    if (!t) {
                        e.disabled = false;
                    }
                });
                i?.classList.remove(Ye.visible);
            }, 1e3);
        }
        toggleClassesOnContainers() {
            const e = this.hasItemsInCart();
            this.cart.classList.toggle(Ye.empty, !e);
            if (!e && this.cartDrawer) {
                setTimeout(() => {
                    Q(this.cartDrawer, { elementToFocus: this.cartDrawer.querySelector(Qe.cartDrawerClose) });
                }, 100);
            }
        }
        build(e) {
            const t = e.querySelector(Qe.apiLineItems);
            const i = e.querySelector(Qe.apiUpsellItems);
            const s = Boolean(t === null && i === null);
            const o = e.querySelector(Qe.apiCartPrice);
            const n = e.querySelector(Qe.cartTotal);
            if (this.priceHolder && o) {
                this.priceHolder.innerHTML = o.innerHTML;
            }
            if (s) {
                this.itemsHolder.innerHTML = e.innerHTML;
                if (this.upsellProductsHolder) {
                    this.upsellProductsHolder.innerHTML = "";
                }
            } else {
                this.itemsHolder.innerHTML = t.innerHTML;
                if (this.upsellProductsHolder) {
                    this.upsellProductsHolder.innerHTML = i.innerHTML;
                }
                this.skipUpsellProductEvent();
                this.checkSkippedUpsellProductsFromStorage();
                this.toggleCartUpsellWidgetVisibility();
            }
            this.newTotalItems = t && t.querySelectorAll(Qe.item).length ? t.querySelectorAll(Qe.item).length : 0;
            this.subtotal = n && n.hasAttribute(Ke.cartTotal) ? parseInt(n.getAttribute(Ke.cartTotal)) : 0;
            this.cartCount = this.getCartItemCount();
            document.dispatchEvent(new CustomEvent("theme:cart:change", { bubbles: true, detail: { cartCount: this.cartCount } }));
            this.cartTotal.innerHTML = this.subtotal === 0 ? window.theme.strings.free : Je(this.subtotal, theme.moneyWithCurrencyFormat);
            if (this.totalItems !== this.newTotalItems) {
                this.totalItems = this.newTotalItems;
                this.toggleClassesOnContainers();
            }
            if (this.cartDrawer?.classList.contains(Ye.open)) {
                this.cart.classList.add(Ye.updated);
            }
            this.cart.classList.remove(Ye.loading);
            if (!this.hasItemsInCart()) {
                this.cartEmpty.querySelectorAll(Qe.animation).forEach((e) => {
                    e.classList.remove(Ye.animated);
                });
            }
            this.freeShippingMessageHandle(this.subtotal);
            this.cartRemoveEvents();
            this.cartUpdateEvents();
            this.toggleErrorMessage();
            this.enableCartButtons();
            this.updateProgress();
            this.animateItems();
            document.dispatchEvent(new CustomEvent("theme:product:added", { bubbles: true }));
        }
        getCartItemCount() {
            return Array.from(this.cart.querySelectorAll(Qe.qtyInput)).reduce((e, t) => e + parseInt(t.value), 0);
        }
        hasItemsInCart() {
            return this.totalItems > 0;
        }
        freeShippingMessageHandle(e) {
            if (!this.freeShipping.length) return;
            this.freeShipping.forEach((t) => {
                const i = t.hasAttribute(Ke.freeShipping) && t.getAttribute(Ke.freeShipping) === "true" && e >= 0;
                t.classList.toggle(Ye.success, i && e >= this.freeShippingLimit);
            });
        }
        updateProgress() {
            this.freeShipping = document.querySelectorAll(Qe.freeShipping);
            if (!this.freeShipping.length) return;
            const e = isNaN(this.subtotal / this.freeShippingLimit) ? 100 : this.subtotal / this.freeShippingLimit;
            const t = Math.min(e * 100, 100);
            const i = this.circumference - ((t / 100) * this.circumference) / 2;
            const s = Je(this.freeShippingLimit - this.subtotal, theme.moneyFormat);
            this.freeShipping.forEach((e) => {
                const o = e.querySelector(Qe.freeShippingProgress);
                const n = e.querySelector(Qe.freeShippingGraph);
                const r = e.querySelector(Qe.leftToSpend);
                if (r) {
                    r.innerHTML = s.replace(".00", "");
                }
                if (o) {
                    o.value = t;
                }
                if (n) {
                    n.style.setProperty("--stroke-dashoffset", `${i}`);
                }
            });
        }
        skipUpsellProductEvent() {
            if (this.upsellProductsHolder === null) {
                return;
            }
            const e = this.upsellProductsHolder.querySelectorAll(Qe.buttonSkipUpsellProduct);
            if (e.length) {
                e.forEach((e) => {
                    e.addEventListener("click", (t) => {
                        t.preventDefault();
                        const i = e.closest(Qe.quickAddHolder).getAttribute(Ke.quickAddHolder);
                        if (!this.skipUpsellProductsArray.includes(i)) {
                            this.skipUpsellProductsArray.push(i);
                        }
                        window.sessionStorage.setItem("skip_upsell_products", this.skipUpsellProductsArray);
                        this.removeUpsellProduct(i);
                        this.toggleCartUpsellWidgetVisibility();
                    });
                });
            }
        }
        checkSkippedUpsellProductsFromStorage() {
            const e = window.sessionStorage.getItem("skip_upsell_products");
            if (!e) return;
            const t = e.split(",");
            t.forEach((e) => {
                if (!this.skipUpsellProductsArray.includes(e)) {
                    this.skipUpsellProductsArray.push(e);
                }
                this.removeUpsellProduct(e);
            });
        }
        removeUpsellProduct(e) {
            if (!this.upsellProductsHolder) return;
            const t = this.upsellProductsHolder.querySelector(`[${Ke.quickAddHolder}="${e}"]`);
            if (t) {
                t.parentNode.remove();
            }
        }
        toggleCartUpsellWidgetVisibility() {
            if (!this.upsellProductsHolder) return;
            const e = this.upsellProductsHolder.querySelectorAll(Qe.quickAddHolder);
            const t = this.upsellProductsHolder.closest(Qe.upsellWidget);
            if (!t) return;
            t.classList.toggle(Ye.hidden, !e.length);
            if (e.length && !t.hasAttribute(Ke.open) && t.hasAttribute(Ke.upsellAutoOpen)) {
                t.setAttribute(Ke.open, true);
                const e = t.querySelector(Qe.collapsibleBody);
                if (e) {
                    e.style.height = "auto";
                }
            }
        }
        resetAnimatedItems() {
            this.cart.querySelectorAll(Qe.animation).forEach((e) => {
                e.classList.remove(Ye.animated);
                e.classList.remove(Ye.hiding);
            });
        }
        animateItems(e) {
            requestAnimationFrame(() => {
                let t = this.cart;
                if (e && e.detail && e.detail.target) {
                    t = e.detail.target;
                }
                t?.querySelectorAll(Qe.animation).forEach((e) => {
                    e.classList.add(Ye.animated);
                });
            });
        }
        recentlyViewedProducts() {
            const e = this.cart.querySelector(`#${Qe.recentlyViewedHolderId}`);
            if (e) {
                Shopify.Products.showRecentlyViewed({ howManyToShow: 3, wrapperId: Qe.recentlyViewedHolderId, section: this, target: "api-upsell-product" });
            }
        }
    }
    if (!customElements.get("cart-items")) {
        customElements.define("cart-items", Ze);
    }
    const et = { count: "data-cart-count", limit: "data-limit" };
    class tt extends HTMLElement {
        constructor() {
            super();
            this.cartCount = null;
            this.limit = this.getAttribute(et.limit);
            this.onCartChangeCallback = this.onCartChange.bind(this);
        }
        connectedCallback() {
            document.addEventListener("theme:cart:change", this.onCartChangeCallback);
        }
        disconnectedCallback() {
            document.addEventListener("theme:cart:change", this.onCartChangeCallback);
        }
        onCartChange(e) {
            this.cartCount = e.detail.cartCount;
            this.update();
        }
        update() {
            if (this.cartCount !== null) {
                this.setAttribute(et.count, this.cartCount);
                let e = this.cartCount;
                if (this.limit && this.cartCount >= this.limit) {
                    e = "9+";
                }
                this.innerText = e;
            }
        }
    }
    if (!customElements.get("cart-count")) {
        customElements.define("cart-count", tt);
    }
    function it(e) {
        return new Promise((t) => {
            function i(s) {
                if (s.target != e) return;
                e.removeEventListener("animationend", i);
                t();
            }
            e?.addEventListener("animationend", i);
        });
    }
    const st = { open: "is-open", closing: "is-closing", duplicate: "drawer--duplicate", drawerEditorError: "drawer-editor-error" };
    const ot = { cartDrawer: "cart-drawer", cartDrawerClose: "[data-cart-drawer-close]", cartDrawerSection: '[data-section-type="cart-drawer"]', cartDrawerInner: "[data-cart-drawer-inner]", shopifySection: ".shopify-section" };
    const nt = { drawerUnderlay: "data-drawer-underlay" };
    class rt extends HTMLElement {
        constructor() {
            super();
            this.cartDrawerIsOpen = false;
            this.cartDrawerClose = this.querySelector(ot.cartDrawerClose);
            this.cartDrawerInner = this.querySelector(ot.cartDrawerInner);
            this.openCartDrawer = this.openCartDrawer.bind(this);
            this.closeCartDrawer = this.closeCartDrawer.bind(this);
            this.toggleCartDrawer = this.toggleCartDrawer.bind(this);
            this.openCartDrawerOnProductAdded = this.openCartDrawerOnProductAdded.bind(this);
            this.openCartDrawerOnSelect = this.openCartDrawerOnSelect.bind(this);
            this.closeCartDrawerOnDeselect = this.closeCartDrawerOnDeselect.bind(this);
            this.cartDrawerSection = this.closest(ot.shopifySection);
            this.closeCartEvents();
        }
        connectedCallback() {
            const e = this.closest(ot.shopifySection);
            if (window.theme.hasCartDrawer) {
                if (!window.Shopify.designMode) {
                    e.remove();
                    return;
                } else {
                    const e = document.createElement("div");
                    e.classList.add(st.drawerEditorError);
                    e.innerText = "Cart drawer section already exists.";
                    if (!this.querySelector(`.${st.drawerEditorError}`)) {
                        this.querySelector(ot.cartDrawerInner).append(e);
                    }
                    this.classList.add(st.duplicate);
                }
            }
            window.theme.hasCartDrawer = true;
            this.addEventListener("theme:cart-drawer:show", this.openCartDrawer);
            document.addEventListener("theme:cart:toggle", this.toggleCartDrawer);
            document.addEventListener("theme:quick-add:open", this.closeCartDrawer);
            document.addEventListener("theme:product:added", this.openCartDrawerOnProductAdded);
            document.addEventListener("shopify:block:select", this.openCartDrawerOnSelect);
            document.addEventListener("shopify:section:select", this.openCartDrawerOnSelect);
            document.addEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect);
        }
        disconnectedCallback() {
            document.removeEventListener("theme:product:added", this.openCartDrawerOnProductAdded);
            document.removeEventListener("theme:cart:toggle", this.toggleCartDrawer);
            document.removeEventListener("theme:quick-add:open", this.closeCartDrawer);
            document.removeEventListener("shopify:block:select", this.openCartDrawerOnSelect);
            document.removeEventListener("shopify:section:select", this.openCartDrawerOnSelect);
            document.removeEventListener("shopify:section:deselect", this.closeCartDrawerOnDeselect);
            if (document.querySelectorAll(ot.cartDrawer).length <= 1) {
                window.theme.hasCartDrawer = false;
            }
            n();
        }
        openCartDrawerOnProductAdded() {
            if (!this.cartDrawerIsOpen) {
                this.openCartDrawer();
            }
        }
        openCartDrawerOnSelect(e) {
            const t = e.target.querySelector(ot.shopifySection) || e.target.closest(ot.shopifySection) || e.target;
            if (t === this.cartDrawerSection) {
                this.openCartDrawer(true);
            }
        }
        closeCartDrawerOnDeselect() {
            if (this.cartDrawerIsOpen) {
                this.closeCartDrawer();
            }
        }
        openCartDrawer(e = false) {
            if (!e && this.classList.contains(st.duplicate)) return;
            this.cartDrawerIsOpen = true;
            this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
            document.body.addEventListener("click", this.onBodyClickEvent);
            document.dispatchEvent(new CustomEvent("theme:cart-drawer:open", { detail: { target: this }, bubbles: true }));
            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
            this.classList.add(st.open);
            this.observeAdditionalCheckoutButtons();
            it(this.cartDrawerInner).then(() => {
                Q(this, { elementToFocus: this.querySelector(ot.cartDrawerClose) });
            });
        }
        closeCartDrawer() {
            if (!this.classList.contains(st.open)) return;
            this.classList.add(st.closing);
            this.classList.remove(st.open);
            this.cartDrawerIsOpen = false;
            document.dispatchEvent(new CustomEvent("theme:cart-drawer:close", { bubbles: true }));
            K();
            Z();
            document.body.removeEventListener("click", this.onBodyClickEvent);
            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
            it(this.cartDrawerInner).then(() => {
                this.classList.remove(st.closing);
            });
        }
        toggleCartDrawer() {
            if (!this.cartDrawerIsOpen) {
                this.openCartDrawer();
            } else {
                this.closeCartDrawer();
            }
        }
        closeCartEvents() {
            this.cartDrawerClose.addEventListener("click", (e) => {
                e.preventDefault();
                this.closeCartDrawer();
            });
            this.addEventListener("keyup", (e) => {
                if (e.code === "Escape") {
                    this.closeCartDrawer();
                }
            });
        }
        onBodyClick(e) {
            if (e.target.hasAttribute(nt.drawerUnderlay)) this.closeCartDrawer();
        }
        observeAdditionalCheckoutButtons() {
            const e = this.querySelector(ot.additionalCheckoutButtons);
            if (e) {
                const t = new MutationObserver(() => {
                    Q(this, { elementToFocus: this.querySelector(ot.cartDrawerClose) });
                    t.disconnect();
                });
                t.observe(e, { subtree: true, childList: true });
            }
        }
    }
    if (!customElements.get("cart-drawer")) {
        customElements.define("cart-drawer", rt);
    }
    const at = { collapsible: "[data-collapsible]", trigger: "[data-collapsible-trigger]", body: "[data-collapsible-body]", content: "[data-collapsible-content]" };
    const lt = { desktop: "desktop", disabled: "disabled", mobile: "mobile", open: "open", single: "single" };
    class ct extends HTMLElement {
        constructor() {
            super();
            this.collapsibles = this.querySelectorAll(at.collapsible);
            this.single = this.hasAttribute(lt.single);
            this.toggle = this.toggle.bind(this);
        }
        connectedCallback() {
            this.toggle();
            document.addEventListener("theme:resize:width", this.toggle);
            this.collapsibles.forEach((e) => {
                const t = e.querySelector(at.trigger);
                const i = e.querySelector(at.body);
                t?.addEventListener("click", (e) => this.onCollapsibleClick(e));
                i?.addEventListener("transitionend", (t) => {
                    if (t.target !== i) return;
                    if (e.getAttribute(lt.open) == "true") {
                        this.setBodyHeight(i, "auto");
                    }
                    if (e.getAttribute(lt.open) == "false") {
                        e.removeAttribute(lt.open);
                        this.setBodyHeight(i, "");
                    }
                });
            });
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.toggle);
        }
        toggle() {
            const e = b();
            this.collapsibles.forEach((t) => {
                if (!t.hasAttribute(lt.desktop) && !t.hasAttribute(lt.mobile)) return;
                const i = t.hasAttribute(lt.desktop) ? t.getAttribute(lt.desktop) : "true";
                const s = t.hasAttribute(lt.mobile) ? t.getAttribute(lt.mobile) : "true";
                const o = (e && i == "true") || (!e && s == "true");
                const n = t.querySelector(at.body);
                if (o) {
                    t.removeAttribute(lt.disabled);
                    t.querySelector(at.trigger).removeAttribute("tabindex");
                    t.removeAttribute(lt.open);
                    this.setBodyHeight(n, "");
                } else {
                    t.setAttribute(lt.disabled, "");
                    t.setAttribute("open", true);
                    t.querySelector(at.trigger).setAttribute("tabindex", -1);
                }
            });
        }
        open(e) {
            if (e.getAttribute("open") == "true") return;
            const t = e.querySelector(at.body);
            const i = e.querySelector(at.content);
            e.setAttribute("open", true);
            this.setBodyHeight(t, i.offsetHeight);
        }
        close(e) {
            if (!e.hasAttribute("open")) return;
            const t = e.querySelector(at.body);
            const i = e.querySelector(at.content);
            this.setBodyHeight(t, i.offsetHeight);
            e.setAttribute("open", false);
            setTimeout(() => {
                requestAnimationFrame(() => {
                    this.setBodyHeight(t, 0);
                });
            });
        }
        setBodyHeight(e, t) {
            e.style.height = t !== "auto" && t !== "" ? `${t}px` : t;
        }
        onCollapsibleClick(e) {
            e.preventDefault();
            const t = e.target;
            const i = t.closest(at.collapsible);
            if (this.single) {
                this.collapsibles.forEach((e) => {
                    if (e.hasAttribute(lt.open) && e != i) {
                        requestAnimationFrame(() => {
                            this.close(e);
                        });
                    }
                });
            }
            if (i.hasAttribute(lt.open)) {
                this.close(i);
            } else {
                this.open(i);
            }
            i.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: true, detail: { element: "accordion" } }));
            i.dispatchEvent(new CustomEvent("theme:collapsible:toggle", { bubbles: true }));
        }
    }
    if (!customElements.get("collapsible-elements")) {
        customElements.define("collapsible-elements", ct);
    }
    const dt = { details: "details", popdown: "[data-popdown]", popdownClose: "[data-popdown-close]", input: 'input:not([type="hidden"])' };
    const ht = { popdownUnderlay: "data-popdown-underlay" };
    const ut = { open: "is-open" };
    class pt extends HTMLElement {
        constructor() {
            super();
            this.popdown = this.querySelector(dt.popdown);
            this.popdownContainer = this.querySelector(dt.details);
            this.popdownClose = this.querySelector(dt.popdownClose);
            this.popdownTransitionCallback = this.popdownTransitionCallback.bind(this);
            this.detailsToggleCallback = this.detailsToggleCallback.bind(this);
            this.a11y = te;
        }
        connectedCallback() {
            this.popdown.addEventListener("transitionend", this.popdownTransitionCallback);
            this.popdownContainer.addEventListener("keyup", (e) => e.code.toUpperCase() === "ESCAPE" && this.close());
            this.popdownContainer.addEventListener("toggle", this.detailsToggleCallback);
            this.popdownClose.addEventListener("click", this.close.bind(this));
        }
        detailsToggleCallback(e) {
            if (e.target.hasAttribute("open")) {
                this.open();
            }
        }
        popdownTransitionCallback(e) {
            if (e.target !== this.popdown) return;
            if (!this.classList.contains(ut.open)) {
                this.popdownContainer.removeAttribute("open");
                this.a11y.removeTrapFocus();
            } else if (e.propertyName === "transform") {
                this.a11y.trapFocus(this.popdown, { elementToFocus: this.popdown.querySelector(dt.input) });
            }
        }
        onBodyClick(e) {
            if (!this.contains(e.target) || e.target.hasAttribute(ht.popdownUnderlay)) this.close();
        }
        open() {
            this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
            document.body.addEventListener("click", this.onBodyClickEvent);
            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
            requestAnimationFrame(() => {
                this.classList.add(ut.open);
            });
        }
        close() {
            this.classList.remove(ut.open);
            document.body.removeEventListener("click", this.onBodyClickEvent);
            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
        }
    }
    customElements.define("header-search-popdown", pt);
    const mt = { inputSearch: 'input[type="search"]' };
    class ft extends oe {
        constructor() {
            super();
            this.allSearchInputs = document.querySelectorAll(mt.inputSearch);
            this.setupEventListeners();
        }
        setupEventListeners() {
            let e = [];
            this.allSearchInputs.forEach((t) => e.push(t.form));
            this.input.addEventListener("focus", this.onInputFocus.bind(this));
            if (e.length < 2) return;
            e.forEach((e) => e.addEventListener("reset", this.onFormReset.bind(this)));
            this.allSearchInputs.forEach((e) => e.addEventListener("input", this.onInput.bind(this)));
        }
        onFormReset(e) {
            super.onFormReset(e);
            if (super.shouldResetForm()) {
                this.keepInSync("", this.input);
            }
        }
        onInput(e) {
            const t = e.target;
            this.keepInSync(t.value, t);
        }
        onInputFocus() {
            if (!b()) {
                this.scrollIntoView({ behavior: "smooth" });
            }
        }
        keepInSync(e, t) {
            this.allSearchInputs.forEach((i) => {
                if (i !== t) {
                    i.value = e;
                }
            });
        }
    }
    customElements.define("main-search", ft);
    const gt = { actions: "[data-actions]", content: "[data-content]", trigger: "[data-button]" };
    const vt = { height: "data-height" };
    const bt = { open: "is-open", enabled: "is-enabled" };
    class yt extends HTMLElement {
        constructor() {
            super();
            this.initialHeight = this.getAttribute(vt.height);
            this.content = this.querySelector(gt.content);
            this.trigger = this.querySelector(gt.trigger);
            this.actions = this.querySelector(gt.actions);
            this.toggleActions = this.toggleActions.bind(this);
        }
        connectedCallback() {
            this.setHeight(this.initialHeight);
            this.trigger.addEventListener("click", () => {
                this.setHeight(this.content.offsetHeight);
                this.classList.add(bt.open);
            });
            this.setHeight(this.initialHeight);
            this.toggleActions();
            document.addEventListener("theme:resize", this.toggleActions);
            document.addEventListener("theme:collapsible:toggle", this.toggleActions);
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize", this.toggleActions);
            document.removeEventListener("theme:collapsible:toggle", this.toggleActions);
        }
        setHeight(e) {
            this.style.setProperty("--height", `${e}px`);
        }
        toggleActions() {
            this.classList.toggle(bt.enabled, this.content.offsetHeight + this.actions.offsetHeight > this.initialHeight);
        }
    }
    if (!customElements.get("toggle-ellipsis")) {
        customElements.define("toggle-ellipsis", yt);
    }
    const wt = {
        templateAddresses: ".template-addresses",
        addressNewForm: "#AddressNewForm",
        btnNew: ".address-new-toggle",
        btnEdit: ".address-edit-toggle",
        btnDelete: ".address-delete",
        dataFormId: "data-form-id",
        dataConfirmMessage: "data-confirm-message",
        editAddress: "#EditAddress",
        addressCountryNew: "AddressCountryNew",
        addressProvinceNew: "AddressProvinceNew",
        addressProvinceContainerNew: "AddressProvinceContainerNew",
        addressCountryOption: ".address-country-option",
        addressCountry: "AddressCountry",
        addressProvince: "AddressProvince",
        addressProvinceContainer: "AddressProvinceContainer",
    };
    const St = { hidden: "hidden" };
    class Et {
        constructor(e) {
            this.section = e;
            this.addressNewForm = this.section.querySelector(wt.addressNewForm);
            this.init();
        }
        init() {
            if (this.addressNewForm) {
                const e = this.section;
                const t = this.addressNewForm;
                this.customerAddresses();
                const i = e.querySelectorAll(wt.btnNew);
                if (i.length) {
                    i.forEach((e) => {
                        e.addEventListener("click", function () {
                            t.classList.toggle(St.hidden);
                        });
                    });
                }
                const s = e.querySelectorAll(wt.btnEdit);
                if (s.length) {
                    s.forEach((t) => {
                        t.addEventListener("click", function () {
                            const t = this.getAttribute(wt.dataFormId);
                            e.querySelector(`${wt.editAddress}_${t}`).classList.toggle(St.hidden);
                        });
                    });
                }
                const o = e.querySelectorAll(wt.btnDelete);
                if (o.length) {
                    o.forEach((e) => {
                        e.addEventListener("click", function () {
                            const e = this.getAttribute(wt.dataFormId);
                            const t = this.getAttribute(wt.dataConfirmMessage);
                            if (confirm(t)) {
                                Shopify.postLink(window.theme.routes.addresses_url + "/" + e, { parameters: { _method: "delete" } });
                            }
                        });
                    });
                }
            }
        }
        customerAddresses() {
            if (Shopify.CountryProvinceSelector) {
                new Shopify.CountryProvinceSelector(wt.addressCountryNew, wt.addressProvinceNew, { hideElement: wt.addressProvinceContainerNew });
            }
            const e = this.section.querySelectorAll(wt.addressCountryOption);
            e.forEach((e) => {
                const t = e.getAttribute(wt.dataFormId);
                const i = `${wt.addressCountry}_${t}`;
                const s = `${wt.addressProvince}_${t}`;
                const o = `${wt.addressProvinceContainer}_${t}`;
                new Shopify.CountryProvinceSelector(i, s, { hideElement: o });
            });
        }
    }
    const Lt = document.querySelector(wt.templateAddresses);
    if (Lt) {
        new Et(Lt);
    }
    const kt = { accountTemplateLogged: ".customer-logged-in", account: ".account", accountSidebarMobile: ".account-sidebar--mobile" };
    class At {
        constructor(e) {
            this.section = e;
            this.init();
        }
        init() {
            if (this.section.querySelector(kt.account)) {
                this.accountMobileSidebar();
            }
        }
        accountMobileSidebar() {
            if (this.section.querySelector(kt.accountSidebarMobile)) {
                this.section.querySelector(kt.accountSidebarMobile).addEventListener("click", function () {
                    const e = this.nextElementSibling;
                    if (e && e.tagName === "UL") {
                        e.classList.toggle("visible");
                    }
                });
            }
        }
    }
    const Ct = document.querySelector(kt.accountTemplateLogged);
    if (Ct) {
        new At(Ct);
    }
    const Tt = {
        form: "[data-account-form]",
        showReset: "[data-show-reset]",
        hideReset: "[data-hide-reset]",
        recover: "[data-recover-password]",
        recoverSuccess: "[data-recover-success]",
        login: "[data-login-form]",
        recoverHash: "#recover",
        hideClass: "is-hidden",
    };
    class qt {
        constructor(e) {
            this.form = e;
            this.showButton = e.querySelector(Tt.showReset);
            this.hideButton = e.querySelector(Tt.hideReset);
            this.recover = e.querySelector(Tt.recover);
            this.recoverSuccess = e.querySelector(Tt.recoverSuccess);
            this.login = e.querySelector(Tt.login);
            this.init();
        }
        init() {
            if (window.location.hash == Tt.recoverHash || this.recoverSuccess) {
                this.showRecoverPasswordForm();
            } else {
                this.hideRecoverPasswordForm();
            }
            this.showButton.addEventListener(
                "click",
                function (e) {
                    e.preventDefault();
                    this.showRecoverPasswordForm();
                }.bind(this),
                false
            );
            this.hideButton.addEventListener(
                "click",
                function (e) {
                    e.preventDefault();
                    this.hideRecoverPasswordForm();
                }.bind(this),
                false
            );
        }
        showRecoverPasswordForm() {
            this.login.classList.add(Tt.hideClass);
            this.recover.classList.remove(Tt.hideClass);
            window.location.hash = Tt.recoverHash;
            return false;
        }
        hideRecoverPasswordForm() {
            this.recover.classList.add(Tt.hideClass);
            this.login.classList.remove(Tt.hideClass);
            window.location.hash = "";
            return false;
        }
    }
    const It = document.querySelector(Tt.form);
    if (It) {
        new qt(It);
    }
    window.Shopify = window.Shopify || {};
    window.Shopify.theme = window.Shopify.theme || {};
    window.Shopify.theme.sections = window.Shopify.theme.sections || {};
    window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {};
    window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
    const Pt = window.Shopify.theme.sections.registered;
    const xt = window.Shopify.theme.sections.instances;
    const Mt = { id: "data-section-id", type: "data-section-type" };
    class Ht {
        constructor(e = null, t = []) {
            this.type = e;
            this.components = Dt(t);
            this.callStack = { onLoad: [], onUnload: [], onSelect: [], onDeselect: [], onBlockSelect: [], onBlockDeselect: [], onReorder: [] };
            t.forEach((e) => {
                for (const [t, i] of Object.entries(e)) {
                    const e = this.callStack[t];
                    if (Array.isArray(e) && typeof i === "function") {
                        e.push(i);
                    } else {
                        console.warn(`Unregisted function: '${t}' in component: '${this.type}'`);
                        console.warn(i);
                    }
                }
            });
        }
        getStack() {
            return this.callStack;
        }
    }
    class Ot {
        constructor(e, t) {
            this.container = Bt(e);
            this.id = e.getAttribute(Mt.id);
            this.type = t.type;
            this.callStack = t.getStack();
            try {
                this.onLoad();
            } catch (e) {
                console.warn(`Error in section: ${this.id}`);
                console.warn(this);
                console.warn(e);
            }
        }
        callFunctions(e, t = null) {
            this.callStack[e].forEach((e) => {
                const i = { id: this.id, type: this.type, container: this.container };
                if (t) {
                    e.call(i, t);
                } else {
                    e.call(i);
                }
            });
        }
        onLoad() {
            this.callFunctions("onLoad");
        }
        onUnload() {
            this.callFunctions("onUnload");
        }
        onSelect(e) {
            this.callFunctions("onSelect", e);
        }
        onDeselect(e) {
            this.callFunctions("onDeselect", e);
        }
        onBlockSelect(e) {
            this.callFunctions("onBlockSelect", e);
        }
        onBlockDeselect(e) {
            this.callFunctions("onBlockDeselect", e);
        }
        onReorder(e) {
            this.callFunctions("onReorder", e);
        }
    }
    function Bt(e) {
        if (!(e instanceof Element)) {
            throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
        }
        if (e.getAttribute(Mt.id) === null) {
            throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + Mt.id + " attribute.");
        }
        return e;
    }
    function Dt(e) {
        if ((typeof e !== "undefined" && typeof e !== "object") || e === null) {
            throw new TypeError("Theme Sections: The components object provided is not a valid");
        }
        return e;
    }
    function Ft(e, t) {
        if (typeof e !== "string") {
            throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        }
        if (typeof Pt[e] !== "undefined") {
            throw new Error('Theme Sections: A section of type "' + e + '" has already been registered. You cannot register the same section type twice');
        }
        if (!Array.isArray(t)) {
            t = [t];
        }
        const i = new Ht(e, t);
        Pt[e] = i;
        return Pt;
    }
    function _t(e, t) {
        e = Ut(e);
        if (typeof t === "undefined") {
            t = document.querySelectorAll("[" + Mt.type + "]");
        }
        t = zt(t);
        e.forEach(function (e) {
            const i = Pt[e];
            if (typeof i === "undefined") {
                return;
            }
            t = t.filter(function (t) {
                if (Vt(t)) {
                    return false;
                }
                if (t.getAttribute(Mt.type) === null) {
                    return false;
                }
                if (t.getAttribute(Mt.type) !== e) {
                    return true;
                }
                xt.push(new Ot(t, i));
                return false;
            });
        });
    }
    function $t(e) {
        var t = Wt(e);
        t.forEach(function (e) {
            e.onReorder();
        });
    }
    function Nt(e) {
        var t = Wt(e);
        t.forEach(function (e) {
            var t = xt
                .map(function (e) {
                    return e.id;
                })
                .indexOf(e.id);
            xt.splice(t, 1);
            e.onUnload();
        });
    }
    function Wt(e) {
        var t = [];
        if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) {
            var i = e[0];
        }
        if (e instanceof Element || i instanceof Element) {
            var s = zt(e);
            s.forEach(function (e) {
                t = t.concat(
                    xt.filter(function (t) {
                        return t.container === e;
                    })
                );
            });
        } else if (typeof e === "string" || typeof i === "string") {
            var o = Ut(e);
            o.forEach(function (e) {
                t = t.concat(
                    xt.filter(function (t) {
                        return t.type === e;
                    })
                );
            });
        }
        return t;
    }
    function Rt(e) {
        var t;
        for (var i = 0; i < xt.length; i++) {
            if (xt[i].id === e) {
                t = xt[i];
                break;
            }
        }
        return t;
    }
    function Vt(e) {
        return Wt(e).length > 0;
    }
    function Ut(e) {
        if (e === "*") {
            e = Object.keys(Pt);
        } else if (typeof e === "string") {
            e = [e];
        } else if (e.constructor === Ot) {
            e = [e.prototype.type];
        } else if (Array.isArray(e) && e[0].constructor === Ot) {
            e = e.map(function (e) {
                return e.type;
            });
        }
        e = e.map(function (e) {
            return e.toLowerCase();
        });
        return e;
    }
    function zt(e) {
        if (NodeList.prototype.isPrototypeOf(e) && e.length > 0) {
            e = Array.prototype.slice.call(e);
        } else if (NodeList.prototype.isPrototypeOf(e) && e.length === 0) {
            e = [];
        } else if (e === null) {
            e = [];
        } else if (!Array.isArray(e) && e instanceof Element) {
            e = [e];
        }
        return e;
    }
    if (window.Shopify.designMode) {
        document.addEventListener("shopify:section:load", function (e) {
            var t = e.detail.sectionId;
            var i = e.target.querySelector("[" + Mt.id + '="' + t + '"]');
            if (i !== null) {
                _t(i.getAttribute(Mt.type), i);
            }
        });
        document.addEventListener("shopify:section:reorder", function (e) {
            var t = e.detail.sectionId;
            var i = e.target.querySelector("[" + Mt.id + '="' + t + '"]');
            var s = Wt(i)[0];
            if (typeof s === "object") {
                $t(i);
            }
        });
        document.addEventListener("shopify:section:unload", function (e) {
            var t = e.detail.sectionId;
            var i = e.target.querySelector("[" + Mt.id + '="' + t + '"]');
            var s = Wt(i)[0];
            if (typeof s === "object") {
                Nt(i);
            }
        });
        document.addEventListener("shopify:section:select", function (e) {
            var t = Rt(e.detail.sectionId);
            if (typeof t === "object") {
                t.onSelect(e);
            }
        });
        document.addEventListener("shopify:section:deselect", function (e) {
            var t = Rt(e.detail.sectionId);
            if (typeof t === "object") {
                t.onDeselect(e);
            }
        });
        document.addEventListener("shopify:block:select", function (e) {
            var t = Rt(e.detail.sectionId);
            if (typeof t === "object") {
                t.onBlockSelect(e);
            }
        });
        document.addEventListener("shopify:block:deselect", function (e) {
            var t = Rt(e.detail.sectionId);
            if (typeof t === "object") {
                t.onBlockDeselect(e);
            }
        });
    }
    const jt = { tooltip: "data-tooltip", tooltipStopMouseEnter: "data-tooltip-stop-mouseenter" };
    const Jt = { tooltipDefault: "tooltip-default", visible: "is-visible", hiding: "is-hiding" };
    let Xt = {};
    class Gt {
        constructor(e, t = {}) {
            this.tooltip = e;
            if (!this.tooltip.hasAttribute(jt.tooltip)) return;
            this.label = this.tooltip.getAttribute(jt.tooltip);
            this.class = t.class || Jt.tooltipDefault;
            this.transitionSpeed = t.transitionSpeed || 200;
            this.hideTransitionTimeout = 0;
            this.addPinEvent = () => this.addPin();
            this.addPinMouseEvent = () => this.addPin(true);
            this.removePinEvent = (e) => Xe(this.removePin(e), 50);
            this.removePinMouseEvent = (e) => this.removePin(e, true, true);
            this.init();
        }
        init() {
            if (!document.querySelector(`.${this.class}`)) {
                const e = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`;
                const t = document.createElement("div");
                t.className = this.class;
                t.innerHTML = e;
                document.body.appendChild(t);
            }
            this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent);
            this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent);
            this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent);
            document.addEventListener("theme:tooltip:close", this.removePinEvent);
        }
        addPin(e = false) {
            const t = document.querySelector(`.${this.class}`);
            if (this.label && t && ((e && !this.tooltip.hasAttribute(jt.tooltipStopMouseEnter)) || !e)) {
                const e = t.querySelector(`.${this.class}__arrow`);
                const i = t.querySelector(`.${this.class}__inner`);
                const s = t.querySelector(`.${this.class}__text`);
                s.innerHTML = this.label;
                const o = i.offsetWidth;
                const n = this.tooltip.getBoundingClientRect();
                const r = n.top;
                const a = n.width;
                const l = n.height;
                const c = r + l + window.scrollY;
                let d = n.left - o / 2 + a / 2;
                const h = d + o;
                const u = 24;
                const p = h - g() + u;
                if (p > 0) {
                    d -= p;
                }
                if (d < 0) {
                    d = 0;
                }
                e.style.left = `${n.left + a / 2}px`;
                t.style.setProperty("--tooltip-top", `${c}px`);
                i.style.transform = `translateX(${d}px)`;
                t.classList.remove(Jt.hiding);
                t.classList.add(Jt.visible);
                document.addEventListener("theme:scroll", this.removePinEvent);
            }
        }
        removePin(e, t = false, i = false) {
            const s = document.querySelector(`.${this.class}`);
            const o = s.classList.contains(Jt.visible);
            if (s && ((t && !this.tooltip.hasAttribute(jt.tooltipStopMouseEnter)) || !t)) {
                if (o && (i || e.detail.hideTransition)) {
                    s.classList.add(Jt.hiding);
                    if (this.hideTransitionTimeout) {
                        clearTimeout(this.hideTransitionTimeout);
                    }
                    this.hideTransitionTimeout = setTimeout(() => {
                        s.classList.remove(Jt.hiding);
                    }, this.transitionSpeed);
                }
                s.classList.remove(Jt.visible);
                document.removeEventListener("theme:scroll", this.removePinEvent);
            }
        }
        unload() {
            this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent);
            this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent);
            this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent);
            document.removeEventListener("theme:tooltip:close", this.removePinEvent);
            document.removeEventListener("theme:scroll", this.removePinEvent);
        }
    }
    const Yt = {
        onLoad() {
            Xt[this.id] = [];
            const e = this.container.querySelectorAll(`[${jt.tooltip}]`);
            e.forEach((e) => {
                Xt[this.id].push(new Gt(e));
            });
        },
        onUnload: function () {
            Xt[this.id].forEach((e) => {
                if (typeof e.unload === "function") {
                    e.unload();
                }
            });
        },
    };
    var Qt = {};
    const Kt = {
        onLoad() {
            Qt[this.id] = [];
            const e = this.container.querySelectorAll("[data-parallax-wrapper]");
            e.forEach((e) => {
                const i = e.querySelector("[data-parallax-img]");
                Qt[this.id].push(new t(i, { center: true, round: true, frame: e }));
            });
            window.addEventListener("load", () => {
                Qt[this.id].forEach((e) => {
                    if (typeof e.refresh === "function") {
                        e.refresh();
                    }
                });
            });
        },
        onUnload: function () {
            Qt[this.id].forEach((e) => {
                if (typeof e.destroy === "function") {
                    e.destroy();
                }
            });
        },
    };
    Ft("article", [Yt, Kt]);
    const Zt = {
        aos: "[data-aos]",
        collectionImage: ".collection-item__image",
        columnImage: "[data-column-image]",
        flickityNextArrow: ".flickity-button.next",
        flickityPrevArrow: ".flickity-button.previous",
        link: "a:not(.btn)",
        productItemImage: ".product-item__image",
        slide: "[data-slide]",
        slideValue: "data-slide",
        slider: "[data-slider]",
        sliderThumb: "[data-slider-thumb]",
    };
    const ei = { arrowPositionMiddle: "data-arrow-position-middle", slideIndex: "data-slide-index", sliderOptions: "data-options", slideTextColor: "data-slide-text-color" };
    const ti = {
        aosAnimate: "aos-animate",
        desktop: "desktop",
        focused: "is-focused",
        flickityEnabled: "flickity-enabled",
        heroContentTransparent: "hero__content--transparent",
        initialized: "is-initialized",
        isLoading: "is-loading",
        isSelected: "is-selected",
        mobile: "mobile",
        singleSlide: "single-slide",
        sliderInitialized: "js-slider--initialized",
    };
    const ii = {};
    class si {
        constructor(e, t = null) {
            this.container = e;
            this.slideshow = t || this.container.querySelector(Zt.slider);
            if (!this.slideshow) return;
            this.slideshowSlides = this.slideshow.querySelectorAll(Zt.slide);
            if (this.slideshowSlides.length <= 1) return;
            this.sliderThumbs = this.container.querySelectorAll(Zt.sliderThumb);
            this.multipleSlides = this.slideshow.hasAttribute(ei.slidesLargeDesktop);
            if (this.slideshow.hasAttribute(ei.sliderOptions)) {
                this.customOptions = JSON.parse(decodeURIComponent(this.slideshow.getAttribute(ei.sliderOptions)));
            }
            this.flkty = null;
            this.init();
        }
        init() {
            this.slideshow.classList.add(ti.isLoading);
            let e = Zt.slide;
            const t = b();
            const o = `${Zt.slide}:not(.${ti.mobile})`;
            const n = `${Zt.slide}:not(.${ti.desktop})`;
            const r = this.slideshow.querySelectorAll(n).length || this.slideshow.querySelectorAll(o).length;
            if (r) {
                if (t) {
                    e = o;
                } else {
                    e = n;
                }
            }
            if (this.slideshow.querySelectorAll(e).length <= 1) {
                this.slideshow.classList.add(ti.singleSlide);
                this.slideshow.classList.remove(ti.isLoading);
            }
            this.sliderOptions = {
                cellSelector: e,
                contain: true,
                wrapAround: true,
                adaptiveHeight: true,
                ...this.customOptions,
                on: {
                    ready: () => {
                        requestAnimationFrame(() => {
                            this.slideshow.classList.add(ti.initialized);
                            this.slideshow.classList.remove(ti.isLoading);
                            this.slideshow.parentNode.dispatchEvent(new CustomEvent("theme:slider:loaded", { bubbles: true, detail: { slider: this } }));
                        });
                        this.slideActions();
                        if (this.sliderOptions.prevNextButtons) {
                            this.positionArrows();
                        }
                    },
                    change: (e) => {
                        const t = this.slideshowSlides[e];
                        if (!t || this.sliderOptions.groupCells) return;
                        const i = t.querySelectorAll(Zt.aos);
                        if (i.length) {
                            i.forEach((e) => {
                                e.classList.remove(ti.aosAnimate);
                                requestAnimationFrame(() => {
                                    setTimeout(() => {
                                        e.classList.add(ti.aosAnimate);
                                    }, 0);
                                });
                            });
                        }
                    },
                    resize: () => {
                        if (this.sliderOptions.prevNextButtons) {
                            this.positionArrows();
                        }
                    },
                },
            };
            if (this.sliderOptions.fade) {
                this.flkty = new s(this.slideshow, this.sliderOptions);
            }
            if (!this.sliderOptions.fade) {
                this.flkty = new i(this.slideshow, this.sliderOptions);
            }
            this.flkty.on("change", () => this.slideActions(true));
            if (this.sliderThumbs.length) {
                this.sliderThumbs.forEach((e) => {
                    e.addEventListener("click", (t) => {
                        t.preventDefault();
                        const i = [...e.parentElement.children].indexOf(e);
                        this.flkty.select(i);
                    });
                });
            }
            if (!this.flkty || !this.flkty.isActive) {
                this.slideshow.classList.remove(ti.isLoading);
            }
        }
        slideActions(e = false) {
            const t = this.slideshow.querySelector(`.${ti.isSelected}`);
            if (!t) return;
            const i = t.hasAttribute(ei.slideTextColor) ? t.getAttribute(ei.slideTextColor) : "";
            const s = t.querySelector(Zt.link);
            const o = this.slideshow.querySelectorAll(`${Zt.slide} a, ${Zt.slide} button`);
            if (document.body.classList.contains(ti.focused) && s && this.sliderOptions.groupCells && e) {
                s.focus();
            }
            if (o.length) {
                o.forEach((e) => {
                    const t = e.closest(Zt.slide);
                    if (t) {
                        const i = t.classList.contains(ti.isSelected) ? 0 : -1;
                        e.setAttribute("tabindex", i);
                    }
                });
            }
            if (i !== "rgba(0,0,0,0)" && i !== "") {
                this.slideshow.style.setProperty("--text", i);
            }
            if (this.sliderThumbs.length && this.sliderThumbs.length === this.slideshowSlides.length && t.hasAttribute(ei.slideIndex)) {
                const e = parseInt(t.getAttribute(ei.slideIndex));
                const i = this.container.querySelector(`${Zt.sliderThumb}.${ti.isSelected}`);
                if (i) {
                    i.classList.remove(ti.isSelected);
                }
                this.sliderThumbs[e].classList.add(ti.isSelected);
            }
        }
        positionArrows() {
            if (this.slideshow.hasAttribute(ei.arrowPositionMiddle) && this.sliderOptions.prevNextButtons) {
                const e = this.slideshow.querySelector(Zt.collectionImage) || this.slideshow.querySelector(Zt.productItemImage) || this.slideshow.querySelector(Zt.columnImage);
                if (!e) return;
                this.slideshow.querySelector(Zt.flickityPrevArrow).style.top = e.clientHeight / 2 + "px";
                this.slideshow.querySelector(Zt.flickityNextArrow).style.top = e.clientHeight / 2 + "px";
            }
        }
        onUnload() {
            if (this.slideshow && this.flkty) {
                this.flkty.options.watchCSS = false;
                this.flkty.destroy();
            }
        }
        onBlockSelect(e) {
            if (!this.slideshow) return;
            const t = this.slideshow.querySelector(`[${Zt.slideValue}="${e.detail.blockId}"]`);
            if (!t) return;
            let i = parseInt(t.getAttribute(ei.slideIndex));
            if (this.multipleSlides && !this.slideshow.classList.contains(ti.sliderInitialized)) {
                i = 0;
            }
            this.slideshow.classList.add(ti.isSelected);
            if (this.flkty && this.slideshow.classList.contains(ti.flickityEnabled)) {
                this.flkty.selectCell(i);
                this.flkty.stopPlayer();
            }
        }
        onBlockDeselect() {
            if (!this.slideshow) return;
            this.slideshow.classList.remove(ti.isSelected);
            if (this.flkty && this.sliderOptions.hasOwnProperty("autoPlay") && this.sliderOptions.autoPlay) {
                this.flkty.playPlayer();
            }
        }
    }
    const oi = {
        onLoad() {
            ii[this.id] = [];
            const e = this.container.querySelectorAll(Zt.slider);
            e.forEach((e) => {
                ii[this.id].push(new si(this.container, e));
            });
        },
        onUnload() {
            ii[this.id].forEach((e) => {
                if (typeof e.onUnload === "function") {
                    e.onUnload();
                }
            });
        },
        onBlockSelect(e) {
            ii[this.id].forEach((t) => {
                if (typeof t.onBlockSelect === "function") {
                    t.onBlockSelect(e);
                }
            });
        },
        onBlockDeselect(e) {
            ii[this.id].forEach((t) => {
                if (typeof t.onBlockDeselect === "function") {
                    t.onBlockDeselect(e);
                }
            });
        },
    };
    Ft("blog-section", [oi]);
    Ft("hero", Kt);
    Ft("double", oi);
    const ni = (e) => {
        let { stickyHeaderHeight: t } = l();
        window.scrollTo({ top: e + window.scrollY - t, left: 0, behavior: "smooth" });
    };
    class ri {
        constructor(e, t, i = 7) {
            const s = new Date();
            const o = new Date();
            o.setTime(s.getTime() + 36e5 * 24 * i);
            this.configuration = { expires: o.toGMTString(), path: "/", domain: window.location.hostname, sameSite: "none", secure: true };
            this.name = e;
            this.value = t;
        }
        write() {
            const e = document.cookie.indexOf("; ") !== -1 && !document.cookie.split("; ").find((e) => e.startsWith(this.name));
            if (e || document.cookie.indexOf("; ") === -1) {
                document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
            }
        }
        read() {
            if (document.cookie.indexOf("; ") !== -1 && document.cookie.split("; ").find((e) => e.startsWith(this.name))) {
                const e = document.cookie
                    .split("; ")
                    .find((e) => e.startsWith(this.name))
                    .split("=")[1];
                return e;
            } else {
                return false;
            }
        }
        destroy() {
            if (document.cookie.split("; ").find((e) => e.startsWith(this.name))) {
                document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
            }
        }
    }
    const ai = { newsletterForm: "[data-newsletter-form]", newsletterHeading: "[data-newsletter-heading]", newsletterPopup: "[data-newsletter]" };
    const li = { success: "has-success", error: "has-error", hidden: "hidden" };
    const ci = { cookieNameAttribute: "data-cookie-name" };
    const di = {};
    class hi {
        constructor(e) {
            this.sessionStorage = window.sessionStorage;
            this.newsletter = e;
            this.popup = this.newsletter.closest(ai.newsletterPopup);
            if (this.popup) {
                this.cookie = new ri(this.popup.getAttribute(ci.cookieNameAttribute), "user_has_closed", null);
            }
            this.stopSubmit = true;
            this.isChallengePage = false;
            this.formID = null;
            this.checkForChallengePage();
            this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e);
            if (!this.isChallengePage) {
                this.init();
            }
        }
        init() {
            this.newsletter.addEventListener("submit", this.newsletterSubmit);
            this.showMessage();
        }
        newsletterSubmitEvent(e) {
            if (this.stopSubmit) {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.removeStorage();
                this.writeStorage();
                this.stopSubmit = false;
                this.newsletter.submit();
            }
        }
        checkForChallengePage() {
            this.isChallengePage = window.location.pathname === "/challenge";
        }
        writeStorage() {
            if (this.sessionStorage !== undefined) {
                this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
            }
        }
        readStorage() {
            this.formID = this.sessionStorage.getItem("newsletter_form_id");
        }
        removeStorage() {
            this.sessionStorage.removeItem("newsletter_form_id");
        }
        showMessage() {
            this.readStorage();
            if (this.newsletter.id === this.formID) {
                const e = document.getElementById(this.formID);
                const t = e.parentElement.querySelector(ai.newsletterHeading);
                const i = window.location.search.indexOf("?customer_posted=true") !== -1;
                const s = window.location.search.indexOf("accepts_marketing") !== -1;
                if (i) {
                    e.classList.remove(li.error);
                    e.classList.add(li.success);
                    if (t) {
                        t.classList.add(li.hidden);
                        e.classList.remove(li.hidden);
                    }
                    if (this.popup) {
                        this.cookie.write();
                    }
                } else if (s) {
                    e.classList.remove(li.success);
                    e.classList.add(li.error);
                    if (t) {
                        t.classList.add(li.hidden);
                        e.classList.remove(li.hidden);
                    }
                }
                if (i || s) {
                    window.addEventListener("load", () => {
                        this.scrollToForm(e);
                    });
                }
            }
        }
        scrollToForm(e) {
            const t = e.getBoundingClientRect();
            const i = t.top >= 0 && t.left >= 0 && t.bottom <= v() && t.right <= g();
            if (!i) {
                setTimeout(() => {
                    ni(e.getBoundingClientRect().top);
                }, 500);
            }
        }
        unload() {
            this.newsletter.removeEventListener("submit", this.newsletterSubmit);
        }
    }
    const ui = {
        onLoad() {
            di[this.id] = [];
            const e = this.container.querySelectorAll(ai.newsletterForm);
            e.forEach((e) => {
                di[this.id].push(new hi(e));
            });
        },
        onUnload() {
            di[this.id].forEach((e) => {
                if (typeof e.unload === "function") {
                    e.unload();
                }
            });
        },
    };
    Ft("footer", [Kt, ui]);
    const pi = {
        collectionSidebar: "[data-collection-sidebar]",
        collectionSidebarSlideOut: "[data-collection-sidebar-slide-out]",
        collectionSidebarCloseButton: "[data-collection-sidebar-close]",
        groupTagsButton: "[data-aria-toggle]",
        animation: "[data-animation]",
    };
    const mi = { animated: "drawer--animated", hiding: "is-hiding", expanded: "expanded", noMobileAnimation: "no-mobile-animation", focused: "is-focused" };
    let fi = {};
    class gi {
        constructor(e) {
            this.container = e.container;
            this.collectionSidebar = this.container.querySelector(pi.collectionSidebar);
            this.groupTagsButton = this.container.querySelector(pi.groupTagsButton);
            this.a11y = te;
            this.groupTagsButtonClickEvent = (e) => this.groupTagsButtonClick(e);
            this.sidebarResizeEvent = () => this.toggleSidebarSlider();
            this.collectionSidebarCloseEvent = (e) => this.collectionSidebarClose(e);
            this.init();
        }
        init() {
            if (this.groupTagsButton !== null) {
                document.addEventListener("theme:resize:width", this.sidebarResizeEvent);
                this.groupTagsButton.addEventListener("click", this.groupTagsButtonClickEvent);
                if (this.collectionSidebar) {
                    setTimeout(() => {
                        this.collectionSidebar.classList.remove(mi.noMobileAnimation);
                    }, 1e3);
                }
                const e = new MutationObserver((e) => {
                    for (const t of e) {
                        if (t.type === "attributes") {
                            const e = t.target.getAttribute("aria-expanded") == "true";
                            if (e) {
                                this.showSidebarCallback();
                            }
                        }
                    }
                });
                e.observe(this.groupTagsButton, { attributes: true, childList: false, subtree: false });
            }
            this.container.addEventListener(
                "keyup",
                function (e) {
                    if (e.code !== "Escape") {
                        return;
                    }
                    this.hideSidebar();
                }.bind(this)
            );
            if (this.collectionSidebar) {
                this.collectionSidebar.addEventListener("transitionend", () => {
                    if (!this.collectionSidebar.classList.contains(mi.expanded)) {
                        this.collectionSidebar.classList.remove(mi.animated);
                    }
                });
                this.toggleSidebarSlider();
                this.container.addEventListener("theme:filter:close", this.collectionSidebarCloseEvent);
            }
        }
        showSidebarCallback() {
            const e = this.container.querySelector(pi.collectionSidebarSlideOut);
            const t = document.documentElement.hasAttribute("data-scroll-locked");
            const i = y();
            this.collectionSidebar.classList.add(mi.animated);
            if (e === null) {
                if (!i && t) {
                    this.a11y.removeTrapFocus();
                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
                }
            }
            if (i || e !== null) {
                if (e) {
                    this.a11y.trapFocus(this.collectionSidebar, { elementToFocus: this.collectionSidebar.querySelector(pi.collectionSidebarCloseButton) });
                }
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
            }
        }
        hideSidebar() {
            const e = this.container.querySelector(pi.collectionSidebarSlideOut);
            const t = document.documentElement.hasAttribute("data-scroll-locked");
            this.groupTagsButton.setAttribute("aria-expanded", "false");
            this.collectionSidebar.classList.remove(mi.expanded);
            if (e) {
                this.a11y.removeTrapFocus();
            }
            if (t) {
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
            }
        }
        toggleSidebarSlider() {
            if (y()) {
                this.hideSidebar();
            } else if (this.collectionSidebar.classList.contains(mi.expanded)) {
                this.showSidebarCallback();
            }
        }
        collectionSidebarClose(e) {
            e.preventDefault();
            this.hideSidebar();
            if (document.body.classList.contains(mi.focused) && this.groupTagsButton) {
                this.groupTagsButton.focus();
            }
        }
        groupTagsButtonClick() {
            const e = document.documentElement.hasAttribute("data-scroll-locked");
            if (e) {
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
            }
        }
        onUnload() {
            if (this.groupTagsButton !== null) {
                document.removeEventListener("theme:resize:width", this.sidebarResizeEvent);
                this.groupTagsButton.removeEventListener("click", this.groupTagsButtonClickEvent);
            }
            if (this.collectionSidebar) {
                this.container.removeEventListener("theme:filter:close", this.collectionSidebarCloseEvent);
            }
        }
    }
    const vi = {
        onLoad() {
            fi[this.id] = new gi(this);
        },
        onUnload() {
            fi[this.id].onUnload();
        },
    };
    Ft("collection", [oi, Kt, vi, Yt]);
    const bi = { frame: "[data-ticker-frame]", scale: "[data-ticker-scale]", text: "[data-ticker-text]", clone: "data-clone" };
    const yi = { autoplay: "autoplay", speed: "speed" };
    const wi = { animation: "ticker--animated", unloaded: "ticker--unloaded", comparitor: "ticker__comparitor" };
    const Si = { speed: 1.63, space: 100 };
    class Ei extends HTMLElement {
        constructor() {
            super();
            this.autoplay = this.hasAttribute(yi.autoplay);
            this.scale = this.querySelector(bi.scale);
            this.text = this.querySelector(bi.text);
            this.speed = this.hasAttribute(yi.speed) ? this.getAttribute(yi.speed) : Si.speed;
            this.comparitor = this.text.cloneNode(true);
            this.comparitor.classList.add(wi.comparitor);
            this.appendChild(this.comparitor);
            this.scale.classList.remove(wi.unloaded);
            this.checkWidthEvent = this.checkWidth.bind(this);
        }
        connectedCallback() {
            this.checkWidth();
            this.addEventListener(
                "theme:ticker:refresh",
                f(() => this.checkWidthEvent(), 50)
            );
            screen.orientation.addEventListener("change", this.checkWidthEvent);
            document.addEventListener("theme:resize:width", this.checkWidthEvent);
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.checkWidthEvent);
        }
        checkWidth() {
            this.text = this.querySelector(bi.text);
            const e = window.getComputedStyle(this).paddingLeft.replace("px", "") * 2;
            const t = this.clientWidth - e < this.comparitor.clientWidth;
            if (t || this.autoplay) {
                this.text.classList.remove(wi.animation);
                const i = this.scale.querySelectorAll(`[${bi.clone}]`);
                const s = this.autoplay ? parseInt((window.innerWidth - e) / this.text.clientWidth) : 2;
                i?.forEach((e) => {
                    e.remove();
                });
                if (this.autoplay || t) {
                    for (let e = 0; e <= s; e++) {
                        const e = this.text.cloneNode(true);
                        e.setAttribute(bi.clone, "");
                        this.scale.appendChild(e);
                    }
                }
                const o = ((this.text.clientWidth / Si.space) * Number(this.speed)).toFixed(2);
                this.scale.style.removeProperty("--animation-time");
                this.scale.style.setProperty("--animation-time", `${o}s`);
                this.scale.querySelectorAll(bi.text)?.forEach((e) => {
                    e.classList.add(wi.animation);
                });
            } else {
                this.text.classList.add(wi.animation);
                const e = this.scale.querySelectorAll(`[${bi.clone}]`);
                e.forEach((e) => {
                    e.parentNode.removeChild(e);
                });
                this.text.classList.remove(wi.animation);
            }
        }
    }
    const Li = { marquee: ".announcement__bar-holder--marquee", slide: "[data-slide]", slider: "[data-slider]", ticker: "ticker-bar", tickerSlide: ".announcement__slide" };
    const ki = { hidden: "hidden" };
    class Ai extends HTMLElement {
        constructor() {
            super();
            this.slider = this.querySelector(Li.slider);
            this.enableSlider = b();
            this.slidesCount = this.querySelectorAll(Li.tickerSlide).length;
            this.initSliderEvent = (e) => this.initSlider(e);
        }
        connectedCallback() {
            if (this.slider) {
                this.initSliders();
            }
            this.addEventListener("theme:block:select", (e) => {
                this.onBlockSelect(e);
            });
            this.addEventListener("theme:block:deselect", (e) => {
                this.onBlockDeselect(e);
            });
            this.addEventListener("theme:countdown:hide", (e) => {
                if (window.Shopify.designMode) return;
                const t = e.target.closest(Li.marquee);
                if (this.slidesCount === 1) {
                    const e = this.querySelector(Li.ticker);
                    e.style.display = "none";
                }
                if (t) {
                    const t = e.target.closest(Li.tickerSlide);
                    this.removeTickerText(t);
                } else {
                    const t = e.target.closest(Li.slide);
                    this.removeSlide(t);
                }
            });
            this.addEventListener("theme:countdown:expire", () => {
                this.querySelectorAll(Li.ticker)?.forEach((e) => {
                    e.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
                });
            });
            document.dispatchEvent(new CustomEvent("theme:announcement:init", { bubbles: true }));
        }
        initSliders() {
            this.initSlider();
            document.addEventListener("theme:resize:width", this.initSliderEvent);
            this.addEventListener("theme:slider:loaded", () => {
                this.querySelectorAll(Li.tickerBar)?.forEach((e) => {
                    e.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
                });
            });
        }
        initSlider() {
            const e = b();
            const t = !e;
            if ((e && this.enableSlider) || (t && !this.enableSlider)) {
                this.slider.flkty?.destroy();
                if (e && this.enableSlider) {
                    this.enableSlider = false;
                } else if (t && !this.enableSlider) {
                    this.enableSlider = true;
                }
                this.slider = new si(this, this.querySelector(Li.slider));
                this.slider.flkty?.reposition();
            }
        }
        removeSlide(e) {
            this.slider.flkty?.remove(e);
            if (this.slider.flkty?.cells.length === 0) {
                this.section.classList.add(ki.hidden);
            }
        }
        removeTickerText(e) {
            const t = e.closest(Li.ticker);
            e.remove();
            t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
        }
        onBlockSelect(e) {
            if (this.slider) {
                this.slider.onBlockSelect(e);
            }
        }
        onBlockDeselect(e) {
            if (this.slider) {
                this.slider.onBlockDeselect(e);
            }
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize:width", this.initSliderEvent);
            document.removeEventListener("theme:resize:width", this.tickerResizeEvent);
            this.removeEventListener("theme:block:select", (e) => {
                this.onBlockSelect(e);
            });
            this.removeEventListener("theme:block:deselect", (e) => {
                this.onBlockDeselect(e);
            });
        }
    }
    if (!customElements.get("announcement-bar")) {
        customElements.define("announcement-bar", Ai);
    }
    if (!customElements.get("ticker-bar")) {
        customElements.define("ticker-bar", Ei);
    }
    const Ci = {
        body: "body",
        drawerWrappper: "[data-drawer]",
        drawerInner: "[data-drawer-inner]",
        underlay: "[data-drawer-underlay]",
        stagger: "[data-stagger-animation]",
        wrapper: "[data-header-wrapper]",
        drawerToggle: "data-drawer-toggle",
        focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    };
    const Ti = { animated: "drawer--animated", open: "is-open", closing: "is-closing", isFocused: "is-focused", headerStuck: "js__header__stuck" };
    let qi = {};
    class Ii {
        constructor(e) {
            this.isAnimating = false;
            this.drawer = e;
            this.drawerWrapper = this.drawer.closest(Ci.drawerWrappper);
            this.drawerInner = this.drawer.querySelector(Ci.drawerInner);
            this.underlay = this.drawer.querySelector(Ci.underlay);
            this.wrapper = this.drawer.closest(Ci.wrapper);
            this.key = this.drawer.dataset.drawer;
            this.btnSelector = `[${Ci.drawerToggle}='${this.key}']`;
            this.buttons = document.querySelectorAll(this.btnSelector);
            this.staggers = this.drawer.querySelectorAll(Ci.stagger);
            this.body = document.querySelector(Ci.body);
            this.showDrawer = this.showDrawer.bind(this);
            this.hideDrawer = this.hideDrawer.bind(this);
            this.connectToggle();
            this.connectDrawer();
            this.closers();
        }
        connectToggle() {
            this.buttons.forEach((e) => {
                e.addEventListener("click", () => {
                    this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", { bubbles: false }));
                });
            });
        }
        connectDrawer() {
            this.drawer.addEventListener("theme:drawer:toggle", () => {
                if (this.drawer.classList.contains(Ti.open)) {
                    this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", { bubbles: true }));
                } else {
                    this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: true }));
                }
            });
            document.addEventListener("theme:cart-drawer:open", this.hideDrawer);
            document.addEventListener("theme:drawer:close", this.hideDrawer);
            document.addEventListener("theme:drawer:open", this.showDrawer);
        }
        closers() {
            this.wrapper.addEventListener("keyup", (e) => {
                if (e.code !== "Escape") {
                    return;
                }
                this.hideDrawer();
            });
            this.underlay.addEventListener("click", () => {
                this.hideDrawer();
            });
        }
        showDrawer() {
            if (this.isAnimating) return;
            this.isAnimating = true;
            this.buttons.forEach((e) => {
                e.setAttribute("aria-expanded", true);
            });
            this.drawer.classList.add(Ti.open, Ti.animated);
            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
            if (this.drawerInner && this.drawerInner.querySelector(this.btnSelector)) {
                K();
                it(this.drawerInner).then(() => {
                    this.drawer.querySelector(Ci.focusable).focus();
                    this.isAnimating = false;
                    Q(this.drawerInner, { elementToFocus: this.drawerInner.querySelector(this.btnSelector) });
                });
            }
        }
        hideDrawer() {
            if (!this.drawer.classList.contains(Ti.open) || this.isAnimating) {
                return;
            }
            this.isAnimating = true;
            this.drawer.classList.add(Ti.closing);
            this.drawer.classList.remove(Ti.open);
            K();
            if (this.body.classList.contains(Ti.isFocused) && this.buttons.length) {
                this.buttons[0].focus();
            }
            this.buttons.forEach((e) => {
                e.setAttribute("aria-expanded", false);
            });
            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
            it(this.drawerInner).then(() => {
                this.drawer.classList.remove(Ti.closing, Ti.animated);
                this.isAnimating = false;
                document.dispatchEvent(new CustomEvent("theme:sliderule:close", { bubbles: false }));
            });
        }
        onUnload() {
            document.removeEventListener("theme:cart-drawer:open", this.hideDrawer);
            document.removeEventListener("theme:drawer:close", this.hideDrawer);
            document.removeEventListener("theme:drawer:open", this.showDrawer);
        }
    }
    const Pi = {
        onLoad() {
            qi[this.id] = [];
            const e = this.container.querySelectorAll(Ci.drawerWrappper);
            e.forEach((e) => {
                qi[this.id].push(new Ii(e));
            });
        },
        onUnload() {
            qi[this.id].forEach((e) => {
                if (typeof e.onUnload === "function") {
                    e.onUnload();
                }
            });
        },
    };
    const xi = { pageHeader: ".page-header" };
    const Mi = { stuck: "js__header__stuck", sticky: "has-header-sticky", headerGroup: "shopify-section-group-header-group" };
    const Hi = { stickyHeader: "data-header-sticky", scrollLock: "data-scroll-locked" };
    let Oi = {};
    class Bi {
        constructor(e) {
            this.wrapper = e;
            this.sticks = this.wrapper.hasAttribute(Hi.stickyHeader);
            document.body.classList.toggle(Mi.sticky, this.sticks);
            if (!this.sticks) return;
            this.isStuck = false;
            this.cls = this.wrapper.classList;
            this.headerOffset = document.querySelector(xi.pageHeader)?.offsetTop;
            this.updateHeaderOffset = this.updateHeaderOffset.bind(this);
            this.scrollEvent = (e) => this.onScroll(e);
            this.listen();
            this.stickOnLoad();
        }
        listen() {
            document.addEventListener("theme:scroll", this.scrollEvent);
            document.addEventListener("shopify:section:load", this.updateHeaderOffset);
            document.addEventListener("shopify:section:unload", this.updateHeaderOffset);
        }
        onScroll(e) {
            if (e.detail.down) {
                if (!this.isStuck && e.detail.position > this.headerOffset) {
                    this.stickSimple();
                }
            } else if (e.detail.position <= this.headerOffset) {
                this.unstickSimple();
            }
        }
        updateHeaderOffset(e) {
            if (!e.target.classList.contains(Mi.headerGroup)) return;
            setTimeout(() => {
                this.headerOffset = document.querySelector(xi.pageHeader)?.offsetTop;
            });
        }
        stickOnLoad() {
            if (window.scrollY > this.headerOffset) {
                this.stickSimple();
            }
        }
        stickSimple() {
            this.cls.add(Mi.stuck);
            this.isStuck = true;
        }
        unstickSimple() {
            if (!document.documentElement.hasAttribute(Hi.scrollLock)) {
                this.cls.remove(Mi.stuck);
                this.isStuck = false;
            }
        }
        unload() {
            document.removeEventListener("theme:scroll", this.scrollEvent);
            document.removeEventListener("shopify:section:load", this.updateHeaderOffset);
            document.removeEventListener("shopify:section:unload", this.updateHeaderOffset);
        }
    }
    const Di = {
        onLoad() {
            Oi = new Bi(this.container);
        },
        onUnload: function () {
            if (typeof Oi.unload === "function") {
                Oi.unload();
            }
        },
    };
    const Fi = {
        disclosureToggle: "data-hover-disclosure-toggle",
        disclosureWrappper: "[data-hover-disclosure]",
        link: "[data-top-link]",
        wrapper: "[data-header-wrapper]",
        stagger: "[data-stagger]",
        staggerPair: "[data-stagger-first]",
        staggerAfter: "[data-stagger-second]",
        focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    };
    const _i = { isVisible: "is-visible", meganavVisible: "meganav--visible", meganavIsTransitioning: "meganav--is-transitioning" };
    let $i = {};
    let Ni = {};
    class Wi {
        constructor(e) {
            this.disclosure = e;
            this.wrapper = e.closest(Fi.wrapper);
            this.key = this.disclosure.id;
            this.trigger = document.querySelector(`[${Fi.disclosureToggle}='${this.key}']`);
            this.link = this.trigger.querySelector(Fi.link);
            this.grandparent = this.trigger.classList.contains("grandparent");
            this.transitionTimeout = 0;
            this.trigger.setAttribute("aria-haspopup", true);
            this.trigger.setAttribute("aria-expanded", false);
            this.trigger.setAttribute("aria-controls", this.key);
            this.connectHoverToggle();
            this.handleTablets();
            this.staggerChildAnimations();
        }
        onBlockSelect(e) {
            if (this.disclosure.contains(e.target)) {
                this.showDisclosure(e);
            }
        }
        onBlockDeselect(e) {
            if (this.disclosure.contains(e.target)) {
                this.hideDisclosure();
            }
        }
        showDisclosure(e) {
            if (e && e.type && e.type === "mouseenter") {
                this.wrapper.classList.add(_i.meganavIsTransitioning);
            }
            if (this.grandparent) {
                this.wrapper.classList.add(_i.meganavVisible);
            } else {
                this.wrapper.classList.remove(_i.meganavVisible);
            }
            this.trigger.setAttribute("aria-expanded", true);
            this.trigger.classList.add(_i.isVisible);
            this.disclosure.classList.add(_i.isVisible);
            if (this.transitionTimeout) {
                clearTimeout(this.transitionTimeout);
            }
            this.transitionTimeout = setTimeout(() => {
                this.wrapper.classList.remove(_i.meganavIsTransitioning);
            }, 200);
        }
        hideDisclosure() {
            this.disclosure.classList.remove(_i.isVisible);
            this.trigger.classList.remove(_i.isVisible);
            this.trigger.setAttribute("aria-expanded", false);
            this.wrapper.classList.remove(_i.meganavVisible, _i.meganavIsTransitioning);
        }
        staggerChildAnimations() {
            const e = this.disclosure.querySelectorAll(Fi.stagger);
            e.forEach((e, t) => {
                e.style.transitionDelay = `${t * 50 + 10}ms`;
            });
            const t = this.disclosure.querySelectorAll(Fi.staggerPair);
            t.forEach((e, t) => {
                const i = t * 100;
                e.style.transitionDelay = `${i}ms`;
                e.parentElement.querySelectorAll(Fi.staggerAfter).forEach((e, t) => {
                    const s = t + 1;
                    const o = s * 20;
                    e.style.transitionDelay = `${i + o}ms`;
                });
            });
        }
        handleTablets() {
            this.trigger.addEventListener(
                "touchstart",
                function (e) {
                    const t = this.disclosure.classList.contains(_i.isVisible);
                    if (!t) {
                        e.preventDefault();
                        this.showDisclosure(e);
                    }
                }.bind(this),
                { passive: true }
            );
        }
        connectHoverToggle() {
            this.trigger.addEventListener("mouseenter", (e) => this.showDisclosure(e));
            this.link.addEventListener("focus", (e) => this.showDisclosure(e));
            this.trigger.addEventListener("mouseleave", () => this.hideDisclosure());
            this.trigger.addEventListener("focusout", (e) => {
                const t = this.trigger.contains(e.relatedTarget);
                if (!t) {
                    this.hideDisclosure();
                }
            });
            this.disclosure.addEventListener("keyup", (e) => {
                if (e.code !== "Escape") {
                    return;
                }
                this.hideDisclosure();
            });
        }
    }
    const Ri = {
        onLoad() {
            $i[this.id] = [];
            Ni = this.container.querySelectorAll(Fi.disclosureWrappper);
            Ni.forEach((e) => {
                $i[this.id].push(new Wi(e));
            });
        },
        onBlockSelect(e) {
            $i[this.id].forEach((t) => {
                if (typeof t.onBlockSelect === "function") {
                    t.onBlockSelect(e);
                }
            });
        },
        onBlockDeselect(e) {
            $i[this.id].forEach((t) => {
                if (typeof t.onBlockDeselect === "function") {
                    t.onBlockDeselect(e);
                }
            });
        },
    };
    const Vi = {
        slideruleOpen: "data-sliderule-open",
        slideruleClose: "data-sliderule-close",
        sliderulePane: "data-sliderule-pane",
        slideruleWrappper: "[data-sliderule]",
        drawerContent: "[data-drawer-content]",
        focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        dataAnimates: "data-animates",
        children: `:scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *`,
    };
    const Ui = { isVisible: "is-visible", isHiding: "is-hiding", isHidden: "is-hidden", focused: "is-focused", scrolling: "is-scrolling" };
    let zi = {};
    class ji {
        constructor(e) {
            this.sliderule = e;
            this.key = this.sliderule.id;
            const t = `[${Vi.slideruleOpen}='${this.key}']`;
            this.exitSelector = `[${Vi.slideruleClose}='${this.key}']`;
            this.trigger = document.querySelector(t);
            this.exit = document.querySelectorAll(this.exitSelector);
            this.pane = document.querySelector(`[${Vi.sliderulePane}]`);
            this.children = this.sliderule.querySelectorAll(Vi.children);
            this.drawerContent = document.querySelector(Vi.drawerContent);
            this.cachedButton = null;
            this.accessibility = te;
            this.trigger.setAttribute("aria-haspopup", true);
            this.trigger.setAttribute("aria-expanded", false);
            this.trigger.setAttribute("aria-controls", this.key);
            this.closeSliderule = this.closeSliderule.bind(this);
            this.clickEvents();
            this.keyboardEvents();
            document.addEventListener("theme:sliderule:close", this.closeSliderule);
        }
        clickEvents() {
            this.trigger.addEventListener("click", () => {
                this.cachedButton = this.trigger;
                this.showSliderule();
            });
            this.exit.forEach((e) => {
                e.addEventListener("click", () => {
                    this.hideSliderule();
                });
            });
        }
        keyboardEvents() {
            this.sliderule.addEventListener("keyup", (e) => {
                e.stopPropagation();
                if (e.code !== "Escape") {
                    return;
                }
                this.hideSliderule();
            });
        }
        trapFocusSliderule(e = true) {
            const t = e ? this.sliderule.querySelector(this.exitSelector) : this.cachedButton;
            this.accessibility.removeTrapFocus();
            if (t && this.drawerContent) {
                this.accessibility.trapFocus(this.drawerContent, { elementToFocus: document.body.classList.contains(Ui.focused) ? t : null });
            }
        }
        hideSliderule(e = false) {
            const t = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
            this.pane.setAttribute(Vi.sliderulePane, t);
            this.pane.classList.add(Ui.isHiding);
            this.sliderule.classList.add(Ui.isHiding);
            const i = e ? `[${Vi.dataAnimates}].${Ui.isHidden}` : `[${Vi.dataAnimates}="${t}"]`;
            const s = this.pane.querySelectorAll(i);
            if (s.length) {
                s.forEach((e) => {
                    e.classList.remove(Ui.isHidden);
                });
            }
            const o = e ? this.pane.querySelectorAll(`.${Ui.isVisible}, .${Ui.isHiding}`) : this.children;
            o.forEach((i, s) => {
                const n = o.length - 1 == s;
                i.classList.remove(Ui.isVisible);
                if (e) {
                    i.classList.remove(Ui.isHiding);
                    this.pane.classList.remove(Ui.isHiding);
                }
                const r = () => {
                    if (parseInt(this.pane.getAttribute(Vi.sliderulePane)) === t) {
                        this.sliderule.classList.remove(Ui.isVisible);
                    }
                    this.sliderule.classList.remove(Ui.isHiding);
                    this.pane.classList.remove(Ui.isHiding);
                    if (n) {
                        this.accessibility.removeTrapFocus();
                        if (!e) {
                            this.trapFocusSliderule(false);
                        }
                    }
                    i.removeEventListener("animationend", r);
                };
                if (window.theme.settings.enableAnimations) {
                    i.addEventListener("animationend", r);
                } else {
                    r();
                }
            });
        }
        showSliderule() {
            let e = null;
            const t = this.sliderule.closest(`.${Ui.isVisible}`);
            let i = this.pane;
            if (t) {
                i = t;
            }
            i.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            i.classList.add(Ui.scrolling);
            const s = () => {
                if (i.scrollTop <= 0) {
                    i.classList.remove(Ui.scrolling);
                    if (e) {
                        cancelAnimationFrame(e);
                    }
                } else {
                    e = requestAnimationFrame(s);
                }
            };
            e = requestAnimationFrame(s);
            this.sliderule.classList.add(Ui.isVisible);
            const o = parseInt(this.pane.dataset.sliderulePane, 10);
            const n = o + 1;
            this.pane.setAttribute(Vi.sliderulePane, n);
            const r = this.pane.querySelectorAll(`[${Vi.dataAnimates}="${o}"]`);
            if (r.length) {
                r.forEach((e, t) => {
                    const i = r.length - 1 == t;
                    e.classList.add(Ui.isHiding);
                    const s = () => {
                        e.classList.remove(Ui.isHiding);
                        if (parseInt(this.pane.getAttribute(Vi.sliderulePane)) !== o) {
                            e.classList.add(Ui.isHidden);
                        }
                        if (i) {
                            this.trapFocusSliderule();
                        }
                        e.removeEventListener("animationend", s);
                    };
                    if (window.theme.settings.enableAnimations) {
                        e.addEventListener("animationend", s);
                    } else {
                        s();
                    }
                });
            }
        }
        closeSliderule() {
            if (this.pane && this.pane.hasAttribute(Vi.sliderulePane) && parseInt(this.pane.getAttribute(Vi.sliderulePane)) > 0) {
                this.hideSliderule(true);
                if (parseInt(this.pane.getAttribute(Vi.sliderulePane)) > 0) {
                    this.pane.setAttribute(Vi.sliderulePane, 0);
                }
            }
        }
        onUnload() {
            document.removeEventListener("theme:sliderule:close", this.closeSliderule);
        }
    }
    const Ji = {
        onLoad() {
            zi[this.id] = [];
            const e = this.container.querySelectorAll(Vi.slideruleWrappper);
            e.forEach((e) => {
                zi[this.id].push(new ji(e));
            });
        },
        onUnload() {
            zi[this.id].forEach((e) => {
                if (typeof e.onUnload === "function") {
                    e.onUnload();
                }
            });
        },
    };
    const Xi = {
        wrapper: "[data-header-wrapper]",
        style: "data-header-style",
        widthContentWrapper: "[data-takes-space-wrapper]",
        widthContent: "[data-child-takes-space]",
        desktop: "[data-header-desktop]",
        deadLink: '.navlink[href="#"]',
        cartDrawer: "cart-drawer",
        cartToggleButton: "[data-cart-toggle]",
        firstSectionOverlayHeader: ".main-content > .shopify-section.section-overlay-header:first-of-type",
    };
    const Gi = { clone: "js__header__clone", firstSectionOverlayHeader: "has-first-section-overlay-header", showMobileClass: "js__show__mobile", transparent: "has-header-transparent" };
    const Yi = { transparent: "data-header-transparent" };
    let Qi = {};
    class Ki {
        constructor(e) {
            this.wrapper = e;
            this.style = this.wrapper.dataset.style;
            this.desktop = this.wrapper.querySelector(Xi.desktop);
            this.deadLinks = document.querySelectorAll(Xi.deadLink);
            this.resizeObserver = null;
            this.checkWidth = this.checkWidth.bind(this);
            this.killDeadLinks();
            if (this.style !== "drawer" && this.desktop) {
                this.minWidth = this.getMinWidth();
                this.listenWidth();
            }
            this.cartToggleEvent();
            const t = document.querySelector(Xi.firstSectionOverlayHeader);
            document.body.classList.toggle(Gi.transparent, this.wrapper.hasAttribute(Yi.transparent));
            document.body.classList.toggle(Gi.firstSectionOverlayHeader, t);
        }
        initTicker(e = false) {
            this.tickerFrames.forEach((t) => {
                new Ei(t, e);
            });
            this.tickerResizeEvent = (e) => this.onTickerResize(e);
            document.addEventListener("theme:resize:width", this.tickerResizeEvent);
        }
        listenWidth() {
            if ("ResizeObserver" in window) {
                this.resizeObserver = new ResizeObserver(this.checkWidth);
                this.resizeObserver.observe(this.wrapper);
            } else {
                document.addEventListener("theme:resize", this.checkWidth);
            }
        }
        killDeadLinks() {
            this.deadLinks.forEach((e) => {
                e.onclick = (e) => {
                    e.preventDefault();
                };
            });
        }
        checkWidth() {
            if (document.body.clientWidth < this.minWidth) {
                this.wrapper.classList.add(Gi.showMobileClass);
                const { headerHeight: e } = l();
                document.documentElement.style.setProperty("--header-height", `${e}px`);
            } else {
                this.wrapper.classList.remove(Gi.showMobileClass);
            }
        }
        getMinWidth() {
            const e = this.wrapper.cloneNode(true);
            e.classList.add(Gi.clone);
            document.body.appendChild(e);
            const t = e.querySelectorAll(Xi.widthContentWrapper);
            let i = 0;
            let s = 0;
            t.forEach((e) => {
                const t = e.querySelectorAll(Xi.widthContent);
                let o = 0;
                if (t.length === 3) {
                    o = Zi(t);
                } else {
                    o = es(t);
                }
                if (o > i) {
                    i = o;
                    s = t.length * 20;
                }
            });
            document.body.removeChild(e);
            return i + s;
        }
        cartToggleEvent() {
            if (theme.settings.cartType !== "drawer") return;
            this.wrapper.querySelectorAll(Xi.cartToggleButton)?.forEach((e) => {
                e.addEventListener("click", (t) => {
                    const i = document.querySelector(Xi.cartDrawer);
                    if (i) {
                        t.preventDefault();
                        i.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));
                        window.accessibility.lastElement = e;
                    }
                });
            });
        }
        toggleButtonClick(e) {
            e.preventDefault();
            document.dispatchEvent(new CustomEvent("theme:cart:toggle", { bubbles: true }));
        }
        unload() {
            if ("ResizeObserver" in window) {
                this.resizeObserver?.unobserve(this.wrapper);
            } else {
                document.removeEventListener("theme:resize", this.checkWidth);
            }
        }
    }
    function Zi(e) {
        let t = [];
        e.forEach((e) => {
            if (e.firstElementChild) {
                t.push(e.firstElementChild.clientWidth);
            }
        });
        if (t[0] > t[2]) {
            t[2] = t[0];
        } else {
            t[0] = t[2];
        }
        const i = t.reduce((e, t) => e + t);
        return i;
    }
    function es(e) {
        let t = 0;
        e.forEach((e) => {
            t += e.clientWidth;
        });
        return t;
    }
    const ts = {
        onLoad() {
            Qi = new Ki(this.container);
        },
        onUnload() {
            if (typeof Qi.unload === "function") {
                Qi.unload();
            }
        },
    };
    Ft("header", [ts, Pi, Ji, Di, Ri]);
    if (!customElements.get("ticker-bar")) {
        customElements.define("ticker-bar", Ei);
    }
    const is = { scrollElement: "[data-block-scroll]", flickityEnabled: "flickity-enabled" };
    const ss = {};
    class os {
        constructor(e) {
            this.container = e.container;
        }
        onBlockSelect(e) {
            const t = this.container.querySelector(is.scrollElement);
            if (t && !t.classList.contains(is.flickityEnabled)) {
                const i = e.srcElement;
                if (i) {
                    t.scrollTo({ top: 0, left: i.offsetLeft, behavior: "smooth" });
                }
            }
        }
    }
    const ns = {
        onLoad() {
            ss[this.id] = new os(this);
        },
        onBlockSelect(e) {
            ss[this.id].onBlockSelect(e);
        },
    };
    const rs = { slider: "[data-slider-mobile]", slide: "[data-slide]", thumb: "[data-slider-thumb]", sliderContainer: "[data-slider-container]", popupContainer: "[data-popup-container]", popupClose: "[data-popup-close]" };
    const as = { isAnimating: "is-animating", isSelected: "is-selected", isOpen: "is-open" };
    const ls = { thumbValue: "data-slider-thumb" };
    const cs = {};
    class ds {
        constructor(e) {
            this.container = e.container;
            this.slider = this.container.querySelector(rs.slider);
            this.slides = this.container.querySelectorAll(rs.slide);
            this.thumbs = this.container.querySelectorAll(rs.thumb);
            this.popupContainer = this.container.querySelector(rs.popupContainer);
            this.popupClose = this.container.querySelectorAll(rs.popupClose);
            this.popupCloseByEvent = this.popupCloseByEvent.bind(this);
            this.init();
        }
        init() {
            if (this.slider && this.slides.length && this.thumbs.length) {
                this.popupContainer.addEventListener("transitionend", (e) => {
                    if (e.target != this.popupContainer) return;
                    this.popupContainer.classList.remove(as.isAnimating);
                    if (e.target.classList.contains(as.isOpen)) {
                        this.popupOpenCallback();
                    } else {
                        this.popupCloseCallback();
                    }
                });
                this.popupContainer.addEventListener("transitionstart", (e) => {
                    if (e.target != this.popupContainer) return;
                    this.popupContainer.classList.add(as.isAnimating);
                });
                this.popupClose.forEach((e) => {
                    e.addEventListener("click", () => {
                        this.popupContainer.classList.remove(as.isOpen);
                        document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
                    });
                });
                this.thumbs.forEach((e, t) => {
                    e.addEventListener("click", (i) => {
                        i.preventDefault();
                        const s = e.hasAttribute(ls.thumbValue) && e.getAttribute(ls.thumbValue) !== "" ? parseInt(e.getAttribute(ls.thumbValue)) : t;
                        const o = this.slides[s];
                        if (y()) {
                            const e = parseInt(window.getComputedStyle(this.slider).paddingLeft);
                            this.slider.scrollTo({ top: 0, left: o.offsetLeft - e, behavior: "auto" });
                            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
                            this.popupContainer.classList.add(as.isAnimating, as.isOpen);
                        } else {
                            let { stickyHeaderHeight: e } = l();
                            const t = o.getBoundingClientRect().top;
                            const i = o.offsetHeight / 2;
                            const s = window.innerHeight;
                            const n = s / 2;
                            const r = this.container.querySelector(rs.sliderContainer);
                            let a = t + i - n + window.scrollY;
                            if (r) {
                                const t = r.getBoundingClientRect().top + window.scrollY;
                                const i = r.offsetHeight;
                                const o = t + i;
                                if (a < t) {
                                    a = t - e;
                                } else if (a + s > o) {
                                    a = o - s;
                                }
                            }
                            window.scrollTo({ top: a, left: 0, behavior: "smooth" });
                        }
                    });
                });
            }
        }
        popupCloseByEvent() {
            this.popupContainer.classList.remove(as.isOpen);
        }
        popupOpenCallback() {
            document.addEventListener("theme:quick-add:open", this.popupCloseByEvent, { once: true });
            document.addEventListener("theme:product:added", this.popupCloseByEvent, { once: true });
        }
        popupCloseCallback() {
            document.removeEventListener("theme:quick-add:open", this.popupCloseByEvent, { once: true });
            document.removeEventListener("theme:product:added", this.popupCloseByEvent, { once: true });
        }
    }
    const hs = {
        onLoad() {
            cs[this.id] = new ds(this);
        },
    };
    Ft("look", [hs, ns]);
    function us() {
        this.entries = [];
    }
    us.prototype.add = function (e, t, i) {
        this.entries.push({ element: e, event: t, fn: i });
        e.addEventListener(t, i);
    };
    us.prototype.removeAll = function () {
        this.entries = this.entries.filter(function (e) {
            e.element.removeEventListener(e.event, e.fn);
            return false;
        });
    };
    function ps(e, t) {
        gs(e);
        var i = fs(e, t);
        return ms(e, i);
    }
    function ms(e, t) {
        gs(e);
        bs(t);
        var i = e.variants.filter(function (e) {
            return t.every(function (t, i) {
                return e.options[i] === t;
            });
        });
        return i[0] || null;
    }
    function fs(e, t) {
        gs(e);
        vs(t);
        var i = [];
        t.forEach(function (t) {
            for (var s = 0; s < e.options.length; s++) {
                var o = e.options[s].name || e.options[s];
                if (o.toLowerCase() === t.name.toLowerCase()) {
                    i[s] = t.value;
                    break;
                }
            }
        });
        return i;
    }
    function gs(e) {
        if (typeof e !== "object") {
            throw new TypeError(e + " is not an object.");
        }
        if (Object.keys(e).length === 0 && e.constructor === Object) {
            throw new Error(e + " is empty.");
        }
    }
    function vs(e) {
        if (!Array.isArray(e)) {
            throw new TypeError(e + " is not an array.");
        }
        if (e.length === 0) {
            throw new Error(e + " is empty.");
        }
        if (e[0].hasOwnProperty("name")) {
            if (typeof e[0].name !== "string") {
                throw new TypeError("Invalid value type passed for name of option " + e[0].name + ". Value should be string.");
            }
        } else {
            throw new Error(e[0] + "does not contain name key.");
        }
    }
    function bs(e) {
        if (Array.isArray(e) && typeof e[0] === "object") {
            throw new Error(e + "is not a valid array of options.");
        }
    }
    var ys = { idInput: '[name="id"]', planInput: '[name="selling_plan"]', optionInput: '[name^="options"]', quantityInput: '[name="quantity"]', propertyInput: '[name^="properties"]' };
    function ws(e, t) {
        if (/variant=/.test(e)) {
            return e.replace(/(variant=)[^&]+/, "$1" + t);
        } else if (/\?/.test(e)) {
            return e.concat("&variant=").concat(t);
        }
        return e.concat("?variant=").concat(t);
    }
    class Ss {
        constructor(e, t, i) {
            this.element = e;
            this.product = this._validateProductObject(t);
            this.variantElement = this.element.querySelector(ys.idInput);
            i = i || {};
            this._listeners = new us();
            this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i));
            this.optionInputs = this._initInputs(ys.optionInput, i.onOptionChange);
            this.planInputs = this._initInputs(ys.planInput, i.onPlanChange);
            this.quantityInputs = this._initInputs(ys.quantityInput, i.onQuantityChange);
            this.propertyInputs = this._initInputs(ys.propertyInput, i.onPropertyChange);
        }
        destroy() {
            this._listeners.removeAll();
        }
        options() {
            return this._serializeInputValues(this.optionInputs, function (e) {
                var t = /(?:^(options\[))(.*?)(?:\])/;
                e.name = t.exec(e.name)[2];
                return e;
            });
        }
        variant() {
            const e = this.options();
            if (e.length) {
                return ps(this.product, e);
            } else {
                return this.product.variants[0];
            }
        }
        plan(e) {
            let t = { allocation: null, group: null, detail: null };
            const i = this.element.querySelector(`${ys.planInput}:checked`);
            if (!i) return null;
            const s = i.value;
            const o = s && s !== "" ? s : null;
            if (o && e) {
                t.allocation = e.selling_plan_allocations.find(function (e) {
                    return e.selling_plan_id.toString() === o.toString();
                });
            }
            if (t.allocation) {
                t.group = this.product.selling_plan_groups.find(function (e) {
                    return e.id.toString() === t.allocation.selling_plan_group_id.toString();
                });
            }
            if (t.group) {
                t.detail = t.group.selling_plans.find(function (e) {
                    return e.id.toString() === o.toString();
                });
            }
            if (t && t.allocation && t.detail && t.allocation) {
                return t;
            } else return null;
        }
        properties() {
            return this._serializeInputValues(this.propertyInputs, function (e) {
                var t = /(?:^(properties\[))(.*?)(?:\])/;
                e.name = t.exec(e.name)[2];
                return e;
            });
        }
        quantity() {
            return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
        }
        getFormState() {
            const e = this.variant();
            return { options: this.options(), variant: e, properties: this.properties(), quantity: this.quantity(), plan: this.plan(e) };
        }
        _setIdInputValue(e) {
            if (e && e.id) {
                this.variantElement.value = e.id.toString();
            } else {
                this.variantElement.value = "";
            }
            this.variantElement.dispatchEvent(new Event("change"));
        }
        _onSubmit(e, t) {
            t.dataset = this.getFormState();
            if (e.onFormSubmit) {
                e.onFormSubmit(t);
            }
        }
        _onOptionChange(e) {
            this._setIdInputValue(e.dataset.variant);
        }
        _onFormEvent(e) {
            if (typeof e === "undefined") {
                return Function.prototype.bind();
            }
            return function (t) {
                t.dataset = this.getFormState();
                this._setIdInputValue(t.dataset.variant);
                e(t);
            }.bind(this);
        }
        _initInputs(e, t) {
            var i = Array.prototype.slice.call(this.element.querySelectorAll(e));
            return i.map(
                function (e) {
                    this._listeners.add(e, "change", this._onFormEvent(t));
                    return e;
                }.bind(this)
            );
        }
        _serializeInputValues(e, t) {
            return e.reduce(function (e, i) {
                if (i.checked || (i.type !== "radio" && i.type !== "checkbox")) {
                    e.push(t({ name: i.name, value: i.value }));
                }
                return e;
            }, []);
        }
        _validateProductObject(e) {
            if (typeof e !== "object") {
                throw new TypeError(e + " is not an object.");
            }
            if (typeof e.variants[0].options === "undefined") {
                throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
            }
            return e;
        }
    }
    function Es(e) {
        const t = `${window.theme.routes.root}products/${e}.js`;
        return window
            .fetch(t)
            .then((e) => e.json())
            .catch((e) => {
                console.error(e);
            });
    }
    const Ls = {
        scrollbarAttribute: "data-scrollbar",
        scrollbar: "data-scrollbar-slider",
        scrollbarSlideFullWidth: "data-scrollbar-slide-fullwidth",
        scrollbarArrowPrev: "[data-scrollbar-arrow-prev]",
        scrollbarArrowNext: "[data-scrollbar-arrow-next]",
    };
    const ks = { hidden: "is-hidden" };
    const As = { delay: 200 };
    class Cs {
        constructor(e) {
            this.scrollbar = e;
            this.arrowNext = this.scrollbar.parentNode.querySelector(Ls.scrollbarArrowNext);
            this.arrowPrev = this.scrollbar.parentNode.querySelector(Ls.scrollbarArrowPrev);
            if (this.scrollbar.hasAttribute(Ls.scrollbarAttribute)) {
                this.init();
                this.listen();
            }
            if (this.scrollbar.hasAttribute(Ls.scrollbar)) {
                this.scrollToVisibleElement();
            }
        }
        init() {
            if (this.arrowNext && this.arrowPrev) {
                this.toggleNextArrow();
                this.events();
            }
        }
        listen() {
            document.addEventListener("theme:modal:open", () => {
                this.toggleNextArrow();
            });
            document.addEventListener("theme:resize", () => {
                this.toggleNextArrow();
            });
        }
        events() {
            this.arrowNext.addEventListener("click", (e) => {
                e.preventDefault();
                this.goToNext();
            });
            this.arrowPrev.addEventListener("click", (e) => {
                e.preventDefault();
                this.goToPrev();
            });
            this.scrollbar.addEventListener("scroll", () => {
                this.togglePrevArrow();
                this.toggleNextArrow();
            });
        }
        goToNext() {
            const e = this.scrollbar.hasAttribute(Ls.scrollbarSlideFullWidth) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2;
            const t = e + this.scrollbar.scrollLeft;
            this.move(t);
            this.arrowPrev.classList.remove(ks.hidden);
            this.toggleNextArrow();
        }
        goToPrev() {
            const e = this.scrollbar.hasAttribute(Ls.scrollbarSlideFullWidth) ? this.scrollbar.getBoundingClientRect().width : this.scrollbar.getBoundingClientRect().width / 2;
            const t = this.scrollbar.scrollLeft - e;
            this.move(t);
            this.arrowNext.classList.remove(ks.hidden);
            this.togglePrevArrow();
        }
        toggleNextArrow() {
            setTimeout(() => {
                this.arrowNext?.classList.toggle(ks.hidden, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth);
            }, As.delay);
        }
        togglePrevArrow() {
            setTimeout(() => {
                this.arrowPrev.classList.toggle(ks.hidden, this.scrollbar.scrollLeft <= 0);
            }, As.delay);
        }
        scrollToVisibleElement() {
            [].forEach.call(this.scrollbar.children, (e) => {
                e.addEventListener("click", (t) => {
                    t.preventDefault();
                    this.move(e.offsetLeft - e.clientWidth);
                });
            });
        }
        move(e) {
            this.scrollbar.scrollTo({ top: 0, left: e, behavior: "smooth" });
        }
    }
    const Ts = {
        gridSwatchForm: "[data-grid-swatch-form]",
        input: "[data-swatch-input]",
        productItem: "[data-grid-item]",
        productInfo: "[data-product-information]",
        sectionId: "[data-section-id]",
        productImage: "[data-product-image]",
        swatchButton: "[data-swatch-button]",
        swatchLink: "[data-swatch-link]",
        swatchText: "[data-swatch-text]",
        template: "[data-swatch-template]",
    };
    const qs = { visible: "is-visible", hidden: "hidden", stopEvents: "no-events", swatch: "swatch" };
    const Is = {
        image: "data-swatch-image",
        handle: "data-swatch-handle",
        label: "data-swatch-label",
        scrollbar: "data-scrollbar",
        swatchCount: "data-swatch-count",
        tooltip: "data-tooltip",
        variant: "data-swatch-variant",
        variantName: "data-swatch-variant-name",
        variantTitle: "data-variant-title",
        swatchValues: "data-swatch-values",
    };
    class Ps extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            if (this.hasAttribute(Is.tooltip)) {
                new Gt(this);
            }
        }
    }
    class xs extends HTMLElement {
        constructor() {
            super();
            this.productItemMouseLeaveEvent = () => this.hideVariantImages();
            this.showVariantImageEvent = (e) => this.showVariantImage(e);
        }
        connectedCallback() {
            this.handle = this.getAttribute(Is.handle);
            this.productItem = this.closest(Ts.productItem);
            this.productInfo = this.closest(Ts.productInfo);
            this.productImage = this.productItem.querySelector(Ts.productImage);
            this.template = document.querySelector(Ts.template).innerHTML;
            this.swatchesJSON = this.getSwatchesJSON();
            this.swatchesStyle = theme.settings.collectionSwatchStyle;
            const e = this.getAttribute(Is.label).trim().toLowerCase();
            Es(this.handle).then((t) => {
                this.product = t;
                this.colorOption = t.options.find(function (t) {
                    return t.name.toLowerCase() === e || null;
                });
                if (this.colorOption) {
                    this.swatches = this.colorOption.values;
                    this.init();
                }
            });
        }
        init() {
            this.innerHTML = "";
            this.count = 0;
            this.limitedCount = 0;
            this.swatches.forEach((e) => {
                let t = null;
                let i = false;
                let s = "";
                for (const i of this.product.variants) {
                    const o = i.options.includes(e);
                    if (!t && o) {
                        t = i;
                    }
                    if (o && i.featured_media) {
                        s = i.featured_media.preview_image.src;
                        t = i;
                        break;
                    }
                }
                for (const t of this.product.variants) {
                    const s = t.options.includes(e);
                    if (s && t.available) {
                        i = true;
                        break;
                    }
                }
                if (t) {
                    const o = document.createElement("div");
                    o.innerHTML = this.template;
                    const n = o.querySelector(Ts.swatchButton);
                    const r = o.querySelector(Ts.swatchLink);
                    const a = o.querySelector(Ts.swatchText);
                    const l = this.swatchesJSON[e];
                    const c = theme.settings.swatchesType == "native" ? l : `var(--${l})`;
                    const d = t.title.replaceAll('"', "'");
                    n.style = `--animation-delay: ${(100 * this.count) / 1250}s`;
                    n.classList.add(`${qs.swatch}-${l}`);
                    n.dataset.tooltip = e;
                    n.dataset.swatchVariant = t.id;
                    n.dataset.swatchVariantName = d;
                    n.dataset.swatchImage = s;
                    n.dataset.variant = t.id;
                    n.style.setProperty("--swatch", c);
                    r.href = ws(this.product.url, t.id);
                    r.dataset.swatch = e;
                    r.disabled = !i;
                    a.innerText = e;
                    if (this.swatchesStyle != "limited") {
                        this.innerHTML += o.innerHTML;
                    } else if (this.count <= 4) {
                        this.innerHTML += o.innerHTML;
                        this.limitedCount++;
                    }
                    this.count++;
                }
            });
            this.swatchCount = this.productInfo.querySelector(`[${Is.swatchCount}]`);
            this.swatchElements = this.querySelectorAll(Ts.swatchLink);
            this.swatchForm = this.productInfo.querySelector(Ts.gridSwatchForm);
            this.hideSwatchesTimer = 0;
            if (this.swatchCount.hasAttribute(Is.swatchCount)) {
                if (this.swatchesStyle == "text" || this.swatchesStyle == "text-slider") {
                    this.swatchCount.innerText = `${this.count} ${this.count > 1 ? theme.strings.otherColor : theme.strings.oneColor}`;
                    if (this.swatchesStyle == "text") return;
                    this.swatchCount.addEventListener("mouseenter", () => {
                        if (this.hideSwatchesTimer) clearTimeout(this.hideSwatchesTimer);
                        this.productInfo.classList.add(qs.stopEvents);
                        this.swatchForm.classList.add(qs.visible);
                    });
                    this.productInfo.addEventListener("mouseleave", () => {
                        this.hideSwatchesTimer = setTimeout(() => {
                            this.productInfo.classList.remove(qs.stopEvents);
                            this.swatchForm.classList.remove(qs.visible);
                        }, 100);
                    });
                }
                if (this.swatchesStyle == "slider" || this.swatchesStyle == "grid") {
                    this.swatchForm.classList.add(qs.visible);
                }
                if (this.swatchesStyle == "limited") {
                    const e = this.count - this.limitedCount;
                    this.swatchForm.classList.add(qs.visible);
                    if (e > 0) {
                        this.innerHTML += `<div class="swatch-limited">+${e}</div>`;
                    }
                }
            }
            if (this.swatchesStyle == "text-slider" || this.swatchesStyle == "slider") {
                if (this.hasAttribute(Is.scrollbar)) {
                    new Cs(this);
                }
            }
            this.bindSwatchButtonEvents();
        }
        bindSwatchButtonEvents() {
            this.querySelectorAll(Ts.swatchButton)?.forEach((e) => {
                e.addEventListener("mouseenter", this.showVariantImageEvent);
                if (e.hasAttribute(Is.tooltip)) {
                    new Gt(e);
                }
            });
            this.productItem.addEventListener("mouseleave", this.productItemMouseLeaveEvent);
        }
        showVariantImage(e) {
            const t = e.target;
            const i = t.getAttribute(Is.variantName)?.replaceAll('"', "'");
            const s = this.productImage.querySelectorAll(`[${Is.variantTitle}]`);
            const o = this.productImage.querySelector(`[${Is.variantTitle}="${i}"]`);
            s?.forEach((e) => {
                e.classList.remove(qs.visible);
            });
            o?.classList.add(qs.visible);
        }
        hideVariantImages() {
            this.productImage.querySelectorAll(`[${Is.variantTitle}].${qs.visible}`)?.forEach((e) => {
                e.classList.remove(qs.visible);
            });
        }
        getSwatchesJSON() {
            if (!this.hasAttribute(Is.swatchValues)) return {};
            const e = this.getAttribute(Is.swatchValues).split(",");
            const t = {};
            e?.forEach((e) => {
                const [i, s] = e.split(":");
                t[i.trim()] = s.trim();
            });
            return t;
        }
    }
    const Ms = {
        productCutline: "[data-product-cutline]",
        productLink: "[data-product-link]",
        productGridItem: "[data-grid-item]",
        productInfo: "[data-product-information]",
        productImage: "[data-product-image-default]",
        productImageSibling: "[data-product-image-sibling]",
        productPrice: "[data-product-price]",
        siblingsInnerHolder: "[data-sibling-inner]",
        siblingCount: "[data-sibling-count]",
        siblingFieldset: "[data-sibling-fieldset]",
        siblingLink: "[data-sibling-link]",
        tooltip: "[data-tooltip]",
    };
    const Hs = { visible: "is-visible", fade: "is-fade", stopEvents: "no-events", active: "is-active" };
    const Os = {
        siblingAddedImage: "data-sibling-added-image",
        siblingCutline: "data-sibling-cutline",
        siblingImage: "data-sibling-image",
        siblingLink: "data-sibling-link",
        siblingPrice: "data-sibling-price",
        siblingCompareAtPrice: "data-sibling-compare-at-price",
        productLink: "data-product-link",
    };
    class Bs {
        constructor(e, t) {
            this.swatches = e;
            this.product = t;
            this.productLinks = this.product.querySelectorAll(Ms.productLink);
            this.productCutline = this.product.querySelector(Ms.productCutline);
            this.productPrice = this.product.querySelector(Ms.productPrice);
            this.productImage = this.product.querySelector(Ms.productImage);
            this.productImageSibling = this.product.querySelector(Ms.productImageSibling);
            this.init();
        }
        init() {
            this.cacheDefaultValues();
            this.product.addEventListener("mouseleave", () => this.resetProductValues());
            this.swatches.forEach((e) => {
                e.addEventListener("mouseenter", (e) => this.showSibling(e));
            });
            if (this.productLinks.length) {
                this.swatches.forEach((e) => {
                    e.addEventListener("click", () => {
                        this.productLinks[0].click();
                    });
                });
            }
        }
        cacheDefaultValues() {
            this.productLinkValue = this.productLinks[0].hasAttribute(Os.productLink) ? this.productLinks[0].getAttribute(Os.productLink) : "";
            this.productPriceValue = this.productPrice.innerHTML;
            if (this.productCutline) {
                this.productCutlineValue = this.productCutline.innerHTML;
            }
        }
        resetProductValues() {
            this.product.classList.remove(Hs.active);
            if (this.productLinkValue) {
                this.productLinks.forEach((e) => {
                    e.href = this.productLinkValue;
                });
            }
            if (this.productPrice) {
                this.productPrice.innerHTML = this.productPriceValue;
            }
            if (this.productCutline && this.productCutline) {
                this.productCutline.innerHTML = this.productCutlineValue;
                this.productCutline.title = this.productCutlineValue;
            }
            this.hideSiblingImage();
        }
        showSibling(e) {
            const t = e.target;
            const i = t.hasAttribute(Os.siblingLink) ? t.getAttribute(Os.siblingLink) : "";
            const s = t.hasAttribute(Os.siblingPrice) ? t.getAttribute(Os.siblingPrice) : "";
            const o = t.hasAttribute(Os.siblingCompareAtPrice) ? t.getAttribute(Os.siblingCompareAtPrice) : "";
            const n = t.hasAttribute(Os.siblingCutline) ? t.getAttribute(Os.siblingCutline) : "";
            const r = t.hasAttribute(Os.siblingImage) ? t.getAttribute(Os.siblingImage) : "";
            if (i) {
                this.productLinks.forEach((e) => {
                    e.href = i;
                });
            }
            if (o) {
                this.productPrice.innerHTML = `<span class="price sale"><span class="new-price">${s}</span> <span class="old-price">${o}</span></span>`;
            } else {
                this.productPrice.innerHTML = `<span class="price">${s}</span>`;
            }
            if (this.productCutline) {
                if (n) {
                    this.productCutline.innerHTML = n;
                    this.productCutline.title = n;
                } else {
                    this.productCutline.innerHTML = "";
                    this.productCutline.title = "";
                }
            }
            if (r) {
                this.showSiblingImage(r);
            }
        }
        showSiblingImage(e) {
            if (!this.productImageSibling) return;
            const t = window.devicePixelRatio || 1;
            const i = this.productImage.offsetWidth * t;
            const s = Math.ceil(i / 180) * 180;
            const n = o.getSizedImageUrl(e, `${s}x`);
            const r = this.productImageSibling.querySelector(`[src="${n}"]`);
            const a = () => {
                this.productImageSibling.classList.add(Hs.visible);
                this.productImageSibling.querySelector(`[src="${n}"]`).classList.add(Hs.fade);
            };
            const l = () => {
                this.productImageSibling.querySelectorAll("img").forEach((e) => {
                    e.classList.remove(Hs.fade);
                });
                requestAnimationFrame(a);
            };
            if (r) {
                l();
            } else {
                const e = document.createElement("img");
                e.src = n;
                if (this.productCutline) {
                    e.alt = this.productCutline.innerText;
                }
                e.addEventListener("load", () => {
                    this.productImageSibling.append(e);
                    l();
                });
            }
        }
        hideSiblingImage() {
            if (!this.productImageSibling) return;
            this.productImageSibling.classList.remove(Hs.visible);
            this.productImageSibling.querySelectorAll("img").forEach((e) => {
                e.classList.remove(Hs.fade);
            });
        }
    }
    class Ds extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.product = this.closest(Ms.productGridItem);
            this.siblingScrollbar = this.querySelector(Ms.siblingsInnerHolder);
            this.siblingCount = this.querySelector(Ms.siblingCount);
            this.siblingFieldset = this.querySelector(Ms.siblingFieldset);
            this.siblingLinks = this.querySelectorAll(Ms.siblingLink);
            this.productInfo = this.closest(Ms.productInfo);
            this.productLink = this.closest(Ms.link);
            this.hideSwatchesTimer = 0;
            this.swatchesStyle = theme.settings.collectionSwatchStyle;
            this.initScrollbar();
            if (this.siblingFieldset && this.productInfo) {
                if (this.swatchesStyle == "grid" || this.swatchesStyle == "slider" || this.swatchesStyle == "limited") {
                    this.siblingFieldset.classList.add(Hs.visible);
                }
                if (this.siblingCount) {
                    this.siblingCount.addEventListener("mouseenter", () => this.showSiblings());
                    this.productInfo.addEventListener("mouseleave", () => this.hideSiblings());
                }
            }
            if (this.siblingLinks.length) {
                new Bs(this.siblingLinks, this.product);
            }
            this.querySelectorAll(Ms.tooltip).forEach((e) => {
                new Gt(e);
            });
        }
        showSiblings() {
            if (this.hideSwatchesTimer) clearTimeout(this.hideSwatchesTimer);
            if (this.productLink) {
                this.productLink.classList.add(Hs.stopEvents);
            }
            if (this.swatchesStyle == "text") return;
            this.siblingFieldset.classList.add(Hs.visible);
        }
        hideSiblings() {
            this.hideSwatchesTimer = setTimeout(() => {
                if (this.productLink) {
                    this.productLink.classList.remove(Hs.stopEvents);
                }
                this.siblingFieldset.classList.remove(Hs.visible);
            }, 100);
        }
        initScrollbar() {
            if (this.siblingScrollbar) {
                new Cs(this.siblingScrollbar);
            }
        }
    }
    const Fs = { slide: "[data-hover-slide]", slideTouch: "[data-hover-slide-touch]", slider: "[data-hover-slider]", productLink: "[data-product-link]", flickityButton: ".flickity-prev-next-button" };
    class _s extends HTMLElement {
        constructor() {
            super();
            this.flkty = null;
            this.slider = this.querySelector(Fs.slider);
            this.handleScroll = this.handleScroll.bind(this);
        }
        connectedCallback() {
            if (window.theme.touch) {
                this.initTouch();
            } else {
                this.initFlickity();
            }
        }
        disconnectedCallback() {
            if (this.flkty) {
                this.flkty.options.watchCSS = false;
                this.flkty.destroy();
            }
        }
        initTouch() {
            this.style.setProperty("--slides-count", this.querySelectorAll(Fs.slideTouch).length);
            this.slider.addEventListener("scroll", this.handleScroll);
        }
        handleScroll() {
            const e = this.slider.scrollLeft / this.slider.clientWidth;
            this.style.setProperty("--slider-index", e);
        }
        initFlickity() {
            if (this.querySelectorAll(Fs.slide).length < 2) return;
            this.flkty = new i(this.slider, { cellSelector: Fs.slide, contain: true, wrapAround: true, watchCSS: true, autoPlay: false, draggable: false, pageDots: false, prevNextButtons: true });
            this.flkty.pausePlayer();
            this.addEventListener("mouseenter", () => {
                this.flkty.unpausePlayer();
            });
            this.addEventListener("mouseleave", () => {
                this.flkty.pausePlayer();
            });
            this.closest(Fs.productLink).addEventListener("click", (e) => {
                if (e.target.matches(Fs.flickityButton)) {
                    e.preventDefault();
                }
            });
        }
    }
    const $s = {
        body: "body",
        dataRelatedSectionElem: "[data-related-section]",
        dataTabsHolder: "[data-tabs-holder]",
        dataTab: "data-tab",
        dataTabIndex: "data-tab-index",
        dataAos: "[data-aos]",
        blockId: "data-block-id",
        tabsLi: "[data-tab]",
        tabLink: ".tab-link",
        tabLinkRecent: ".tab-link__recent",
        tabContent: ".tab-content",
        scrollbarHolder: "[data-scrollbar]",
    };
    const Ns = { current: "current", hidden: "hidden", aosAnimate: "aos-animate", aosNoTransition: "aos-no-transition", focused: "is-focused" };
    const Ws = {};
    class Rs {
        constructor(e) {
            this.container = e;
            this.body = document.querySelector($s.body);
            this.accessibility = window.accessibility;
            if (this.container) {
                this.scrollbarHolder = this.container.querySelectorAll($s.scrollbarHolder);
                this.init();
                this.initNativeScrollbar();
            }
        }
        init() {
            const e = this.container.querySelectorAll($s.tabsLi);
            this.container.addEventListener("theme:tab:check", () => this.checkRecentTab());
            this.container.addEventListener("theme:tab:hide", () => this.hideRelatedTab());
            if (e.length) {
                e.forEach((e) => {
                    const t = parseInt(e.getAttribute($s.dataTab));
                    const i = this.container.querySelector(`${$s.tabContent}-${t}`);
                    e.addEventListener("click", () => {
                        this.tabChange(e, i);
                    });
                    e.addEventListener("keyup", (t) => {
                        if ((t.code === "Space" || t.code === "Enter") && this.body.classList.contains(Ns.focused)) {
                            this.tabChange(e, i);
                        }
                    });
                });
            }
        }
        tabChange(e, t) {
            if (e.classList.contains(Ns.current)) {
                return;
            }
            const i = this.container.querySelector(`${$s.tabsLi}.${Ns.current}`);
            const s = this.container.querySelector(`${$s.tabContent}.${Ns.current}`);
            i?.classList.remove(Ns.current);
            s?.classList.remove(Ns.current);
            e.classList.add(Ns.current);
            t.classList.add(Ns.current);
            if (e.classList.contains(Ns.hidden)) {
                t.classList.add(Ns.hidden);
            }
            this.accessibility.a11y.removeTrapFocus();
            this.container.dispatchEvent(new CustomEvent("theme:tab:change", { bubbles: true }));
            e.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: true, detail: { element: "tab" } }));
            this.animateItems(t);
        }
        animateItems(e, t = true) {
            const i = e.querySelectorAll($s.dataAos);
            if (i.length) {
                i.forEach((e) => {
                    e.classList.remove(Ns.aosAnimate);
                    if (t) {
                        e.classList.add(Ns.aosNoTransition);
                        requestAnimationFrame(() => {
                            e.classList.remove(Ns.aosNoTransition);
                            e.classList.add(Ns.aosAnimate);
                        });
                    }
                });
            }
        }
        initNativeScrollbar() {
            if (this.scrollbarHolder.length) {
                this.scrollbarHolder.forEach((e) => {
                    new Cs(e);
                });
            }
        }
        checkRecentTab() {
            const e = this.container.querySelector($s.tabLinkRecent);
            if (e) {
                e.classList.remove(Ns.hidden);
                const t = parseInt(e.getAttribute($s.dataTab));
                const i = this.container.querySelector(`${$s.tabContent}[${$s.dataTabIndex}="${t}"]`);
                if (i) {
                    i.classList.remove(Ns.hidden);
                    this.animateItems(i, false);
                }
                this.initNativeScrollbar();
            }
        }
        hideRelatedTab() {
            const e = this.container.querySelector($s.dataRelatedSectionElem);
            if (!e) {
                return;
            }
            const t = e.closest(`${$s.tabContent}.${Ns.current}`);
            if (!t) {
                return;
            }
            const i = parseInt(t.getAttribute($s.dataTabIndex));
            const s = this.container.querySelectorAll($s.tabsLi);
            if (s.length > i) {
                const e = s[i].nextSibling;
                if (e) {
                    s[i].classList.add(Ns.hidden);
                    e.dispatchEvent(new Event("click"));
                    this.initNativeScrollbar();
                }
            }
        }
        onBlockSelect(e) {
            const t = this.container.querySelector(`${$s.tabLink}[${$s.blockId}="${e.detail.blockId}"]`);
            if (t) {
                t.dispatchEvent(new Event("click"));
                t.parentNode.scrollTo({ top: 0, left: t.offsetLeft - t.clientWidth, behavior: "smooth" });
            }
        }
    }
    const Vs = {
        onLoad() {
            Ws[this.id] = [];
            const e = this.container.querySelectorAll($s.dataTabsHolder);
            e.forEach((e) => {
                Ws[this.id].push(new Rs(e));
            });
        },
        onBlockSelect(e) {
            Ws[this.id].forEach((t) => {
                if (typeof t.onBlockSelect === "function") {
                    t.onBlockSelect(e);
                }
            });
        },
    };
    function Us() {
        const e = Boolean(document.querySelectorAll("dialog[open][data-scroll-lock-required]").length);
        const t = Boolean(document.querySelectorAll(".drawer.is-open").length);
        return e || t;
    }
    const zs = {
        added: "is-added",
        animated: "is-animated",
        disabled: "is-disabled",
        error: "has-error",
        loading: "is-loading",
        open: "is-open",
        overlayText: "product-item--overlay-text",
        visible: "is-visible",
        siblingLinkCurrent: "sibling__link--current",
    };
    const js = { errorDelay: 3e3 };
    const Js = {
        animation: "[data-animation]",
        apiContent: "[data-api-content]",
        buttonQuickAdd: "[data-quick-add-btn]",
        buttonAddToCart: "[data-add-to-cart]",
        cartDrawer: "cart-drawer",
        cartPage: "[data-cart-page]",
        cartLineItems: "[data-line-items]",
        dialog: "dialog",
        focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        messageError: "[data-message-error]",
        modalButton: "[data-quick-add-modal-handle]",
        modalContainer: "[data-product-upsell-container]",
        modalContent: "[data-product-upsell-ajax]",
        modalClose: "[data-quick-add-modal-close]",
        productGridItem: "data-grid-item",
        productInformationHolder: "[data-product-information]",
        quickAddHolder: "[data-quick-add-holder]",
        quickAddModal: "[data-quick-add-modal]",
        quickAddModalTemplate: "[data-quick-add-modal-template]",
        tooltip: "[data-tooltip]",
    };
    const Xs = { closing: "closing", productId: "data-product-id", modalHandle: "data-quick-add-modal-handle", siblingSwapper: "data-sibling-swapper", quickAddHolder: "data-quick-add-holder" };
    class Gs extends HTMLElement {
        constructor() {
            super();
            this.container = this;
            this.quickAddHolder = this.container.querySelector(Js.quickAddHolder);
            if (this.quickAddHolder) {
                this.modal = null;
                this.currentModal = null;
                this.productId = this.quickAddHolder.getAttribute(Xs.quickAddHolder);
                this.modalButton = this.quickAddHolder.querySelector(Js.modalButton);
                this.handle = this.modalButton?.getAttribute(Xs.modalHandle);
                this.buttonQuickAdd = this.quickAddHolder.querySelector(Js.buttonQuickAdd);
                this.buttonATC = this.quickAddHolder.querySelector(Js.buttonAddToCart);
                this.button = this.modalButton || this.buttonATC;
                this.modalClose = this.modalClose.bind(this);
                this.modalCloseOnProductAdded = this.modalCloseOnProductAdded.bind(this);
                this.a11y = te;
                this.isAnimating = false;
                this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this);
                this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this);
            }
        }
        connectedCallback() {
            if (this.modalButton) {
                this.modalButton.addEventListener("click", this.modalButtonClickEvent);
            }
            if (this.buttonATC) {
                this.buttonATC.addEventListener("click", (e) => {
                    e.preventDefault();
                    window.accessibility.lastElement = this.buttonATC;
                    document.dispatchEvent(new CustomEvent("theme:cart:add", { detail: { button: this.buttonATC } }));
                });
            }
            if (this.quickAddHolder) {
                this.quickAddHolder.addEventListener("animationend", this.quickAddLoadingToggle);
                this.errorHandler();
            }
        }
        modalButtonClickEvent(e) {
            e.preventDefault();
            const t = this.modalButton.hasAttribute(Xs.siblingSwapper);
            const i = this.modalButton.classList.contains(zs.siblingLinkCurrent);
            if (i) return;
            this.modalButton.classList.add(zs.loading);
            this.modalButton.disabled = true;
            if (t && !i) {
                this.currentModal = e.target.closest(Js.quickAddModal);
                this.currentModal.classList.add(zs.loading);
            }
            this.renderModal();
        }
        modalCreate(e) {
            const t = document.querySelector(`${Js.quickAddModal}[${Xs.productId}="${this.productId}"]`);
            if (t) {
                this.modal = t;
                this.modalOpen();
            } else {
                const t = this.quickAddHolder.querySelector(Js.quickAddModalTemplate);
                if (!t) return;
                const i = document.createElement("div");
                i.innerHTML = t.innerHTML;
                document.body.appendChild(i.querySelector(Js.quickAddModal));
                t.remove();
                this.modal = document.querySelector(`${Js.quickAddModal}[${Xs.productId}="${this.productId}"]`);
                this.modal.querySelector(Js.modalContent).innerHTML = new DOMParser().parseFromString(e, "text/html").querySelector(Js.apiContent).innerHTML;
                this.modal.querySelectorAll(Js.tooltip).forEach((e) => {
                    new Gt(e);
                });
                this.modalCreatedCallback();
            }
        }
        modalOpen() {
            if (this.currentModal) {
                this.currentModal.dispatchEvent(new CustomEvent("theme:modal:close", { bubbles: false }));
            }
            if (typeof this.modal.show === "function") {
                this.modal.show();
            }
            this.modal.setAttribute("open", true);
            this.modal.removeAttribute("inert");
            this.quickAddHolder.classList.add(zs.disabled);
            if (this.modalButton) {
                this.modalButton.classList.remove(zs.loading);
                this.modalButton.disabled = false;
                window.accessibility.lastElement = this.modalButton;
            }
            requestAnimationFrame(() => {
                this.modal.querySelectorAll(Js.animation).forEach((e) => {
                    e.classList.add(zs.animated);
                });
            });
            document.dispatchEvent(new CustomEvent("theme:quick-add:open", { bubbles: true }));
            document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
            document.addEventListener("theme:product:added", this.modalCloseOnProductAdded, { once: true });
        }
        modalClose() {
            if (this.isAnimating) {
                return;
            }
            if (!this.modal.hasAttribute(Xs.closing)) {
                this.modal.setAttribute(Xs.closing, "");
                this.isAnimating = true;
                return;
            }
            if (typeof this.modal.close === "function") {
                this.modal.close();
            } else {
                this.modal.removeAttribute("open");
            }
            this.modal.removeAttribute(Xs.closing);
            this.modal.setAttribute("inert", "");
            this.modal.classList.remove(zs.loading);
            if (this.modalButton) {
                this.modalButton.disabled = false;
            }
            if (this.quickAddHolder && this.quickAddHolder.classList.contains(zs.disabled)) {
                this.quickAddHolder.classList.remove(zs.disabled);
            }
            this.resetAnimatedItems();
            if (!Us()) {
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
            }
            document.removeEventListener("theme:product:added", this.modalCloseOnProductAdded);
            this.a11y.removeTrapFocus();
            this.a11y.autoFocusLastElement();
        }
        modalEvents() {
            this.modal.querySelector(Js.modalClose)?.addEventListener("click", (e) => {
                e.preventDefault();
                this.modalClose();
            });
            this.modal.addEventListener("click", (e) => {
                if (e.target.nodeName === "DIALOG" && e.type === "click") {
                    this.modalClose();
                }
            });
            this.modal.addEventListener("keydown", (e) => {
                if (e.code == "Escape") {
                    e.preventDefault();
                    this.modalClose();
                }
            });
            this.modal.addEventListener("theme:modal:close", () => {
                this.modalClose();
            });
            this.modal.addEventListener("animationend", (e) => {
                if (e.target !== this.modal) return;
                this.isAnimating = false;
                if (this.modal.hasAttribute(Xs.closing)) {
                    this.modalClose();
                } else {
                    setTimeout(() => {
                        this.a11y.trapFocus(this.modal);
                        const e = this.modal.querySelector("[autofocus]") || this.modal.querySelector(Js.focusable);
                        e?.focus();
                    }, 50);
                }
            });
        }
        modalCloseOnProductAdded() {
            this.resetQuickAddButtons();
            if (this.modal && this.modal.hasAttribute("open")) {
                this.modalClose();
            }
        }
        quickAddLoadingToggle(e) {
            if (e.target != this.quickAddHolder) return;
            this.quickAddHolder.classList.remove(zs.disabled);
        }
        errorHandler() {
            this.quickAddHolder.addEventListener("theme:cart:error", (e) => {
                const t = e.detail.holder;
                const i = t.closest(`[${Js.productGridItem}]`);
                if (!i) return;
                const s = t.querySelector(Js.messageError);
                const o = i.classList.contains(zs.overlayText);
                const n = i.querySelector(Js.productInformationHolder);
                const r = t.querySelector(Js.buttonAddToCart);
                if (r) {
                    r.classList.remove(zs.added, zs.loading);
                    t.classList.add(zs.error);
                }
                if (s) {
                    s.innerText = e.detail.description;
                }
                if (o) {
                    n.classList.add(zs.hidden);
                }
                setTimeout(() => {
                    this.resetQuickAddButtons();
                    if (o) {
                        n.classList.remove(zs.hidden);
                    }
                }, js.errorDelay);
            });
        }
        resetQuickAddButtons() {
            if (this.quickAddHolder) {
                this.quickAddHolder.classList.remove(zs.visible, zs.error);
            }
            if (this.buttonQuickAdd) {
                this.buttonQuickAdd.classList.remove(zs.added);
                this.buttonQuickAdd.disabled = false;
            }
        }
        renderModal() {
            if (this.modal) {
                this.modalOpen();
            } else {
                window
                    .fetch(`${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`)
                    .then(this.upsellErrorsHandler)
                    .then((e) => e.text())
                    .then((e) => {
                        this.modalCreate(e);
                    });
            }
        }
        modalCreatedCallback() {
            this.modalEvents();
            this.modalOpen();
            D(this.modal);
        }
        upsellErrorsHandler(e) {
            if (!e.ok) {
                return e.json().then(function (t) {
                    const i = new Ge({ status: e.statusText, headers: e.headers, json: t });
                    throw i;
                });
            }
            return e;
        }
        resetAnimatedItems() {
            this.modal?.querySelectorAll(Js.animation).forEach((e) => {
                e.classList.remove(zs.animated);
            });
        }
    }
    Ft("product-grid", [Vs]);
    if (!customElements.get("quick-add-product")) {
        customElements.define("quick-add-product", Gs);
    }
    if (!customElements.get("radio-swatch")) {
        customElements.define("radio-swatch", Ps);
    }
    if (!customElements.get("grid-swatch")) {
        customElements.define("grid-swatch", xs);
    }
    if (!customElements.get("product-siblings")) {
        customElements.define("product-siblings", Ds);
    }
    if (!customElements.get("hover-images")) {
        customElements.define("hover-images", _s);
    }
    const Ys = { fields: 'input:not([type="checkbox"]):not([type="hidden"]), textarea', fieldEmail: 'input[type="email"]', fieldCheckbox: 'input[type="checkbox"]', form: "[data-form-wrapper]" };
    class Qs extends HTMLElement {
        constructor() {
            super();
            this.fieldCheckbox = this.querySelector(Ys.fieldCheckbox);
            this.fieldEmail = this.querySelector(Ys.fieldEmail);
            this.fields = this.querySelectorAll(Ys.fields);
            this.form = this.closest(Ys.form);
            this.onChangeEvent = (e) => this.onChange(e);
        }
        connectedCallback() {
            if (this.fieldCheckbox) {
                this.fieldCheckbox.addEventListener("change", this.onChangeEvent);
                if (this.form) {
                    this.form.addEventListener("theme:product:add", () => {
                        this.fieldCheckbox.checked = false;
                        this.fieldCheckbox.dispatchEvent(new Event("change"));
                    });
                }
            }
        }
        clearInputValues() {
            if (this.fields.length) {
                this.fields.forEach((e) => {
                    e.value = "";
                });
            }
        }
        onChange(e) {
            this.fieldEmail.required = Boolean(e.target.checked);
            if (!e.target.checked) {
                this.clearInputValues();
            }
        }
        disconnectedCallback() {
            this.fieldCheckbox.removeEventListener("change", this.onChangeEvent);
        }
    }
    const Ks = { productPage: ".product__page", formWrapper: "[data-form-wrapper]", headerSticky: "[data-header-sticky]", productMediaList: "[data-product-media-list]" };
    const Zs = { sticky: "is-sticky" };
    const eo = { stickyEnabled: "data-sticky-enabled" };
    window.theme.variables = { productPageSticky: false };
    const to = {};
    class io {
        constructor(e) {
            this.section = e;
            this.container = e.container;
            this.stickyEnabled = this.container.getAttribute(eo.stickyEnabled) === "true";
            this.formWrapper = this.container.querySelector(Ks.formWrapper);
            this.stickyScrollTop = 0;
            this.scrollLastPosition = 0;
            this.stickyDefaultTop = 0;
            this.currentPoint = 0;
            this.defaultTopBottomSpacings = 30;
            this.scrollTop = window.scrollY;
            this.scrollDirectionDown = true;
            this.requestAnimationSticky = null;
            this.stickyFormLoad = true;
            this.stickyFormLastHeight = null;
            this.onChangeCounter = 0;
            this.scrollEvent = (e) => this.scrollEvents(e);
            this.resizeEvent = (e) => this.resizeEvents(e);
            this.stickyFormEvent = (e) => this.stickyFormEvents(e);
            setTimeout(() => {
                this.init();
            }, 50);
        }
        init() {
            if (this.stickyEnabled) {
                this.stickyScrollCheck();
                document.addEventListener("theme:resize", this.resizeEvent);
            }
            this.initSticky();
        }
        initSticky() {
            if (theme.variables.productPageSticky) {
                this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition());
                this.formWrapper.addEventListener("theme:form:sticky", this.stickyFormEvent);
                document.addEventListener("theme:scroll", this.scrollEvent);
            }
        }
        stickyFormEvents(e) {
            this.removeAnimationFrameSticky();
            this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(e));
        }
        scrollEvents(e) {
            this.scrollTop = e.detail.position;
            this.scrollDirectionDown = e.detail.down;
            if (!this.requestAnimationSticky) {
                this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition());
            }
        }
        resizeEvents(e) {
            this.stickyScrollCheck();
            document.removeEventListener("theme:scroll", this.scrollEvent);
            this.formWrapper.removeEventListener("theme:form:sticky", this.stickyFormEvent);
            this.initSticky();
        }
        stickyScrollCheck() {
            const e = this.container.querySelector(`${Ks.productPage} ${Ks.formWrapper}`);
            if (!e) return;
            if (b()) {
                const t = this.container.querySelector(Ks.formWrapper);
                const i = this.container.querySelector(Ks.productMediaList);
                if (!t || !i) return;
                const s = t.offsetHeight;
                const o = i.offsetHeight;
                if (s < o) {
                    theme.variables.productPageSticky = true;
                    e.classList.add(Zs.sticky);
                } else {
                    theme.variables.productPageSticky = false;
                    e.classList.remove(Zs.sticky);
                }
            } else {
                theme.variables.productPageSticky = false;
                e.classList.remove(Zs.sticky);
            }
        }
        calculateStickyPosition(e = null) {
            const t = document.documentElement.hasAttribute("data-scroll-locked");
            if (t) {
                this.removeAnimationFrameSticky();
                return;
            }
            const i = Boolean(e && e.detail);
            const s = Boolean(i && e.detail.element && e.detail.element === "accordion");
            const o = this.formWrapper.offsetHeight;
            const n = window.innerHeight - o - this.defaultTopBottomSpacings;
            const r = Math.abs(this.scrollTop - this.scrollLastPosition);
            if (this.scrollDirectionDown) {
                this.stickyScrollTop -= r;
            } else {
                this.stickyScrollTop += r;
            }
            if (this.stickyFormLoad) {
                if (document.querySelector(Ks.headerSticky)) {
                    let { headerHeight: e } = l();
                    this.stickyDefaultTop = e;
                } else {
                    this.stickyDefaultTop = this.defaultTopBottomSpacings;
                }
                this.stickyScrollTop = this.stickyDefaultTop;
            }
            this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, n), this.stickyDefaultTop);
            const a = this.stickyScrollTop - this.currentPoint;
            this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + a * 0.5;
            this.formWrapper.style.setProperty("--sticky-top", `${this.currentPoint}px`);
            this.scrollLastPosition = this.scrollTop;
            this.stickyFormLoad = false;
            if ((s && this.onChangeCounter <= 10) || (s && this.stickyFormLastHeight !== o) || (this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky)) {
                if (s) {
                    this.onChangeCounter += 1;
                }
                if (s && this.stickyFormLastHeight !== o) {
                    this.onChangeCounter = 11;
                }
                this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(e));
            } else if (this.requestAnimationSticky) {
                this.removeAnimationFrameSticky();
            }
            this.stickyFormLastHeight = o;
        }
        removeAnimationFrameSticky() {
            if (this.requestAnimationSticky) {
                cancelAnimationFrame(this.requestAnimationSticky);
                this.requestAnimationSticky = null;
                this.onChangeCounter = 0;
            }
        }
        onUnload() {
            if (this.stickyEnabled) {
                document.removeEventListener("theme:resize", this.resizeEvent);
            }
            if (theme.variables.productPageSticky) {
                document.removeEventListener("theme:scroll", this.scrollEvent);
            }
        }
    }
    const so = {
        onLoad() {
            to[this.id] = new io(this);
        },
        onUnload() {
            to[this.id].onUnload();
        },
    };
    const oo = {
        buttonArrow: "[data-button-arrow]",
        deferredMediaButton: "[data-deferred-media-button]",
        focusedElement: "model-viewer, video, iframe, button, [href], input, [tabindex]",
        productMedia: "[data-image-id]",
        productMediaList: "[data-product-media-list]",
        section: "[data-section-type]",
    };
    const no = { arrows: "slider__arrows", dragging: "is-dragging", hidden: "hidden", isFocused: "is-focused", mediaActive: "media--active", mediaHidden: "media--hidden", mediaHiding: "media--hiding" };
    const ro = {
        activeMedia: "data-active-media",
        buttonPrev: "data-button-prev",
        buttonNext: "data-button-next",
        imageId: "data-image-id",
        mediaId: "data-media-id",
        type: "data-type",
        faderDesktop: "data-fader-desktop",
        faderMobile: "data-fader-mobile",
    };
    class ao extends HTMLElement {
        constructor() {
            super();
            this.initialized = false;
            this.buttons = false;
            this.isDown = false;
            this.startX = 0;
            this.startY = 0;
            this.scrollLeft = 0;
            this.onButtonArrowClick = (e) => this.buttonArrowClickEvent(e);
            this.container = this.closest(oo.section);
            this.handleMouseDown = this.handleMouseDown.bind(this);
            this.handleMouseLeave = this.handleMouseLeave.bind(this);
            this.handleMouseUp = this.handleMouseUp.bind(this);
            this.handleMouseMove = this.handleMouseMove.bind(this);
            this.handleKeyUp = this.handleKeyUp.bind(this);
            this.productMediaItems = this.querySelectorAll(oo.productMedia);
            this.productMediaList = this.querySelector(oo.productMediaList);
            this.setHeight = this.setHeight.bind(this);
            this.toggleEvents = this.toggleEvents.bind(this);
            this.selectMediaEvent = (e) => this.showMediaOnVariantSelect(e);
        }
        connectedCallback() {
            if (Object.keys(this.productMediaItems).length === 1) return;
            this.productMediaObserver();
            this.toggleEvents();
            this.listen();
            this.setHeight();
        }
        disconnectedCallback() {
            this.unlisten();
        }
        listen() {
            document.addEventListener("theme:resize:width", this.toggleEvents);
            document.addEventListener("theme:resize:width", this.setHeight);
            this.addEventListener("theme:media:select", this.selectMediaEvent);
        }
        unlisten() {
            document.removeEventListener("theme:resize:width", this.toggleEvents);
            document.removeEventListener("theme:resize:width", this.setHeight);
            this.removeEventListener("theme:media:select", this.selectMediaEvent);
        }
        toggleEvents() {
            const e = y();
            if ((e && this.hasAttribute(ro.faderMobile)) || (!e && this.hasAttribute(ro.faderDesktop))) {
                this.bindEventListeners();
            } else {
                this.unbindEventListeners();
            }
        }
        bindEventListeners() {
            if (this.initialized) return;
            this.productMediaList.addEventListener("mousedown", this.handleMouseDown);
            this.productMediaList.addEventListener("mouseleave", this.handleMouseLeave);
            this.productMediaList.addEventListener("mouseup", this.handleMouseUp);
            this.productMediaList.addEventListener("mousemove", this.handleMouseMove);
            this.productMediaList.addEventListener("touchstart", this.handleMouseDown, { passive: true });
            this.productMediaList.addEventListener("touchend", this.handleMouseUp, { passive: true });
            this.productMediaList.addEventListener("touchmove", this.handleMouseMove, { passive: true });
            this.productMediaList.addEventListener("keyup", this.handleKeyUp);
            this.initArrows();
            this.resetScrollPosition();
            this.initialized = true;
        }
        unbindEventListeners() {
            if (!this.initialized) return;
            this.productMediaList.removeEventListener("mousedown", this.handleMouseDown);
            this.productMediaList.removeEventListener("mouseleave", this.handleMouseLeave);
            this.productMediaList.removeEventListener("mouseup", this.handleMouseUp);
            this.productMediaList.removeEventListener("mousemove", this.handleMouseMove);
            this.productMediaList.removeEventListener("touchstart", this.handleMouseDown);
            this.productMediaList.removeEventListener("touchend", this.handleMouseUp);
            this.productMediaList.removeEventListener("touchmove", this.handleMouseMove);
            this.productMediaList.removeEventListener("keyup", this.handleKeyUp);
            this.removeArrows();
            this.initialized = false;
        }
        handleMouseDown(e) {
            this.isDown = true;
            this.startX = (e.pageX || e.changedTouches[0].screenX) - this.offsetLeft;
            this.startY = (e.pageY || e.changedTouches[0].screenY) - this.offsetTop;
        }
        handleMouseLeave() {
            if (!this.isDown) return;
            this.isDown = false;
        }
        handleMouseUp(e) {
            const t = (e.pageX || e.changedTouches[0].screenX) - this.offsetLeft;
            const i = (e.pageY || e.changedTouches[0].screenY) - this.offsetTop;
            const s = t - this.startX;
            const o = i - this.startY;
            const n = s > 0 ? 1 : -1;
            const r = this.getCurrentMedia().hasAttribute(ro.type) && this.getCurrentMedia().getAttribute(ro.type) === "image";
            if (Math.abs(s) > 10 && Math.abs(s) > Math.abs(o) && r) {
                n < 0 ? this.showNextImage() : this.showPreviousImage();
            }
            this.isDown = false;
            requestAnimationFrame(() => {
                this.classList.remove(no.dragging);
            });
        }
        handleMouseMove() {
            if (!this.isDown) return;
            this.classList.add(no.dragging);
        }
        handleKeyUp(e) {
            if (e.code === "ArrowLeft") {
                this.showPreviousImage();
            }
            if (e.code === "ArrowRight") {
                this.showNextImage();
            }
        }
        handleArrowsClickEvent() {
            this.querySelectorAll(oo.buttonArrow)?.forEach((e) => {
                e.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (e.target.hasAttribute(ro.buttonPrev)) {
                        this.showPreviousImage();
                    }
                    if (e.target.hasAttribute(ro.buttonNext)) {
                        this.showNextImage();
                    }
                });
            });
        }
        resetScrollPosition() {
            if (this.productMediaList.scrollLeft !== 0) {
                this.productMediaList.scrollLeft = 0;
            }
        }
        initArrows() {
            if (!this.buttons.length) {
                const e = document.createElement("div");
                e.classList.add(no.arrows);
                e.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next;
                this.productMediaList.append(e);
                this.buttons = this.querySelectorAll(oo.buttonArrow);
                this.buttonPrev = this.querySelector(`[${ro.buttonPrev}]`);
                this.buttonNext = this.querySelector(`[${ro.buttonNext}]`);
            }
            this.handleArrowsClickEvent();
            this.preloadImageOnArrowHover();
        }
        removeArrows() {
            this.querySelector(`.${no.arrows}`)?.remove();
        }
        preloadImageOnArrowHover() {
            this.buttonPrev?.addEventListener("mouseover", () => {
                const e = this.getPreviousMediaId();
                this.preloadImage(e);
            });
            this.buttonNext?.addEventListener("mouseover", () => {
                const e = this.getNextMediaId();
                this.preloadImage(e);
            });
        }
        preloadImage(e) {
            this.querySelector(`[${ro.mediaId}="${e}"] img`)?.setAttribute("loading", "eager");
        }
        showMediaOnVariantSelect(e) {
            const t = e.detail.id;
            this.setActiveMedia(t);
        }
        getCurrentMedia() {
            return this.querySelector(`${oo.productMedia}.${no.mediaActive}`);
        }
        getNextMediaId() {
            const e = this.getCurrentMedia();
            const t = e?.nextElementSibling.hasAttribute(ro.imageId) ? e?.nextElementSibling : this.querySelector(oo.productMedia);
            return t?.getAttribute(ro.mediaId);
        }
        getPreviousMediaId() {
            const e = this.getCurrentMedia();
            const t = this.productMediaItems.length - 1;
            const i = e?.previousElementSibling || this.productMediaItems[t];
            return i?.getAttribute(ro.mediaId);
        }
        showNextImage() {
            const e = this.getNextMediaId();
            this.selectMedia(e);
        }
        showPreviousImage() {
            const e = this.getPreviousMediaId();
            this.selectMedia(e);
        }
        selectMedia(e) {
            this.dispatchEvent(new CustomEvent("theme:media:select", { detail: { id: e } }));
        }
        setActiveMedia(e) {
            if (!e) return;
            this.setAttribute(ro.activeMedia, e);
            const t = this.querySelector(`${oo.productMedia}.${no.mediaActive}`);
            const i = this.querySelector(`[${ro.mediaId}="${e}"]`);
            const s = i?.querySelector(oo.focusedElement);
            const o = i.querySelector("deferred-media");
            t?.classList.add(no.mediaHiding);
            t?.classList.remove(no.mediaActive);
            i?.classList.remove(no.mediaHiding, no.mediaHidden);
            i?.classList.add(no.mediaActive);
            if (o && o.getAttribute("loaded") !== true) {
                i.querySelector(oo.deferredMediaButton)?.dispatchEvent(new Event("click", { bubbles: false }));
            }
            requestAnimationFrame(() => {
                this.setHeight();
                if (document.body.classList.contains(no.isFocused)) {
                    s?.focus();
                }
            });
        }
        setHeight() {
            const e = this.querySelector(`${oo.productMedia}.${no.mediaActive}`)?.offsetHeight || this.productMediaItems[0]?.offsetHeight;
            this.style.setProperty("--height", `${e}px`);
        }
        productMediaObserver() {
            this.productMediaItems.forEach((e) => {
                e.addEventListener("transitionend", (t) => {
                    if (t.target == e && e.classList.contains(no.mediaHiding)) {
                        e.classList.remove(no.mediaHiding);
                        e.classList.add(no.mediaHidden);
                    }
                });
                e.addEventListener("transitioncancel", (t) => {
                    if (t.target == e && e.classList.contains(no.mediaHiding)) {
                        e.classList.remove(no.mediaHiding);
                        e.classList.add(no.mediaHidden);
                    }
                });
            });
        }
    }
    const lo = (e) => {
        if (e) {
            e.style.display = "none";
        }
    };
    const co = {
        optionPosition: "data-option-position",
        optionInput: '[name^="options"], [data-popout-option]',
        optionInputCurrent: '[name^="options"]:checked, [name^="options"][type="hidden"]',
        selectOptionValue: "data-value",
        popout: "[data-popout]",
    };
    const ho = { soldOut: "sold-out", unavailable: "unavailable", sale: "sale" };
    class uo {
        constructor(e, t) {
            this.container = e;
            this.productJSON = t;
            this.optionElements = this.container.querySelectorAll(co.optionInput);
            if (this.productJSON && this.optionElements.length) {
                this.init();
            }
        }
        init() {
            this.update();
        }
        update() {
            this.getCurrentState();
            this.optionElements.forEach((e) => {
                const t = e.closest(`[${co.optionPosition}]`);
                if (!t) return;
                const i = e.value || e.getAttribute(co.selectOptionValue);
                const s = t.getAttribute(co.optionPosition);
                const o = parseInt(s, 10) - 1;
                const n = e.closest(co.popout);
                let r = [...this.selections];
                r[o] = i;
                const a = this.productJSON.variants.find((e) => {
                    let t = true;
                    for (let i = 0; i < r.length; i++) {
                        if (e.options[i] !== r[i]) {
                            t = false;
                        }
                    }
                    return t;
                });
                e.classList.remove(ho.soldOut, ho.unavailable);
                e.parentNode.classList.remove(ho.sale);
                if (n) {
                    n.classList.remove(ho.soldOut, ho.unavailable, ho.sale);
                }
                if (typeof a === "undefined") {
                    e.classList.add(ho.unavailable);
                    if (n) {
                        n.classList.add(ho.unavailable);
                    }
                } else if (a && a.available === false) {
                    e.classList.add(ho.soldOut);
                    if (n) {
                        n.classList.add(ho.soldOut);
                    }
                }
                if (a && a.compare_at_price > a.price && theme.settings.variantOnSale) {
                    e.parentNode.classList.add(ho.sale);
                }
            });
        }
        getCurrentState() {
            this.selections = [];
            const e = this.container.querySelectorAll(co.optionInputCurrent);
            if (e.length) {
                e.forEach((e) => {
                    const t = e.value;
                    if (t && t !== "") {
                        this.selections.push(t);
                    }
                });
            }
        }
    }
    const po = {
        product: "[data-product]",
        productForm: "[data-product-form]",
        productNotification: "product-notification",
        variantTitle: "[data-variant-title]",
        notificationProduct: "[data-notification-product]",
        addToCart: "[data-add-to-cart]",
        addToCartText: "[data-add-to-cart-text]",
        cartPage: "[data-cart-page]",
        comparePrice: "[data-compare-price]",
        comparePriceText: "[data-compare-text]",
        formWrapper: "[data-form-wrapper]",
        originalSelectorId: "[data-product-select]",
        priceWrapper: "[data-price-wrapper]",
        productImages: "product-images",
        productImage: "[data-product-image]",
        productMediaList: "[data-product-media-list]",
        productJson: "[data-product-json]",
        productPrice: "[data-product-price]",
        unitPrice: "[data-product-unit-price]",
        unitBase: "[data-product-base]",
        unitWrapper: "[data-product-unit]",
        isPreOrder: "[data-product-preorder]",
        productSlide: ".product__slide",
        subPrices: "[data-subscription-watch-price]",
        subSelectors: "[data-subscription-selectors]",
        subsToggle: "[data-toggles-group]",
        subsChild: "data-group-toggle",
        subDescription: "[data-plan-description]",
        section: "[data-section-type]",
        variantSku: "[data-variant-sku]",
        variantBarcode: "[data-variant-barcode]",
        variantFinalSaleMeta: "[data-variant-final-sale-metafield]",
        variantButtons: "[data-variant-buttons]",
        variantOptionImage: "[data-variant-option-image]",
        quickAddModal: "[data-quick-add-modal]",
        priceOffWrap: "[data-price-off]",
        priceOffType: "[data-price-off-type]",
        priceOffAmount: "[data-price-off-amount]",
        remainingCount: "[data-remaining-count]",
        remainingMax: "[data-remaining-max]",
        remainingWrapper: "[data-remaining-wrapper]",
        remainingJSON: "[data-product-remaining-json]",
        optionValue: "[data-option-value]",
        optionPosition: "[data-option-position]",
        installment: "[data-product-form-installment]",
        inputId: 'input[name="id"]',
    };
    const mo = {
        hidden: "hidden",
        variantSoldOut: "variant--soldout",
        variantUnavailable: "variant--unavailable",
        productPriceSale: "product__price--sale",
        remainingLow: "count-is-low",
        remainingIn: "count-is-in",
        remainingOut: "count-is-out",
        remainingUnavailable: "count-is-unavailable",
    };
    const fo = {
        remainingMaxAttr: "data-remaining-max",
        enableHistoryState: "data-enable-history-state",
        notificationPopup: "data-notification-popup",
        faderDesktop: "data-fader-desktop",
        faderMobile: "data-fader-mobile",
        optionPosition: "data-option-position",
        imageId: "data-image-id",
        mediaId: "data-media-id",
        quickAddButton: "data-quick-add-btn",
        finalSale: "data-final-sale",
        variantImageScroll: "data-variant-image-scroll",
    };
    class go extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.cartAddEvents();
            this.container = this.closest(po.section) || this.closest(po.quickAddModal);
            if (!this.container) return;
            this.sectionId = this.container.dataset.sectionId;
            this.product = this.container.querySelector(po.product);
            this.productForm = this.container.querySelector(po.productForm);
            this.productNotification = this.container.querySelector(po.productNotification);
            this.productImages = this.container.querySelector(po.productImages);
            this.productMediaList = this.container.querySelector(po.productMediaList);
            this.installmentForm = this.container.querySelector(po.installment);
            this.skuWrapper = this.container.querySelector(po.variantSku);
            this.barcodeWrapper = this.container.querySelector(po.variantBarcode);
            this.sellout = null;
            this.variantImageScroll = this.container.getAttribute(fo.variantImageScroll) === "true";
            this.priceOffWrap = this.container.querySelector(po.priceOffWrap);
            this.priceOffAmount = this.container.querySelector(po.priceOffAmount);
            this.priceOffType = this.container.querySelector(po.priceOffType);
            this.planDescription = this.container.querySelector(po.subDescription);
            this.remainingWrapper = this.container.querySelector(po.remainingWrapper);
            if (this.remainingWrapper) {
                const e = this.container.querySelector(po.remainingMax);
                if (e) {
                    this.remainingMaxInt = parseInt(e.getAttribute(fo.remainingMaxAttr), 10);
                    this.remainingCount = this.container.querySelector(po.remainingCount);
                    this.remainingJSONWrapper = this.container.querySelector(po.remainingJSON);
                    this.remainingJSON = null;
                    if (this.remainingJSONWrapper && this.remainingJSONWrapper.innerHTML !== "") {
                        this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML);
                    } else {
                        console.warn("Missing product quantity JSON");
                    }
                }
            }
            this.enableHistoryState = this.container.getAttribute(fo.enableHistoryState) === "true";
            this.hasUnitPricing = this.container.querySelector(po.unitWrapper);
            this.subSelectors = this.container.querySelector(po.subSelectors);
            this.subPrices = this.container.querySelector(po.subPrices);
            this.isPreOrder = this.container.querySelector(po.isPreOrder);
            let e = null;
            const t = this.container.querySelector(po.productJson);
            if (t) {
                e = t.innerHTML;
            }
            if (e) {
                this.productJSON = JSON.parse(e);
                this.linkForm();
                this.sellout = new uo(this.container, this.productJSON);
            } else {
                console.error("Missing product JSON");
            }
            this.variantOptionImages = this.container.querySelectorAll(po.variantOptionImage);
            this.variantButtons = this.container.querySelectorAll(po.variantButtons);
            if (this.variantOptionImages.length > 1) {
                this.optionImagesWidth();
            }
        }
        cartAddEvents() {
            this.buttonATC = this.querySelector(po.addToCart);
            this.buttonATC.addEventListener("click", (e) => {
                e.preventDefault();
                document.dispatchEvent(new CustomEvent("theme:cart:add", { detail: { button: this.buttonATC }, bubbles: false }));
                if (!this.closest(po.quickAddModal)) {
                    window.accessibility.lastElement = this.buttonATC;
                }
            });
        }
        destroy() {
            this.productForm.destroy();
        }
        linkForm() {
            this.productForm = new Ss(this.container, this.productJSON, { onOptionChange: this.onOptionChange.bind(this), onPlanChange: this.onPlanChange.bind(this) });
            this.pushState(this.productForm.getFormState(), true);
            this.subsToggleListeners();
        }
        onOptionChange(e) {
            this.pushState(e.dataset);
            this.updateProductImage(e);
        }
        onPlanChange(e) {
            if (this.subPrices) {
                this.pushState(e.dataset);
            }
        }
        pushState(e, t = false) {
            this.productState = this.setProductState(e);
            this.updateAddToCartState(e);
            this.updateNotificationForm(e);
            this.updateProductPrices(e);
            this.updateSaleText(e);
            this.updateSku(e);
            this.updateBarcode(e);
            this.updateSubscriptionText(e);
            this.updateRemaining(e);
            this.updateLegend(e);
            this.fireHookEvent(e);
            this.sellout?.update(e);
            if (this.enableHistoryState && !t) {
                this.updateHistoryState(e);
            }
        }
        updateAddToCartState(e) {
            const t = e.variant;
            let i = theme.strings.addToCart;
            const s = this.container.querySelectorAll(po.priceWrapper);
            const o = this.container.querySelectorAll(po.addToCart);
            const n = this.container.querySelectorAll(po.addToCartText);
            const r = this.container.querySelectorAll(po.formWrapper);
            if (this.installmentForm && t) {
                const e = this.installmentForm.querySelector(po.inputId);
                e.value = t.id;
                e.dispatchEvent(new Event("change", { bubbles: true }));
            }
            if (this.isPreOrder) {
                i = theme.strings.preOrder;
            }
            if (s.length && t) {
                s.forEach((e) => {
                    e.classList.remove(mo.hidden);
                });
            }
            o?.forEach((e) => {
                if (e.hasAttribute(fo.quickAddButton)) return;
                if (t) {
                    if (t.available) {
                        e.disabled = false;
                    } else {
                        e.disabled = true;
                    }
                } else {
                    e.disabled = true;
                }
            });
            n?.forEach((e) => {
                let s = i;
                if (t) {
                    if (!t.available) {
                        s = theme.strings.soldOut;
                    }
                } else {
                    s = theme.strings.unavailable;
                }
                e.textContent = s;
            });
            if (r.length) {
                r.forEach((e) => {
                    if (t) {
                        if (t.available) {
                            e.classList.remove(mo.variantSoldOut, mo.variantUnavailable);
                        } else {
                            e.classList.add(mo.variantSoldOut);
                            e.classList.remove(mo.variantUnavailable);
                        }
                        const i = e.querySelector(po.originalSelectorId);
                        if (i) {
                            i.value = t.id;
                        }
                        const s = e.querySelector(`${po.inputId}[form]`);
                        if (s) {
                            s.value = t.id;
                            s.dispatchEvent(new Event("change"));
                        }
                    } else {
                        e.classList.add(mo.variantUnavailable);
                        e.classList.remove(mo.variantSoldOut);
                    }
                });
            }
        }
        updateNotificationForm(e) {
            if (!this.productNotification) return;
            const t = this.productNotification.querySelector(po.variantTitle);
            const i = this.productNotification.querySelector(po.notificationProduct);
            if (t != null) {
                t.textContent = e.variant.title;
                i.value = e.variant.name;
            }
        }
        updateHistoryState(e) {
            const t = e.variant;
            const i = e.plan;
            const s = window.location.href;
            if (t && s.includes("/product")) {
                const e = new window.URL(s);
                const o = e.searchParams;
                o.set("variant", t.id);
                if (i && i.detail && i.detail.id && this.productState.hasPlan) {
                    o.set("selling_plan", i.detail.id);
                } else {
                    o.delete("selling_plan");
                }
                e.search = o.toString();
                const n = e.toString();
                window.history.replaceState({ path: n }, "", n);
            }
        }
        updateRemaining(e) {
            const t = e.variant;
            this.remainingWrapper?.classList.remove(mo.remainingIn, mo.remainingOut, mo.remainingUnavailable, mo.remainingLow);
            if (t && this.remainingWrapper && this.remainingJSON) {
                const e = this.remainingJSON[t.id];
                if (e === "out" || e < 1) {
                    this.remainingWrapper.classList.add(mo.remainingOut);
                }
                if (e === "in" || e >= this.remainingMaxInt) {
                    this.remainingWrapper.classList.add(mo.remainingIn);
                }
                if (e === "low" || (e > 0 && e < this.remainingMaxInt)) {
                    this.remainingWrapper.classList.add(mo.remainingLow);
                    if (this.remainingCount) {
                        this.remainingCount.innerHTML = e;
                    }
                }
            } else if (!t && this.remainingWrapper) {
                this.remainingWrapper.classList.add(mo.remainingUnavailable);
            }
        }
        optionImagesWidth() {
            if (!this.variantButtons) return;
            let e = 0;
            requestAnimationFrame(() => {
                this.variantOptionImages.forEach((t) => {
                    const i = t.clientWidth;
                    if (i > e) {
                        e = i;
                    }
                });
                this.variantButtons.forEach((t) => {
                    t.style?.setProperty("--option-image-width", e + "px");
                });
            });
        }
        getBaseUnit(e) {
            return e.unit_price_measurement.reference_value === 1 ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
        }
        subsToggleListeners() {
            const e = this.container.querySelectorAll(po.subsToggle);
            e.forEach((e) => {
                e.addEventListener(
                    "change",
                    function (e) {
                        const t = e.target.value.toString();
                        const i = this.container.querySelector(`[${po.subsChild}="${t}"]`);
                        const s = this.container.querySelectorAll(`[${po.subsChild}]`);
                        if (i) {
                            i.classList.remove(mo.hidden);
                            const e = i.querySelector(`[name="selling_plan"]`);
                            e.checked = true;
                            e.dispatchEvent(new Event("change"));
                        }
                        s.forEach((e) => {
                            if (e !== i) {
                                e.classList.add(mo.hidden);
                                const t = e.querySelectorAll(`[name="selling_plan"]`);
                                t.forEach((e) => {
                                    e.checked = false;
                                    e.dispatchEvent(new Event("change"));
                                });
                            }
                        });
                    }.bind(this)
                );
            });
        }
        updateSaleText(e) {
            if (this.productState.planSale) {
                this.updateSaleTextSubscription(e);
            } else if (this.productState.onSale) {
                this.updateSaleTextStandard(e);
            } else if (this.priceOffWrap) {
                this.priceOffWrap.classList.add(mo.hidden);
            }
        }
        isVariantFinalSale(e) {
            const t = document.querySelector(po.variantFinalSaleMeta).textContent;
            const i = JSON.parse(t);
            let s = false;
            i.forEach((t) => {
                if (Number(t.variant_id) === e.id) {
                    s = t.metafield_value === "true";
                }
            });
            return s;
        }
        updateSaleTextStandard(e) {
            const t = e.variant;
            if (this.priceOffType) {
                this.priceOffType.innerHTML = window.theme.strings.sale || "sale";
            }
            if (this.priceOffAmount && this.priceOffWrap) {
                const e = (t.compare_at_price - t.price) / t.compare_at_price;
                const i = Math.floor(e * 100);
                this.priceOffAmount.innerHTML = `${i}%`;
                this.priceOffWrap.classList.remove(mo.hidden);
            }
            if (this.priceOffWrap.hasAttribute(fo.finalSale) || this.isVariantFinalSale(t)) {
                this.priceOffWrap.classList.remove(mo.hidden);
            } else {
                this.priceOffWrap.classList.add(mo.hidden);
            }
        }
        updateSubscriptionText(e) {
            if (e.plan && this.planDescription) {
                this.planDescription.innerHTML = e.plan.detail.description;
                this.planDescription.classList.remove(mo.hidden);
            } else if (this.planDescription) {
                this.planDescription.classList.add(mo.hidden);
            }
        }
        updateSaleTextSubscription(e) {
            if (this.priceOffType) {
                this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton";
            }
            if (this.priceOffAmount && this.priceOffWrap) {
                const t = e.plan.detail.price_adjustments[0];
                const i = t.value;
                if (t && t.value_type === "percentage") {
                    this.priceOffAmount.innerHTML = `${i}%`;
                } else {
                    this.priceOffAmount.innerHTML = Je(i, theme.moneyFormat);
                }
                this.priceOffWrap.classList.remove(mo.hidden);
            }
        }
        updateProductPrices(e) {
            const t = e.variant;
            const i = e.plan;
            const s = this.container.querySelectorAll(po.priceWrapper);
            s.forEach((e) => {
                const s = e.querySelector(po.comparePrice);
                const o = e.querySelector(po.productPrice);
                const n = e.querySelector(po.comparePriceText);
                let r = "";
                let a = "";
                // WPD
                try{
                    o.classList.remove("wpd-processed");
                    o.setAttribute("data-wpd-variant-compare-at-price",t.compare_at_price == null ? "":t.compare_at_price);
                    o.setAttribute("data-wpd-variant-price",t.price);
                    o.setAttribute("data-wpd-variant-id",t.id);
                    o.setAttribute("data-wpd-product-handle",window.wpdExtensionIsProductPage.handle);
                  }catch(e){}
              
                if (this.productState.available) {
                    r = t.compare_at_price;
                    a = t.price;
                }
                if (this.productState.hasPlan) {
                    a = i.allocation.price;
                }
                if (this.productState.planSale) {
                    r = i.allocation.compare_at_price;
                    a = i.allocation.price;
                }
                if (s) {
                    if (this.productState.onSale || this.productState.planSale) {
                        s.classList.remove(mo.hidden);
                        n.classList.remove(mo.hidden);
                        o.classList.add(mo.productPriceSale);
                    } else {
                        s.classList.add(mo.hidden);
                        n.classList.add(mo.hidden);
                        o.classList.remove(mo.productPriceSale);
                    }
                    s.innerHTML = Je(r, theme.moneyFormat);
                }
                o.innerHTML = a === 0 ? window.theme.strings.free : Je(a, theme.moneyFormat);
            });
            if (this.hasUnitPricing) {
                this.updateProductUnits(e);
            }
        }
        updateProductUnits(e) {
            const t = e.variant;
            const i = e.plan;
            let s = null;
            if (t && t.unit_price) {
                s = t.unit_price;
            }
            if (i && i.allocation && i.allocation.unit_price) {
                s = i.allocation.unit_price;
            }
            if (s) {
                const e = this.getBaseUnit(t);
                const i = Je(s, theme.moneyFormat);
                this.container.querySelector(po.unitPrice).innerHTML = i;
                this.container.querySelector(po.unitBase).innerHTML = e;
                Re(this.container.querySelector(po.unitWrapper));
            } else {
                lo(this.container.querySelector(po.unitWrapper));
            }
        }
        updateSku(e) {
            if (!this.skuWrapper) return;
            this.skuWrapper.innerHTML = `${theme.strings.sku}: ${e.variant.sku}`;
        }
        updateBarcode(e) {
            if (!this.barcodeWrapper) return;
            this.barcodeWrapper.innerHTML = `${theme.strings.barcode}: ${e.variant.barcode}`;
        }
        fireHookEvent(e) {
            const t = e.variant;
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", { detail: { variant: t }, bubbles: true }));
        }
        setProductState(e) {
            const t = e.variant;
            const i = e.plan;
            const s = { available: true, soldOut: false, onSale: false, showUnitPrice: false, requiresPlan: false, hasPlan: false, planPerDelivery: false, planSale: false };
            if (!t || (t.requires_selling_plan && !i)) {
                s.available = false;
            } else {
                if (!t.available) {
                    s.soldOut = true;
                }
                if (t.compare_at_price > t.price) {
                    s.onSale = true;
                }
                if (t.unit_price) {
                    s.showUnitPrice = true;
                }
                if (this.product && this.product.requires_selling_plan) {
                    s.requiresPlan = true;
                }
                if (i && this.subPrices) {
                    s.hasPlan = true;
                    if (i.allocation.per_delivery_price !== i.allocation.price) {
                        s.planPerDelivery = true;
                    }
                    if (t.price > i.allocation.price) {
                        s.planSale = true;
                    }
                }
            }
            return s;
        }
        updateProductImage(e) {
            const t = e.dataset.variant;
            if (t) {
                if (t.featured_media) {
                    const e = this.container.querySelector(`[${fo.imageId}="${t.featured_media.id}"]`);
                    if (e) {
                        const t = e.getAttribute(fo.mediaId);
                        const i = b();
                        e.dispatchEvent(new CustomEvent("theme:media:select", { bubbles: true, detail: { id: t } }));
                        if (i && !this.productImages.hasAttribute(fo.faderDesktop) && this.variantImageScroll) {
                            const t = e.getBoundingClientRect().top;
                            document.dispatchEvent(new CustomEvent("theme:tooltip:close", { bubbles: false, detail: { hideTransition: false } }));
                            ni(t);
                        }
                        if (!i && !this.productImages.hasAttribute(fo.faderMobile)) {
                            this.productMediaList.scrollTo({ left: e.offsetLeft });
                        }
                    }
                }
            }
        }
        updateLegend(e) {
            const t = e.variant;
            if (t) {
                const e = this.container.querySelectorAll(po.optionValue);
                if (e.length) {
                    e.forEach((e) => {
                        const i = e.closest(po.optionPosition);
                        if (i) {
                            const s = i.getAttribute(fo.optionPosition);
                            const o = parseInt(s, 10) - 1;
                            const n = t.options[o];
                            e.innerHTML = n;
                        }
                    });
                }
            }
        }
    }
    const vo = { open: "[data-popup-open]", close: "[data-popup-close]", focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])' };
    const bo = { closing: "closing" };
    class yo {
        constructor(e, t, i = true, s = true) {
            this.popup = e;
            this.holder = t;
            this.a11y = te;
            this.isAnimating = false;
            this.showModal = i;
            this.enableScrollLock = s;
            this.buttonPopupOpen = this.holder?.querySelector(vo.open);
            this.popupEvents();
        }
        popupOpen() {
            if (!this.popup) return;
            this.isAnimating = true;
            if (this.showModal && typeof this.popup.showModal === "function") {
                this.popup.showModal();
            } else if (!this.showModal && typeof this.popup.show === "function") {
                this.popup.show();
            } else {
                this.popup.setAttribute("open", "");
            }
            this.popup.removeAttribute("inert");
            this.popup.focus();
            if (this.enableScrollLock) {
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));
            }
            it(this.popup).then(() => {
                this.isAnimating = false;
                if (this.enableScrollLock) {
                    this.a11y.trapFocus(this.popup);
                }
                const e = this.popup.querySelector("[autofocus]") || this.popup.querySelector(vo.focusable);
                e?.focus();
            });
        }
        popupClose() {
            if (this.isAnimating || !this.popup || this.popup.hasAttribute("inert")) {
                return;
            }
            if (!this.popup.hasAttribute(bo.closing)) {
                this.popup.setAttribute(bo.closing, "");
                this.isAnimating = true;
                it(this.popup).then(() => {
                    this.isAnimating = false;
                    this.popupClose();
                });
                return;
            }
            if (typeof this.popup.close === "function") {
                this.popup.close();
            } else {
                this.popup.removeAttribute("open");
            }
            this.popupCloseActions();
        }
        popupCloseActions() {
            if (this.popup.hasAttribute("inert")) return;
            this.popup.setAttribute("inert", "");
            this.popup.removeAttribute(bo.closing);
            if (!Us() && this.enableScrollLock) {
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
            }
            this.popup.dispatchEvent(new CustomEvent("theme:popup:onclose", { bubbles: false }));
            if (this.enableScrollLock) {
                this.a11y.removeTrapFocus();
                this.a11y.autoFocusLastElement();
            }
        }
        popupEvents() {
            if (!this.popup) return;
            this.buttonPopupOpen?.addEventListener("click", (e) => {
                e.preventDefault();
                this.popupOpen();
                window.accessibility.lastElement = this.buttonPopupOpen;
            });
            const e = this.popup.querySelectorAll(vo.close);
            if (e.length) {
                e.forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault();
                        this.popupClose();
                    });
                });
            }
            if (this.showModal) {
                this.popup.addEventListener("click", (e) => {
                    if (e.target.nodeName === "DIALOG" && e.type === "click") {
                        this.popupClose();
                    }
                });
            }
            this.popup.addEventListener("keydown", (e) => {
                if (e.code === "Escape") {
                    e.preventDefault();
                    this.popupClose();
                }
            });
            this.popup.addEventListener("close", () => this.popupCloseActions());
        }
    }
    const wo = { dialog: "dialog" };
    class So extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            new yo(this.querySelector(wo.dialog), this, true, true);
        }
    }
    class Eo extends Ce {
        constructor() {
            super();
        }
        loadContent() {
            super.loadContent();
            Shopify.loadFeatures([{ name: "model-viewer-ui", version: "1.0", onLoad: this.setupModelViewerUI.bind(this) }]);
        }
        setupModelViewerUI(e) {
            if (e) return;
            this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer"));
        }
    }
    window.ProductModel = {
        loadShopifyXR() {
            Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: this.setupShopifyXR.bind(this) }]);
        },
        setupShopifyXR(e) {
            if (e) return;
            if (!window.ShopifyXR) {
                document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR());
                return;
            }
            document.querySelectorAll('[id^="ModelJSON-"]').forEach((e) => {
                window.ShopifyXR.addModels(JSON.parse(e.textContent));
                e.remove();
            });
            window.ShopifyXR.setupXRElements();
        },
    };
    window.addEventListener("DOMContentLoaded", () => {
        if (window.ProductModel) window.ProductModel.loadShopifyXR();
    });
    const Lo = {
        addToCart: "[data-add-to-cart]",
        productImage: "[data-product-image]",
        productJson: "[data-product-json]",
        form: "[data-product-form]",
        cartBar: "#cart-bar",
        productNotificationPopupButton: "[data-popup-open]",
        productSubmitAdd: ".product__submit__add",
        formWrapper: "[data-form-wrapper]",
        productVariants: "[data-product-variants]",
        slider: "[data-slider]",
    };
    const ko = { expanded: "is-expanded", visible: "is-visible", loading: "is-loading", added: "is-added" };
    const Ao = {
        cartBarEnabled: "data-cart-bar-enabled",
        cartBarAdd: "data-add-to-cart-bar",
        cartBarScroll: "data-cart-bar-scroll",
        cartBarProductNotification: "data-cart-bar-product-notification",
        sectionId: "data-section-id",
        sliderIndex: "data-slider-index",
    };
    const Co = {};
    class To {
        constructor(e) {
            this.section = e;
            this.container = e.container;
            this.id = this.container.getAttribute(Ao.sectionId);
            this.sliders = this.container.querySelectorAll(Lo.slider);
            this.slider = [];
            this.formWrapper = this.container.querySelector(Lo.formWrapper);
            this.cartBarEnabled = this.container.hasAttribute(Ao.cartBarEnabled);
            this.cartBar = this.container.querySelector(Lo.cartBar);
            this.setCartBarHeight = this.setCartBarHeight.bind(this);
            this.scrollToTop = this.scrollToTop.bind(this);
            this.toggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this);
            this.unlockTimer = 0;
            this.accessibility = te;
            const t = this.container.querySelector(Lo.productJson);
            if ((t && !t.innerHTML) || !t) {
                return;
            }
            const i = JSON.parse(t.innerHTML).handle;
            let s = {};
            if (i) {
                s = { handle: i };
            }
            Shopify.Products.recordRecentlyViewed(s);
            this.form = this.container.querySelector(Lo.form);
            if (this.sliders.length) {
                this.sliders.forEach((e, t) => {
                    e.setAttribute(Ao.sliderIndex, t);
                    this.slider.push(new si(this.container, e));
                });
            }
            if (this.cartBarEnabled) {
                this.initCartBar();
                this.setCartBarHeight();
                document.addEventListener("theme:scroll", this.toggleCartBarOnScroll);
                document.addEventListener("theme:resize", this.setCartBarHeight);
            }
        }
        initCartBar() {
            this.cartBarBtns = this.cartBar.querySelectorAll(Lo.productSubmitAdd);
            if (this.cartBarBtns.length > 0) {
                this.cartBarBtns.forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault();
                        if (e.currentTarget.hasAttribute(Ao.cartBarAdd)) {
                            if (this.cartBarEnabled) {
                                e.currentTarget.classList.add(ko.loading);
                                e.currentTarget.setAttribute("disabled", "disabled");
                            }
                            this.form.querySelector(Lo.addToCart).dispatchEvent(new Event("click", { bubbles: true }));
                        } else if (e.currentTarget.hasAttribute(Ao.cartBarScroll)) {
                            this.scrollToTop();
                        } else if (e.currentTarget.hasAttribute(Ao.cartBarProductNotification)) {
                            this.container.querySelector(Lo.productNotificationPopupButton).dispatchEvent(new Event("click"));
                        }
                    });
                    if (e.hasAttribute(Ao.cartBarAdd)) {
                        document.addEventListener("theme:product:add-error", this.scrollToTop);
                    }
                });
            }
            this.setCartBarHeight();
        }
        scrollToTop() {
            const e = this.container.querySelector(Lo.productVariants);
            const t = b() ? this.container : e ? e : this.form;
            const i = t.getBoundingClientRect().top;
            ni(b() ? i : i - 10);
        }
        toggleCartBarOnScroll() {
            const e = window.scrollY;
            const t = theme.variables.productPageSticky && this.formWrapper ? this.formWrapper : this.form;
            if (t && this.cartBar) {
                const i = t.offsetTop;
                const s = t.offsetHeight;
                const o = e > i + s;
                this.cartBar.classList.toggle(ko.visible, o);
            }
        }
        setCartBarHeight() {
            const e = this.cartBar.offsetHeight;
            document.documentElement.style.setProperty("--cart-bar-height", `${e}px`);
        }
        onUnload() {
            document.removeEventListener("theme:product:add-error", this.scrollToTop);
            if (this.cartBarEnabled) {
                document.removeEventListener("theme:scroll", this.toggleCartBarOnScroll);
                document.removeEventListener("theme:resize", this.setCartBarHeight);
            }
        }
        onBlockSelect(e) {
            const t = e.srcElement.closest(Lo.slider);
            if (t && this.slider.length) {
                const i = t.hasAttribute(Ao.sliderIndex) ? t.getAttribute(Ao.sliderIndex) : 0;
                if (!this.slider[i]) return;
                this.slider[i].onBlockSelect(e);
            }
        }
        onBlockDeselect(e) {
            const t = e.srcElement.closest(Lo.slider);
            if (t && this.slider.length) {
                const i = t.hasAttribute(Ao.sliderIndex) ? t.getAttribute(Ao.sliderIndex) : 0;
                if (!this.slider[i]) return;
                this.slider[i].onBlockDeselect(e);
            }
        }
    }
    const qo = {
        onLoad() {
            Co[this.id] = new To(this);
        },
        onUnload(e) {
            Co[this.id].onUnload(e);
        },
        onBlockSelect(e) {
            Co[this.id].onBlockSelect(e);
        },
        onBlockDeselect(e) {
            Co[this.id].onBlockDeselect(e);
        },
    };
    Ft("product", [qo, Yt, Vs, so]);
    if (!customElements.get("product-form")) {
        customElements.define("product-form", go);
    }
    if (!customElements.get("product-images")) {
        customElements.define("product-images", ao);
    }
    if (!customElements.get("product-modal")) {
        customElements.define("product-modal", So);
    }
    if (!customElements.get("product-model")) {
        customElements.define("product-model", Eo);
    }
    if (!customElements.get("product-siblings")) {
        customElements.define("product-siblings", Ds);
    }
    if (!customElements.get("radio-swatch")) {
        customElements.define("radio-swatch", Ps);
    }
    if (!customElements.get("recipient-form")) {
        customElements.define("recipient-form", Qs);
    }
    const Io = {
        apiRelatedProductsTemplate: "[data-api-related-template]",
        relatedSection: "[data-related-section]",
        relatedProduct: "[data-grid-item]",
        recentlyViewed: "[data-recent-wrapper]",
        recentlyViewedWrapper: "[data-recently-viewed-wrapper]",
        productItem: ".product-item",
        slider: "grid-slider",
    };
    const Po = { limit: "data-limit", minimum: "data-minimum", productId: "data-product-id" };
    const xo = { isHidden: "is-hidden", gridMobileSlider: "grid--mobile-slider" };
    const Mo = {};
    class Ho {
        constructor(e) {
            this.section = e;
            this.sectionId = e.id;
            this.container = e.container;
            this.related();
            this.recent();
        }
        related() {
            const e = this.container.querySelector(Io.relatedSection);
            if (!e) {
                return;
            }
            const t = e.getAttribute(Po.productId);
            const i = e.getAttribute(Po.limit);
            const s = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${i}&product_id=${t}&intent=related`;
            fetch(s)
                .then((e) => e.text())
                .then((t) => {
                    const i = document.createElement("div");
                    i.innerHTML = new DOMParser().parseFromString(t, "text/html").querySelector(Io.apiRelatedProductsTemplate).innerHTML;
                    const s = i.querySelector(Io.relatedProduct);
                    if (s) {
                        e.innerHTML = i.innerHTML;
                        const t = parseInt(e.style.getPropertyValue("--COLUMNS-MOBILE"));
                        if (t === 0) {
                            const t = e.querySelector(Io.relatedProduct);
                            t.parentElement.classList.add(xo.gridMobileSlider);
                        }
                    } else {
                        e.dispatchEvent(new CustomEvent("theme:tab:hide", { bubbles: true }));
                    }
                })
                .catch(function () {
                    e.dispatchEvent(new CustomEvent("theme:tab:hide", { bubbles: true }));
                });
        }
        recent() {
            const e = this.container.querySelector(Io.recentlyViewed);
            const t = e ? parseInt(e.getAttribute(Po.limit)) : 4;
            Shopify.Products.showRecentlyViewed({
                howManyToShow: t,
                wrapperId: `recently-viewed-products-${this.sectionId}`,
                section: this.section,
                target: "api-product-grid-item",
                onComplete: (e, t) => {
                    const i = t.container;
                    if (!i) return;
                    const s = i.querySelector(Io.recentlyViewed);
                    const o = i.querySelector(Io.recentlyViewedWrapper);
                    const n = e.querySelectorAll(Io.productItem);
                    const r = s.querySelector(Io.slider);
                    const a = s.hasAttribute(Po.minimum) ? parseInt(s.getAttribute(Po.minimum)) : 4;
                    const l = !o && n.length > 0;
                    const c = o && n.length >= a;
                    if (l || c) {
                        if (c) {
                            o.classList.remove(xo.isHidden);
                        }
                        s.classList.remove("is-hidden");
                        s.dispatchEvent(new CustomEvent("theme:tab:check", { bubbles: true }));
                        if (r) {
                            r.dispatchEvent(new CustomEvent("theme:grid-slider:init", { bubbles: true }));
                        }
                    }
                },
            });
        }
    }
    const Oo = {
        onLoad() {
            Mo[this.id] = new Ho(this);
        },
    };
    Ft("related", [Oo, Vs]);
    Ft("reviews", [oi, ns]);
    const Bo = {};
    const Do = { sliderLogos: "[data-slider-logos]", sliderText: "[data-slider-text]", slide: "[data-slide]" };
    const Fo = { isSelected: "is-selected", isInitialized: "is-initialized", flickityEnabled: "flickity-enabled" };
    const _o = { slideData: "data-slide", slideIndex: "data-slide-index" };
    class $o {
        constructor(e) {
            this.container = e.container;
            this.slideshowNav = this.container.querySelector(Do.sliderLogos);
            this.slideshowText = this.container.querySelector(Do.sliderText);
            this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState();
            this.flkty = null;
            this.flktyNav = null;
            this.logoSlides = this.slideshowNav.querySelectorAll(Do.slide);
            this.logoSlidesWidth = this.getSlidesWidth();
            this.initSlideshowText();
            this.initSlideshowNav();
        }
        getSlidesWidth() {
            const e = this.logoSlides.length;
            const t = 200;
            return e * t;
        }
        initSlideshowText() {
            if (!this.slideshowText) return;
            this.flkty = new s(this.slideshowText, {
                fade: true,
                autoPlay: false,
                prevNextButtons: false,
                cellAlign: "left",
                contain: true,
                pageDots: false,
                wrapAround: false,
                selectedAttraction: 0.2,
                friction: 0.6,
                draggable: false,
                accessibility: false,
                on: { ready: () => this.sliderAccessibility(), change: () => this.sliderAccessibility() },
            });
        }
        sliderAccessibility() {
            const e = this.slideshowText.querySelectorAll(`${Do.slide} a, ${Do.slide} button`);
            if (e.length) {
                e.forEach((e) => {
                    const t = e.closest(Do.slide);
                    if (t) {
                        const i = t.classList.contains(Fo.isSelected) ? 0 : -1;
                        e.setAttribute("tabindex", i);
                    }
                });
            }
        }
        initSlideshowNav() {
            if (!this.slideshowNav) return;
            if (this.logoSlides.length) {
                this.logoSlides.forEach((e) => {
                    e.addEventListener("click", () => {
                        const t = parseInt(e.getAttribute(_o.slideIndex));
                        const i = this.slideshowNav.classList.contains(Fo.flickityEnabled);
                        if (this.flkty) {
                            this.flkty.select(t);
                        }
                        if (i) {
                            this.flktyNav.select(t);
                            if (!this.slideshowNav.classList.contains(Fo.isSelected)) {
                                this.flktyNav.playPlayer();
                            }
                        } else {
                            const t = this.slideshowNav.querySelector(`.${Fo.isSelected}`);
                            if (t) {
                                t.classList.remove(Fo.isSelected);
                            }
                            e.classList.add(Fo.isSelected);
                        }
                    });
                });
            }
            this.setSlideshowNavState();
            document.addEventListener("theme:resize", this.setSlideshowNavStateOnResize);
        }
        setSlideshowNavState() {
            const e = this.slideshowNav.classList.contains(Fo.flickityEnabled);
            if (this.logoSlidesWidth > g()) {
                if (!e) {
                    this.slideshowNav.classList.add(Fo.isInitialized);
                    const e = this.slideshowNav.querySelector(`.${Fo.isSelected}`);
                    if (e) {
                        e.classList.remove(Fo.isSelected);
                    }
                    this.logoSlides[0].classList.add(Fo.isSelected);
                    if (!this.flktyNav) {
                        this.flktyNav = new i(this.slideshowNav, { autoPlay: 4e3, prevNextButtons: false, contain: false, pageDots: false, wrapAround: true, watchCSS: true, selectedAttraction: 0.05, friction: 0.8, initialIndex: 0 });
                        this.flktyNav.on("deactivate", () => {
                            this.slideshowNav.querySelector(Do.slide).classList.add(Fo.isSelected);
                            if (this.flkty) {
                                this.flkty.select(0);
                            }
                        });
                        if (this.flkty) {
                            this.flkty.select(0);
                            this.flktyNav.on("change", (e) => this.flkty.select(e));
                        }
                    }
                }
            } else if (e) {
                this.slideshowNav.classList.remove(Fo.isInitialized);
            }
        }
        onBlockSelect(e) {
            if (!this.slideshowNav) return;
            const t = this.slideshowNav.querySelector(`[${_o.slideData}="${e.detail.blockId}"]`);
            const i = parseInt(t.getAttribute(_o.slideIndex));
            if (this.slideshowNav.classList.contains(Fo.flickityEnabled)) {
                this.flktyNav.select(i);
                this.flktyNav.stopPlayer();
                this.slideshowNav.classList.add(Fo.isSelected);
            } else {
                t.dispatchEvent(new Event("click"));
            }
        }
        onBlockDeselect() {
            if (this.slideshowNav && this.slideshowNav.classList.contains(Fo.flickityEnabled)) {
                this.flktyNav.playPlayer();
                this.slideshowNav.classList.remove(Fo.isSelected);
            }
        }
        onUnload() {
            document.removeEventListener("theme:resize", this.setSlideshowNavStateOnResize);
        }
    }
    const No = {
        onLoad() {
            Bo[this.id] = new $o(this);
        },
        onUnload(e) {
            Bo[this.id].onUnload(e);
        },
        onBlockSelect(e) {
            Bo[this.id].onBlockSelect(e);
        },
        onBlockDeselect(e) {
            Bo[this.id].onBlockDeselect(e);
        },
    };
    Ft("logos", [No, ns]);
    function Wo(e, t, i) {
        let s = document.getElementsByTagName("head")[0];
        let o = false;
        let n = document.createElement("script");
        n.src = e;
        n.onload = n.onreadystatechange = function () {
            if (!o && (!this.readyState || this.readyState == "loaded" || this.readyState == "complete")) {
                o = true;
                t();
            } else {
                i();
            }
        };
        s.appendChild(n);
    }
    const Ro = {};
    window.isYoutubeAPILoaded = false;
    window.isVimeoAPILoaded = false;
    function Vo(e = {}) {
        if (!e.type) {
            e.type = "json";
        }
        if (e.url) {
            if (Ro[e.url]) {
                return Ro[e.url];
            } else {
                return Uo(e.url, e.type);
            }
        } else if (e.json) {
            if (Ro[e.json]) {
                return Promise.resolve(Ro[e.json]);
            } else {
                return window
                    .fetch(e.json)
                    .then((e) => e.json())
                    .then((t) => {
                        Ro[e.json] = t;
                        return t;
                    });
            }
        } else if (e.name) {
            const t = "".concat(e.name, e.version);
            if (Ro[t]) {
                return Ro[t];
            } else {
                return zo(e);
            }
        } else {
            return Promise.reject();
        }
    }
    function Uo(e, t) {
        const i = new Promise((i, s) => {
            if (t === "text") {
                fetch(e)
                    .then((e) => e.text())
                    .then((e) => {
                        i(e);
                    })
                    .catch((e) => {
                        s(e);
                    });
            } else {
                Wo(
                    e,
                    function () {
                        i();
                    },
                    function () {
                        s();
                    }
                );
            }
        });
        Ro[e] = i;
        return i;
    }
    function zo(e) {
        const t = "".concat(e.name, e.version);
        const i = new Promise((t, i) => {
            try {
                window.Shopify.loadFeatures([
                    {
                        name: e.name,
                        version: e.version,
                        onLoad: (e) => {
                            jo(t, i, e);
                        },
                    },
                ]);
            } catch (e) {
                i(e);
            }
        });
        Ro[t] = i;
        return i;
    }
    function jo(e, t, i) {
        if (i) {
            return t(i);
        } else {
            return e();
        }
    }
    const Jo = { popupContainer: ".pswp", popupCloseBtn: ".pswp__custom-close", popupIframe: "iframe, video", popupThumbs: ".pswp__thumbs", popupButtons: ".pswp__button, .pswp__caption-close" };
    const Xo = { current: "is-current", customLoader: "pswp--custom-loader", customOpen: "pswp--custom-opening", loader: "pswp__loader", popupCloseButton: "pswp__button--close", isFocused: "is-focused" };
    const Go = { dataOptionClasses: "data-pswp-option-classes", ariaCurrent: "aria-current" };
    const Yo = `<div class="${Xo.loader}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
    class Qo {
        constructor(e, t = "") {
            this.items = e;
            this.pswpElement = document.querySelectorAll(Jo.popupContainer)[0];
            this.popup = null;
            this.popupThumbs = null;
            this.popupThumbsContainer = this.pswpElement.querySelector(Jo.popupThumbs);
            this.closeBtn = this.pswpElement.querySelector(Jo.popupCloseBtn);
            this.keyupCloseEvent = (e) => this.keyupClose(e);
            this.a11y = te;
            const i = { history: false, focus: false, mainClass: "" };
            this.options = t !== "" ? t : i;
            this.init();
        }
        init() {
            this.pswpElement.classList.add(Xo.customOpen);
            this.initLoader();
            Vo({ url: window.theme.assets.photoswipe })
                .then(() => this.loadPopup())
                .catch((e) => console.error(e));
        }
        initLoader() {
            if (this.pswpElement.classList.contains(Xo.customLoader) && this.options !== "" && this.options.mainClass) {
                this.pswpElement.setAttribute(Go.dataOptionClasses, this.options.mainClass);
                let e = document.createElement("div");
                e.innerHTML = Yo;
                e = e.firstChild;
                this.pswpElement.appendChild(e);
            } else {
                this.pswpElement.setAttribute(Go.dataOptionClasses, "");
            }
        }
        loadPopup() {
            const e = window.themePhotoswipe.PhotoSwipe.default;
            const t = window.themePhotoswipe.PhotoSwipeUI.default;
            if (this.pswpElement.classList.contains(Xo.customLoader)) {
                this.pswpElement.classList.remove(Xo.customLoader);
            }
            this.pswpElement.classList.remove(Xo.customOpen);
            this.popup = new e(this.pswpElement, t, this.items, this.options);
            this.popup.init();
            this.thumbsActions();
            if (document.body.classList.contains(Xo.isFocused)) {
                setTimeout(() => {
                    this.a11y.trapFocus(this.pswpElement, { elementToFocus: this.closeBtn });
                }, 200);
            }
            this.popup.listen("close", () => this.onClose());
            if (this.options && this.options.closeElClasses && this.options.closeElClasses.length) {
                this.options.closeElClasses.forEach((e) => {
                    const t = this.pswpElement.querySelector(`.pswp__${e}`);
                    if (t) {
                        t.addEventListener("keyup", this.keyupCloseEvent);
                    }
                });
            }
        }
        thumbsActions() {
            if (!this.popupThumbsContainer || !this.popupThumbsContainer.children.length) return;
            this.popupThumbsContainer.addEventListener("wheel", (e) => this.stopDisabledScroll(e));
            this.popupThumbsContainer.addEventListener("mousewheel", (e) => this.stopDisabledScroll(e));
            this.popupThumbsContainer.addEventListener("DOMMouseScroll", (e) => this.stopDisabledScroll(e));
            this.popupThumbs = this.pswpElement.querySelectorAll(`${Jo.popupThumbs} > *`);
            this.popupThumbs.forEach((e, t) => {
                e.addEventListener("click", (i) => {
                    i.preventDefault();
                    const s = e.parentElement.querySelector(`.${Xo.current}`);
                    s.classList.remove(Xo.current);
                    s.setAttribute(Go.ariaCurrent, false);
                    e.classList.add(Xo.current);
                    e.setAttribute(Go.ariaCurrent, true);
                    this.popup.goTo(t);
                });
            });
            this.popup.listen("imageLoadComplete", () => this.setCurrentThumb());
            this.popup.listen("beforeChange", () => this.setCurrentThumb());
        }
        stopDisabledScroll(e) {
            e.stopPropagation();
        }
        keyupClose(e) {
            if (e.code === "Enter") {
                this.popup.close();
            }
        }
        onClose() {
            const e = this.pswpElement.querySelector(Jo.popupIframe);
            if (e) {
                e.parentNode.removeChild(e);
            }
            if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) {
                while (this.popupThumbsContainer.firstChild) this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
            }
            this.pswpElement.setAttribute(Go.dataOptionClasses, "");
            const t = this.pswpElement.querySelector(`.${Xo.loader}`);
            if (t) {
                this.pswpElement.removeChild(t);
            }
            if (this.options && this.options.closeElClasses && this.options.closeElClasses.length) {
                this.options.closeElClasses.forEach((e) => {
                    const t = this.pswpElement.querySelector(`.pswp__${e}`);
                    if (t) {
                        t.removeEventListener("keyup", this.keyupCloseEvent);
                    }
                });
            }
            this.a11y.removeTrapFocus();
            this.a11y.autoFocusLastElement();
        }
        setCurrentThumb() {
            const e = this.pswpElement.querySelector(`${Jo.popupThumbs} > .${Xo.current}`);
            if (e) {
                e.classList.remove(Xo.current);
                e.setAttribute(Go.ariaCurrent, false);
            }
            if (!this.popupThumbs) return;
            const t = this.popupThumbs[this.popup.getCurrentIndex()];
            t.classList.add(Xo.current);
            t.setAttribute(Go.ariaCurrent, true);
            this.scrollThumbs(t);
        }
        scrollThumbs(e) {
            const t = this.popupThumbsContainer.scrollLeft;
            const i = this.popupThumbsContainer.offsetWidth;
            const s = t + i;
            const o = e.offsetLeft;
            const n = e.offsetWidth;
            const r = o + n;
            if (s <= r || s > o) {
                const t = parseInt(window.getComputedStyle(e).marginLeft);
                this.popupThumbsContainer.scrollTo({ top: 0, left: o - t, behavior: "smooth" });
            }
        }
    }
    const Ko = { videoPlay: "data-video-play" };
    class Zo extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.videoPlay = this.querySelectorAll(`[${Ko.videoPlay}]`);
            this.videoPlay?.forEach((e) => {
                e.addEventListener("click", (e) => {
                    const t = e.currentTarget;
                    if (t.getAttribute(Ko.videoPlay).trim() !== "") {
                        e.preventDefault();
                        const i = [{ html: t.getAttribute(Ko.videoPlay) }];
                        const s = { mainClass: "pswp--video" };
                        new Qo(i, s);
                        window.accessibility.lastElement = t;
                    }
                });
            });
        }
    }
    const en = { videoTemplate: "[data-video-template]" };
    const tn = { loading: "is-loading" };
    const sn = { videoId: "data-video-id" };
    class on extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.videoId = this.getAttribute(sn.videoId);
            this.videoTemplate = this.querySelector(en.videoTemplate);
            this.video = null;
            this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this);
            if (this.videoId) {
                this.renderVideo();
            }
        }
        powerSaverVideoPlay() {
            this.video?.play();
        }
        renderVideo() {
            this.videoTemplateObserver = new IntersectionObserver(
                (e, t) => {
                    e.forEach((e) => {
                        if (e.isIntersecting) {
                            const i = this.videoTemplate.innerHTML;
                            this.innerHTML = i;
                            this.classList.remove(tn.loading);
                            this.video = this.querySelector("video");
                            this.observeVideoPlayToggle();
                            this.video
                                .play()
                                .then(() => {})
                                .catch(() => {
                                    document.addEventListener("click", this.powerSaverVideoPlay, { passive: true, bubbles: true, once: true });
                                    document.addEventListener("touchstart", this.powerSaverVideoPlay, { passive: true, bubbles: true, once: true });
                                });
                            t.unobserve(e.target);
                        }
                    });
                },
                { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
            );
            this.videoTemplateObserver.observe(this);
        }
        observeVideoPlayToggle() {
            if (!this.video) return;
            const e = { rootMargin: "0px", threshold: [0, 1] };
            this.videoPlayObserver = new IntersectionObserver((e) => {
                e.forEach((e) => {
                    const t = e.isIntersecting;
                    if (t && typeof this.video.play === "function") {
                        const e = this.video.play();
                        if (e !== undefined) {
                            e.then((e) => {}).catch((e) => {});
                        }
                    }
                    if (!t && typeof this.video.pause === "function") {
                        this.video.pause();
                    }
                });
            }, e);
            this.videoPlayObserver.observe(this.video);
        }
        disconnectedCallback() {
            if (this.videoTemplateObserver) {
                this.videoTemplateObserver.disconnect();
            }
            if (this.videoPlayObserver) {
                this.videoPlayObserver.disconnect();
            }
            if (this.videoId) {
                document.removeEventListener("click", this.powerSaverVideoPlay);
                document.removeEventListener("touchstart", this.powerSaverVideoPlay);
            }
        }
    }
    Ft("featured-video", [Kt]);
    if (!customElements.get("video-background")) {
        customElements.define("video-background", on);
    }
    if (!customElements.get("video-popup")) {
        customElements.define("video-popup", Zo);
    }
    Ft("slideshow", [oi, Kt]);
    const nn = { imagesContainer: "[data-images-container]", imageHolder: "[data-image-holder]", imageElement: "[data-image-element]", rangeButton: "[data-range-button]", rangeInput: "[data-range-input]" };
    class rn extends HTMLElement {
        constructor() {
            super();
            this.imageHolder = this.querySelector(nn.imageHolder);
            this.imageElement = this.querySelector(nn.imageElement);
            this.rangeButton = this.querySelector(nn.rangeButton);
            this.rangeInput = this.querySelector(nn.rangeInput);
            this.setOverlapImageSize = this.setOverlapImageSize.bind(this);
        }
        connectedCallback() {
            this.setOverlapImageSize();
            this.setImagePosition();
            this.rangeInput.addEventListener("input", () => this.setImagePosition());
            document.addEventListener("theme:resize", this.setOverlapImageSize);
        }
        disconnectedCallback() {
            document.removeEventListener("theme:resize", this.setOverlapImageSize);
        }
        setImagePosition() {
            const e = this.rangeInput.value;
            const t = this.imageElement.offsetWidth;
            const i = this.rangeButton.offsetWidth;
            this.rangeButton.style.left = `${e}%`;
            this.imageHolder.style.width = `${((t - i) * (100 - e)) / 100 + i / 2}px`;
        }
        setOverlapImageSize() {
            const e = this.offsetWidth;
            this.imageElement.style.width = `${e}px`;
            this.setImagePosition();
        }
    }
    Ft("custom-content", [oi, Kt, ui]);
    if (!customElements.get("video-background")) {
        customElements.define("video-background", on);
    }
    if (!customElements.get("video-popup")) {
        customElements.define("video-popup", Zo);
    }
    if (!customElements.get("compare-images")) {
        customElements.define("compare-images", rn);
    }
    var an = {};
    an.basic = [];
    an.light = [
        { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "simplified" }, { lightness: "64" }, { hue: "#ff0000" }] },
        { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
        { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
        { featureType: "landscape", elementType: "all", stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }] },
        { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
        { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
        { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
        { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
        { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
        { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
        { featureType: "poi.park", elementType: "geometry", stylers: [{ saturation: "-41" }, { color: "#e8ede7" }] },
        { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
        { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
        { featureType: "road", elementType: "labels", stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }] },
        { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
        { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
        { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }, { visibility: "simplified" }] },
        { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
        { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
        { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
        { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
        { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
        { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
        { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }] },
        { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "simplified" }, { weight: "0.01" }, { lightness: "39" }] },
        { featureType: "road.local", elementType: "labels.text.stroke", stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }] },
        { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
        { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
    ];
    an.white_label = [
        { featureType: "all", elementType: "all", stylers: [{ visibility: "simplified" }] },
        { featureType: "all", elementType: "labels", stylers: [{ visibility: "simplified" }] },
        { featureType: "administrative", elementType: "labels", stylers: [{ gamma: "3.86" }, { lightness: "100" }] },
        { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#cccccc" }] },
        { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
        { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
        { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
        { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
        { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
        { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
        { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
        { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
        { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
        { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
        { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
        { featureType: "road.local", elementType: "labels.text", stylers: [{ visibility: "off" }] },
        { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
        { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
    ];
    an.dark_label = [
        { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
        { featureType: "all", elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }] },
        { featureType: "all", elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }] },
        { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
        { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 20 }] },
        { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }] },
        { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "simplified" }, { lightness: "-82" }] },
        { featureType: "administrative", elementType: "labels.text.stroke", stylers: [{ invert_lightness: true }, { weight: "7.15" }] },
        { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
        { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
        { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
        { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
        { featureType: "road", elementType: "labels", stylers: [{ visibility: "simplified" }] },
        { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }] },
        { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }] },
        { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
        { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 18 }] },
        { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
        { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
        { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
        { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] },
        { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
        { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
        { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
    ];
    function ln(e) {
        return an[e];
    }
    window.theme.allMaps = window.theme.allMaps || {};
    let cn = window.theme.allMaps;
    window.theme.mapAPI = window.theme.mapAPI || null;
    class dn {
        constructor(e) {
            this.container = e.container;
            this.mapContainer = this.container.querySelector("[data-map-container]");
            this.key = this.container.getAttribute("data-api-key");
            this.styleString = this.container.getAttribute("data-style") || "";
            this.zoomString = this.container.getAttribute("data-zoom") || 14;
            this.address = this.container.getAttribute("data-address");
            this.enableCorrection = this.container.getAttribute("data-latlong-correction");
            this.lat = this.container.getAttribute("data-lat");
            this.long = this.container.getAttribute("data-long");
            if (this.key) {
                this.initMaps();
            }
        }
        initMaps() {
            const e = un(this.key);
            e.then(() => (this.enableCorrection === "true" && this.lat !== "" && this.long !== "" ? new google.maps.LatLng(this.lat, this.long) : mn(this.address)))
                .then((e) => {
                    const t = parseInt(this.zoomString, 10);
                    const i = ln(this.styleString);
                    const s = { zoom: t, styles: i, center: e, draggable: true, clickableIcons: false, scrollwheel: false, zoomControl: false, disableDefaultUI: true };
                    const o = pn(this.mapContainer, s);
                    return o;
                })
                .then((e) => {
                    this.map = e;
                    cn[this.id] = e;
                })
                .catch((e) => {
                    console.log("Failed to load Google Map");
                    console.log(e);
                });
        }
        unload() {
            if (typeof window.google !== "undefined") {
                google.maps.event.clearListeners(this.map, "resize");
            }
        }
    }
    const hn = {
        onLoad() {
            cn[this.id] = new dn(this);
        },
        onUnload() {
            if (typeof cn[this.id].unload === "function") {
                cn[this.id].unload();
            }
        },
    };
    Ft("map", hn);
    function un(e) {
        if (window.theme.mapAPI === null) {
            const t = `https://maps.googleapis.com/maps/api/js?key=${e}`;
            window.theme.mapAPI = Vo({ url: t });
        }
        return window.theme.mapAPI;
    }
    function pn(e, t) {
        var i = new google.maps.Map(e, t);
        var s = i.getCenter();
        new google.maps.Marker({ map: i, position: s });
        google.maps.event.addDomListener(window, "resize", function () {
            google.maps.event.trigger(i, "resize");
            i.setCenter(s);
        });
        return i;
    }
    function mn(e) {
        return new Promise((t, i) => {
            var s = new google.maps.Geocoder();
            s.geocode({ address: e }, function (e, s) {
                if (s == "OK") {
                    var o = { lat: e[0].geometry.location.lat(), lng: e[0].geometry.location.lng() };
                    t(o);
                } else {
                    i(s);
                }
            });
        });
    }
    const fn = {
        largePromo: "[data-large-promo]",
        largePromoInner: "[data-large-promo-inner]",
        trackingInner: "[data-tracking-consent-inner]",
        tracking: "[data-tracking-consent]",
        trackingAccept: "[data-confirm-cookies]",
        cartBar: "cart-bar",
        newsletterPopup: "[data-newsletter]",
        newsletterPopupHolder: "[data-newsletter-holder]",
        newsletterHeading: "[data-newsletter-heading]",
        newsletterField: "[data-newsletter-field]",
        promoPopup: "[data-promo-text]",
        newsletterForm: "[data-newsletter-form]",
        delayAttribite: "data-popup-delay",
        cookieNameAttribute: "data-cookie-name",
        dataTargetReferrer: "data-target-referrer",
    };
    const gn = {
        hidden: "hidden",
        hasValue: "has-value",
        cartBarVisible: "cart-bar-visible",
        isVisible: "is-visible",
        success: "has-success",
        selected: "selected",
        hasBlockSelected: "has-block-selected",
        mobile: "mobile",
        desktop: "desktop",
        bottom: "bottom",
    };
    const vn = { enable: "data-enable" };
    let bn = {};
    class yn {
        constructor(e, t, i) {
            this.element = t;
            this.delay = e.getAttribute(fn.delayAttribite);
            this.isSubmitted = window.location.href.indexOf("accepts_marketing") !== -1 || window.location.href.indexOf("customer_posted=true") !== -1;
            this.popupActions = i;
            this.showPopupOnScrollEvent = () => this.showPopupOnScroll();
            if (this.delay === "always" || this.isSubmitted) {
                this.always();
            }
            if (this.delay && this.delay.includes("delayed") && !this.isSubmitted) {
                const e = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
                this.delayed(e);
            }
            if (this.delay === "bottom" && !this.isSubmitted) {
                this.bottom();
            }
            if (this.delay === "idle" && !this.isSubmitted) {
                this.idle();
            }
        }
        always() {
            this.popupActions.popupOpen();
        }
        delayed(e = 10) {
            setTimeout(() => {
                this.popupActions.popupOpen();
            }, e * 1e3);
        }
        idle() {
            let e = 0;
            let t = 6e4;
            const i = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"];
            const s = ["load", "resize", "scroll"];
            const o = () => {
                e = setTimeout(() => {
                    e = 0;
                    this.popupActions.popupOpen();
                }, t);
                i.forEach((e) => {
                    document.addEventListener(e, n);
                });
                s.forEach((e) => {
                    window.addEventListener(e, n);
                });
            };
            const n = () => {
                if (e) {
                    clearTimeout(e);
                }
                i.forEach((e) => {
                    document.removeEventListener(e, n);
                });
                s.forEach((e) => {
                    window.removeEventListener(e, n);
                });
                o();
            };
            o();
        }
        bottom() {
            document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
        }
        showPopupOnScroll() {
            if (window.scrollY + window.innerHeight >= document.body.clientHeight) {
                this.popupActions.popupOpen();
                document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
            }
        }
        onUnload() {
            document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
        }
    }
    class wn {
        constructor(e) {
            this.el = e;
            this.locationPath = location.href;
            if (!this.el.hasAttribute(fn.dataTargetReferrer)) {
                return false;
            }
            this.init();
        }
        init() {
            if (this.locationPath.indexOf(this.el.getAttribute(fn.dataTargetReferrer)) === -1 && !window.Shopify.designMode) {
                this.el.parentNode.removeChild(this.el);
            }
        }
    }
    class Sn {
        constructor(e) {
            this.popup = e;
            this.modal = this.popup.querySelector(fn.largePromoInner);
            this.form = this.popup.querySelector(fn.newsletterForm);
            this.cookie = new ri(this.popup.getAttribute(fn.cookieNameAttribute), "user_has_closed");
            this.isTargeted = new wn(this.popup);
            this.popupActions = new yo(this.modal, this.modal, true, true);
            this.a11y = te;
            this.init();
        }
        init() {
            const e = this.cookie.read() !== false;
            const t = this.popup.classList.contains(gn.mobile);
            const i = this.popup.classList.contains(gn.desktop);
            const s = !b();
            let o = true;
            if ((t && !s) || (i && s)) {
                o = false;
            }
            if (!o) {
                this.a11y.removeTrapFocus();
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true }));
                return;
            }
            if (!e || window.Shopify.designMode) {
                if (!window.Shopify.designMode && !window.location.pathname.endsWith("/challenge")) {
                    new yn(this.popup, this.modal, this.popupActions);
                }
                if (this.form && this.form.classList.contains(gn.success)) {
                    this.checkForSuccess();
                }
                this.modal.addEventListener("theme:popup:onclose", () => this.cookie.write());
            }
        }
        checkForSuccess() {
            this.popupActions.popupOpen();
            this.cookie.write();
        }
        onBlockSelect(e) {
            if (this.popup.contains(e.target)) {
                this.popupActions.popupOpen();
                this.popup.classList.add(gn.selected);
                this.popup.parentNode.classList.add(gn.hasBlockSelected);
            }
        }
        onBlockDeselect(e) {
            if (this.popup.contains(e.target)) {
                this.popupActions.popupClose();
                this.popup.classList.remove(gn.selected);
                this.popup.parentNode.classList.remove(gn.hasBlockSelected);
            }
        }
    }
    class En {
        constructor(e) {
            this.popup = e;
            this.modal = document.querySelector(fn.tracking);
            this.acceptButton = this.modal.querySelector(fn.trackingAccept);
            this.enable = this.modal.getAttribute(vn.enable) === "true";
            this.showPopup = false;
            this.popupActions = new yo(this.popup, this.popup, false, false);
            window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (e) => {
                if (e) {
                    throw e;
                }
                const t = window.Shopify.customerPrivacy.userCanBeTracked();
                const i = window.Shopify.customerPrivacy.getTrackingConsent();
                this.showPopup = !t && i === "no_interaction" && this.enable;
                if (window.Shopify.designMode) {
                    this.showPopup = true;
                }
                this.init();
            });
        }
        init() {
            if (this.showPopup) {
                this.popupActions.popupOpen();
            }
            this.clickEvents();
        }
        clickEvents() {
            this.acceptButton.addEventListener("click", (e) => {
                e.preventDefault();
                window.Shopify.customerPrivacy.setTrackingConsent(true, () => this.popupActions.popupClose());
                document.documentElement.style.setProperty("--cookie-bar-height", "0px");
            });
            document.addEventListener("trackingConsentAccepted", () => {});
        }
        onSelect() {
            if (this.showPopup) {
                this.popupActions.popupOpen();
                this.popup.classList.add(gn.selected);
                this.popup.parentNode.classList.add(gn.hasBlockSelected);
            }
        }
        onDeselect() {
            if (this.showPopup) {
                this.popupActions.popupClose();
                this.popup.classList.remove(gn.selected);
                this.popup.parentNode.classList.remove(gn.hasBlockSelected);
            }
        }
    }
    class Ln {
        constructor(e) {
            this.popup = e;
            this.cookie = new ri(this.popup.getAttribute(fn.cookieNameAttribute), "user_has_closed");
            this.isTargeted = new wn(this.popup);
            this.popupActions = new yo(this.popup, this.popup, false, false);
            this.init();
        }
        init() {
            const e = this.cookie.read() !== false;
            if (!e || window.Shopify.designMode) {
                if (!window.Shopify.designMode) {
                    new yn(this.popup, this.popup, this.popupActions);
                } else {
                    this.popupActions.popupOpen();
                }
                this.popup.addEventListener("theme:popup:onclose", () => this.cookie.write());
            }
        }
        onSelect() {
            this.popupActions.popupOpen();
            this.popup.classList.add(gn.selected);
            this.popup.parentNode.classList.add(gn.hasBlockSelected);
        }
        onDeselect() {
            this.popupActions.popupClose();
            this.popup.classList.remove(gn.selected);
            this.popup.parentNode.classList.remove(gn.hasBlockSelected);
        }
    }
    class kn {
        constructor(e) {
            this.popup = e;
            this.holder = this.popup.querySelector(fn.newsletterPopupHolder);
            this.heading = this.popup.querySelector(fn.newsletterHeading);
            this.newsletterField = this.popup.querySelector(fn.newsletterField);
            this.cookie = new ri(this.popup.getAttribute(fn.cookieNameAttribute), "newsletter_is_closed");
            this.form = this.popup.querySelector(fn.newsletterForm);
            this.isTargeted = new wn(this.popup);
            this.popupActions = new yo(this.holder, this.holder, false, false);
            this.resetClassTimer = 0;
            this.init();
        }
        init() {
            const e = this.cookie.read() !== false;
            const t = window.location.search.indexOf("?customer_posted=true") !== -1;
            const i = [...this.holder.classList].toString();
            const s = i.includes(gn.bottom);
            if (t) {
                this.delay = 0;
            }
            if (!e || window.Shopify.designMode) {
                this.show();
                if (this.form.classList.contains(gn.success)) {
                    this.checkForSuccess();
                }
            }
            if (s) {
                this.observeCartBar();
            }
        }
        show() {
            if (!window.location.pathname.endsWith("/challenge")) {
                if (!window.Shopify.designMode) {
                    new yn(this.popup, this.holder, this.popupActions);
                } else {
                    this.popupActions.popupOpen();
                }
            }
            this.showForm();
            this.inputField();
            this.holder.addEventListener("theme:popup:onclose", () => this.cookie.write());
        }
        checkForSuccess() {
            this.popupActions.popupOpen();
            this.cookie.write();
        }
        observeCartBar() {
            this.cartBar = document.getElementById(fn.cartBar);
            if (!this.cartBar) return;
            const e = { attributes: true, childList: false, subtree: false };
            let t = this.cartBar.classList.contains(gn.isVisible);
            document.body.classList.toggle(gn.cartBarVisible, t);
            const i = (e) => {
                for (const i of e) {
                    if (i.type === "attributes") {
                        t = i.target.classList.contains(gn.isVisible);
                        document.body.classList.toggle(gn.cartBarVisible, t);
                    }
                }
            };
            this.observer = new MutationObserver(i);
            this.observer.observe(this.cartBar, e);
        }
        showForm() {
            this.heading.addEventListener("click", (e) => {
                e.preventDefault();
                this.heading.classList.add(gn.hidden);
                this.form.classList.remove(gn.hidden);
                this.newsletterField.focus();
            });
            this.heading.addEventListener("keyup", (e) => {
                if (e.code === "Enter") {
                    this.heading.dispatchEvent(new Event("click"));
                }
            });
        }
        inputField() {
            const e = () => {
                if (this.resetClassTimer) {
                    clearTimeout(this.resetClassTimer);
                }
                if (this.newsletterField.value !== "") {
                    this.holder.classList.add(gn.hasValue);
                }
            };
            const t = () => {
                if (this.resetClassTimer) {
                    clearTimeout(this.resetClassTimer);
                }
                this.resetClassTimer = setTimeout(() => {
                    this.holder.classList.remove(gn.hasValue);
                }, 2e3);
            };
            this.newsletterField.addEventListener("input", e);
            this.newsletterField.addEventListener("focus", e);
            this.newsletterField.addEventListener("focusout", t);
        }
        onBlockSelect(e) {
            if (this.popup.contains(e.target)) {
                this.popupActions.popupOpen();
                this.popup.classList.add(gn.selected);
                this.popup.parentNode.classList.add(gn.hasBlockSelected);
            }
        }
        onBlockDeselect(e) {
            if (this.popup.contains(e.target)) {
                this.popupActions.popupClose();
                this.popup.classList.remove(gn.selected);
                this.popup.parentNode.classList.remove(gn.hasBlockSelected);
            }
        }
        onUnload() {
            if (this.observer) {
                this.observer.disconnect();
            }
        }
    }
    const An = {
        onLoad() {
            bn[this.id] = [];
            const e = this.container.querySelectorAll(fn.largePromo);
            e.forEach((e) => {
                bn[this.id].push(new Sn(e));
            });
            const t = this.container.querySelectorAll(fn.tracking);
            t.forEach((e) => {
                bn[this.id].push(new En(e));
            });
            const i = this.container.querySelectorAll(fn.newsletterPopup);
            i.forEach((e) => {
                bn[this.id].push(new kn(e));
            });
            const s = this.container.querySelectorAll(fn.promoPopup);
            s.forEach((e) => {
                bn[this.id].push(new Ln(e));
            });
        },
        onBlockSelect(e) {
            bn[this.id].forEach((t) => {
                if (typeof t.onBlockSelect === "function") {
                    t.onBlockSelect(e);
                }
            });
        },
        onBlockDeselect(e) {
            bn[this.id].forEach((t) => {
                if (typeof t.onBlockDeselect === "function") {
                    t.onBlockDeselect(e);
                }
            });
        },
        onSelect() {
            bn[this.id].forEach((e) => {
                if (typeof e.onSelect === "function") {
                    e.onSelect();
                }
            });
        },
        onDeselect() {
            bn[this.id].forEach((e) => {
                if (typeof e.onDeselect === "function") {
                    e.onDeselect();
                }
            });
        },
        onUnload() {
            bn[this.id].forEach((e) => {
                if (typeof e.onUnload === "function") {
                    e.onUnload();
                }
            });
        },
    };
    Ft("popups", [An, ui]);
    const Cn = { modal: "[data-password-modal]", loginErrors: "#login_form .errors" };
    class Tn {
        constructor(e) {
            this.container = e.container;
            this.popupActions = new yo(this.container.querySelector(Cn.modal), this.container, true, true);
            if (this.container.querySelector(Cn.loginErrors)) {
                this.popupActions.popupOpen();
            }
        }
    }
    const qn = {
        onLoad() {
            new Tn(this);
        },
    };
    Ft("password-template", qn);
    Ft("list-collections", [oi, ns]);
    Ft("columns", [ns, oi]);
    Ft("newsletter", ui);
    if (!customElements.get("compare-images")) {
        customElements.define("compare-images", rn);
    }
    const In = { scrollToElement: "[data-scroll-to]", tooltip: "[data-tooltip]", collapsibleTrigger: "[data-collapsible-trigger]" };
    const Pn = { open: "open", dataScrollTo: "data-scroll-to", tooltipStopMousenterValue: "data-tooltip-stop-mouseenter" };
    const xn = {};
    class Mn {
        constructor(e) {
            this.section = e;
            this.container = e.container;
            this.scrollToButtons = this.container.querySelectorAll(In.scrollToElement);
            if (this.scrollToButtons.length) {
                this.init();
            }
        }
        init() {
            this.scrollToButtons.forEach((e) => {
                e.addEventListener("click", () => {
                    const t = this.container.querySelector(e.getAttribute(Pn.dataScrollTo));
                    if (!t || e.tagName === "A") return;
                    this.scrollToElement(t);
                });
            });
        }
        scrollToElement(e) {
            ni(e.getBoundingClientRect().top + 1);
            const t = e.nextElementSibling.matches("details") ? e.nextElementSibling : null;
            if (t) {
                const e = t?.querySelector(In.collapsibleTrigger);
                const i = t.hasAttribute(Pn.open);
                if (!i) {
                    e?.dispatchEvent(new Event("click"));
                }
            }
            const i = document.querySelectorAll(`${In.tooltip}:not([${Pn.tooltipStopMousenterValue}])`);
            if (i.length) {
                i.forEach((e) => {
                    e.setAttribute(Pn.tooltipStopMousenterValue, "");
                    setTimeout(() => {
                        e.removeAttribute(Pn.tooltipStopMousenterValue);
                    }, 1e3);
                });
            }
        }
    }
    const Hn = {
        onLoad() {
            xn[this.id] = new Mn(this);
        },
    };
    const On = { scrollSpy: "[data-scroll-spy]" };
    const Bn = { selected: "is-selected" };
    const Dn = { scrollSpy: "data-scroll-spy", mobile: "data-scroll-spy-mobile", desktop: "data-scroll-spy-desktop", triggerPoint: "data-scroll-trigger-point" };
    const Fn = {};
    class _n {
        constructor(e, t) {
            this.container = e;
            this.elementToSpy = t;
            this.anchorSelector = `[${Dn.scrollSpy}="#${this.elementToSpy.id}"]`;
            this.anchor = this.container.querySelector(this.anchorSelector);
            this.anchorSiblings = this.container.querySelectorAll(`[${Dn.scrollSpy}]`);
            this.initialized = false;
            if (!this.anchor) return;
            this.triggerPoint = this.anchor.getAttribute(Dn.triggerPoint);
            this.scrollCallback = () => this.onScroll();
            this.toggleScrollObserver = this.toggleScrollObserver.bind(this);
            this.init();
        }
        init() {
            this.toggleScrollObserver();
            document.addEventListener("theme:resize:width", this.toggleScrollObserver);
        }
        toggleScrollObserver() {
            if (this.isEligible()) {
                if (!this.initialized) {
                    document.addEventListener("theme:scroll", this.scrollCallback);
                    this.initialized = true;
                }
            } else {
                document.removeEventListener("theme:scroll", this.scrollCallback);
                this.initialized = false;
            }
        }
        isEligible() {
            const e = b();
            const t = !e;
            return (t && this.anchor.hasAttribute(Dn.mobile)) || (e && this.anchor.hasAttribute(Dn.desktop)) || (!this.anchor.hasAttribute(Dn.desktop) && !this.anchor.hasAttribute(Dn.mobile));
        }
        onScroll() {
            this.top = this.elementToSpy.getBoundingClientRect().top;
            const e = Math.round(window.innerHeight);
            const t = Math.round(window.scrollY);
            const i = t + e;
            const s = Math.round(this.top + t);
            const o = this.elementToSpy.offsetHeight;
            const n = s + o;
            const r = n < t;
            const a = s < i;
            const l = a && !r;
            if (!l) return;
            if (!this.triggerPointReached()) return;
            this.anchorSiblings.forEach((e) => {
                if (!e.matches(this.anchorSelector)) {
                    e.classList.remove(Bn.selected);
                }
            });
            this.anchor.classList.add(Bn.selected);
        }
        triggerPointReached() {
            let e = false;
            switch (this.triggerPoint) {
                case "top":
                    e = this.top <= 0;
                    break;
                case "middle":
                    e = this.top <= window.innerHeight / 2;
                    break;
                case "bottom":
                    e = this.top <= window.innerHeight;
                    break;
                default:
                    e = this.top <= 0;
            }
            return e;
        }
        onUnload() {
            document.removeEventListener("theme:resize:width", this.toggleScrollObserver);
            document.removeEventListener("theme:scroll", this.scrollCallback);
        }
    }
    const $n = {
        onLoad() {
            Fn[this.id] = [];
            this.container.querySelectorAll(On.scrollSpy)?.forEach((e) => {
                const t = this.container.querySelector(e.getAttribute(Dn.scrollSpy));
                Fn[this.id].push(new _n(this.container, t));
            });
        },
        onUnload() {
            Fn[this.id].forEach((e) => {
                if (typeof e.onUnload === "function") {
                    e.onUnload();
                }
            });
        },
    };
    Ft("sidebar", [Hn, $n]);
    const Nn = { button: "[data-hover-target]", image: "[data-collection-image]" };
    const Wn = { target: "data-hover-target" };
    const Rn = { visible: "is-visible", selected: "is-selected" };
    let Vn = {};
    class Un {
        constructor(e) {
            this.container = e.container;
            this.buttons = this.container.querySelectorAll(Nn.button);
            this.init();
        }
        init() {
            if (this.buttons.length) {
                this.buttons.forEach((e) => {
                    e.addEventListener("mouseenter", (e) => {
                        const t = e.currentTarget.getAttribute(Wn.target);
                        this.updateState(t);
                    });
                });
            }
        }
        updateState(e) {
            const t = this.container.querySelector(`[${Wn.target}="${e}"]`);
            const i = this.container.querySelector(`#${e}:not(.${Rn.visible})`);
            const s = this.container.querySelector(`${Nn.button}.${Rn.selected}`);
            const o = this.container.querySelector(`${Nn.image}.${Rn.visible}`);
            if (i && b()) {
                o?.classList.remove(Rn.visible);
                s?.classList.remove(Rn.selected);
                i.classList.add(Rn.visible);
                t.classList.add(Rn.selected);
            }
        }
        onBlockSelect(e) {
            this.updateState(e.target.id);
        }
    }
    const zn = {
        onLoad() {
            Vn[this.id] = new Un(this);
        },
        onBlockSelect(e) {
            Vn[this.id].onBlockSelect(e);
        },
    };
    Ft("collections-hover", [zn, $n]);
    const jn = { image: "[data-featured-image]", imagesHolder: "[data-featured-aside]", contentHolder: "[data-featured-content]", wrapper: "[data-featured-wrapper]" };
    const Jn = { horizontalScroll: "data-horizontal-scroll", horizontalScrollReversed: "data-horizontal-scroll-reversed" };
    const Xn = {};
    class Gn {
        constructor(e) {
            this.container = e.container;
            this.horizontalScroll = this.container.hasAttribute(Jn.horizontalScroll);
            this.horizontalScrollReversed = this.container.hasAttribute(Jn.horizontalScrollReversed);
            this.images = this.container.querySelectorAll(jn.image);
            this.imagesHolder = this.container.querySelector(jn.imagesHolder);
            this.contentHolder = this.container.querySelector(jn.contentHolder);
            this.wrapper = this.container.querySelector(jn.wrapper);
            this.requestAnimationSticky = null;
            this.lastPercent = 0;
            this.scrollEvent = () => this.scrollEvents();
            this.calculateHorizontalPositionEvent = () => this.calculateHorizontalPosition();
            this.calculateHeightEvent = () => this.calculateHeight();
            this.init();
        }
        init() {
            if (this.horizontalScroll && this.imagesHolder) {
                this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent);
                document.addEventListener("theme:scroll", this.scrollEvent);
            }
            if (this.wrapper && this.contentHolder && this.images.length) {
                this.calculateHeight();
                document.addEventListener("theme:resize:width", this.calculateHeightEvent);
            }
        }
        scrollEvents() {
            if (!this.requestAnimationSticky) {
                this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent);
            }
        }
        removeAnimationFrame() {
            if (this.requestAnimationSticky) {
                cancelAnimationFrame(this.requestAnimationSticky);
                this.requestAnimationSticky = null;
            }
        }
        calculateHorizontalPosition() {
            let e = window.scrollY + this.headerHeight;
            const t = e + window.innerHeight;
            const i = this.imagesHolder.offsetTop;
            const s = this.imagesHolder.offsetHeight;
            const o = i + s + this.headerHeight;
            const n = s - (window.innerHeight - this.headerHeight);
            const r = this.horizontalScrollReversed ? 1 : -1;
            let a = 0;
            if (e >= i && t <= o) {
                a = ((e - i) / n) * 100;
            } else if (e < i) {
                a = 0;
            } else {
                a = 100;
            }
            a *= this.images.length - 1;
            this.container.style.setProperty("--translateX", `${a * r}%`);
            if (this.lastPercent !== a) {
                this.requestAnimationSticky = requestAnimationFrame(this.calculateHorizontalPositionEvent);
            } else if (this.requestAnimationSticky) {
                this.removeAnimationFrame();
            }
            this.lastPercent = a;
        }
        calculateHeight() {
            let { stickyHeaderHeight: e } = l();
            this.container.style.removeProperty("--min-height");
            this.container.style.setProperty("--min-height", `${this.wrapper.offsetHeight + this.contentHolder.offsetHeight}px`);
            this.headerHeight = e;
        }
        onUnload() {
            if (this.horizontalScroll && this.imagesHolder) {
                document.removeEventListener("theme:scroll", this.calculateHorizontalPositionEvent);
            }
            if (this.wrapper && this.contentHolder && this.images.length) {
                document.removeEventListener("theme:resize:width", this.calculateHeightEvent);
            }
        }
    }
    const Yn = {
        onLoad() {
            Xn[this.id] = new Gn(this);
        },
        onUnload(e) {
            Xn[this.id].onUnload(e);
        },
    };
    Ft("featured-product", [Yn]);
    const Qn = {
        holder: "[data-timeline-holder]",
        rows: "[data-timeline-rows]",
        row: "[data-timeline-row]",
        rowEditor: "[data-timeline-row-editor]",
        button: "[data-timeline-button]",
        scrollElement: "[data-block-scroll]",
        headerSticky: "[data-header-sticky]",
        headerHeight: "[data-header-height]",
    };
    const Kn = { selected: "is-selected" };
    const Zn = {};
    class er {
        constructor(e) {
            this.container = e.container;
            this.rows = this.container.querySelectorAll(Qn.row);
            this.holder = this.container.querySelector(Qn.holder);
            if (this.rows.length < 2 || !this.holder) return;
            this.rowsWidth = 0;
            this.rowsHeight = [];
            this.holderTop = this.holder.getBoundingClientRect().top + window.scrollY;
            this.holderHeight = this.holder.offsetHeight;
            this.buttons = this.container.querySelectorAll(Qn.button);
            this.rowsHolder = this.container.querySelector(Qn.rows);
            this.requestAnimation = null;
            this.isDesktopView = b();
            this.isScrollEnabled = false;
            this.scrollEvent = (e) => this.scrollEvents(e);
            this.resizeEvent = () => this.resizeEvents();
            this.init();
        }
        init() {
            this.calculateRowsDimensions();
            this.requestAnimation = requestAnimationFrame(() => this.calculatePosition());
            if (this.isDesktopView && !this.isScrollEnabled) {
                this.isScrollEnabled = true;
                document.addEventListener("theme:scroll", this.scrollEvent);
            }
            this.rowsHolder.addEventListener("scroll", this.scrollEvent);
            document.addEventListener("theme:resize:width", this.resizeEvent);
            if (this.buttons.length) {
                this.buttons.forEach((e, t) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault();
                        const i = e.currentTarget.closest(Qn.row);
                        if (!i) return;
                        if (b()) {
                            const e = Math.max(...this.rowsHeight);
                            const i = this.holderHeight / this.rows.length;
                            const s = this.holder.getBoundingClientRect().top;
                            const o = t > 0 && e < i ? i * t + s : s;
                            const n = o + 1;
                            ni(n);
                        } else {
                            const e = 16;
                            const t = i.offsetLeft - e;
                            this.rowsHolder.scrollTo({ left: t, behavior: "smooth" });
                        }
                    });
                });
            }
        }
        resizeEvents() {
            this.holderTop = this.holder.getBoundingClientRect().top + window.scrollY;
            this.holderHeight = this.holder.offsetHeight;
            this.calculateRowsDimensions();
            this.requestAnimation = requestAnimationFrame(() => this.calculatePosition());
            const e = b();
            if (e && !this.isScrollEnabled) {
                this.isScrollEnabled = true;
                document.addEventListener("theme:scroll", this.scrollEvent);
            } else if (!e && this.isScrollEnabled) {
                this.isScrollEnabled = false;
                document.removeEventListener("theme:scroll", this.scrollEvent);
            }
        }
        scrollEvents(e) {
            if (!this.requestAnimation) {
                const t = e.currentTarget;
                this.requestAnimation = requestAnimationFrame(() => this.calculatePosition(t));
            }
        }
        removeAnimationFrame() {
            if (this.requestAnimation) {
                cancelAnimationFrame(this.requestAnimation);
                this.requestAnimation = null;
            }
        }
        calculateRowsDimensions() {
            if (this.rows.length) {
                this.rowsHeight = [];
                this.rowsWidth = 0;
                let e = 0;
                this.rows.forEach((t, i) => {
                    this.rowsHeight.push(t.offsetHeight);
                    this.rowsWidth += t.offsetWidth + parseInt(getComputedStyle(t).marginRight);
                    if (window.Shopify.designMode) {
                        const s = this.container.querySelectorAll(Qn.rowEditor);
                        if (s.length) {
                            e += t.offsetHeight;
                            s[i]?.style.setProperty("--row-height-min", `${t.offsetHeight}px`);
                            s[i + 1]?.style.setProperty("--row-top-mobile", `${e}px`);
                        }
                    }
                });
            }
        }
        calculatePosition(e = null) {
            this.removeAnimationFrame();
            const t = b();
            const i = this.holderHeight / this.rows.length;
            let s = this.holderTop;
            const o = window.innerHeight;
            const n = window.scrollY + o * 1.5;
            const r = 16;
            let a = 0;
            if (!t && e) {
                const t = e.scrollLeft - r;
                const i = e.offsetWidth;
                a = (t / (this.rowsWidth - i)) * 100;
                this.holder.style.setProperty("--percent-mobile", `${a}%`);
            }
            if (t && (n < this.holderTop || n > this.holderTop + this.holderHeight + o)) return;
            this.rows.forEach((e, o) => {
                if (o > 0) {
                    const o = (e.offsetLeft / this.rowsWidth) * 100;
                    let r = a > o;
                    if (t) {
                        r = s + i < n;
                        if (s - i < n) {
                            e.previousElementSibling?.style.setProperty("--percent-desktop", `${((n - s) / i) * 100}%`);
                        }
                    }
                    e.classList.toggle(Kn.selected, r);
                }
                s += i;
            });
        }
        onUnload() {
            if (this.isScrollEnabled) {
                this.isScrollEnabled = false;
                document.removeEventListener("theme:scroll", this.scrollEvent);
            }
            this.rowsHolder.removeEventListener("scroll", this.scrollEvent);
            document.removeEventListener("theme:resize:width", this.resizeEvent);
        }
        onBlockSelect(e) {
            const t = this.container.querySelector(Qn.scrollElement);
            if (t) {
                const i = e.srcElement;
                const s = [...i.parentElement.children].indexOf(i);
                const o = this.rows[s];
                if (o) {
                    t.scrollTo({ top: 0, left: o.offsetLeft, behavior: "smooth" });
                }
            }
        }
    }
    const tr = {
        onLoad() {
            Zn[this.id] = new er(this);
        },
        onUnload(e) {
            Zn[this.id].onUnload(e);
        },
        onBlockSelect(e) {
            Zn[this.id].onBlockSelect(e);
        },
    };
    Ft("timeline", [tr]);
    document.addEventListener("DOMContentLoaded", function () {
        _t("*");
        const e = document.querySelector("[data-scroll-top-button]");
        if (e) {
            e.addEventListener("click", () => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            });
            document.addEventListener("theme:scroll", () => {
                e.classList.toggle("is-visible", window.scrollY > window.innerHeight);
            });
        }
        if (window.self !== window.top) {
            document.querySelector("html").classList.add("iframe");
        }
        let t = "scrollBehavior" in document.documentElement.style;
        if (!t) {
            Vo({ url: window.theme.assets.smoothscroll });
        }
    });
    if (window.navigator.cookieEnabled) {
        document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies");
    }
})(themeVendor.ScrollLock, themeVendor.Rellax, themeVendor.Flickity, themeVendor.FlickityFade, themeVendor.themeImages);
